// Generated by starfall-protocol-gen from protocol/starfall.schema. Do not edit.
/* eslint-disable */

import { Reader, Writer, NULL_UUID, type Uuid, type Vec2, type Vec3, type Vec4, type Quat, type Color } from "./codec";

export const PROTOCOL_VERSION = 1;
/** Builds of the same epoch can talk, whatever their revisions (protocol/starfall.lock). */
export const PROTOCOL_EPOCH = 1;
/** How far the protocol has grown within its epoch. */
export const PROTOCOL_REVISION = 17;
/** Changes whenever the wire format does. The region checks it on entry. */
export const PROTOCOL_FINGERPRINT = 0x160b1dbf47885109n;

export enum Channel {
  Unreliable = 0,
  Reliable = 1,
  Bulk = 2,
}

export enum Direction {
  ClientToServer = 0,
  ServerToClient = 1,
  Both = 2,
}

export enum ChatType {
  Whisper = 0,
  Say = 1,
  Shout = 2,
  System = 3,
  OwnerSay = 4,
  Debug = 5,
  RegionSay = 6,
}

const CHAT_TYPE_VALUES: ReadonlySet<number> = new Set([
  0, 1, 2, 3, 4, 5, 6,
]);

export enum ChatSource {
  Agent = 0,
  Object = 1,
  System = 2,
}

const CHAT_SOURCE_VALUES: ReadonlySet<number> = new Set([
  0, 1, 2,
]);

export enum AssetKind {
  Texture = 0,
  Sound = 1,
  Animation = 2,
  Mesh = 3,
  Script = 4,
  Notecard = 5,
  BodyPart = 6,
  Clothing = 7,
  Gesture = 8,
  Landmark = 9,
  SkySettings = 10,
  WaterSettings = 11,
  DayCycle = 12,
  Material = 13,
  Object = 14,
  Terrain = 15,
  Folder = 16,
  Shader = 17,
  Unknown = 255,
}

const ASSET_KIND_VALUES: ReadonlySet<number> = new Set([
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 255,
]);

export enum PrimType {
  Box = 0,
  Cylinder = 1,
  Prism = 2,
  Sphere = 3,
  Torus = 4,
  Tube = 5,
  Ring = 6,
  Mesh = 7,
  Tree = 8,
  Grass = 9,
  Rock = 10,
  Sculpt = 11,
}

const PRIM_TYPE_VALUES: ReadonlySet<number> = new Set([
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11,
]);

export enum HoleShape {
  Same = 0,
  Circle = 1,
  Square = 2,
  Triangle = 3,
}

const HOLE_SHAPE_VALUES: ReadonlySet<number> = new Set([
  0, 1, 2, 3,
]);

export enum PhysicsShape {
  Prim = 0,
  ConvexHull = 1,
  None = 2,
}

const PHYSICS_SHAPE_VALUES: ReadonlySet<number> = new Set([
  0, 1, 2,
]);

export enum MaterialType {
  Stone = 0,
  Metal = 1,
  Glass = 2,
  Wood = 3,
  Flesh = 4,
  Plastic = 5,
  Rubber = 6,
}

const MATERIAL_TYPE_VALUES: ReadonlySet<number> = new Set([
  0, 1, 2, 3, 4, 5, 6,
]);

export enum WearableSlot {
  Shape = 0,
  Skin = 1,
  Hair = 2,
  Eyes = 3,
  Shirt = 4,
  Pants = 5,
  Shoes = 6,
  Socks = 7,
  Jacket = 8,
  Gloves = 9,
  Undershirt = 10,
  Underpants = 11,
  Skirt = 12,
  Alpha = 13,
  Tattoo = 14,
  Physics = 15,
  Universal = 16,
}

const WEARABLE_SLOT_VALUES: ReadonlySet<number> = new Set([
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16,
]);

export enum AttachPoint {
  None = 0,
  Chest = 1,
  Skull = 2,
  LeftShoulder = 3,
  RightShoulder = 4,
  LeftHand = 5,
  RightHand = 6,
  LeftFoot = 7,
  RightFoot = 8,
  Spine = 9,
  Pelvis = 10,
  Mouth = 11,
  Chin = 12,
  LeftEar = 13,
  RightEar = 14,
  LeftEye = 15,
  RightEye = 16,
  Nose = 17,
  RightUpperArm = 18,
  RightForearm = 19,
  LeftUpperArm = 20,
  LeftForearm = 21,
  RightHip = 22,
  RightUpperLeg = 23,
  RightLowerLeg = 24,
  LeftHip = 25,
  LeftUpperLeg = 26,
  LeftLowerLeg = 27,
  Stomach = 28,
  LeftPec = 29,
  RightPec = 30,
  HudCenter2 = 31,
  HudTopRight = 32,
  HudTop = 33,
  HudTopLeft = 34,
  HudCenter = 35,
  HudBottomLeft = 36,
  HudBottom = 37,
  HudBottomRight = 38,
  Neck = 39,
  Root = 40,
  LeftRingFinger = 41,
  RightRingFinger = 42,
  TailBase = 43,
  TailTip = 44,
  LeftWing = 45,
  RightWing = 46,
  Jaw = 47,
  AltLeftEar = 48,
  AltRightEar = 49,
  AltLeftEye = 50,
  AltRightEye = 51,
  Tongue = 52,
  Groin = 53,
  LeftHindFoot = 54,
  RightHindFoot = 55,
}

const ATTACH_POINT_VALUES: ReadonlySet<number> = new Set([
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55,
]);

export enum TeleportStatus {
  Started = 0,
  Progress = 1,
  Failed = 2,
  Finished = 3,
  Crossing = 4,
}

const TELEPORT_STATUS_VALUES: ReadonlySet<number> = new Set([
  0, 1, 2, 3, 4,
]);

export enum AbuseCategory {
  Other = 0,
  Harassment = 1,
  Indecency = 2,
  Intolerance = 3,
  Fraud = 4,
  Disturbance = 5,
  LandAbuse = 6,
  IntellectualProperty = 7,
  AgeViolation = 8,
}

const ABUSE_CATEGORY_VALUES: ReadonlySet<number> = new Set([
  0, 1, 2, 3, 4, 5, 6, 7, 8,
]);

export enum InventoryOp {
  Create = 0,
  Rename = 1,
  Move = 2,
  Delete = 3,
  Copy = 4,
}

const INVENTORY_OP_VALUES: ReadonlySet<number> = new Set([
  0, 1, 2, 3, 4,
]);

export enum EditOp {
  Move = 0,
  Rotate = 1,
  Scale = 2,
  MoveRotate = 3,
  All = 4,
}

const EDIT_OP_VALUES: ReadonlySet<number> = new Set([
  0, 1, 2, 3, 4,
]);

export enum Maturity {
  General = 0,
  Moderate = 1,
  Adult = 2,
}

const MATURITY_VALUES: ReadonlySet<number> = new Set([
  0, 1, 2,
]);

export enum DialogKind {
  Buttons = 0,
  TextBox = 1,
}

const DIALOG_KIND_VALUES: ReadonlySet<number> = new Set([
  0, 1,
]);

export enum FriendPresence {
  Offline = 0,
  Online = 1,
}

const FRIEND_PRESENCE_VALUES: ReadonlySet<number> = new Set([
  0, 1,
]);

export enum MapItemKind {
  Telehub = 0,
  Event = 1,
  LandForSale = 2,
  Auction = 3,
}

const MAP_ITEM_KIND_VALUES: ReadonlySet<number> = new Set([
  0, 1, 2, 3,
]);

export enum SearchKind {
  People = 0,
  Places = 1,
  Events = 2,
  Classifieds = 3,
}

const SEARCH_KIND_VALUES: ReadonlySet<number> = new Set([
  0, 1, 2, 3,
]);

export enum ExperienceListKind {
  Mine = 0,
  Search = 1,
  Answered = 2,
  Lookup = 3,
}

const EXPERIENCE_LIST_KIND_VALUES: ReadonlySet<number> = new Set([
  0, 1, 2, 3,
]);

export enum MarketListKind {
  Browse = 0,
  Mine = 1,
}

const MARKET_LIST_KIND_VALUES: ReadonlySet<number> = new Set([
  0, 1,
]);

export enum AdminObjectOp {
  ForceOwnerToMe = 0,
  ForceOwnerPermissive = 1,
  Lock = 2,
  Unlock = 3,
}

const ADMIN_OBJECT_OP_VALUES: ReadonlySet<number> = new Set([
  0, 1, 2, 3,
]);

export enum StaffOp {
  KickFromGrid = 0,
  BanFromGrid = 1,
  LiftBan = 2,
  SetLoginMessage = 3,
  SetLoginNotice = 4,
  RestrictLogins = 5,
  NoticeEveryone = 6,
  BringHere = 7,
}

const STAFF_OP_VALUES: ReadonlySet<number> = new Set([
  0, 1, 2, 3, 4, 5, 6, 7,
]);

export enum TouchPhase {
  Start = 0,
  Held = 1,
  End = 2,
}

const TOUCH_PHASE_VALUES: ReadonlySet<number> = new Set([
  0, 1, 2,
]);

export enum SaleType {
  Original = 0,
  Copy = 1,
  Contents = 2,
}

const SALE_TYPE_VALUES: ReadonlySet<number> = new Set([
  0, 1, 2,
]);

export enum EstateAccessKind {
  Resident = 0,
  Group = 1,
  Banned = 2,
}

const ESTATE_ACCESS_KIND_VALUES: ReadonlySet<number> = new Set([
  0, 1, 2,
]);

export enum VoiceCallKind {
  Direct = 0,
  Group = 1,
  Conference = 2,
}

const VOICE_CALL_KIND_VALUES: ReadonlySet<number> = new Set([
  0, 1, 2,
]);

export enum LandSort {
  Cheapest = 0,
  Largest = 1,
  PerSquareMetre = 2,
  Name = 3,
}

const LAND_SORT_VALUES: ReadonlySet<number> = new Set([
  0, 1, 2, 3,
]);

export const ParcelFlag = {
  AllowFly: 1,
  AllowScripts: 2,
  AllowBuild: 4,
  AllowLandmark: 8,
  AllowTerraform: 16,
  AllowDamage: 32,
  ForSale: 64,
  ShowDirectory: 128,
  RestrictPushObject: 256,
  AllowGroupBuild: 512,
  AllowGroupScripts: 1024,
  UseAccessList: 2048,
  UseBanList: 4096,
  AllowVoice: 8192,
  Mature: 16384,
  Adult: 32768,
  NoObjectEntry: 65536,
  AllowGroupObjectEntry: 131072,
  TeleportLandingPoint: 262144,
  TeleportBlocked: 524288,
  HideAvatars: 1048576,
  AllowDeedToGroup: 2097152,
} as const;

export const ItemFlag = {
  GestureActive: 1,
  Favourite: 2,
} as const;

export const ObjectFlag = {
  Physics: 1,
  Phantom: 2,
  Temporary: 4,
  Buoyant: 8,
  CastShadows: 16,
  Scripted: 32,
  Touch: 64,
  Money: 128,
  Sit: 256,
  Locked: 512,
  Attachment: 1024,
  ForSale: 2048,
  Animated: 4096,
  Mouselook: 8192,
  Contents: 16384,
  ContentsNoCopy: 32768,
  ContentsNoTransfer: 65536,
  AllowDrop: 131072,
  Sellable: 262144,
} as const;

export const ObjectUpdateField = {
  Transform: 1,
  Shape: 2,
  Faces: 4,
  Flags: 8,
  Text: 16,
  Names: 32,
  Physics: 64,
  Link: 128,
  Light: 256,
  Flexible: 512,
  Particles: 1024,
  Mesh: 2048,
  Owner: 4096,
  Sit: 8192,
  TextureAnim: 16384,
  Animations: 32768,
  Drawings: 65536,
} as const;

export const ControlFlag = {
  Forward: 1,
  Back: 2,
  Left: 4,
  Right: 8,
  Up: 16,
  Down: 32,
  TurnLeft: 64,
  TurnRight: 128,
  Fly: 256,
  Run: 512,
  Jump: 1024,
  Crouch: 2048,
  Sit: 4096,
  Stand: 8192,
  MouseLook: 16384,
  LButton: 32768,
  MlLButton: 65536,
} as const;

export const Permission = {
  Move: 1,
  Modify: 2,
  Copy: 4,
  Transfer: 8,
  Damage: 16,
  Export: 32,
} as const;

export const GroupPower = {
  Invite: 1n,
  Eject: 2n,
  SendNotices: 8n,
  ChangeIdentity: 16n,
  ChangeOptions: 32n,
  LandDeed: 64n,
  LandRelease: 128n,
  LandEdit: 256n,
  ObjectReturn: 512n,
  Moderate: 1024n,
  JoinChat: 2048n,
  JoinVoice: 4096n,
  ReceiveNotices: 8192n,
  RoleCreate: 16384n,
  RoleDelete: 32768n,
  RoleProperties: 65536n,
  RoleAssignOwn: 131072n,
  RoleAssignAny: 262144n,
  RoleRemoveMember: 524288n,
  RoleChangeAbilities: 1048576n,
} as const;

export interface Endpoint {
  host: string;
  port: number;
  certificate_hash: string;
  websocket_url: string;
}

export const Endpoint = {
  create(): Endpoint {
    return {
      host: "",
      port: 0,
      certificate_hash: "",
      websocket_url: "",
    };
  },
  encode(w: Writer, v: Endpoint): void {
    w.string(v.host);
    w.u16(v.port);
    w.string(v.certificate_hash);
    w.string(v.websocket_url);
  },
  decode(r: Reader): Endpoint {
    const host = r.string();
    const port = r.u16();
    const certificate_hash = r.string();
    const websocket_url = r.string();
    return { host, port, certificate_hash, websocket_url };
  },
};

export interface Permissions {
  base: number;
  owner: number;
  group: number;
  everyone: number;
  next_owner: number;
}

export const Permissions = {
  create(): Permissions {
    return {
      base: 0,
      owner: 0,
      group: 0,
      everyone: 0,
      next_owner: 0,
    };
  },
  encode(w: Writer, v: Permissions): void {
    w.u32(v.base);
    w.u32(v.owner);
    w.u32(v.group);
    w.u32(v.everyone);
    w.u32(v.next_owner);
  },
  decode(r: Reader): Permissions {
    const base = r.u32();
    const owner = r.u32();
    const group = r.u32();
    const everyone = r.u32();
    const next_owner = r.u32();
    return { base, owner, group, everyone, next_owner };
  },
};

export interface PrimShape {
  prim_type: PrimType;
  hole_shape: HoleShape;
  path_begin: number;
  path_end: number;
  profile_begin: number;
  profile_end: number;
  hollow: number;
  twist_begin: number;
  twist_end: number;
  taper_x: number;
  taper_y: number;
  shear_x: number;
  shear_y: number;
  radius_offset: number;
  revolutions: number;
  skew: number;
  scale_x: number;
  scale_y: number;
  species: number;
  sculpt_texture: Uuid;
  sculpt_type: number;
}

export const PrimShape = {
  create(): PrimShape {
    return {
      prim_type: PrimType.Box,
      hole_shape: HoleShape.Same,
      path_begin: 0,
      path_end: 0,
      profile_begin: 0,
      profile_end: 0,
      hollow: 0,
      twist_begin: 0,
      twist_end: 0,
      taper_x: 0,
      taper_y: 0,
      shear_x: 0,
      shear_y: 0,
      radius_offset: 0,
      revolutions: 0,
      skew: 0,
      scale_x: 0,
      scale_y: 0,
      species: 0,
      sculpt_texture: NULL_UUID,
      sculpt_type: 0,
    };
  },
  encode(w: Writer, v: PrimShape): void {
    w.u8(v.prim_type);
    w.u8(v.hole_shape);
    w.f32(v.path_begin);
    w.f32(v.path_end);
    w.f32(v.profile_begin);
    w.f32(v.profile_end);
    w.f32(v.hollow);
    w.f32(v.twist_begin);
    w.f32(v.twist_end);
    w.f32(v.taper_x);
    w.f32(v.taper_y);
    w.f32(v.shear_x);
    w.f32(v.shear_y);
    w.f32(v.radius_offset);
    w.f32(v.revolutions);
    w.f32(v.skew);
    w.f32(v.scale_x);
    w.f32(v.scale_y);
    w.u8(v.species);
    w.uuid(v.sculpt_texture);
    w.u8(v.sculpt_type);
  },
  decode(r: Reader): PrimShape {
    const prim_type = r.enumValue(PRIM_TYPE_VALUES, r.u8()) as PrimType;
    const hole_shape = r.enumValue(HOLE_SHAPE_VALUES, r.u8()) as HoleShape;
    const path_begin = r.f32();
    const path_end = r.f32();
    const profile_begin = r.f32();
    const profile_end = r.f32();
    const hollow = r.f32();
    const twist_begin = r.f32();
    const twist_end = r.f32();
    const taper_x = r.f32();
    const taper_y = r.f32();
    const shear_x = r.f32();
    const shear_y = r.f32();
    const radius_offset = r.f32();
    const revolutions = r.f32();
    const skew = r.f32();
    const scale_x = r.f32();
    const scale_y = r.f32();
    const species = r.u8();
    const sculpt_texture = r.uuid();
    const sculpt_type = r.u8();
    return { prim_type, hole_shape, path_begin, path_end, profile_begin, profile_end, hollow, twist_begin, twist_end, taper_x, taper_y, shear_x, shear_y, radius_offset, revolutions, skew, scale_x, scale_y, species, sculpt_texture, sculpt_type };
  },
};

export interface FaceMaterial {
  texture: Uuid;
  normal_map: Uuid;
  metallic_roughness_map: Uuid;
  emissive_map: Uuid;
  color: Color;
  emissive: Color;
  metallic: number;
  roughness: number;
  glow: number;
  repeat_u: number;
  repeat_v: number;
  offset_u: number;
  offset_v: number;
  rotation: number;
  fullbright: boolean;
  alpha_mode: number;
  alpha_cutoff: number;
  media_url: string;
  texgen: number;
  shader: Uuid;
}

export const FaceMaterial = {
  create(): FaceMaterial {
    return {
      texture: NULL_UUID,
      normal_map: NULL_UUID,
      metallic_roughness_map: NULL_UUID,
      emissive_map: NULL_UUID,
      color: { r: 255, g: 255, b: 255, a: 255 },
      emissive: { r: 255, g: 255, b: 255, a: 255 },
      metallic: 0,
      roughness: 0,
      glow: 0,
      repeat_u: 0,
      repeat_v: 0,
      offset_u: 0,
      offset_v: 0,
      rotation: 0,
      fullbright: false,
      alpha_mode: 0,
      alpha_cutoff: 0,
      media_url: "",
      texgen: 0,
      shader: NULL_UUID,
    };
  },
  encode(w: Writer, v: FaceMaterial): void {
    w.uuid(v.texture);
    w.uuid(v.normal_map);
    w.uuid(v.metallic_roughness_map);
    w.uuid(v.emissive_map);
    w.color(v.color);
    w.color(v.emissive);
    w.f32(v.metallic);
    w.f32(v.roughness);
    w.f32(v.glow);
    w.f32(v.repeat_u);
    w.f32(v.repeat_v);
    w.f32(v.offset_u);
    w.f32(v.offset_v);
    w.f32(v.rotation);
    w.bool(v.fullbright);
    w.u8(v.alpha_mode);
    w.f32(v.alpha_cutoff);
    w.string(v.media_url);
    w.u8(v.texgen);
    w.uuid(v.shader);
  },
  decode(r: Reader): FaceMaterial {
    const texture = r.uuid();
    const normal_map = r.uuid();
    const metallic_roughness_map = r.uuid();
    const emissive_map = r.uuid();
    const color = r.color();
    const emissive = r.color();
    const metallic = r.f32();
    const roughness = r.f32();
    const glow = r.f32();
    const repeat_u = r.f32();
    const repeat_v = r.f32();
    const offset_u = r.f32();
    const offset_v = r.f32();
    const rotation = r.f32();
    const fullbright = r.bool();
    const alpha_mode = r.u8();
    const alpha_cutoff = r.f32();
    const media_url = r.string();
    const texgen = r.u8();
    const shader = r.uuid();
    return { texture, normal_map, metallic_roughness_map, emissive_map, color, emissive, metallic, roughness, glow, repeat_u, repeat_v, offset_u, offset_v, rotation, fullbright, alpha_mode, alpha_cutoff, media_url, texgen, shader };
  },
};

export interface LightParams {
  enabled: boolean;
  color: Color;
  intensity: number;
  radius: number;
  falloff: number;
  spot_angle: number;
  spot_softness: number;
  texture: Uuid;
  focus: number;
  ambience: number;
}

export const LightParams = {
  create(): LightParams {
    return {
      enabled: false,
      color: { r: 255, g: 255, b: 255, a: 255 },
      intensity: 0,
      radius: 0,
      falloff: 0,
      spot_angle: 0,
      spot_softness: 0,
      texture: NULL_UUID,
      focus: 0,
      ambience: 0,
    };
  },
  encode(w: Writer, v: LightParams): void {
    w.bool(v.enabled);
    w.color(v.color);
    w.f32(v.intensity);
    w.f32(v.radius);
    w.f32(v.falloff);
    w.f32(v.spot_angle);
    w.f32(v.spot_softness);
    w.uuid(v.texture);
    w.f32(v.focus);
    w.f32(v.ambience);
  },
  decode(r: Reader): LightParams {
    const enabled = r.bool();
    const color = r.color();
    const intensity = r.f32();
    const radius = r.f32();
    const falloff = r.f32();
    const spot_angle = r.f32();
    const spot_softness = r.f32();
    const texture = r.uuid();
    const focus = r.f32();
    const ambience = r.f32();
    return { enabled, color, intensity, radius, falloff, spot_angle, spot_softness, texture, focus, ambience };
  },
};

export interface FlexibleParams {
  enabled: boolean;
  softness: number;
  gravity: number;
  drag: number;
  wind: number;
  tension: number;
  force: Vec3;
}

export const FlexibleParams = {
  create(): FlexibleParams {
    return {
      enabled: false,
      softness: 0,
      gravity: 0,
      drag: 0,
      wind: 0,
      tension: 0,
      force: { x: 0, y: 0, z: 0 },
    };
  },
  encode(w: Writer, v: FlexibleParams): void {
    w.bool(v.enabled);
    w.u8(v.softness);
    w.f32(v.gravity);
    w.f32(v.drag);
    w.f32(v.wind);
    w.f32(v.tension);
    w.vec3(v.force);
  },
  decode(r: Reader): FlexibleParams {
    const enabled = r.bool();
    const softness = r.u8();
    const gravity = r.f32();
    const drag = r.f32();
    const wind = r.f32();
    const tension = r.f32();
    const force = r.vec3();
    return { enabled, softness, gravity, drag, wind, tension, force };
  },
};

export interface ParticleParams {
  enabled: boolean;
  texture: Uuid;
  start_color: Color;
  end_color: Color;
  start_scale: Vec2;
  end_scale: Vec2;
  burst_rate: number;
  burst_count: number;
  burst_radius: number;
  speed_min: number;
  speed_max: number;
  lifetime: number;
  particle_lifetime: number;
  acceleration: Vec3;
  angle_begin: number;
  angle_end: number;
  flags: number;
}

export const ParticleParams = {
  create(): ParticleParams {
    return {
      enabled: false,
      texture: NULL_UUID,
      start_color: { r: 255, g: 255, b: 255, a: 255 },
      end_color: { r: 255, g: 255, b: 255, a: 255 },
      start_scale: { x: 0, y: 0 },
      end_scale: { x: 0, y: 0 },
      burst_rate: 0,
      burst_count: 0,
      burst_radius: 0,
      speed_min: 0,
      speed_max: 0,
      lifetime: 0,
      particle_lifetime: 0,
      acceleration: { x: 0, y: 0, z: 0 },
      angle_begin: 0,
      angle_end: 0,
      flags: 0,
    };
  },
  encode(w: Writer, v: ParticleParams): void {
    w.bool(v.enabled);
    w.uuid(v.texture);
    w.color(v.start_color);
    w.color(v.end_color);
    w.vec2(v.start_scale);
    w.vec2(v.end_scale);
    w.f32(v.burst_rate);
    w.u8(v.burst_count);
    w.f32(v.burst_radius);
    w.f32(v.speed_min);
    w.f32(v.speed_max);
    w.f32(v.lifetime);
    w.f32(v.particle_lifetime);
    w.vec3(v.acceleration);
    w.f32(v.angle_begin);
    w.f32(v.angle_end);
    w.u32(v.flags);
  },
  decode(r: Reader): ParticleParams {
    const enabled = r.bool();
    const texture = r.uuid();
    const start_color = r.color();
    const end_color = r.color();
    const start_scale = r.vec2();
    const end_scale = r.vec2();
    const burst_rate = r.f32();
    const burst_count = r.u8();
    const burst_radius = r.f32();
    const speed_min = r.f32();
    const speed_max = r.f32();
    const lifetime = r.f32();
    const particle_lifetime = r.f32();
    const acceleration = r.vec3();
    const angle_begin = r.f32();
    const angle_end = r.f32();
    const flags = r.u32();
    return { enabled, texture, start_color, end_color, start_scale, end_scale, burst_rate, burst_count, burst_radius, speed_min, speed_max, lifetime, particle_lifetime, acceleration, angle_begin, angle_end, flags };
  },
};

export interface PhysicsParams {
  shape: PhysicsShape;
  density: number;
  friction: number;
  restitution: number;
  gravity_multiplier: number;
}

export const PhysicsParams = {
  create(): PhysicsParams {
    return {
      shape: PhysicsShape.Prim,
      density: 0,
      friction: 0,
      restitution: 0,
      gravity_multiplier: 0,
    };
  },
  encode(w: Writer, v: PhysicsParams): void {
    w.u8(v.shape);
    w.f32(v.density);
    w.f32(v.friction);
    w.f32(v.restitution);
    w.f32(v.gravity_multiplier);
  },
  decode(r: Reader): PhysicsParams {
    const shape = r.enumValue(PHYSICS_SHAPE_VALUES, r.u8()) as PhysicsShape;
    const density = r.f32();
    const friction = r.f32();
    const restitution = r.f32();
    const gravity_multiplier = r.f32();
    return { shape, density, friction, restitution, gravity_multiplier };
  },
};

export interface ObjectTransform {
  position: Vec3;
  rotation: Quat;
  scale: Vec3;
  velocity: Vec3;
  angular_velocity: Vec3;
}

export const ObjectTransform = {
  create(): ObjectTransform {
    return {
      position: { x: 0, y: 0, z: 0 },
      rotation: { x: 0, y: 0, z: 0, w: 1 },
      scale: { x: 0, y: 0, z: 0 },
      velocity: { x: 0, y: 0, z: 0 },
      angular_velocity: { x: 0, y: 0, z: 0 },
    };
  },
  encode(w: Writer, v: ObjectTransform): void {
    w.vec3(v.position);
    w.quat(v.rotation);
    w.vec3(v.scale);
    w.vec3(v.velocity);
    w.vec3(v.angular_velocity);
  },
  decode(r: Reader): ObjectTransform {
    const position = r.vec3();
    const rotation = r.quat();
    const scale = r.vec3();
    const velocity = r.vec3();
    const angular_velocity = r.vec3();
    return { position, rotation, scale, velocity, angular_velocity };
  },
};

export interface TextureAnim {
  flags: number;
  face: number;
  size_x: number;
  size_y: number;
  start: number;
  length: number;
  rate: number;
}

export const TextureAnim = {
  create(): TextureAnim {
    return {
      flags: 0,
      face: 0,
      size_x: 0,
      size_y: 0,
      start: 0,
      length: 0,
      rate: 0,
    };
  },
  encode(w: Writer, v: TextureAnim): void {
    w.u8(v.flags);
    w.i8(v.face);
    w.u8(v.size_x);
    w.u8(v.size_y);
    w.f32(v.start);
    w.f32(v.length);
    w.f32(v.rate);
  },
  decode(r: Reader): TextureAnim {
    const flags = r.u8();
    const face = r.i8();
    const size_x = r.u8();
    const size_y = r.u8();
    const start = r.f32();
    const length = r.f32();
    const rate = r.f32();
    return { flags, face, size_x, size_y, start, length, rate };
  },
};

export interface ObjectFull {
  id: number;
  uuid: Uuid;
  parent: number;
  owner: Uuid;
  creator: Uuid;
  group: Uuid;
  name: string;
  description: string;
  transform: ObjectTransform;
  shape: PrimShape;
  faces: FaceMaterial[];
  flags: number;
  material: MaterialType;
  physics: PhysicsParams;
  permissions: Permissions;
  hover_text: string;
  hover_color: Color;
  light: LightParams;
  flexible: FlexibleParams;
  particles: ParticleParams;
  mesh_asset: Uuid;
  sit_offset: Vec3;
  sit_rotation: Quat;
  camera_eye: Vec3;
  camera_at: Vec3;
  click_action: number;
  sale_price: number;
  attach_point: AttachPoint;
  attached_to: Uuid;
  created_at: bigint;
  texture_anim: TextureAnim;
  animations: Uuid[];
  sit_text: string;
  touch_text: string;
}

export const ObjectFull = {
  create(): ObjectFull {
    return {
      id: 0,
      uuid: NULL_UUID,
      parent: 0,
      owner: NULL_UUID,
      creator: NULL_UUID,
      group: NULL_UUID,
      name: "",
      description: "",
      transform: ObjectTransform.create(),
      shape: PrimShape.create(),
      faces: [],
      flags: 0,
      material: MaterialType.Stone,
      physics: PhysicsParams.create(),
      permissions: Permissions.create(),
      hover_text: "",
      hover_color: { r: 255, g: 255, b: 255, a: 255 },
      light: LightParams.create(),
      flexible: FlexibleParams.create(),
      particles: ParticleParams.create(),
      mesh_asset: NULL_UUID,
      sit_offset: { x: 0, y: 0, z: 0 },
      sit_rotation: { x: 0, y: 0, z: 0, w: 1 },
      camera_eye: { x: 0, y: 0, z: 0 },
      camera_at: { x: 0, y: 0, z: 0 },
      click_action: 0,
      sale_price: 0,
      attach_point: AttachPoint.None,
      attached_to: NULL_UUID,
      created_at: 0n,
      texture_anim: TextureAnim.create(),
      animations: [],
      sit_text: "",
      touch_text: "",
    };
  },
  encode(w: Writer, v: ObjectFull): void {
    w.u32(v.id);
    w.uuid(v.uuid);
    w.u32(v.parent);
    w.uuid(v.owner);
    w.uuid(v.creator);
    w.uuid(v.group);
    w.string(v.name);
    w.string(v.description);
    ObjectTransform.encode(w, v.transform);
    PrimShape.encode(w, v.shape);
    w.u16(v.faces.length);
    for (const item of v.faces) {
      FaceMaterial.encode(w, item);
    }
    w.u32(v.flags);
    w.u8(v.material);
    PhysicsParams.encode(w, v.physics);
    Permissions.encode(w, v.permissions);
    w.string(v.hover_text);
    w.color(v.hover_color);
    LightParams.encode(w, v.light);
    FlexibleParams.encode(w, v.flexible);
    ParticleParams.encode(w, v.particles);
    w.uuid(v.mesh_asset);
    w.vec3(v.sit_offset);
    w.quat(v.sit_rotation);
    w.vec3(v.camera_eye);
    w.vec3(v.camera_at);
    w.u8(v.click_action);
    w.i32(v.sale_price);
    w.u8(v.attach_point);
    w.uuid(v.attached_to);
    w.u64(v.created_at);
    TextureAnim.encode(w, v.texture_anim);
    w.u16(v.animations.length);
    for (const item of v.animations) {
      w.uuid(item);
    }
    w.string(v.sit_text);
    w.string(v.touch_text);
  },
  decode(r: Reader): ObjectFull {
    const id = r.u32();
    const uuid = r.uuid();
    const parent = r.u32();
    const owner = r.uuid();
    const creator = r.uuid();
    const group = r.uuid();
    const name = r.string();
    const description = r.string();
    const transform = ObjectTransform.decode(r);
    const shape = PrimShape.decode(r);
    const faces: FaceMaterial[] = [];
    for (let n = r.u16(); n > 0 && r.ok; n--) {
      faces.push(FaceMaterial.decode(r));
    }
    const flags = r.u32();
    const material = r.enumValue(MATERIAL_TYPE_VALUES, r.u8()) as MaterialType;
    const physics = PhysicsParams.decode(r);
    const permissions = Permissions.decode(r);
    const hover_text = r.string();
    const hover_color = r.color();
    const light = LightParams.decode(r);
    const flexible = FlexibleParams.decode(r);
    const particles = ParticleParams.decode(r);
    const mesh_asset = r.uuid();
    const sit_offset = r.vec3();
    const sit_rotation = r.quat();
    const camera_eye = r.vec3();
    const camera_at = r.vec3();
    const click_action = r.u8();
    const sale_price = r.i32();
    const attach_point = r.enumValue(ATTACH_POINT_VALUES, r.u8()) as AttachPoint;
    const attached_to = r.uuid();
    const created_at = r.u64();
    const texture_anim = TextureAnim.decode(r);
    const animations: Uuid[] = [];
    for (let n = r.u16(); n > 0 && r.ok; n--) {
      animations.push(r.uuid());
    }
    const sit_text = r.string();
    const touch_text = r.string();
    return { id, uuid, parent, owner, creator, group, name, description, transform, shape, faces, flags, material, physics, permissions, hover_text, hover_color, light, flexible, particles, mesh_asset, sit_offset, sit_rotation, camera_eye, camera_at, click_action, sale_price, attach_point, attached_to, created_at, texture_anim, animations, sit_text, touch_text };
  },
};

export interface FaceDrawing {
  face: number;
  width: number;
  height: number;
  drawing: string;
}

export const FaceDrawing = {
  create(): FaceDrawing {
    return {
      face: 0,
      width: 0,
      height: 0,
      drawing: "",
    };
  },
  encode(w: Writer, v: FaceDrawing): void {
    w.u8(v.face);
    w.u16(v.width);
    w.u16(v.height);
    w.string(v.drawing);
  },
  decode(r: Reader): FaceDrawing {
    const face = r.u8();
    const width = r.u16();
    const height = r.u16();
    const drawing = r.string();
    return { face, width, height, drawing };
  },
};

export interface PrimDrawings {
  id: number;
  faces: FaceDrawing[];
}

export const PrimDrawings = {
  create(): PrimDrawings {
    return {
      id: 0,
      faces: [],
    };
  },
  encode(w: Writer, v: PrimDrawings): void {
    w.u32(v.id);
    w.u16(v.faces.length);
    for (const item of v.faces) {
      FaceDrawing.encode(w, item);
    }
  },
  decode(r: Reader): PrimDrawings {
    const id = r.u32();
    const faces: FaceDrawing[] = [];
    for (let n = r.u16(); n > 0 && r.ok; n--) {
      faces.push(FaceDrawing.decode(r));
    }
    return { id, faces };
  },
};

export interface ObjectMove {
  id: number;
  position: Vec3;
  rotation: Quat;
  velocity: Vec3;
  angular_velocity: Vec3;
}

export const ObjectMove = {
  create(): ObjectMove {
    return {
      id: 0,
      position: { x: 0, y: 0, z: 0 },
      rotation: { x: 0, y: 0, z: 0, w: 1 },
      velocity: { x: 0, y: 0, z: 0 },
      angular_velocity: { x: 0, y: 0, z: 0 },
    };
  },
  encode(w: Writer, v: ObjectMove): void {
    w.u32(v.id);
    w.vec3(v.position);
    w.quat(v.rotation);
    w.vec3(v.velocity);
    w.vec3(v.angular_velocity);
  },
  decode(r: Reader): ObjectMove {
    const id = r.u32();
    const position = r.vec3();
    const rotation = r.quat();
    const velocity = r.vec3();
    const angular_velocity = r.vec3();
    return { id, position, rotation, velocity, angular_velocity };
  },
};

export interface AgentPose {
  id: Uuid;
  position: Vec3;
  rotation: Quat;
  velocity: Vec3;
  controls: number;
  animation_state: number;
}

export const AgentPose = {
  create(): AgentPose {
    return {
      id: NULL_UUID,
      position: { x: 0, y: 0, z: 0 },
      rotation: { x: 0, y: 0, z: 0, w: 1 },
      velocity: { x: 0, y: 0, z: 0 },
      controls: 0,
      animation_state: 0,
    };
  },
  encode(w: Writer, v: AgentPose): void {
    w.uuid(v.id);
    w.vec3(v.position);
    w.quat(v.rotation);
    w.vec3(v.velocity);
    w.u32(v.controls);
    w.u8(v.animation_state);
  },
  decode(r: Reader): AgentPose {
    const id = r.uuid();
    const position = r.vec3();
    const rotation = r.quat();
    const velocity = r.vec3();
    const controls = r.u32();
    const animation_state = r.u8();
    return { id, position, rotation, velocity, controls, animation_state };
  },
};

export interface WearableRef {
  slot: WearableSlot;
  item: Uuid;
  asset: Uuid;
}

export const WearableRef = {
  create(): WearableRef {
    return {
      slot: WearableSlot.Shape,
      item: NULL_UUID,
      asset: NULL_UUID,
    };
  },
  encode(w: Writer, v: WearableRef): void {
    w.u8(v.slot);
    w.uuid(v.item);
    w.uuid(v.asset);
  },
  decode(r: Reader): WearableRef {
    const slot = r.enumValue(WEARABLE_SLOT_VALUES, r.u8()) as WearableSlot;
    const item = r.uuid();
    const asset = r.uuid();
    return { slot, item, asset };
  },
};

export interface AttachmentRef {
  item: Uuid;
  object: Uuid;
  point: AttachPoint;
}

export const AttachmentRef = {
  create(): AttachmentRef {
    return {
      item: NULL_UUID,
      object: NULL_UUID,
      point: AttachPoint.None,
    };
  },
  encode(w: Writer, v: AttachmentRef): void {
    w.uuid(v.item);
    w.uuid(v.object);
    w.u8(v.point);
  },
  decode(r: Reader): AttachmentRef {
    const item = r.uuid();
    const object = r.uuid();
    const point = r.enumValue(ATTACH_POINT_VALUES, r.u8()) as AttachPoint;
    return { item, object, point };
  },
};

export interface VisualParam {
  id: number;
  value: number;
}

export const VisualParam = {
  create(): VisualParam {
    return {
      id: 0,
      value: 0,
    };
  },
  encode(w: Writer, v: VisualParam): void {
    w.u16(v.id);
    w.u8(v.value);
  },
  decode(r: Reader): VisualParam {
    const id = r.u16();
    const value = r.u8();
    return { id, value };
  },
};

export interface Appearance {
  params: VisualParam[];
  wearables: WearableRef[];
  attachments: AttachmentRef[];
  height: number;
  hover: number;
  serial: number;
}

export const Appearance = {
  create(): Appearance {
    return {
      params: [],
      wearables: [],
      attachments: [],
      height: 0,
      hover: 0,
      serial: 0,
    };
  },
  encode(w: Writer, v: Appearance): void {
    w.u16(v.params.length);
    for (const item of v.params) {
      VisualParam.encode(w, item);
    }
    w.u16(v.wearables.length);
    for (const item of v.wearables) {
      WearableRef.encode(w, item);
    }
    w.u16(v.attachments.length);
    for (const item of v.attachments) {
      AttachmentRef.encode(w, item);
    }
    w.f32(v.height);
    w.f32(v.hover);
    w.u32(v.serial);
  },
  decode(r: Reader): Appearance {
    const params: VisualParam[] = [];
    for (let n = r.u16(); n > 0 && r.ok; n--) {
      params.push(VisualParam.decode(r));
    }
    const wearables: WearableRef[] = [];
    for (let n = r.u16(); n > 0 && r.ok; n--) {
      wearables.push(WearableRef.decode(r));
    }
    const attachments: AttachmentRef[] = [];
    for (let n = r.u16(); n > 0 && r.ok; n--) {
      attachments.push(AttachmentRef.decode(r));
    }
    const height = r.f32();
    const hover = r.f32();
    const serial = r.u32();
    return { params, wearables, attachments, height, hover, serial };
  },
};

export interface InventoryFolder {
  id: Uuid;
  parent: Uuid;
  name: string;
  kind: AssetKind;
  version: number;
}

export const InventoryFolder = {
  create(): InventoryFolder {
    return {
      id: NULL_UUID,
      parent: NULL_UUID,
      name: "",
      kind: AssetKind.Texture,
      version: 0,
    };
  },
  encode(w: Writer, v: InventoryFolder): void {
    w.uuid(v.id);
    w.uuid(v.parent);
    w.string(v.name);
    w.u8(v.kind);
    w.u32(v.version);
  },
  decode(r: Reader): InventoryFolder {
    const id = r.uuid();
    const parent = r.uuid();
    const name = r.string();
    const kind = r.enumValue(ASSET_KIND_VALUES, r.u8()) as AssetKind;
    const version = r.u32();
    return { id, parent, name, kind, version };
  },
};

export interface InventoryItem {
  id: Uuid;
  parent: Uuid;
  asset: Uuid;
  kind: AssetKind;
  wearable_slot: number;
  name: string;
  description: string;
  permissions: Permissions;
  creator: Uuid;
  owner: Uuid;
  group: Uuid;
  flags: number;
  sale_price: number;
  created_at: bigint;
}

export const InventoryItem = {
  create(): InventoryItem {
    return {
      id: NULL_UUID,
      parent: NULL_UUID,
      asset: NULL_UUID,
      kind: AssetKind.Texture,
      wearable_slot: 0,
      name: "",
      description: "",
      permissions: Permissions.create(),
      creator: NULL_UUID,
      owner: NULL_UUID,
      group: NULL_UUID,
      flags: 0,
      sale_price: 0,
      created_at: 0n,
    };
  },
  encode(w: Writer, v: InventoryItem): void {
    w.uuid(v.id);
    w.uuid(v.parent);
    w.uuid(v.asset);
    w.u8(v.kind);
    w.u8(v.wearable_slot);
    w.string(v.name);
    w.string(v.description);
    Permissions.encode(w, v.permissions);
    w.uuid(v.creator);
    w.uuid(v.owner);
    w.uuid(v.group);
    w.u32(v.flags);
    w.i32(v.sale_price);
    w.u64(v.created_at);
  },
  decode(r: Reader): InventoryItem {
    const id = r.uuid();
    const parent = r.uuid();
    const asset = r.uuid();
    const kind = r.enumValue(ASSET_KIND_VALUES, r.u8()) as AssetKind;
    const wearable_slot = r.u8();
    const name = r.string();
    const description = r.string();
    const permissions = Permissions.decode(r);
    const creator = r.uuid();
    const owner = r.uuid();
    const group = r.uuid();
    const flags = r.u32();
    const sale_price = r.i32();
    const created_at = r.u64();
    return { id, parent, asset, kind, wearable_slot, name, description, permissions, creator, owner, group, flags, sale_price, created_at };
  },
};

export interface ParcelInfo {
  id: number;
  uuid: Uuid;
  name: string;
  description: string;
  owner: Uuid;
  group: Uuid;
  area: number;
  flags: number;
  sale_price: number;
  max_objects: number;
  object_count: number;
  music_url: string;
  media_url: string;
  landing: Vec3;
  maturity: Maturity;
  dwell: number;
  claim_date: bigint;
  snapshot: Uuid;
  auction_ends: bigint;
  auction_bid: number;
  auction_bidder: Uuid;
  auction_start_price: number;
  experiences_allowed: Uuid[];
  experiences_blocked: Uuid[];
}

export const ParcelInfo = {
  create(): ParcelInfo {
    return {
      id: 0,
      uuid: NULL_UUID,
      name: "",
      description: "",
      owner: NULL_UUID,
      group: NULL_UUID,
      area: 0,
      flags: 0,
      sale_price: 0,
      max_objects: 0,
      object_count: 0,
      music_url: "",
      media_url: "",
      landing: { x: 0, y: 0, z: 0 },
      maturity: Maturity.General,
      dwell: 0,
      claim_date: 0n,
      snapshot: NULL_UUID,
      auction_ends: 0n,
      auction_bid: 0,
      auction_bidder: NULL_UUID,
      auction_start_price: 0,
      experiences_allowed: [],
      experiences_blocked: [],
    };
  },
  encode(w: Writer, v: ParcelInfo): void {
    w.u32(v.id);
    w.uuid(v.uuid);
    w.string(v.name);
    w.string(v.description);
    w.uuid(v.owner);
    w.uuid(v.group);
    w.u32(v.area);
    w.u32(v.flags);
    w.i32(v.sale_price);
    w.u32(v.max_objects);
    w.u32(v.object_count);
    w.string(v.music_url);
    w.string(v.media_url);
    w.vec3(v.landing);
    w.u8(v.maturity);
    w.f32(v.dwell);
    w.u64(v.claim_date);
    w.uuid(v.snapshot);
    w.u64(v.auction_ends);
    w.u32(v.auction_bid);
    w.uuid(v.auction_bidder);
    w.u32(v.auction_start_price);
    w.u16(v.experiences_allowed.length);
    for (const item of v.experiences_allowed) {
      w.uuid(item);
    }
    w.u16(v.experiences_blocked.length);
    for (const item of v.experiences_blocked) {
      w.uuid(item);
    }
  },
  decode(r: Reader): ParcelInfo {
    const id = r.u32();
    const uuid = r.uuid();
    const name = r.string();
    const description = r.string();
    const owner = r.uuid();
    const group = r.uuid();
    const area = r.u32();
    const flags = r.u32();
    const sale_price = r.i32();
    const max_objects = r.u32();
    const object_count = r.u32();
    const music_url = r.string();
    const media_url = r.string();
    const landing = r.vec3();
    const maturity = r.enumValue(MATURITY_VALUES, r.u8()) as Maturity;
    const dwell = r.f32();
    const claim_date = r.u64();
    const snapshot = r.uuid();
    const auction_ends = r.u64();
    const auction_bid = r.u32();
    const auction_bidder = r.uuid();
    const auction_start_price = r.u32();
    const experiences_allowed: Uuid[] = [];
    for (let n = r.u16(); n > 0 && r.ok; n--) {
      experiences_allowed.push(r.uuid());
    }
    const experiences_blocked: Uuid[] = [];
    for (let n = r.u16(); n > 0 && r.ok; n--) {
      experiences_blocked.push(r.uuid());
    }
    return { id, uuid, name, description, owner, group, area, flags, sale_price, max_objects, object_count, music_url, media_url, landing, maturity, dwell, claim_date, snapshot, auction_ends, auction_bid, auction_bidder, auction_start_price, experiences_allowed, experiences_blocked };
  },
};

export interface SkySettings {
  name: string;
  sun_direction: Vec3;
  sun_color: Color;
  sun_intensity: number;
  moon_direction: Vec3;
  moon_brightness: number;
  ambient: Color;
  horizon: Color;
  zenith: Color;
  haze_density: number;
  haze_horizon: number;
  density_multiplier: number;
  distance_multiplier: number;
  max_altitude: number;
  cloud_color: Color;
  cloud_coverage: number;
  cloud_scale: number;
  cloud_density: Vec3;
  cloud_detail: Vec3;
  cloud_scroll: Vec2;
  cloud_texture: Uuid;
  star_brightness: number;
  gamma: number;
  exposure: number;
  sun_scale: number;
  sun_glow: number;
  moon_scale: number;
  meteor_rate: number;
  real_moon: boolean;
}

export const SkySettings = {
  create(): SkySettings {
    return {
      name: "",
      sun_direction: { x: 0, y: 0, z: 0 },
      sun_color: { r: 255, g: 255, b: 255, a: 255 },
      sun_intensity: 0,
      moon_direction: { x: 0, y: 0, z: 0 },
      moon_brightness: 0,
      ambient: { r: 255, g: 255, b: 255, a: 255 },
      horizon: { r: 255, g: 255, b: 255, a: 255 },
      zenith: { r: 255, g: 255, b: 255, a: 255 },
      haze_density: 0,
      haze_horizon: 0,
      density_multiplier: 0,
      distance_multiplier: 0,
      max_altitude: 0,
      cloud_color: { r: 255, g: 255, b: 255, a: 255 },
      cloud_coverage: 0,
      cloud_scale: 0,
      cloud_density: { x: 0, y: 0, z: 0 },
      cloud_detail: { x: 0, y: 0, z: 0 },
      cloud_scroll: { x: 0, y: 0 },
      cloud_texture: NULL_UUID,
      star_brightness: 0,
      gamma: 0,
      exposure: 0,
      sun_scale: 1,
      sun_glow: 1,
      moon_scale: 1,
      meteor_rate: 1,
      real_moon: false,
    };
  },
  encode(w: Writer, v: SkySettings): void {
    w.string(v.name);
    w.vec3(v.sun_direction);
    w.color(v.sun_color);
    w.f32(v.sun_intensity);
    w.vec3(v.moon_direction);
    w.f32(v.moon_brightness);
    w.color(v.ambient);
    w.color(v.horizon);
    w.color(v.zenith);
    w.f32(v.haze_density);
    w.f32(v.haze_horizon);
    w.f32(v.density_multiplier);
    w.f32(v.distance_multiplier);
    w.f32(v.max_altitude);
    w.color(v.cloud_color);
    w.f32(v.cloud_coverage);
    w.f32(v.cloud_scale);
    w.vec3(v.cloud_density);
    w.vec3(v.cloud_detail);
    w.vec2(v.cloud_scroll);
    w.uuid(v.cloud_texture);
    w.f32(v.star_brightness);
    w.f32(v.gamma);
    w.f32(v.exposure);
    w.f32(v.sun_scale);
    w.f32(v.sun_glow);
    w.f32(v.moon_scale);
    w.f32(v.meteor_rate);
    w.bool(v.real_moon);
  },
  decode(r: Reader): SkySettings {
    const name = r.string();
    const sun_direction = r.vec3();
    const sun_color = r.color();
    const sun_intensity = r.f32();
    const moon_direction = r.vec3();
    const moon_brightness = r.f32();
    const ambient = r.color();
    const horizon = r.color();
    const zenith = r.color();
    const haze_density = r.f32();
    const haze_horizon = r.f32();
    const density_multiplier = r.f32();
    const distance_multiplier = r.f32();
    const max_altitude = r.f32();
    const cloud_color = r.color();
    const cloud_coverage = r.f32();
    const cloud_scale = r.f32();
    const cloud_density = r.vec3();
    const cloud_detail = r.vec3();
    const cloud_scroll = r.vec2();
    const cloud_texture = r.uuid();
    const star_brightness = r.f32();
    const gamma = r.f32();
    const exposure = r.f32();
    const sun_scale = r.f32();
    const sun_glow = r.f32();
    const moon_scale = r.f32();
    const meteor_rate = r.f32();
    const real_moon = r.bool();
    return { name, sun_direction, sun_color, sun_intensity, moon_direction, moon_brightness, ambient, horizon, zenith, haze_density, haze_horizon, density_multiplier, distance_multiplier, max_altitude, cloud_color, cloud_coverage, cloud_scale, cloud_density, cloud_detail, cloud_scroll, cloud_texture, star_brightness, gamma, exposure, sun_scale, sun_glow, moon_scale, meteor_rate, real_moon };
  },
};

export interface WaterSettings {
  name: string;
  color: Color;
  fog_density: number;
  fresnel_scale: number;
  fresnel_offset: number;
  wave_amplitude: number;
  wave_direction: Vec2;
  ripple_direction: Vec2;
  wave_speed: number;
  choppiness: number;
  normal_map: Uuid;
  normal_scale: Vec3;
  blur_multiplier: number;
  refraction_scale_above: number;
  refraction_scale_below: number;
  underwater_fog_mod: number;
}

export const WaterSettings = {
  create(): WaterSettings {
    return {
      name: "",
      color: { r: 255, g: 255, b: 255, a: 255 },
      fog_density: 0,
      fresnel_scale: 0,
      fresnel_offset: 0,
      wave_amplitude: 0,
      wave_direction: { x: 0, y: 0 },
      ripple_direction: { x: 0, y: 0 },
      wave_speed: 0,
      choppiness: 0,
      normal_map: NULL_UUID,
      normal_scale: { x: 0, y: 0, z: 0 },
      blur_multiplier: 0,
      refraction_scale_above: 0,
      refraction_scale_below: 0,
      underwater_fog_mod: 0,
    };
  },
  encode(w: Writer, v: WaterSettings): void {
    w.string(v.name);
    w.color(v.color);
    w.f32(v.fog_density);
    w.f32(v.fresnel_scale);
    w.f32(v.fresnel_offset);
    w.f32(v.wave_amplitude);
    w.vec2(v.wave_direction);
    w.vec2(v.ripple_direction);
    w.f32(v.wave_speed);
    w.f32(v.choppiness);
    w.uuid(v.normal_map);
    w.vec3(v.normal_scale);
    w.f32(v.blur_multiplier);
    w.f32(v.refraction_scale_above);
    w.f32(v.refraction_scale_below);
    w.f32(v.underwater_fog_mod);
  },
  decode(r: Reader): WaterSettings {
    const name = r.string();
    const color = r.color();
    const fog_density = r.f32();
    const fresnel_scale = r.f32();
    const fresnel_offset = r.f32();
    const wave_amplitude = r.f32();
    const wave_direction = r.vec2();
    const ripple_direction = r.vec2();
    const wave_speed = r.f32();
    const choppiness = r.f32();
    const normal_map = r.uuid();
    const normal_scale = r.vec3();
    const blur_multiplier = r.f32();
    const refraction_scale_above = r.f32();
    const refraction_scale_below = r.f32();
    const underwater_fog_mod = r.f32();
    return { name, color, fog_density, fresnel_scale, fresnel_offset, wave_amplitude, wave_direction, ripple_direction, wave_speed, choppiness, normal_map, normal_scale, blur_multiplier, refraction_scale_above, refraction_scale_below, underwater_fog_mod };
  },
};

export interface DayKeyframe {
  time: number;
  sky: Uuid;
  water: Uuid;
}

export const DayKeyframe = {
  create(): DayKeyframe {
    return {
      time: 0,
      sky: NULL_UUID,
      water: NULL_UUID,
    };
  },
  encode(w: Writer, v: DayKeyframe): void {
    w.f32(v.time);
    w.uuid(v.sky);
    w.uuid(v.water);
  },
  decode(r: Reader): DayKeyframe {
    const time = r.f32();
    const sky = r.uuid();
    const water = r.uuid();
    return { time, sky, water };
  },
};

export interface RegionSummary {
  id: Uuid;
  name: string;
  grid_x: number;
  grid_y: number;
  size_x: number;
  size_y: number;
  endpoint: Endpoint;
  maturity: Maturity;
  agents: number;
  map_tile: Uuid;
  online: boolean;
}

export const RegionSummary = {
  create(): RegionSummary {
    return {
      id: NULL_UUID,
      name: "",
      grid_x: 0,
      grid_y: 0,
      size_x: 0,
      size_y: 0,
      endpoint: Endpoint.create(),
      maturity: Maturity.General,
      agents: 0,
      map_tile: NULL_UUID,
      online: false,
    };
  },
  encode(w: Writer, v: RegionSummary): void {
    w.uuid(v.id);
    w.string(v.name);
    w.u32(v.grid_x);
    w.u32(v.grid_y);
    w.u16(v.size_x);
    w.u16(v.size_y);
    Endpoint.encode(w, v.endpoint);
    w.u8(v.maturity);
    w.u16(v.agents);
    w.uuid(v.map_tile);
    w.bool(v.online);
  },
  decode(r: Reader): RegionSummary {
    const id = r.uuid();
    const name = r.string();
    const grid_x = r.u32();
    const grid_y = r.u32();
    const size_x = r.u16();
    const size_y = r.u16();
    const endpoint = Endpoint.decode(r);
    const maturity = r.enumValue(MATURITY_VALUES, r.u8()) as Maturity;
    const agents = r.u16();
    const map_tile = r.uuid();
    const online = r.bool();
    return { id, name, grid_x, grid_y, size_x, size_y, endpoint, maturity, agents, map_tile, online };
  },
};

export interface MapAgentDot {
  position: Vec3;
  count: number;
}

export const MapAgentDot = {
  create(): MapAgentDot {
    return {
      position: { x: 0, y: 0, z: 0 },
      count: 0,
    };
  },
  encode(w: Writer, v: MapAgentDot): void {
    w.vec3(v.position);
    w.u16(v.count);
  },
  decode(r: Reader): MapAgentDot {
    const position = r.vec3();
    const count = r.u16();
    return { position, count };
  },
};

export interface GridBox {
  min_x: number;
  min_y: number;
  max_x: number;
  max_y: number;
}

export const GridBox = {
  create(): GridBox {
    return {
      min_x: 0,
      min_y: 0,
      max_x: 0,
      max_y: 0,
    };
  },
  encode(w: Writer, v: GridBox): void {
    w.u32(v.min_x);
    w.u32(v.min_y);
    w.u32(v.max_x);
    w.u32(v.max_y);
  },
  decode(r: Reader): GridBox {
    const min_x = r.u32();
    const min_y = r.u32();
    const max_x = r.u32();
    const max_y = r.u32();
    return { min_x, min_y, max_x, max_y };
  },
};

export interface AgentName {
  id: Uuid;
  username: string;
  display_name: string;
}

export const AgentName = {
  create(): AgentName {
    return {
      id: NULL_UUID,
      username: "",
      display_name: "",
    };
  },
  encode(w: Writer, v: AgentName): void {
    w.uuid(v.id);
    w.string(v.username);
    w.string(v.display_name);
  },
  decode(r: Reader): AgentName {
    const id = r.uuid();
    const username = r.string();
    const display_name = r.string();
    return { id, username, display_name };
  },
};

export interface FriendInfo {
  id: Uuid;
  username: string;
  display_name: string;
  presence: FriendPresence;
  rights_given: number;
  rights_received: number;
}

export const FriendInfo = {
  create(): FriendInfo {
    return {
      id: NULL_UUID,
      username: "",
      display_name: "",
      presence: FriendPresence.Offline,
      rights_given: 0,
      rights_received: 0,
    };
  },
  encode(w: Writer, v: FriendInfo): void {
    w.uuid(v.id);
    w.string(v.username);
    w.string(v.display_name);
    w.u8(v.presence);
    w.u8(v.rights_given);
    w.u8(v.rights_received);
  },
  decode(r: Reader): FriendInfo {
    const id = r.uuid();
    const username = r.string();
    const display_name = r.string();
    const presence = r.enumValue(FRIEND_PRESENCE_VALUES, r.u8()) as FriendPresence;
    const rights_given = r.u8();
    const rights_received = r.u8();
    return { id, username, display_name, presence, rights_given, rights_received };
  },
};

export interface GroupInfo {
  id: Uuid;
  name: string;
  charter: string;
  insignia: Uuid;
  founder: Uuid;
  member_count: number;
  open_enrollment: boolean;
  fee: number;
  show_in_list: boolean;
  maturity: Maturity;
}

export const GroupInfo = {
  create(): GroupInfo {
    return {
      id: NULL_UUID,
      name: "",
      charter: "",
      insignia: NULL_UUID,
      founder: NULL_UUID,
      member_count: 0,
      open_enrollment: false,
      fee: 0,
      show_in_list: false,
      maturity: Maturity.General,
    };
  },
  encode(w: Writer, v: GroupInfo): void {
    w.uuid(v.id);
    w.string(v.name);
    w.string(v.charter);
    w.uuid(v.insignia);
    w.uuid(v.founder);
    w.u32(v.member_count);
    w.bool(v.open_enrollment);
    w.i32(v.fee);
    w.bool(v.show_in_list);
    w.u8(v.maturity);
  },
  decode(r: Reader): GroupInfo {
    const id = r.uuid();
    const name = r.string();
    const charter = r.string();
    const insignia = r.uuid();
    const founder = r.uuid();
    const member_count = r.u32();
    const open_enrollment = r.bool();
    const fee = r.i32();
    const show_in_list = r.bool();
    const maturity = r.enumValue(MATURITY_VALUES, r.u8()) as Maturity;
    return { id, name, charter, insignia, founder, member_count, open_enrollment, fee, show_in_list, maturity };
  },
};

export interface GroupMemberInfo {
  agent: Uuid;
  name: string;
  title: string;
  powers: bigint;
  online: boolean;
  contribution: number;
}

export const GroupMemberInfo = {
  create(): GroupMemberInfo {
    return {
      agent: NULL_UUID,
      name: "",
      title: "",
      powers: 0n,
      online: false,
      contribution: 0,
    };
  },
  encode(w: Writer, v: GroupMemberInfo): void {
    w.uuid(v.agent);
    w.string(v.name);
    w.string(v.title);
    w.u64(v.powers);
    w.bool(v.online);
    w.i32(v.contribution);
  },
  decode(r: Reader): GroupMemberInfo {
    const agent = r.uuid();
    const name = r.string();
    const title = r.string();
    const powers = r.u64();
    const online = r.bool();
    const contribution = r.i32();
    return { agent, name, title, powers, online, contribution };
  },
};

export interface GroupRoleInfo {
  id: Uuid;
  name: string;
  title: string;
  description: string;
  powers: bigint;
  member_count: number;
}

export const GroupRoleInfo = {
  create(): GroupRoleInfo {
    return {
      id: NULL_UUID,
      name: "",
      title: "",
      description: "",
      powers: 0n,
      member_count: 0,
    };
  },
  encode(w: Writer, v: GroupRoleInfo): void {
    w.uuid(v.id);
    w.string(v.name);
    w.string(v.title);
    w.string(v.description);
    w.u64(v.powers);
    w.u32(v.member_count);
  },
  decode(r: Reader): GroupRoleInfo {
    const id = r.uuid();
    const name = r.string();
    const title = r.string();
    const description = r.string();
    const powers = r.u64();
    const member_count = r.u32();
    return { id, name, title, description, powers, member_count };
  },
};

export interface GroupNoticeInfo {
  id: Uuid;
  subject: string;
  body: string;
  from: string;
  timestamp: bigint;
  attachment: Uuid;
  attachment_kind: AssetKind;
}

export const GroupNoticeInfo = {
  create(): GroupNoticeInfo {
    return {
      id: NULL_UUID,
      subject: "",
      body: "",
      from: "",
      timestamp: 0n,
      attachment: NULL_UUID,
      attachment_kind: AssetKind.Texture,
    };
  },
  encode(w: Writer, v: GroupNoticeInfo): void {
    w.uuid(v.id);
    w.string(v.subject);
    w.string(v.body);
    w.string(v.from);
    w.u64(v.timestamp);
    w.uuid(v.attachment);
    w.u8(v.attachment_kind);
  },
  decode(r: Reader): GroupNoticeInfo {
    const id = r.uuid();
    const subject = r.string();
    const body = r.string();
    const from = r.string();
    const timestamp = r.u64();
    const attachment = r.uuid();
    const attachment_kind = r.enumValue(ASSET_KIND_VALUES, r.u8()) as AssetKind;
    return { id, subject, body, from, timestamp, attachment, attachment_kind };
  },
};

export interface ScriptError {
  object: number;
  item: Uuid;
  line: number;
  message: string;
}

export const ScriptError = {
  create(): ScriptError {
    return {
      object: 0,
      item: NULL_UUID,
      line: 0,
      message: "",
    };
  },
  encode(w: Writer, v: ScriptError): void {
    w.u32(v.object);
    w.uuid(v.item);
    w.u32(v.line);
    w.string(v.message);
  },
  decode(r: Reader): ScriptError {
    const object = r.u32();
    const item = r.uuid();
    const line = r.u32();
    const message = r.string();
    return { object, item, line, message };
  },
};

export interface EstateInfo {
  id: number;
  name: string;
  owner: Uuid;
  managers: Uuid[];
  moderators: Uuid[];
  flags: number;
  sun_hour: number;
  covenant: string;
  experiences_allowed: Uuid[];
  experiences_blocked: Uuid[];
}

export const EstateInfo = {
  create(): EstateInfo {
    return {
      id: 0,
      name: "",
      owner: NULL_UUID,
      managers: [],
      moderators: [],
      flags: 0,
      sun_hour: 0,
      covenant: "",
      experiences_allowed: [],
      experiences_blocked: [],
    };
  },
  encode(w: Writer, v: EstateInfo): void {
    w.u32(v.id);
    w.string(v.name);
    w.uuid(v.owner);
    w.u16(v.managers.length);
    for (const item of v.managers) {
      w.uuid(item);
    }
    w.u16(v.moderators.length);
    for (const item of v.moderators) {
      w.uuid(item);
    }
    w.u32(v.flags);
    w.f32(v.sun_hour);
    w.string(v.covenant);
    w.u16(v.experiences_allowed.length);
    for (const item of v.experiences_allowed) {
      w.uuid(item);
    }
    w.u16(v.experiences_blocked.length);
    for (const item of v.experiences_blocked) {
      w.uuid(item);
    }
  },
  decode(r: Reader): EstateInfo {
    const id = r.u32();
    const name = r.string();
    const owner = r.uuid();
    const managers: Uuid[] = [];
    for (let n = r.u16(); n > 0 && r.ok; n--) {
      managers.push(r.uuid());
    }
    const moderators: Uuid[] = [];
    for (let n = r.u16(); n > 0 && r.ok; n--) {
      moderators.push(r.uuid());
    }
    const flags = r.u32();
    const sun_hour = r.f32();
    const covenant = r.string();
    const experiences_allowed: Uuid[] = [];
    for (let n = r.u16(); n > 0 && r.ok; n--) {
      experiences_allowed.push(r.uuid());
    }
    const experiences_blocked: Uuid[] = [];
    for (let n = r.u16(); n > 0 && r.ok; n--) {
      experiences_blocked.push(r.uuid());
    }
    return { id, name, owner, managers, moderators, flags, sun_hour, covenant, experiences_allowed, experiences_blocked };
  },
};

export interface ViewDefaults {
  draw_distance: number;
  max_avatars: number;
}

export const ViewDefaults = {
  create(): ViewDefaults {
    return {
      draw_distance: 0,
      max_avatars: 0,
    };
  },
  encode(w: Writer, v: ViewDefaults): void {
    w.u16(v.draw_distance);
    w.u16(v.max_avatars);
  },
  decode(r: Reader): ViewDefaults {
    const draw_distance = r.u16();
    const max_avatars = r.u16();
    return { draw_distance, max_avatars };
  },
};

export interface TerrainTextures {
  layers: Uuid[];
  heights: number[];
  ranges: number[];
}

export const TerrainTextures = {
  create(): TerrainTextures {
    return {
      layers: Array.from({ length: 4 }, () => NULL_UUID),
      heights: Array.from({ length: 4 }, () => 0),
      ranges: Array.from({ length: 4 }, () => 0),
    };
  },
  encode(w: Writer, v: TerrainTextures): void {
    for (let i = 0; i < 4; i++) {
      w.uuid(v.layers[i]);
    }
    for (let i = 0; i < 4; i++) {
      w.f32(v.heights[i]);
    }
    for (let i = 0; i < 4; i++) {
      w.f32(v.ranges[i]);
    }
  },
  decode(r: Reader): TerrainTextures {
    const layers: Uuid[] = [];
    for (let i = 0; i < 4; i++) {
      layers.push(r.uuid());
    }
    const heights: number[] = [];
    for (let i = 0; i < 4; i++) {
      heights.push(r.f32());
    }
    const ranges: number[] = [];
    for (let i = 0; i < 4; i++) {
      ranges.push(r.f32());
    }
    return { layers, heights, ranges };
  },
};

export interface TerrainBands {
  layers: Uuid[];
  heights: number[];
  blend: number;
}

export const TerrainBands = {
  create(): TerrainBands {
    return {
      layers: [],
      heights: [],
      blend: 0,
    };
  },
  encode(w: Writer, v: TerrainBands): void {
    w.u16(v.layers.length);
    for (const item of v.layers) {
      w.uuid(item);
    }
    w.u16(v.heights.length);
    for (const item of v.heights) {
      w.f32(item);
    }
    w.f32(v.blend);
  },
  decode(r: Reader): TerrainBands {
    const layers: Uuid[] = [];
    for (let n = r.u16(); n > 0 && r.ok; n--) {
      layers.push(r.uuid());
    }
    const heights: number[] = [];
    for (let n = r.u16(); n > 0 && r.ok; n--) {
      heights.push(r.f32());
    }
    const blend = r.f32();
    return { layers, heights, blend };
  },
};

export interface DetectedInfo {
  id: Uuid;
  name: string;
  position: Vec3;
  rotation: Quat;
  velocity: Vec3;
  is_agent: boolean;
  owner: Uuid;
}

export const DetectedInfo = {
  create(): DetectedInfo {
    return {
      id: NULL_UUID,
      name: "",
      position: { x: 0, y: 0, z: 0 },
      rotation: { x: 0, y: 0, z: 0, w: 1 },
      velocity: { x: 0, y: 0, z: 0 },
      is_agent: false,
      owner: NULL_UUID,
    };
  },
  encode(w: Writer, v: DetectedInfo): void {
    w.uuid(v.id);
    w.string(v.name);
    w.vec3(v.position);
    w.quat(v.rotation);
    w.vec3(v.velocity);
    w.bool(v.is_agent);
    w.uuid(v.owner);
  },
  decode(r: Reader): DetectedInfo {
    const id = r.uuid();
    const name = r.string();
    const position = r.vec3();
    const rotation = r.quat();
    const velocity = r.vec3();
    const is_agent = r.bool();
    const owner = r.uuid();
    return { id, name, position, rotation, velocity, is_agent, owner };
  },
};

export interface SessionStats {
  fps: number;
  ping_ms: number;
  bandwidth_in: number;
  bandwidth_out: number;
  packet_loss: number;
}

export const SessionStats = {
  create(): SessionStats {
    return {
      fps: 0,
      ping_ms: 0,
      bandwidth_in: 0,
      bandwidth_out: 0,
      packet_loss: 0,
    };
  },
  encode(w: Writer, v: SessionStats): void {
    w.f32(v.fps);
    w.f32(v.ping_ms);
    w.u32(v.bandwidth_in);
    w.u32(v.bandwidth_out);
    w.f32(v.packet_loss);
  },
  decode(r: Reader): SessionStats {
    const fps = r.f32();
    const ping_ms = r.f32();
    const bandwidth_in = r.u32();
    const bandwidth_out = r.u32();
    const packet_loss = r.f32();
    return { fps, ping_ms, bandwidth_in, bandwidth_out, packet_loss };
  },
};

export interface RegionStats {
  sim_fps: number;
  physics_fps: number;
  frame_ms: number;
  physics_ms: number;
  script_ms: number;
  net_ms: number;
  agents: number;
  child_agents: number;
  objects: number;
  active_objects: number;
  scripts: number;
  active_scripts: number;
  script_events_per_sec: number;
  packets_in: number;
  packets_out: number;
  pending_downloads: number;
  pending_uploads: number;
  unacked_bytes: number;
  time_dilation: number;
  memory_mb: number;
  uptime_seconds: bigint;
}

export const RegionStats = {
  create(): RegionStats {
    return {
      sim_fps: 0,
      physics_fps: 0,
      frame_ms: 0,
      physics_ms: 0,
      script_ms: 0,
      net_ms: 0,
      agents: 0,
      child_agents: 0,
      objects: 0,
      active_objects: 0,
      scripts: 0,
      active_scripts: 0,
      script_events_per_sec: 0,
      packets_in: 0,
      packets_out: 0,
      pending_downloads: 0,
      pending_uploads: 0,
      unacked_bytes: 0,
      time_dilation: 0,
      memory_mb: 0,
      uptime_seconds: 0n,
    };
  },
  encode(w: Writer, v: RegionStats): void {
    w.f32(v.sim_fps);
    w.f32(v.physics_fps);
    w.f32(v.frame_ms);
    w.f32(v.physics_ms);
    w.f32(v.script_ms);
    w.f32(v.net_ms);
    w.u16(v.agents);
    w.u16(v.child_agents);
    w.u32(v.objects);
    w.u32(v.active_objects);
    w.u32(v.scripts);
    w.u32(v.active_scripts);
    w.f32(v.script_events_per_sec);
    w.u32(v.packets_in);
    w.u32(v.packets_out);
    w.u32(v.pending_downloads);
    w.u32(v.pending_uploads);
    w.u32(v.unacked_bytes);
    w.f32(v.time_dilation);
    w.f32(v.memory_mb);
    w.u64(v.uptime_seconds);
  },
  decode(r: Reader): RegionStats {
    const sim_fps = r.f32();
    const physics_fps = r.f32();
    const frame_ms = r.f32();
    const physics_ms = r.f32();
    const script_ms = r.f32();
    const net_ms = r.f32();
    const agents = r.u16();
    const child_agents = r.u16();
    const objects = r.u32();
    const active_objects = r.u32();
    const scripts = r.u32();
    const active_scripts = r.u32();
    const script_events_per_sec = r.f32();
    const packets_in = r.u32();
    const packets_out = r.u32();
    const pending_downloads = r.u32();
    const pending_uploads = r.u32();
    const unacked_bytes = r.u32();
    const time_dilation = r.f32();
    const memory_mb = r.f32();
    const uptime_seconds = r.u64();
    return { sim_fps, physics_fps, frame_ms, physics_ms, script_ms, net_ms, agents, child_agents, objects, active_objects, scripts, active_scripts, script_events_per_sec, packets_in, packets_out, pending_downloads, pending_uploads, unacked_bytes, time_dilation, memory_mb, uptime_seconds };
  },
};

export interface TextureEntryFace {
  face: number;
  material: FaceMaterial;
}

export const TextureEntryFace = {
  create(): TextureEntryFace {
    return {
      face: 0,
      material: FaceMaterial.create(),
    };
  },
  encode(w: Writer, v: TextureEntryFace): void {
    w.u8(v.face);
    FaceMaterial.encode(w, v.material);
  },
  decode(r: Reader): TextureEntryFace {
    const face = r.u8();
    const material = FaceMaterial.decode(r);
    return { face, material };
  },
};

export interface MediaEntry {
  face: number;
  url: string;
  width: number;
  height: number;
  autoplay: boolean;
  autoscale: boolean;
  autoloop: boolean;
}

export const MediaEntry = {
  create(): MediaEntry {
    return {
      face: 0,
      url: "",
      width: 0,
      height: 0,
      autoplay: false,
      autoscale: false,
      autoloop: false,
    };
  },
  encode(w: Writer, v: MediaEntry): void {
    w.u8(v.face);
    w.string(v.url);
    w.u16(v.width);
    w.u16(v.height);
    w.bool(v.autoplay);
    w.bool(v.autoscale);
    w.bool(v.autoloop);
  },
  decode(r: Reader): MediaEntry {
    const face = r.u8();
    const url = r.string();
    const width = r.u16();
    const height = r.u16();
    const autoplay = r.bool();
    const autoscale = r.bool();
    const autoloop = r.bool();
    return { face, url, width, height, autoplay, autoscale, autoloop };
  },
};

export interface ScriptPanelControl {
  id: string;
  kind: number;
  label: string;
  options: string[];
  value: number;
  min: number;
  max: number;
}

export const ScriptPanelControl = {
  create(): ScriptPanelControl {
    return {
      id: "",
      kind: 0,
      label: "",
      options: [],
      value: 0,
      min: 0,
      max: 0,
    };
  },
  encode(w: Writer, v: ScriptPanelControl): void {
    w.string(v.id);
    w.u8(v.kind);
    w.string(v.label);
    w.u16(v.options.length);
    for (const item of v.options) {
      w.string(item);
    }
    w.f32(v.value);
    w.f32(v.min);
    w.f32(v.max);
  },
  decode(r: Reader): ScriptPanelControl {
    const id = r.string();
    const kind = r.u8();
    const label = r.string();
    const options: string[] = [];
    for (let n = r.u16(); n > 0 && r.ok; n--) {
      options.push(r.string());
    }
    const value = r.f32();
    const min = r.f32();
    const max = r.f32();
    return { id, kind, label, options, value, min, max };
  },
};

export interface MapItem {
  kind: MapItemKind;
  id: Uuid;
  region_id: Uuid;
  position: Vec3;
  name: string;
  price: number;
  area: number;
  when: bigint;
  maturity: Maturity;
}

export const MapItem = {
  create(): MapItem {
    return {
      kind: MapItemKind.Telehub,
      id: NULL_UUID,
      region_id: NULL_UUID,
      position: { x: 0, y: 0, z: 0 },
      name: "",
      price: 0,
      area: 0,
      when: 0n,
      maturity: Maturity.General,
    };
  },
  encode(w: Writer, v: MapItem): void {
    w.u8(v.kind);
    w.uuid(v.id);
    w.uuid(v.region_id);
    w.vec3(v.position);
    w.string(v.name);
    w.i32(v.price);
    w.u32(v.area);
    w.u64(v.when);
    w.u8(v.maturity);
  },
  decode(r: Reader): MapItem {
    const kind = r.enumValue(MAP_ITEM_KIND_VALUES, r.u8()) as MapItemKind;
    const id = r.uuid();
    const region_id = r.uuid();
    const position = r.vec3();
    const name = r.string();
    const price = r.i32();
    const area = r.u32();
    const when = r.u64();
    const maturity = r.enumValue(MATURITY_VALUES, r.u8()) as Maturity;
    return { kind, id, region_id, position, name, price, area, when, maturity };
  },
};

export interface SearchResult {
  id: Uuid;
  name: string;
  description: string;
  region: string;
  position: Vec3;
  image: Uuid;
  online: boolean;
  owner: Uuid;
  owner_name: string;
  when: bigint;
  detail: string;
  rating: number;
}

export const SearchResult = {
  create(): SearchResult {
    return {
      id: NULL_UUID,
      name: "",
      description: "",
      region: "",
      position: { x: 0, y: 0, z: 0 },
      image: NULL_UUID,
      online: false,
      owner: NULL_UUID,
      owner_name: "",
      when: 0n,
      detail: "",
      rating: 0,
    };
  },
  encode(w: Writer, v: SearchResult): void {
    w.uuid(v.id);
    w.string(v.name);
    w.string(v.description);
    w.string(v.region);
    w.vec3(v.position);
    w.uuid(v.image);
    w.bool(v.online);
    w.uuid(v.owner);
    w.string(v.owner_name);
    w.u64(v.when);
    w.string(v.detail);
    w.u8(v.rating);
  },
  decode(r: Reader): SearchResult {
    const id = r.uuid();
    const name = r.string();
    const description = r.string();
    const region = r.string();
    const position = r.vec3();
    const image = r.uuid();
    const online = r.bool();
    const owner = r.uuid();
    const owner_name = r.string();
    const when = r.u64();
    const detail = r.string();
    const rating = r.u8();
    return { id, name, description, region, position, image, online, owner, owner_name, when, detail, rating };
  },
};

export interface VoiceSlot {
  mid: string;
  agent: Uuid;
}

export const VoiceSlot = {
  create(): VoiceSlot {
    return {
      mid: "",
      agent: NULL_UUID,
    };
  },
  encode(w: Writer, v: VoiceSlot): void {
    w.string(v.mid);
    w.uuid(v.agent);
  },
  decode(r: Reader): VoiceSlot {
    const mid = r.string();
    const agent = r.uuid();
    return { mid, agent };
  },
};

export interface VoiceLevel {
  agent: Uuid;
  level: number;
}

export const VoiceLevel = {
  create(): VoiceLevel {
    return {
      agent: NULL_UUID,
      level: 0,
    };
  },
  encode(w: Writer, v: VoiceLevel): void {
    w.uuid(v.agent);
    w.u8(v.level);
  },
  decode(r: Reader): VoiceLevel {
    const agent = r.uuid();
    const level = r.u8();
    return { agent, level };
  },
};

export interface ExperienceInfo {
  id: Uuid;
  name: string;
  description: string;
  owner: Uuid;
  contributors: Uuid[];
  grid_wide: boolean;
  suspended: boolean;
  created_at: bigint;
}

export const ExperienceInfo = {
  create(): ExperienceInfo {
    return {
      id: NULL_UUID,
      name: "",
      description: "",
      owner: NULL_UUID,
      contributors: [],
      grid_wide: false,
      suspended: false,
      created_at: 0n,
    };
  },
  encode(w: Writer, v: ExperienceInfo): void {
    w.uuid(v.id);
    w.string(v.name);
    w.string(v.description);
    w.uuid(v.owner);
    w.u16(v.contributors.length);
    for (const item of v.contributors) {
      w.uuid(item);
    }
    w.bool(v.grid_wide);
    w.bool(v.suspended);
    w.u64(v.created_at);
  },
  decode(r: Reader): ExperienceInfo {
    const id = r.uuid();
    const name = r.string();
    const description = r.string();
    const owner = r.uuid();
    const contributors: Uuid[] = [];
    for (let n = r.u16(); n > 0 && r.ok; n--) {
      contributors.push(r.uuid());
    }
    const grid_wide = r.bool();
    const suspended = r.bool();
    const created_at = r.u64();
    return { id, name, description, owner, contributors, grid_wide, suspended, created_at };
  },
};

export interface MarketListing {
  id: Uuid;
  seller: Uuid;
  seller_name: string;
  name: string;
  description: string;
  category: number;
  price: number;
  image: Uuid;
  kind: AssetKind;
  permissions: Permissions;
  sales: number;
  active: boolean;
  created_at: bigint;
}

export const MarketListing = {
  create(): MarketListing {
    return {
      id: NULL_UUID,
      seller: NULL_UUID,
      seller_name: "",
      name: "",
      description: "",
      category: 0,
      price: 0,
      image: NULL_UUID,
      kind: AssetKind.Texture,
      permissions: Permissions.create(),
      sales: 0,
      active: false,
      created_at: 0n,
    };
  },
  encode(w: Writer, v: MarketListing): void {
    w.uuid(v.id);
    w.uuid(v.seller);
    w.string(v.seller_name);
    w.string(v.name);
    w.string(v.description);
    w.u8(v.category);
    w.i32(v.price);
    w.uuid(v.image);
    w.u8(v.kind);
    Permissions.encode(w, v.permissions);
    w.u32(v.sales);
    w.bool(v.active);
    w.u64(v.created_at);
  },
  decode(r: Reader): MarketListing {
    const id = r.uuid();
    const seller = r.uuid();
    const seller_name = r.string();
    const name = r.string();
    const description = r.string();
    const category = r.u8();
    const price = r.i32();
    const image = r.uuid();
    const kind = r.enumValue(ASSET_KIND_VALUES, r.u8()) as AssetKind;
    const permissions = Permissions.decode(r);
    const sales = r.u32();
    const active = r.bool();
    const created_at = r.u64();
    return { id, seller, seller_name, name, description, category, price, image, kind, permissions, sales, active, created_at };
  },
};

export interface ProfilePick {
  id: Uuid;
  owner: Uuid;
  name: string;
  description: string;
  snapshot: Uuid;
  region: string;
  position: Vec3;
  parcel: string;
}

export const ProfilePick = {
  create(): ProfilePick {
    return {
      id: NULL_UUID,
      owner: NULL_UUID,
      name: "",
      description: "",
      snapshot: NULL_UUID,
      region: "",
      position: { x: 0, y: 0, z: 0 },
      parcel: "",
    };
  },
  encode(w: Writer, v: ProfilePick): void {
    w.uuid(v.id);
    w.uuid(v.owner);
    w.string(v.name);
    w.string(v.description);
    w.uuid(v.snapshot);
    w.string(v.region);
    w.vec3(v.position);
    w.string(v.parcel);
  },
  decode(r: Reader): ProfilePick {
    const id = r.uuid();
    const owner = r.uuid();
    const name = r.string();
    const description = r.string();
    const snapshot = r.uuid();
    const region = r.string();
    const position = r.vec3();
    const parcel = r.string();
    return { id, owner, name, description, snapshot, region, position, parcel };
  },
};

export interface TradeItem {
  name: string;
  kind: AssetKind;
  next_owner: number;
  copyable: boolean;
}

export const TradeItem = {
  create(): TradeItem {
    return {
      name: "",
      kind: AssetKind.Texture,
      next_owner: 0,
      copyable: false,
    };
  },
  encode(w: Writer, v: TradeItem): void {
    w.string(v.name);
    w.u8(v.kind);
    w.u32(v.next_owner);
    w.bool(v.copyable);
  },
  decode(r: Reader): TradeItem {
    const name = r.string();
    const kind = r.enumValue(ASSET_KIND_VALUES, r.u8()) as AssetKind;
    const next_owner = r.u32();
    const copyable = r.bool();
    return { name, kind, next_owner, copyable };
  },
};

export interface GroupChatLine {
  from: Uuid;
  from_name: string;
  text: string;
  timestamp: bigint;
}

export const GroupChatLine = {
  create(): GroupChatLine {
    return {
      from: NULL_UUID,
      from_name: "",
      text: "",
      timestamp: 0n,
    };
  },
  encode(w: Writer, v: GroupChatLine): void {
    w.uuid(v.from);
    w.string(v.from_name);
    w.string(v.text);
    w.u64(v.timestamp);
  },
  decode(r: Reader): GroupChatLine {
    const from = r.uuid();
    const from_name = r.string();
    const text = r.string();
    const timestamp = r.u64();
    return { from, from_name, text, timestamp };
  },
};

export interface ParcelObjectEntry {
  id: number;
  uuid: Uuid;
  name: string;
  prims: number;
  land_impact: number;
  position: Vec3;
}

export const ParcelObjectEntry = {
  create(): ParcelObjectEntry {
    return {
      id: 0,
      uuid: NULL_UUID,
      name: "",
      prims: 0,
      land_impact: 0,
      position: { x: 0, y: 0, z: 0 },
    };
  },
  encode(w: Writer, v: ParcelObjectEntry): void {
    w.u32(v.id);
    w.uuid(v.uuid);
    w.string(v.name);
    w.u32(v.prims);
    w.u32(v.land_impact);
    w.vec3(v.position);
  },
  decode(r: Reader): ParcelObjectEntry {
    const id = r.u32();
    const uuid = r.uuid();
    const name = r.string();
    const prims = r.u32();
    const land_impact = r.u32();
    const position = r.vec3();
    return { id, uuid, name, prims, land_impact, position };
  },
};

export interface AccountPreferences {
  max_maturity: Maturity;
  in_search: boolean;
  ims_from_anyone: boolean;
}

export const AccountPreferences = {
  create(): AccountPreferences {
    return {
      max_maturity: Maturity.General,
      in_search: false,
      ims_from_anyone: false,
    };
  },
  encode(w: Writer, v: AccountPreferences): void {
    w.u8(v.max_maturity);
    w.bool(v.in_search);
    w.bool(v.ims_from_anyone);
  },
  decode(r: Reader): AccountPreferences {
    const max_maturity = r.enumValue(MATURITY_VALUES, r.u8()) as Maturity;
    const in_search = r.bool();
    const ims_from_anyone = r.bool();
    return { max_maturity, in_search, ims_from_anyone };
  },
};

export interface VoiceCallMember {
  agent: Uuid;
  name: string;
  joined: boolean;
}

export const VoiceCallMember = {
  create(): VoiceCallMember {
    return {
      agent: NULL_UUID,
      name: "",
      joined: false,
    };
  },
  encode(w: Writer, v: VoiceCallMember): void {
    w.uuid(v.agent);
    w.string(v.name);
    w.bool(v.joined);
  },
  decode(r: Reader): VoiceCallMember {
    const agent = r.uuid();
    const name = r.string();
    const joined = r.bool();
    return { agent, name, joined };
  },
};

export interface GroupMember {
  agent: Uuid;
  name: string;
  title: string;
  powers: bigint;
  online: boolean;
  last_online: bigint;
  contribution: number;
  roles: Uuid[];
}

export const GroupMember = {
  create(): GroupMember {
    return {
      agent: NULL_UUID,
      name: "",
      title: "",
      powers: 0n,
      online: false,
      last_online: 0n,
      contribution: 0,
      roles: [],
    };
  },
  encode(w: Writer, v: GroupMember): void {
    w.uuid(v.agent);
    w.string(v.name);
    w.string(v.title);
    w.u64(v.powers);
    w.bool(v.online);
    w.u64(v.last_online);
    w.u32(v.contribution);
    w.u16(v.roles.length);
    for (const item of v.roles) {
      w.uuid(item);
    }
  },
  decode(r: Reader): GroupMember {
    const agent = r.uuid();
    const name = r.string();
    const title = r.string();
    const powers = r.u64();
    const online = r.bool();
    const last_online = r.u64();
    const contribution = r.u32();
    const roles: Uuid[] = [];
    for (let n = r.u16(); n > 0 && r.ok; n--) {
      roles.push(r.uuid());
    }
    return { agent, name, title, powers, online, last_online, contribution, roles };
  },
};

export interface GroupParcel {
  region_name: string;
  name: string;
  area: number;
  position: Vec3;
}

export const GroupParcel = {
  create(): GroupParcel {
    return {
      region_name: "",
      name: "",
      area: 0,
      position: { x: 0, y: 0, z: 0 },
    };
  },
  encode(w: Writer, v: GroupParcel): void {
    w.string(v.region_name);
    w.string(v.name);
    w.u32(v.area);
    w.vec3(v.position);
  },
  decode(r: Reader): GroupParcel {
    const region_name = r.string();
    const name = r.string();
    const area = r.u32();
    const position = r.vec3();
    return { region_name, name, area, position };
  },
};

export interface EnvironmentFrame {
  time: number;
  sky: SkySettings;
  water: WaterSettings;
}

export const EnvironmentFrame = {
  create(): EnvironmentFrame {
    return {
      time: 0,
      sky: SkySettings.create(),
      water: WaterSettings.create(),
    };
  },
  encode(w: Writer, v: EnvironmentFrame): void {
    w.f32(v.time);
    SkySettings.encode(w, v.sky);
    WaterSettings.encode(w, v.water);
  },
  decode(r: Reader): EnvironmentFrame {
    const time = r.f32();
    const sky = SkySettings.decode(r);
    const water = WaterSettings.decode(r);
    return { time, sky, water };
  },
};

export interface LandListing {
  parcel: Uuid;
  region_id: Uuid;
  region: string;
  name: string;
  description: string;
  position: Vec3;
  area: number;
  price: number;
  owner: Uuid;
  owner_name: string;
  for_sale: boolean;
  auction: boolean;
  maturity: Maturity;
  snapshot: Uuid;
}

export const LandListing = {
  create(): LandListing {
    return {
      parcel: NULL_UUID,
      region_id: NULL_UUID,
      region: "",
      name: "",
      description: "",
      position: { x: 0, y: 0, z: 0 },
      area: 0,
      price: 0,
      owner: NULL_UUID,
      owner_name: "",
      for_sale: false,
      auction: false,
      maturity: Maturity.General,
      snapshot: NULL_UUID,
    };
  },
  encode(w: Writer, v: LandListing): void {
    w.uuid(v.parcel);
    w.uuid(v.region_id);
    w.string(v.region);
    w.string(v.name);
    w.string(v.description);
    w.vec3(v.position);
    w.u32(v.area);
    w.i32(v.price);
    w.uuid(v.owner);
    w.string(v.owner_name);
    w.bool(v.for_sale);
    w.bool(v.auction);
    w.u8(v.maturity);
    w.uuid(v.snapshot);
  },
  decode(r: Reader): LandListing {
    const parcel = r.uuid();
    const region_id = r.uuid();
    const region = r.string();
    const name = r.string();
    const description = r.string();
    const position = r.vec3();
    const area = r.u32();
    const price = r.i32();
    const owner = r.uuid();
    const owner_name = r.string();
    const for_sale = r.bool();
    const auction = r.bool();
    const maturity = r.enumValue(MATURITY_VALUES, r.u8()) as Maturity;
    const snapshot = r.uuid();
    return { parcel, region_id, region, name, description, position, area, price, owner, owner_name, for_sale, auction, maturity, snapshot };
  },
};

export interface FeaturedPlace {
  id: Uuid;
  name: string;
  description: string;
  category: string;
  region_id: Uuid;
  region: string;
  position: Vec3;
  snapshot: Uuid;
  maturity: Maturity;
  agents: number;
}

export const FeaturedPlace = {
  create(): FeaturedPlace {
    return {
      id: NULL_UUID,
      name: "",
      description: "",
      category: "",
      region_id: NULL_UUID,
      region: "",
      position: { x: 0, y: 0, z: 0 },
      snapshot: NULL_UUID,
      maturity: Maturity.General,
      agents: 0,
    };
  },
  encode(w: Writer, v: FeaturedPlace): void {
    w.uuid(v.id);
    w.string(v.name);
    w.string(v.description);
    w.string(v.category);
    w.uuid(v.region_id);
    w.string(v.region);
    w.vec3(v.position);
    w.uuid(v.snapshot);
    w.u8(v.maturity);
    w.u16(v.agents);
  },
  decode(r: Reader): FeaturedPlace {
    const id = r.uuid();
    const name = r.string();
    const description = r.string();
    const category = r.string();
    const region_id = r.uuid();
    const region = r.string();
    const position = r.vec3();
    const snapshot = r.uuid();
    const maturity = r.enumValue(MATURITY_VALUES, r.u8()) as Maturity;
    const agents = r.u16();
    return { id, name, description, category, region_id, region, position, snapshot, maturity, agents };
  },
};

export interface SkyFrame {
  time: number;
  sky: SkySettings;
}

export const SkyFrame = {
  create(): SkyFrame {
    return {
      time: 0,
      sky: SkySettings.create(),
    };
  },
  encode(w: Writer, v: SkyFrame): void {
    w.f32(v.time);
    SkySettings.encode(w, v.sky);
  },
  decode(r: Reader): SkyFrame {
    const time = r.f32();
    const sky = SkySettings.decode(r);
    return { time, sky };
  },
};

export interface SkyLayer {
  altitude: number;
  name: string;
  frames: SkyFrame[];
}

export const SkyLayer = {
  create(): SkyLayer {
    return {
      altitude: 0,
      name: "",
      frames: [],
    };
  },
  encode(w: Writer, v: SkyLayer): void {
    w.f32(v.altitude);
    w.string(v.name);
    w.u16(v.frames.length);
    for (const item of v.frames) {
      SkyFrame.encode(w, item);
    }
  },
  decode(r: Reader): SkyLayer {
    const altitude = r.f32();
    const name = r.string();
    const frames: SkyFrame[] = [];
    for (let n = r.u16(); n > 0 && r.ok; n--) {
      frames.push(SkyFrame.decode(r));
    }
    return { altitude, name, frames };
  },
};

export interface TopObject {
  id: number;
  name: string;
  owner: Uuid;
  parcel: string;
  score: number;
  memory_kb: number;
  position: Vec3;
}

export const TopObject = {
  create(): TopObject {
    return {
      id: 0,
      name: "",
      owner: NULL_UUID,
      parcel: "",
      score: 0,
      memory_kb: 0,
      position: { x: 0, y: 0, z: 0 },
    };
  },
  encode(w: Writer, v: TopObject): void {
    w.u32(v.id);
    w.string(v.name);
    w.uuid(v.owner);
    w.string(v.parcel);
    w.f32(v.score);
    w.u32(v.memory_kb);
    w.vec3(v.position);
  },
  decode(r: Reader): TopObject {
    const id = r.u32();
    const name = r.string();
    const owner = r.uuid();
    const parcel = r.string();
    const score = r.f32();
    const memory_kb = r.u32();
    const position = r.vec3();
    return { id, name, owner, parcel, score, memory_kb, position };
  },
};

export interface ScriptUse {
  object: number;
  name: string;
  owner: Uuid;
  scripts: number;
  memory: number;
  time_ms: number;
  position: Vec3;
}

export const ScriptUse = {
  create(): ScriptUse {
    return {
      object: 0,
      name: "",
      owner: NULL_UUID,
      scripts: 0,
      memory: 0,
      time_ms: 0,
      position: { x: 0, y: 0, z: 0 },
    };
  },
  encode(w: Writer, v: ScriptUse): void {
    w.u32(v.object);
    w.string(v.name);
    w.uuid(v.owner);
    w.u32(v.scripts);
    w.u32(v.memory);
    w.f32(v.time_ms);
    w.vec3(v.position);
  },
  decode(r: Reader): ScriptUse {
    const object = r.u32();
    const name = r.string();
    const owner = r.uuid();
    const scripts = r.u32();
    const memory = r.u32();
    const time_ms = r.f32();
    const position = r.vec3();
    return { object, name, owner, scripts, memory, time_ms, position };
  },
};

export interface MapLevelTile {
  x: number;
  y: number;
  tile: Uuid;
}

export const MapLevelTile = {
  create(): MapLevelTile {
    return {
      x: 0,
      y: 0,
      tile: NULL_UUID,
    };
  },
  encode(w: Writer, v: MapLevelTile): void {
    w.u32(v.x);
    w.u32(v.y);
    w.uuid(v.tile);
  },
  decode(r: Reader): MapLevelTile {
    const x = r.u32();
    const y = r.u32();
    const tile = r.uuid();
    return { x, y, tile };
  },
};

export interface MapLand {
  region_id: Uuid;
  for_sale: Uint8Array;
  auction: Uint8Array;
}

export const MapLand = {
  create(): MapLand {
    return {
      region_id: NULL_UUID,
      for_sale: new Uint8Array(0),
      auction: new Uint8Array(0),
    };
  },
  encode(w: Writer, v: MapLand): void {
    w.uuid(v.region_id);
    w.bytes(v.for_sale);
    w.bytes(v.auction);
  },
  decode(r: Reader): MapLand {
    const region_id = r.uuid();
    const for_sale = r.bytes();
    const auction = r.bytes();
    return { region_id, for_sale, auction };
  },
};

export interface TerrainPoint {
  x: number;
  y: number;
  height: number;
}

export const TerrainPoint = {
  create(): TerrainPoint {
    return {
      x: 0,
      y: 0,
      height: 0,
    };
  },
  encode(w: Writer, v: TerrainPoint): void {
    w.u16(v.x);
    w.u16(v.y);
    w.f32(v.height);
  },
  decode(r: Reader): TerrainPoint {
    const x = r.u16();
    const y = r.u16();
    const height = r.f32();
    return { x, y, height };
  },
};

export interface Ping {
  sent_at: bigint;
}

export const Ping = {
  ID: 1 as const,
  NAME: "Ping" as const,
  CHANNEL: Channel.Unreliable,
  DIRECTION: Direction.Both,
  SINCE: 1,
  create(): Ping {
    return {
      sent_at: 0n,
    };
  },
  encode(w: Writer, v: Ping): void {
    w.u64(v.sent_at);
  },
  decode(r: Reader): Ping {
    const sent_at = r.remaining > 0 ? r.u64() : 0n;
    return { sent_at };
  },
};

export interface Pong {
  sent_at: bigint;
  received_at: bigint;
}

export const Pong = {
  ID: 2 as const,
  NAME: "Pong" as const,
  CHANNEL: Channel.Unreliable,
  DIRECTION: Direction.Both,
  SINCE: 1,
  create(): Pong {
    return {
      sent_at: 0n,
      received_at: 0n,
    };
  },
  encode(w: Writer, v: Pong): void {
    w.u64(v.sent_at);
    w.u64(v.received_at);
  },
  decode(r: Reader): Pong {
    const sent_at = r.remaining > 0 ? r.u64() : 0n;
    const received_at = r.remaining > 0 ? r.u64() : 0n;
    return { sent_at, received_at };
  },
};

export interface Disconnect {
  reason: string;
}

export const Disconnect = {
  ID: 3 as const,
  NAME: "Disconnect" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.Both,
  SINCE: 1,
  create(): Disconnect {
    return {
      reason: "",
    };
  },
  encode(w: Writer, v: Disconnect): void {
    w.string(v.reason);
  },
  decode(r: Reader): Disconnect {
    const reason = r.remaining > 0 ? r.string() : "";
    return { reason };
  },
};

export interface Alert {
  text: string;
  modal: boolean;
}

export const Alert = {
  ID: 4 as const,
  NAME: "Alert" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): Alert {
    return {
      text: "",
      modal: false,
    };
  },
  encode(w: Writer, v: Alert): void {
    w.string(v.text);
    w.bool(v.modal);
  },
  decode(r: Reader): Alert {
    const text = r.remaining > 0 ? r.string() : "";
    const modal = r.remaining > 0 ? r.bool() : false;
    return { text, modal };
  },
};

export interface Kick {
  reason: string;
}

export const Kick = {
  ID: 5 as const,
  NAME: "Kick" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): Kick {
    return {
      reason: "",
    };
  },
  encode(w: Writer, v: Kick): void {
    w.string(v.reason);
  },
  decode(r: Reader): Kick {
    const reason = r.remaining > 0 ? r.string() : "";
    return { reason };
  },
};

export interface LoginRequest {
  username: string;
  password: string;
  client_version: string;
  platform: string;
  start_location: string;
  machine_id: Uint8Array;
  accept_terms: string;
  remember: boolean;
  login_token: string;
}

export const LoginRequest = {
  ID: 10 as const,
  NAME: "LoginRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): LoginRequest {
    return {
      username: "",
      password: "",
      client_version: "",
      platform: "",
      start_location: "",
      machine_id: new Uint8Array(0),
      accept_terms: "",
      remember: false,
      login_token: "",
    };
  },
  encode(w: Writer, v: LoginRequest): void {
    w.string(v.username);
    w.string(v.password);
    w.string(v.client_version);
    w.string(v.platform);
    w.string(v.start_location);
    w.bytes(v.machine_id);
    w.string(v.accept_terms);
    w.bool(v.remember);
    w.string(v.login_token);
  },
  decode(r: Reader): LoginRequest {
    const username = r.remaining > 0 ? r.string() : "";
    const password = r.remaining > 0 ? r.string() : "";
    const client_version = r.remaining > 0 ? r.string() : "";
    const platform = r.remaining > 0 ? r.string() : "";
    const start_location = r.remaining > 0 ? r.string() : "";
    const machine_id = r.remaining > 0 ? r.bytes() : new Uint8Array(0);
    const accept_terms = r.remaining > 0 ? r.string() : "";
    const remember = r.remaining > 0 ? r.bool() : false;
    const login_token = r.remaining > 0 ? r.string() : "";
    return { username, password, client_version, platform, start_location, machine_id, accept_terms, remember, login_token };
  },
};

export interface LoginResponse {
  ok: boolean;
  message: string;
  agent_id: Uuid;
  session_token: Uint8Array;
  username: string;
  display_name: string;
  account_level: number;
  region: Endpoint;
  region_id: Uuid;
  region_name: string;
  position: Vec3;
  look_at: Vec3;
  home_region: Uuid;
  home_position: Vec3;
  inventory_root: Uuid;
  library_root: Uuid;
  library_owner: Uuid;
  balance: bigint;
  currency_symbol: string;
  grid_name: string;
  grid_nick: string;
  motd: string;
  server_time: bigint;
  upload_cost: number;
  max_groups: number;
  terms_version: string;
  staff_permissions: string[];
  login_token: string;
}

export const LoginResponse = {
  ID: 11 as const,
  NAME: "LoginResponse" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): LoginResponse {
    return {
      ok: false,
      message: "",
      agent_id: NULL_UUID,
      session_token: new Uint8Array(0),
      username: "",
      display_name: "",
      account_level: 0,
      region: Endpoint.create(),
      region_id: NULL_UUID,
      region_name: "",
      position: { x: 0, y: 0, z: 0 },
      look_at: { x: 0, y: 0, z: 0 },
      home_region: NULL_UUID,
      home_position: { x: 0, y: 0, z: 0 },
      inventory_root: NULL_UUID,
      library_root: NULL_UUID,
      library_owner: NULL_UUID,
      balance: 0n,
      currency_symbol: "",
      grid_name: "",
      grid_nick: "",
      motd: "",
      server_time: 0n,
      upload_cost: 0,
      max_groups: 0,
      terms_version: "",
      staff_permissions: [],
      login_token: "",
    };
  },
  encode(w: Writer, v: LoginResponse): void {
    w.bool(v.ok);
    w.string(v.message);
    w.uuid(v.agent_id);
    w.bytes(v.session_token);
    w.string(v.username);
    w.string(v.display_name);
    w.u8(v.account_level);
    Endpoint.encode(w, v.region);
    w.uuid(v.region_id);
    w.string(v.region_name);
    w.vec3(v.position);
    w.vec3(v.look_at);
    w.uuid(v.home_region);
    w.vec3(v.home_position);
    w.uuid(v.inventory_root);
    w.uuid(v.library_root);
    w.uuid(v.library_owner);
    w.i64(v.balance);
    w.string(v.currency_symbol);
    w.string(v.grid_name);
    w.string(v.grid_nick);
    w.string(v.motd);
    w.u64(v.server_time);
    w.i32(v.upload_cost);
    w.u16(v.max_groups);
    w.string(v.terms_version);
    w.u16(v.staff_permissions.length);
    for (const item of v.staff_permissions) {
      w.string(item);
    }
    w.string(v.login_token);
  },
  decode(r: Reader): LoginResponse {
    const ok = r.remaining > 0 ? r.bool() : false;
    const message = r.remaining > 0 ? r.string() : "";
    const agent_id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const session_token = r.remaining > 0 ? r.bytes() : new Uint8Array(0);
    const username = r.remaining > 0 ? r.string() : "";
    const display_name = r.remaining > 0 ? r.string() : "";
    const account_level = r.remaining > 0 ? r.u8() : 0;
    const region = r.remaining > 0 ? Endpoint.decode(r) : Endpoint.create();
    const region_id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const region_name = r.remaining > 0 ? r.string() : "";
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const look_at = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const home_region = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const home_position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const inventory_root = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const library_root = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const library_owner = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const balance = r.remaining > 0 ? r.i64() : 0n;
    const currency_symbol = r.remaining > 0 ? r.string() : "";
    const grid_name = r.remaining > 0 ? r.string() : "";
    const grid_nick = r.remaining > 0 ? r.string() : "";
    const motd = r.remaining > 0 ? r.string() : "";
    const server_time = r.remaining > 0 ? r.u64() : 0n;
    const upload_cost = r.remaining > 0 ? r.i32() : 0;
    const max_groups = r.remaining > 0 ? r.u16() : 0;
    const terms_version = r.remaining > 0 ? r.string() : "";
    const staff_permissions: string[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      staff_permissions.push(r.string());
    }
    const login_token = r.remaining > 0 ? r.string() : "";
    return { ok, message, agent_id, session_token, username, display_name, account_level, region, region_id, region_name, position, look_at, home_region, home_position, inventory_root, library_root, library_owner, balance, currency_symbol, grid_name, grid_nick, motd, server_time, upload_cost, max_groups, terms_version, staff_permissions, login_token };
  },
};

export interface LogoutRequest {
}

export const LogoutRequest = {
  ID: 12 as const,
  NAME: "LogoutRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): LogoutRequest {
    return {
    };
  },
  encode(w: Writer, v: LogoutRequest): void {
    void w;
    void v;
  },
  decode(r: Reader): LogoutRequest {
    void r;
    return {};
  },
};

export interface LogoutResponse {
  seconds_online: number;
}

export const LogoutResponse = {
  ID: 13 as const,
  NAME: "LogoutResponse" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): LogoutResponse {
    return {
      seconds_online: 0,
    };
  },
  encode(w: Writer, v: LogoutResponse): void {
    w.u32(v.seconds_online);
  },
  decode(r: Reader): LogoutResponse {
    const seconds_online = r.remaining > 0 ? r.u32() : 0;
    return { seconds_online };
  },
};

export interface CreateAccountRequest {
  username: string;
  password: string;
  display_name: string;
  email: string;
  invite_code: string;
  accept_terms: string;
  first_name: string;
  last_name: string;
  birth_date: string;
  country: string;
}

export const CreateAccountRequest = {
  ID: 14 as const,
  NAME: "CreateAccountRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): CreateAccountRequest {
    return {
      username: "",
      password: "",
      display_name: "",
      email: "",
      invite_code: "",
      accept_terms: "",
      first_name: "",
      last_name: "",
      birth_date: "",
      country: "",
    };
  },
  encode(w: Writer, v: CreateAccountRequest): void {
    w.string(v.username);
    w.string(v.password);
    w.string(v.display_name);
    w.string(v.email);
    w.string(v.invite_code);
    w.string(v.accept_terms);
    w.string(v.first_name);
    w.string(v.last_name);
    w.string(v.birth_date);
    w.string(v.country);
  },
  decode(r: Reader): CreateAccountRequest {
    const username = r.remaining > 0 ? r.string() : "";
    const password = r.remaining > 0 ? r.string() : "";
    const display_name = r.remaining > 0 ? r.string() : "";
    const email = r.remaining > 0 ? r.string() : "";
    const invite_code = r.remaining > 0 ? r.string() : "";
    const accept_terms = r.remaining > 0 ? r.string() : "";
    const first_name = r.remaining > 0 ? r.string() : "";
    const last_name = r.remaining > 0 ? r.string() : "";
    const birth_date = r.remaining > 0 ? r.string() : "";
    const country = r.remaining > 0 ? r.string() : "";
    return { username, password, display_name, email, invite_code, accept_terms, first_name, last_name, birth_date, country };
  },
};

export interface CreateAccountResponse {
  ok: boolean;
  message: string;
  agent_id: Uuid;
}

export const CreateAccountResponse = {
  ID: 15 as const,
  NAME: "CreateAccountResponse" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): CreateAccountResponse {
    return {
      ok: false,
      message: "",
      agent_id: NULL_UUID,
    };
  },
  encode(w: Writer, v: CreateAccountResponse): void {
    w.bool(v.ok);
    w.string(v.message);
    w.uuid(v.agent_id);
  },
  decode(r: Reader): CreateAccountResponse {
    const ok = r.remaining > 0 ? r.bool() : false;
    const message = r.remaining > 0 ? r.string() : "";
    const agent_id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { ok, message, agent_id };
  },
};

export interface RegionEnter {
  agent_id: Uuid;
  protocol: bigint;
  session_token: Uint8Array;
  child: boolean;
  client_version: string;
  draw_distance: number;
  viewport_width: number;
  viewport_height: number;
  language: string;
}

export const RegionEnter = {
  ID: 20 as const,
  NAME: "RegionEnter" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): RegionEnter {
    return {
      agent_id: NULL_UUID,
      protocol: 0n,
      session_token: new Uint8Array(0),
      child: false,
      client_version: "",
      draw_distance: 0,
      viewport_width: 0,
      viewport_height: 0,
      language: "",
    };
  },
  encode(w: Writer, v: RegionEnter): void {
    w.uuid(v.agent_id);
    w.u64(v.protocol);
    w.bytes(v.session_token);
    w.bool(v.child);
    w.string(v.client_version);
    w.f32(v.draw_distance);
    w.u16(v.viewport_width);
    w.u16(v.viewport_height);
    w.string(v.language);
  },
  decode(r: Reader): RegionEnter {
    const agent_id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const protocol = r.remaining > 0 ? r.u64() : 0n;
    const session_token = r.remaining > 0 ? r.bytes() : new Uint8Array(0);
    const child = r.remaining > 0 ? r.bool() : false;
    const client_version = r.remaining > 0 ? r.string() : "";
    const draw_distance = r.remaining > 0 ? r.f32() : 0;
    const viewport_width = r.remaining > 0 ? r.u16() : 0;
    const viewport_height = r.remaining > 0 ? r.u16() : 0;
    const language = r.remaining > 0 ? r.string() : "";
    return { agent_id, protocol, session_token, child, client_version, draw_distance, viewport_width, viewport_height, language };
  },
};

export interface RegionWelcome {
  region_id: Uuid;
  name: string;
  grid_x: number;
  grid_y: number;
  size_x: number;
  size_y: number;
  water_height: number;
  terrain_min: number;
  terrain_max: number;
  terrain_textures: TerrainTextures;
  maturity: Maturity;
  estate: EstateInfo;
  owner: Uuid;
  flags: number;
  tick_rate: number;
  max_agents: number;
  max_objects: number;
  your_local_id: number;
  sim_version: string;
  server_time: bigint;
  time_of_day: number;
  day_length_seconds: number;
  allow_damage: boolean;
  is_estate_manager: boolean;
  god_level: number;
  view: ViewDefaults;
  product: string;
  moderators: Uuid[];
  protocol_revision: number;
  terrain_bands: TerrainBands;
  terrain_lift: number[];
}

export const RegionWelcome = {
  ID: 21 as const,
  NAME: "RegionWelcome" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): RegionWelcome {
    return {
      region_id: NULL_UUID,
      name: "",
      grid_x: 0,
      grid_y: 0,
      size_x: 0,
      size_y: 0,
      water_height: 0,
      terrain_min: 0,
      terrain_max: 0,
      terrain_textures: TerrainTextures.create(),
      maturity: Maturity.General,
      estate: EstateInfo.create(),
      owner: NULL_UUID,
      flags: 0,
      tick_rate: 0,
      max_agents: 0,
      max_objects: 0,
      your_local_id: 0,
      sim_version: "",
      server_time: 0n,
      time_of_day: 0,
      day_length_seconds: 0,
      allow_damage: false,
      is_estate_manager: false,
      god_level: 0,
      view: ViewDefaults.create(),
      product: "",
      moderators: [],
      protocol_revision: 0,
      terrain_bands: TerrainBands.create(),
      terrain_lift: [],
    };
  },
  encode(w: Writer, v: RegionWelcome): void {
    w.uuid(v.region_id);
    w.string(v.name);
    w.u32(v.grid_x);
    w.u32(v.grid_y);
    w.u16(v.size_x);
    w.u16(v.size_y);
    w.f32(v.water_height);
    w.f32(v.terrain_min);
    w.f32(v.terrain_max);
    TerrainTextures.encode(w, v.terrain_textures);
    w.u8(v.maturity);
    EstateInfo.encode(w, v.estate);
    w.uuid(v.owner);
    w.u32(v.flags);
    w.u8(v.tick_rate);
    w.u16(v.max_agents);
    w.u32(v.max_objects);
    w.u32(v.your_local_id);
    w.string(v.sim_version);
    w.u64(v.server_time);
    w.f32(v.time_of_day);
    w.u32(v.day_length_seconds);
    w.bool(v.allow_damage);
    w.bool(v.is_estate_manager);
    w.u8(v.god_level);
    ViewDefaults.encode(w, v.view);
    w.string(v.product);
    w.u16(v.moderators.length);
    for (const item of v.moderators) {
      w.uuid(item);
    }
    w.u32(v.protocol_revision);
    TerrainBands.encode(w, v.terrain_bands);
    w.u16(v.terrain_lift.length);
    for (const item of v.terrain_lift) {
      w.f32(item);
    }
  },
  decode(r: Reader): RegionWelcome {
    const region_id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const name = r.remaining > 0 ? r.string() : "";
    const grid_x = r.remaining > 0 ? r.u32() : 0;
    const grid_y = r.remaining > 0 ? r.u32() : 0;
    const size_x = r.remaining > 0 ? r.u16() : 0;
    const size_y = r.remaining > 0 ? r.u16() : 0;
    const water_height = r.remaining > 0 ? r.f32() : 0;
    const terrain_min = r.remaining > 0 ? r.f32() : 0;
    const terrain_max = r.remaining > 0 ? r.f32() : 0;
    const terrain_textures = r.remaining > 0 ? TerrainTextures.decode(r) : TerrainTextures.create();
    const maturity = r.remaining > 0 ? r.enumValue(MATURITY_VALUES, r.u8()) as Maturity : Maturity.General;
    const estate = r.remaining > 0 ? EstateInfo.decode(r) : EstateInfo.create();
    const owner = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const flags = r.remaining > 0 ? r.u32() : 0;
    const tick_rate = r.remaining > 0 ? r.u8() : 0;
    const max_agents = r.remaining > 0 ? r.u16() : 0;
    const max_objects = r.remaining > 0 ? r.u32() : 0;
    const your_local_id = r.remaining > 0 ? r.u32() : 0;
    const sim_version = r.remaining > 0 ? r.string() : "";
    const server_time = r.remaining > 0 ? r.u64() : 0n;
    const time_of_day = r.remaining > 0 ? r.f32() : 0;
    const day_length_seconds = r.remaining > 0 ? r.u32() : 0;
    const allow_damage = r.remaining > 0 ? r.bool() : false;
    const is_estate_manager = r.remaining > 0 ? r.bool() : false;
    const god_level = r.remaining > 0 ? r.u8() : 0;
    const view = r.remaining > 0 ? ViewDefaults.decode(r) : ViewDefaults.create();
    const product = r.remaining > 0 ? r.string() : "";
    const moderators: Uuid[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      moderators.push(r.uuid());
    }
    const protocol_revision = r.remaining > 0 ? r.u32() : 0;
    const terrain_bands = r.remaining > 0 ? TerrainBands.decode(r) : TerrainBands.create();
    const terrain_lift: number[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      terrain_lift.push(r.f32());
    }
    return { region_id, name, grid_x, grid_y, size_x, size_y, water_height, terrain_min, terrain_max, terrain_textures, maturity, estate, owner, flags, tick_rate, max_agents, max_objects, your_local_id, sim_version, server_time, time_of_day, day_length_seconds, allow_damage, is_estate_manager, god_level, view, product, moderators, protocol_revision, terrain_bands, terrain_lift };
  },
};

export interface RegionReady {
}

export const RegionReady = {
  ID: 22 as const,
  NAME: "RegionReady" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): RegionReady {
    return {
    };
  },
  encode(w: Writer, v: RegionReady): void {
    void w;
    void v;
  },
  decode(r: Reader): RegionReady {
    void r;
    return {};
  },
};

export interface RegionLeave {
}

export const RegionLeave = {
  ID: 23 as const,
  NAME: "RegionLeave" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): RegionLeave {
    return {
    };
  },
  encode(w: Writer, v: RegionLeave): void {
    void w;
    void v;
  },
  decode(r: Reader): RegionLeave {
    void r;
    return {};
  },
};

export interface RegionStatsUpdate {
  stats: RegionStats;
}

export const RegionStatsUpdate = {
  ID: 24 as const,
  NAME: "RegionStatsUpdate" as const,
  CHANNEL: Channel.Unreliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): RegionStatsUpdate {
    return {
      stats: RegionStats.create(),
    };
  },
  encode(w: Writer, v: RegionStatsUpdate): void {
    RegionStats.encode(w, v.stats);
  },
  decode(r: Reader): RegionStatsUpdate {
    const stats = r.remaining > 0 ? RegionStats.decode(r) : RegionStats.create();
    return { stats };
  },
};

export interface NeighborRegions {
  regions: RegionSummary[];
}

export const NeighborRegions = {
  ID: 25 as const,
  NAME: "NeighborRegions" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): NeighborRegions {
    return {
      regions: [],
    };
  },
  encode(w: Writer, v: NeighborRegions): void {
    w.u16(v.regions.length);
    for (const item of v.regions) {
      RegionSummary.encode(w, item);
    }
  },
  decode(r: Reader): NeighborRegions {
    const regions: RegionSummary[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      regions.push(RegionSummary.decode(r));
    }
    return { regions };
  },
};

export interface RegionInfoUpdate {
  name: string;
  flags: number;
  maturity: Maturity;
  max_agents: number;
  max_objects: number;
  water_height: number;
  terrain_textures: TerrainTextures;
  estate: EstateInfo;
  product: string;
  moderators: Uuid[];
  terrain_bands: TerrainBands;
  terrain_lift: number[];
}

export const RegionInfoUpdate = {
  ID: 26 as const,
  NAME: "RegionInfoUpdate" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): RegionInfoUpdate {
    return {
      name: "",
      flags: 0,
      maturity: Maturity.General,
      max_agents: 0,
      max_objects: 0,
      water_height: 0,
      terrain_textures: TerrainTextures.create(),
      estate: EstateInfo.create(),
      product: "",
      moderators: [],
      terrain_bands: TerrainBands.create(),
      terrain_lift: [],
    };
  },
  encode(w: Writer, v: RegionInfoUpdate): void {
    w.string(v.name);
    w.u32(v.flags);
    w.u8(v.maturity);
    w.u16(v.max_agents);
    w.u32(v.max_objects);
    w.f32(v.water_height);
    TerrainTextures.encode(w, v.terrain_textures);
    EstateInfo.encode(w, v.estate);
    w.string(v.product);
    w.u16(v.moderators.length);
    for (const item of v.moderators) {
      w.uuid(item);
    }
    TerrainBands.encode(w, v.terrain_bands);
    w.u16(v.terrain_lift.length);
    for (const item of v.terrain_lift) {
      w.f32(item);
    }
  },
  decode(r: Reader): RegionInfoUpdate {
    const name = r.remaining > 0 ? r.string() : "";
    const flags = r.remaining > 0 ? r.u32() : 0;
    const maturity = r.remaining > 0 ? r.enumValue(MATURITY_VALUES, r.u8()) as Maturity : Maturity.General;
    const max_agents = r.remaining > 0 ? r.u16() : 0;
    const max_objects = r.remaining > 0 ? r.u32() : 0;
    const water_height = r.remaining > 0 ? r.f32() : 0;
    const terrain_textures = r.remaining > 0 ? TerrainTextures.decode(r) : TerrainTextures.create();
    const estate = r.remaining > 0 ? EstateInfo.decode(r) : EstateInfo.create();
    const product = r.remaining > 0 ? r.string() : "";
    const moderators: Uuid[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      moderators.push(r.uuid());
    }
    const terrain_bands = r.remaining > 0 ? TerrainBands.decode(r) : TerrainBands.create();
    const terrain_lift: number[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      terrain_lift.push(r.f32());
    }
    return { name, flags, maturity, max_agents, max_objects, water_height, terrain_textures, estate, product, moderators, terrain_bands, terrain_lift };
  },
};

export interface RegionSettingsUpdate {
  name: string;
  flags: number;
  maturity: Maturity;
  max_agents: number;
  water_height: number;
  terrain_textures: TerrainTextures;
  product: string;
  moderators: Uuid[];
  terrain_bands: TerrainBands;
}

export const RegionSettingsUpdate = {
  ID: 27 as const,
  NAME: "RegionSettingsUpdate" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): RegionSettingsUpdate {
    return {
      name: "",
      flags: 0,
      maturity: Maturity.General,
      max_agents: 0,
      water_height: 0,
      terrain_textures: TerrainTextures.create(),
      product: "",
      moderators: [],
      terrain_bands: TerrainBands.create(),
    };
  },
  encode(w: Writer, v: RegionSettingsUpdate): void {
    w.string(v.name);
    w.u32(v.flags);
    w.u8(v.maturity);
    w.u16(v.max_agents);
    w.f32(v.water_height);
    TerrainTextures.encode(w, v.terrain_textures);
    w.string(v.product);
    w.u16(v.moderators.length);
    for (const item of v.moderators) {
      w.uuid(item);
    }
    TerrainBands.encode(w, v.terrain_bands);
  },
  decode(r: Reader): RegionSettingsUpdate {
    const name = r.remaining > 0 ? r.string() : "";
    const flags = r.remaining > 0 ? r.u32() : 0;
    const maturity = r.remaining > 0 ? r.enumValue(MATURITY_VALUES, r.u8()) as Maturity : Maturity.General;
    const max_agents = r.remaining > 0 ? r.u16() : 0;
    const water_height = r.remaining > 0 ? r.f32() : 0;
    const terrain_textures = r.remaining > 0 ? TerrainTextures.decode(r) : TerrainTextures.create();
    const product = r.remaining > 0 ? r.string() : "";
    const moderators: Uuid[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      moderators.push(r.uuid());
    }
    const terrain_bands = r.remaining > 0 ? TerrainBands.decode(r) : TerrainBands.create();
    return { name, flags, maturity, max_agents, water_height, terrain_textures, product, moderators, terrain_bands };
  },
};

export interface LandHolding {
  allowance: number;
  held: number;
}

export const LandHolding = {
  ID: 306 as const,
  NAME: "LandHolding" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): LandHolding {
    return {
      allowance: 0,
      held: 0,
    };
  },
  encode(w: Writer, v: LandHolding): void {
    w.u32(v.allowance);
    w.u32(v.held);
  },
  decode(r: Reader): LandHolding {
    const allowance = r.remaining > 0 ? r.u32() : 0;
    const held = r.remaining > 0 ? r.u32() : 0;
    return { allowance, held };
  },
};

export interface RegionRestartNotice {
  seconds: number;
  message: string;
}

export const RegionRestartNotice = {
  ID: 28 as const,
  NAME: "RegionRestartNotice" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): RegionRestartNotice {
    return {
      seconds: 0,
      message: "",
    };
  },
  encode(w: Writer, v: RegionRestartNotice): void {
    w.u32(v.seconds);
    w.string(v.message);
  },
  decode(r: Reader): RegionRestartNotice {
    const seconds = r.remaining > 0 ? r.u32() : 0;
    const message = r.remaining > 0 ? r.string() : "";
    return { seconds, message };
  },
};

export interface TimeSync {
  server_time: bigint;
  time_of_day: number;
  day_length_seconds: number;
}

export const TimeSync = {
  ID: 29 as const,
  NAME: "TimeSync" as const,
  CHANNEL: Channel.Unreliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): TimeSync {
    return {
      server_time: 0n,
      time_of_day: 0,
      day_length_seconds: 0,
    };
  },
  encode(w: Writer, v: TimeSync): void {
    w.u64(v.server_time);
    w.f32(v.time_of_day);
    w.u32(v.day_length_seconds);
  },
  decode(r: Reader): TimeSync {
    const server_time = r.remaining > 0 ? r.u64() : 0n;
    const time_of_day = r.remaining > 0 ? r.f32() : 0;
    const day_length_seconds = r.remaining > 0 ? r.u32() : 0;
    return { server_time, time_of_day, day_length_seconds };
  },
};

export interface TerrainPatch {
  x: number;
  y: number;
  base: number;
  scale: number;
  heights: number[];
}

export const TerrainPatch = {
  ID: 30 as const,
  NAME: "TerrainPatch" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): TerrainPatch {
    return {
      x: 0,
      y: 0,
      base: 0,
      scale: 0,
      heights: Array.from({ length: 256 }, () => 0),
    };
  },
  encode(w: Writer, v: TerrainPatch): void {
    w.u8(v.x);
    w.u8(v.y);
    w.f32(v.base);
    w.f32(v.scale);
    for (let i = 0; i < 256; i++) {
      w.u16(v.heights[i]);
    }
  },
  decode(r: Reader): TerrainPatch {
    const x = r.remaining > 0 ? r.u8() : 0;
    const y = r.remaining > 0 ? r.u8() : 0;
    const base = r.remaining > 0 ? r.f32() : 0;
    const scale = r.remaining > 0 ? r.f32() : 0;
    const heights: number[] = r.remaining > 0 ? [] : Array.from({ length: 256 }, () => 0);
    for (let i = 0; i < 256 && heights.length < 256 && r.remaining > 0; i++) {
      heights.push(r.u16());
    }
    return { x, y, base, scale, heights };
  },
};

export interface TerrainEdit {
  tool: number;
  center: Vec3;
  radius: number;
  strength: number;
  duration: number;
}

export const TerrainEdit = {
  ID: 31 as const,
  NAME: "TerrainEdit" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): TerrainEdit {
    return {
      tool: 0,
      center: { x: 0, y: 0, z: 0 },
      radius: 0,
      strength: 0,
      duration: 0,
    };
  },
  encode(w: Writer, v: TerrainEdit): void {
    w.u8(v.tool);
    w.vec3(v.center);
    w.f32(v.radius);
    w.f32(v.strength);
    w.f32(v.duration);
  },
  decode(r: Reader): TerrainEdit {
    const tool = r.remaining > 0 ? r.u8() : 0;
    const center = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const radius = r.remaining > 0 ? r.f32() : 0;
    const strength = r.remaining > 0 ? r.f32() : 0;
    const duration = r.remaining > 0 ? r.f32() : 0;
    return { tool, center, radius, strength, duration };
  },
};

export interface TerrainTexturesUpdate {
  textures: TerrainTextures;
  bands: TerrainBands;
  lift: number[];
}

export const TerrainTexturesUpdate = {
  ID: 32 as const,
  NAME: "TerrainTexturesUpdate" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): TerrainTexturesUpdate {
    return {
      textures: TerrainTextures.create(),
      bands: TerrainBands.create(),
      lift: [],
    };
  },
  encode(w: Writer, v: TerrainTexturesUpdate): void {
    TerrainTextures.encode(w, v.textures);
    TerrainBands.encode(w, v.bands);
    w.u16(v.lift.length);
    for (const item of v.lift) {
      w.f32(item);
    }
  },
  decode(r: Reader): TerrainTexturesUpdate {
    const textures = r.remaining > 0 ? TerrainTextures.decode(r) : TerrainTextures.create();
    const bands = r.remaining > 0 ? TerrainBands.decode(r) : TerrainBands.create();
    const lift: number[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      lift.push(r.f32());
    }
    return { textures, bands, lift };
  },
};

export interface TerrainBake {
  revert: boolean;
}

export const TerrainBake = {
  ID: 33 as const,
  NAME: "TerrainBake" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): TerrainBake {
    return {
      revert: false,
    };
  },
  encode(w: Writer, v: TerrainBake): void {
    w.bool(v.revert);
  },
  decode(r: Reader): TerrainBake {
    const revert = r.remaining > 0 ? r.bool() : false;
    return { revert };
  },
};

export interface WindUpdate {
  direction: Vec2;
  speed: number;
  gusts: number;
}

export const WindUpdate = {
  ID: 34 as const,
  NAME: "WindUpdate" as const,
  CHANNEL: Channel.Unreliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): WindUpdate {
    return {
      direction: { x: 0, y: 0 },
      speed: 0,
      gusts: 0,
    };
  },
  encode(w: Writer, v: WindUpdate): void {
    w.vec2(v.direction);
    w.f32(v.speed);
    w.f32(v.gusts);
  },
  decode(r: Reader): WindUpdate {
    const direction = r.remaining > 0 ? r.vec2() : { x: 0, y: 0 };
    const speed = r.remaining > 0 ? r.f32() : 0;
    const gusts = r.remaining > 0 ? r.f32() : 0;
    return { direction, speed, gusts };
  },
};

export interface SkyUpdate {
  sky: SkySettings;
  transition_seconds: number;
}

export const SkyUpdate = {
  ID: 40 as const,
  NAME: "SkyUpdate" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): SkyUpdate {
    return {
      sky: SkySettings.create(),
      transition_seconds: 0,
    };
  },
  encode(w: Writer, v: SkyUpdate): void {
    SkySettings.encode(w, v.sky);
    w.f32(v.transition_seconds);
  },
  decode(r: Reader): SkyUpdate {
    const sky = r.remaining > 0 ? SkySettings.decode(r) : SkySettings.create();
    const transition_seconds = r.remaining > 0 ? r.f32() : 0;
    return { sky, transition_seconds };
  },
};

export interface WaterUpdate {
  water: WaterSettings;
  transition_seconds: number;
}

export const WaterUpdate = {
  ID: 41 as const,
  NAME: "WaterUpdate" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): WaterUpdate {
    return {
      water: WaterSettings.create(),
      transition_seconds: 0,
    };
  },
  encode(w: Writer, v: WaterUpdate): void {
    WaterSettings.encode(w, v.water);
    w.f32(v.transition_seconds);
  },
  decode(r: Reader): WaterUpdate {
    const water = r.remaining > 0 ? WaterSettings.decode(r) : WaterSettings.create();
    const transition_seconds = r.remaining > 0 ? r.f32() : 0;
    return { water, transition_seconds };
  },
};

export interface DayCycleUpdate {
  keyframes: DayKeyframe[];
  day_length_seconds: number;
  day_offset: number;
}

export const DayCycleUpdate = {
  ID: 42 as const,
  NAME: "DayCycleUpdate" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): DayCycleUpdate {
    return {
      keyframes: [],
      day_length_seconds: 0,
      day_offset: 0,
    };
  },
  encode(w: Writer, v: DayCycleUpdate): void {
    w.u16(v.keyframes.length);
    for (const item of v.keyframes) {
      DayKeyframe.encode(w, item);
    }
    w.u32(v.day_length_seconds);
    w.f32(v.day_offset);
  },
  decode(r: Reader): DayCycleUpdate {
    const keyframes: DayKeyframe[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      keyframes.push(DayKeyframe.decode(r));
    }
    const day_length_seconds = r.remaining > 0 ? r.u32() : 0;
    const day_offset = r.remaining > 0 ? r.f32() : 0;
    return { keyframes, day_length_seconds, day_offset };
  },
};

export interface EnvironmentSet {
  sky: SkySettings;
  water: WaterSettings;
  parcel: number;
}

export const EnvironmentSet = {
  ID: 43 as const,
  NAME: "EnvironmentSet" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): EnvironmentSet {
    return {
      sky: SkySettings.create(),
      water: WaterSettings.create(),
      parcel: 0,
    };
  },
  encode(w: Writer, v: EnvironmentSet): void {
    SkySettings.encode(w, v.sky);
    WaterSettings.encode(w, v.water);
    w.u32(v.parcel);
  },
  decode(r: Reader): EnvironmentSet {
    const sky = r.remaining > 0 ? SkySettings.decode(r) : SkySettings.create();
    const water = r.remaining > 0 ? WaterSettings.decode(r) : WaterSettings.create();
    const parcel = r.remaining > 0 ? r.u32() : 0;
    return { sky, water, parcel };
  },
};

export interface ObjectAdd {
  objects: ObjectFull[];
  drawings: PrimDrawings[];
}

export const ObjectAdd = {
  ID: 50 as const,
  NAME: "ObjectAdd" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): ObjectAdd {
    return {
      objects: [],
      drawings: [],
    };
  },
  encode(w: Writer, v: ObjectAdd): void {
    w.u16(v.objects.length);
    for (const item of v.objects) {
      ObjectFull.encode(w, item);
    }
    w.u16(v.drawings.length);
    for (const item of v.drawings) {
      PrimDrawings.encode(w, item);
    }
  },
  decode(r: Reader): ObjectAdd {
    const objects: ObjectFull[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      objects.push(ObjectFull.decode(r));
    }
    const drawings: PrimDrawings[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      drawings.push(PrimDrawings.decode(r));
    }
    return { objects, drawings };
  },
};

export interface ObjectUpdate {
  fields: number;
  object: ObjectFull;
  drawings: FaceDrawing[];
}

export const ObjectUpdate = {
  ID: 51 as const,
  NAME: "ObjectUpdate" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): ObjectUpdate {
    return {
      fields: 0,
      object: ObjectFull.create(),
      drawings: [],
    };
  },
  encode(w: Writer, v: ObjectUpdate): void {
    w.u32(v.fields);
    ObjectFull.encode(w, v.object);
    w.u16(v.drawings.length);
    for (const item of v.drawings) {
      FaceDrawing.encode(w, item);
    }
  },
  decode(r: Reader): ObjectUpdate {
    const fields = r.remaining > 0 ? r.u32() : 0;
    const object = r.remaining > 0 ? ObjectFull.decode(r) : ObjectFull.create();
    const drawings: FaceDrawing[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      drawings.push(FaceDrawing.decode(r));
    }
    return { fields, object, drawings };
  },
};

export interface ObjectMoveBatch {
  moves: ObjectMove[];
}

export const ObjectMoveBatch = {
  ID: 52 as const,
  NAME: "ObjectMoveBatch" as const,
  CHANNEL: Channel.Unreliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): ObjectMoveBatch {
    return {
      moves: [],
    };
  },
  encode(w: Writer, v: ObjectMoveBatch): void {
    w.u16(v.moves.length);
    for (const item of v.moves) {
      ObjectMove.encode(w, item);
    }
  },
  decode(r: Reader): ObjectMoveBatch {
    const moves: ObjectMove[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      moves.push(ObjectMove.decode(r));
    }
    return { moves };
  },
};

export interface ObjectRemove {
  ids: number[];
}

export const ObjectRemove = {
  ID: 53 as const,
  NAME: "ObjectRemove" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): ObjectRemove {
    return {
      ids: [],
    };
  },
  encode(w: Writer, v: ObjectRemove): void {
    w.u16(v.ids.length);
    for (const item of v.ids) {
      w.u32(item);
    }
  },
  decode(r: Reader): ObjectRemove {
    const ids: number[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      ids.push(r.u32());
    }
    return { ids };
  },
};

export interface ObjectCreate {
  shape: PrimShape;
  position: Vec3;
  rotation: Quat;
  scale: Vec3;
  material: MaterialType;
  ray_end: Vec3;
  ray_target: number;
}

export const ObjectCreate = {
  ID: 54 as const,
  NAME: "ObjectCreate" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectCreate {
    return {
      shape: PrimShape.create(),
      position: { x: 0, y: 0, z: 0 },
      rotation: { x: 0, y: 0, z: 0, w: 1 },
      scale: { x: 0, y: 0, z: 0 },
      material: MaterialType.Stone,
      ray_end: { x: 0, y: 0, z: 0 },
      ray_target: 0,
    };
  },
  encode(w: Writer, v: ObjectCreate): void {
    PrimShape.encode(w, v.shape);
    w.vec3(v.position);
    w.quat(v.rotation);
    w.vec3(v.scale);
    w.u8(v.material);
    w.vec3(v.ray_end);
    w.u32(v.ray_target);
  },
  decode(r: Reader): ObjectCreate {
    const shape = r.remaining > 0 ? PrimShape.decode(r) : PrimShape.create();
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const rotation = r.remaining > 0 ? r.quat() : { x: 0, y: 0, z: 0, w: 1 };
    const scale = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const material = r.remaining > 0 ? r.enumValue(MATERIAL_TYPE_VALUES, r.u8()) as MaterialType : MaterialType.Stone;
    const ray_end = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const ray_target = r.remaining > 0 ? r.u32() : 0;
    return { shape, position, rotation, scale, material, ray_end, ray_target };
  },
};

export interface ObjectEdit {
  id: number;
  op: EditOp;
  position: Vec3;
  rotation: Quat;
  scale: Vec3;
  linkset: boolean;
}

export const ObjectEdit = {
  ID: 55 as const,
  NAME: "ObjectEdit" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectEdit {
    return {
      id: 0,
      op: EditOp.Move,
      position: { x: 0, y: 0, z: 0 },
      rotation: { x: 0, y: 0, z: 0, w: 1 },
      scale: { x: 0, y: 0, z: 0 },
      linkset: false,
    };
  },
  encode(w: Writer, v: ObjectEdit): void {
    w.u32(v.id);
    w.u8(v.op);
    w.vec3(v.position);
    w.quat(v.rotation);
    w.vec3(v.scale);
    w.bool(v.linkset);
  },
  decode(r: Reader): ObjectEdit {
    const id = r.remaining > 0 ? r.u32() : 0;
    const op = r.remaining > 0 ? r.enumValue(EDIT_OP_VALUES, r.u8()) as EditOp : EditOp.Move;
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const rotation = r.remaining > 0 ? r.quat() : { x: 0, y: 0, z: 0, w: 1 };
    const scale = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const linkset = r.remaining > 0 ? r.bool() : false;
    return { id, op, position, rotation, scale, linkset };
  },
};

export interface ObjectSetShape {
  id: number;
  shape: PrimShape;
}

export const ObjectSetShape = {
  ID: 56 as const,
  NAME: "ObjectSetShape" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectSetShape {
    return {
      id: 0,
      shape: PrimShape.create(),
    };
  },
  encode(w: Writer, v: ObjectSetShape): void {
    w.u32(v.id);
    PrimShape.encode(w, v.shape);
  },
  decode(r: Reader): ObjectSetShape {
    const id = r.remaining > 0 ? r.u32() : 0;
    const shape = r.remaining > 0 ? PrimShape.decode(r) : PrimShape.create();
    return { id, shape };
  },
};

export interface ObjectSetFaces {
  id: number;
  faces: TextureEntryFace[];
}

export const ObjectSetFaces = {
  ID: 57 as const,
  NAME: "ObjectSetFaces" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectSetFaces {
    return {
      id: 0,
      faces: [],
    };
  },
  encode(w: Writer, v: ObjectSetFaces): void {
    w.u32(v.id);
    w.u16(v.faces.length);
    for (const item of v.faces) {
      TextureEntryFace.encode(w, item);
    }
  },
  decode(r: Reader): ObjectSetFaces {
    const id = r.remaining > 0 ? r.u32() : 0;
    const faces: TextureEntryFace[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      faces.push(TextureEntryFace.decode(r));
    }
    return { id, faces };
  },
};

export interface ObjectSetFlags {
  id: number;
  flags: number;
  mask: number;
  physics: PhysicsParams;
}

export const ObjectSetFlags = {
  ID: 58 as const,
  NAME: "ObjectSetFlags" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectSetFlags {
    return {
      id: 0,
      flags: 0,
      mask: 0,
      physics: PhysicsParams.create(),
    };
  },
  encode(w: Writer, v: ObjectSetFlags): void {
    w.u32(v.id);
    w.u32(v.flags);
    w.u32(v.mask);
    PhysicsParams.encode(w, v.physics);
  },
  decode(r: Reader): ObjectSetFlags {
    const id = r.remaining > 0 ? r.u32() : 0;
    const flags = r.remaining > 0 ? r.u32() : 0;
    const mask = r.remaining > 0 ? r.u32() : 0;
    const physics = r.remaining > 0 ? PhysicsParams.decode(r) : PhysicsParams.create();
    return { id, flags, mask, physics };
  },
};

export interface ObjectSetNames {
  id: number;
  name: string;
  description: string;
}

export const ObjectSetNames = {
  ID: 59 as const,
  NAME: "ObjectSetNames" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectSetNames {
    return {
      id: 0,
      name: "",
      description: "",
    };
  },
  encode(w: Writer, v: ObjectSetNames): void {
    w.u32(v.id);
    w.string(v.name);
    w.string(v.description);
  },
  decode(r: Reader): ObjectSetNames {
    const id = r.remaining > 0 ? r.u32() : 0;
    const name = r.remaining > 0 ? r.string() : "";
    const description = r.remaining > 0 ? r.string() : "";
    return { id, name, description };
  },
};

export interface ObjectSetText {
  id: number;
  text: string;
  color: Color;
}

export const ObjectSetText = {
  ID: 60 as const,
  NAME: "ObjectSetText" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectSetText {
    return {
      id: 0,
      text: "",
      color: { r: 255, g: 255, b: 255, a: 255 },
    };
  },
  encode(w: Writer, v: ObjectSetText): void {
    w.u32(v.id);
    w.string(v.text);
    w.color(v.color);
  },
  decode(r: Reader): ObjectSetText {
    const id = r.remaining > 0 ? r.u32() : 0;
    const text = r.remaining > 0 ? r.string() : "";
    const color = r.remaining > 0 ? r.color() : { r: 255, g: 255, b: 255, a: 255 };
    return { id, text, color };
  },
};

export interface ObjectSetLight {
  id: number;
  light: LightParams;
}

export const ObjectSetLight = {
  ID: 61 as const,
  NAME: "ObjectSetLight" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectSetLight {
    return {
      id: 0,
      light: LightParams.create(),
    };
  },
  encode(w: Writer, v: ObjectSetLight): void {
    w.u32(v.id);
    LightParams.encode(w, v.light);
  },
  decode(r: Reader): ObjectSetLight {
    const id = r.remaining > 0 ? r.u32() : 0;
    const light = r.remaining > 0 ? LightParams.decode(r) : LightParams.create();
    return { id, light };
  },
};

export interface ObjectSetFlexible {
  id: number;
  flexible: FlexibleParams;
}

export const ObjectSetFlexible = {
  ID: 62 as const,
  NAME: "ObjectSetFlexible" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectSetFlexible {
    return {
      id: 0,
      flexible: FlexibleParams.create(),
    };
  },
  encode(w: Writer, v: ObjectSetFlexible): void {
    w.u32(v.id);
    FlexibleParams.encode(w, v.flexible);
  },
  decode(r: Reader): ObjectSetFlexible {
    const id = r.remaining > 0 ? r.u32() : 0;
    const flexible = r.remaining > 0 ? FlexibleParams.decode(r) : FlexibleParams.create();
    return { id, flexible };
  },
};

export interface ObjectSetParticles {
  id: number;
  particles: ParticleParams;
}

export const ObjectSetParticles = {
  ID: 63 as const,
  NAME: "ObjectSetParticles" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectSetParticles {
    return {
      id: 0,
      particles: ParticleParams.create(),
    };
  },
  encode(w: Writer, v: ObjectSetParticles): void {
    w.u32(v.id);
    ParticleParams.encode(w, v.particles);
  },
  decode(r: Reader): ObjectSetParticles {
    const id = r.remaining > 0 ? r.u32() : 0;
    const particles = r.remaining > 0 ? ParticleParams.decode(r) : ParticleParams.create();
    return { id, particles };
  },
};

export interface ObjectSetMaterial {
  id: number;
  material: MaterialType;
}

export const ObjectSetMaterial = {
  ID: 64 as const,
  NAME: "ObjectSetMaterial" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectSetMaterial {
    return {
      id: 0,
      material: MaterialType.Stone,
    };
  },
  encode(w: Writer, v: ObjectSetMaterial): void {
    w.u32(v.id);
    w.u8(v.material);
  },
  decode(r: Reader): ObjectSetMaterial {
    const id = r.remaining > 0 ? r.u32() : 0;
    const material = r.remaining > 0 ? r.enumValue(MATERIAL_TYPE_VALUES, r.u8()) as MaterialType : MaterialType.Stone;
    return { id, material };
  },
};

export interface ObjectSetPermissions {
  id: number;
  permissions: Permissions;
  sale_price: number;
  for_sale: boolean;
}

export const ObjectSetPermissions = {
  ID: 65 as const,
  NAME: "ObjectSetPermissions" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectSetPermissions {
    return {
      id: 0,
      permissions: Permissions.create(),
      sale_price: 0,
      for_sale: false,
    };
  },
  encode(w: Writer, v: ObjectSetPermissions): void {
    w.u32(v.id);
    Permissions.encode(w, v.permissions);
    w.i32(v.sale_price);
    w.bool(v.for_sale);
  },
  decode(r: Reader): ObjectSetPermissions {
    const id = r.remaining > 0 ? r.u32() : 0;
    const permissions = r.remaining > 0 ? Permissions.decode(r) : Permissions.create();
    const sale_price = r.remaining > 0 ? r.i32() : 0;
    const for_sale = r.remaining > 0 ? r.bool() : false;
    return { id, permissions, sale_price, for_sale };
  },
};

export interface ObjectLink {
  root: number;
  children: number[];
}

export const ObjectLink = {
  ID: 66 as const,
  NAME: "ObjectLink" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectLink {
    return {
      root: 0,
      children: [],
    };
  },
  encode(w: Writer, v: ObjectLink): void {
    w.u32(v.root);
    w.u16(v.children.length);
    for (const item of v.children) {
      w.u32(item);
    }
  },
  decode(r: Reader): ObjectLink {
    const root = r.remaining > 0 ? r.u32() : 0;
    const children: number[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      children.push(r.u32());
    }
    return { root, children };
  },
};

export interface ObjectUnlink {
  ids: number[];
}

export const ObjectUnlink = {
  ID: 67 as const,
  NAME: "ObjectUnlink" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectUnlink {
    return {
      ids: [],
    };
  },
  encode(w: Writer, v: ObjectUnlink): void {
    w.u16(v.ids.length);
    for (const item of v.ids) {
      w.u32(item);
    }
  },
  decode(r: Reader): ObjectUnlink {
    const ids: number[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      ids.push(r.u32());
    }
    return { ids };
  },
};

export interface ObjectDelete {
  ids: number[];
  to_trash: boolean;
}

export const ObjectDelete = {
  ID: 68 as const,
  NAME: "ObjectDelete" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectDelete {
    return {
      ids: [],
      to_trash: false,
    };
  },
  encode(w: Writer, v: ObjectDelete): void {
    w.u16(v.ids.length);
    for (const item of v.ids) {
      w.u32(item);
    }
    w.bool(v.to_trash);
  },
  decode(r: Reader): ObjectDelete {
    const ids: number[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      ids.push(r.u32());
    }
    const to_trash = r.remaining > 0 ? r.bool() : false;
    return { ids, to_trash };
  },
};

export interface ObjectDuplicate {
  ids: number[];
  offset: Vec3;
}

export const ObjectDuplicate = {
  ID: 69 as const,
  NAME: "ObjectDuplicate" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectDuplicate {
    return {
      ids: [],
      offset: { x: 0, y: 0, z: 0 },
    };
  },
  encode(w: Writer, v: ObjectDuplicate): void {
    w.u16(v.ids.length);
    for (const item of v.ids) {
      w.u32(item);
    }
    w.vec3(v.offset);
  },
  decode(r: Reader): ObjectDuplicate {
    const ids: number[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      ids.push(r.u32());
    }
    const offset = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    return { ids, offset };
  },
};

export interface ObjectSelect {
  ids: number[];
  selected: boolean;
}

export const ObjectSelect = {
  ID: 70 as const,
  NAME: "ObjectSelect" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectSelect {
    return {
      ids: [],
      selected: false,
    };
  },
  encode(w: Writer, v: ObjectSelect): void {
    w.u16(v.ids.length);
    for (const item of v.ids) {
      w.u32(item);
    }
    w.bool(v.selected);
  },
  decode(r: Reader): ObjectSelect {
    const ids: number[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      ids.push(r.u32());
    }
    const selected = r.remaining > 0 ? r.bool() : false;
    return { ids, selected };
  },
};

export interface ObjectTake {
  ids: number[];
  copy: boolean;
  folder: Uuid;
}

export const ObjectTake = {
  ID: 71 as const,
  NAME: "ObjectTake" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectTake {
    return {
      ids: [],
      copy: false,
      folder: NULL_UUID,
    };
  },
  encode(w: Writer, v: ObjectTake): void {
    w.u16(v.ids.length);
    for (const item of v.ids) {
      w.u32(item);
    }
    w.bool(v.copy);
    w.uuid(v.folder);
  },
  decode(r: Reader): ObjectTake {
    const ids: number[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      ids.push(r.u32());
    }
    const copy = r.remaining > 0 ? r.bool() : false;
    const folder = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { ids, copy, folder };
  },
};

export interface ObjectRez {
  item: Uuid;
  position: Vec3;
  rotation: Quat;
  ray_target: number;
}

export const ObjectRez = {
  ID: 72 as const,
  NAME: "ObjectRez" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectRez {
    return {
      item: NULL_UUID,
      position: { x: 0, y: 0, z: 0 },
      rotation: { x: 0, y: 0, z: 0, w: 1 },
      ray_target: 0,
    };
  },
  encode(w: Writer, v: ObjectRez): void {
    w.uuid(v.item);
    w.vec3(v.position);
    w.quat(v.rotation);
    w.u32(v.ray_target);
  },
  decode(r: Reader): ObjectRez {
    const item = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const rotation = r.remaining > 0 ? r.quat() : { x: 0, y: 0, z: 0, w: 1 };
    const ray_target = r.remaining > 0 ? r.u32() : 0;
    return { item, position, rotation, ray_target };
  },
};

export interface ObjectTouch {
  id: number;
  face: number;
  position: Vec3;
  uv: Vec2;
  start: boolean;
}

export const ObjectTouch = {
  ID: 73 as const,
  NAME: "ObjectTouch" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectTouch {
    return {
      id: 0,
      face: 0,
      position: { x: 0, y: 0, z: 0 },
      uv: { x: 0, y: 0 },
      start: false,
    };
  },
  encode(w: Writer, v: ObjectTouch): void {
    w.u32(v.id);
    w.u8(v.face);
    w.vec3(v.position);
    w.vec2(v.uv);
    w.bool(v.start);
  },
  decode(r: Reader): ObjectTouch {
    const id = r.remaining > 0 ? r.u32() : 0;
    const face = r.remaining > 0 ? r.u8() : 0;
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const uv = r.remaining > 0 ? r.vec2() : { x: 0, y: 0 };
    const start = r.remaining > 0 ? r.bool() : false;
    return { id, face, position, uv, start };
  },
};

export interface ObjectGrab {
  id: number;
  offset: Vec3;
  active: boolean;
}

export const ObjectGrab = {
  ID: 74 as const,
  NAME: "ObjectGrab" as const,
  CHANNEL: Channel.Unreliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectGrab {
    return {
      id: 0,
      offset: { x: 0, y: 0, z: 0 },
      active: false,
    };
  },
  encode(w: Writer, v: ObjectGrab): void {
    w.u32(v.id);
    w.vec3(v.offset);
    w.bool(v.active);
  },
  decode(r: Reader): ObjectGrab {
    const id = r.remaining > 0 ? r.u32() : 0;
    const offset = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const active = r.remaining > 0 ? r.bool() : false;
    return { id, offset, active };
  },
};

export interface ObjectSit {
  id: number;
  offset: Vec3;
}

export const ObjectSit = {
  ID: 75 as const,
  NAME: "ObjectSit" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectSit {
    return {
      id: 0,
      offset: { x: 0, y: 0, z: 0 },
    };
  },
  encode(w: Writer, v: ObjectSit): void {
    w.u32(v.id);
    w.vec3(v.offset);
  },
  decode(r: Reader): ObjectSit {
    const id = r.remaining > 0 ? r.u32() : 0;
    const offset = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    return { id, offset };
  },
};

export interface ObjectStand {
}

export const ObjectStand = {
  ID: 76 as const,
  NAME: "ObjectStand" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectStand {
    return {
    };
  },
  encode(w: Writer, v: ObjectStand): void {
    void w;
    void v;
  },
  decode(r: Reader): ObjectStand {
    void r;
    return {};
  },
};

export interface ObjectPay {
  id: number;
  amount: number;
}

export const ObjectPay = {
  ID: 77 as const,
  NAME: "ObjectPay" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectPay {
    return {
      id: 0,
      amount: 0,
    };
  },
  encode(w: Writer, v: ObjectPay): void {
    w.u32(v.id);
    w.i32(v.amount);
  },
  decode(r: Reader): ObjectPay {
    const id = r.remaining > 0 ? r.u32() : 0;
    const amount = r.remaining > 0 ? r.i32() : 0;
    return { id, amount };
  },
};

export interface ObjectBuy {
  id: number;
  price: number;
}

export const ObjectBuy = {
  ID: 78 as const,
  NAME: "ObjectBuy" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectBuy {
    return {
      id: 0,
      price: 0,
    };
  },
  encode(w: Writer, v: ObjectBuy): void {
    w.u32(v.id);
    w.i32(v.price);
  },
  decode(r: Reader): ObjectBuy {
    const id = r.remaining > 0 ? r.u32() : 0;
    const price = r.remaining > 0 ? r.i32() : 0;
    return { id, price };
  },
};

export interface ObjectSetMesh {
  id: number;
  mesh_asset: Uuid;
}

export const ObjectSetMesh = {
  ID: 79 as const,
  NAME: "ObjectSetMesh" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectSetMesh {
    return {
      id: 0,
      mesh_asset: NULL_UUID,
    };
  },
  encode(w: Writer, v: ObjectSetMesh): void {
    w.u32(v.id);
    w.uuid(v.mesh_asset);
  },
  decode(r: Reader): ObjectSetMesh {
    const id = r.remaining > 0 ? r.u32() : 0;
    const mesh_asset = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { id, mesh_asset };
  },
};

export interface ObjectSetSit {
  id: number;
  offset: Vec3;
  rotation: Quat;
  click_action: number;
}

export const ObjectSetSit = {
  ID: 80 as const,
  NAME: "ObjectSetSit" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectSetSit {
    return {
      id: 0,
      offset: { x: 0, y: 0, z: 0 },
      rotation: { x: 0, y: 0, z: 0, w: 1 },
      click_action: 0,
    };
  },
  encode(w: Writer, v: ObjectSetSit): void {
    w.u32(v.id);
    w.vec3(v.offset);
    w.quat(v.rotation);
    w.u8(v.click_action);
  },
  decode(r: Reader): ObjectSetSit {
    const id = r.remaining > 0 ? r.u32() : 0;
    const offset = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const rotation = r.remaining > 0 ? r.quat() : { x: 0, y: 0, z: 0, w: 1 };
    const click_action = r.remaining > 0 ? r.u8() : 0;
    return { id, offset, rotation, click_action };
  },
};

export interface ObjectSetMedia {
  id: number;
  media: MediaEntry[];
}

export const ObjectSetMedia = {
  ID: 81 as const,
  NAME: "ObjectSetMedia" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectSetMedia {
    return {
      id: 0,
      media: [],
    };
  },
  encode(w: Writer, v: ObjectSetMedia): void {
    w.u32(v.id);
    w.u16(v.media.length);
    for (const item of v.media) {
      MediaEntry.encode(w, item);
    }
  },
  decode(r: Reader): ObjectSetMedia {
    const id = r.remaining > 0 ? r.u32() : 0;
    const media: MediaEntry[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      media.push(MediaEntry.decode(r));
    }
    return { id, media };
  },
};

export interface ObjectAttach {
  item: Uuid;
  point: AttachPoint;
}

export const ObjectAttach = {
  ID: 82 as const,
  NAME: "ObjectAttach" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectAttach {
    return {
      item: NULL_UUID,
      point: AttachPoint.None,
    };
  },
  encode(w: Writer, v: ObjectAttach): void {
    w.uuid(v.item);
    w.u8(v.point);
  },
  decode(r: Reader): ObjectAttach {
    const item = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const point = r.remaining > 0 ? r.enumValue(ATTACH_POINT_VALUES, r.u8()) as AttachPoint : AttachPoint.None;
    return { item, point };
  },
};

export interface ObjectDetach {
  item: Uuid;
}

export const ObjectDetach = {
  ID: 83 as const,
  NAME: "ObjectDetach" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectDetach {
    return {
      item: NULL_UUID,
    };
  },
  encode(w: Writer, v: ObjectDetach): void {
    w.uuid(v.item);
  },
  decode(r: Reader): ObjectDetach {
    const item = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { item };
  },
};

export interface ObjectSetOwner {
  ids: number[];
  owner: Uuid;
  group: Uuid;
}

export const ObjectSetOwner = {
  ID: 84 as const,
  NAME: "ObjectSetOwner" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectSetOwner {
    return {
      ids: [],
      owner: NULL_UUID,
      group: NULL_UUID,
    };
  },
  encode(w: Writer, v: ObjectSetOwner): void {
    w.u16(v.ids.length);
    for (const item of v.ids) {
      w.u32(item);
    }
    w.uuid(v.owner);
    w.uuid(v.group);
  },
  decode(r: Reader): ObjectSetOwner {
    const ids: number[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      ids.push(r.u32());
    }
    const owner = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { ids, owner, group };
  },
};

export interface ObjectRequestFull {
  ids: number[];
}

export const ObjectRequestFull = {
  ID: 85 as const,
  NAME: "ObjectRequestFull" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectRequestFull {
    return {
      ids: [],
    };
  },
  encode(w: Writer, v: ObjectRequestFull): void {
    w.u16(v.ids.length);
    for (const item of v.ids) {
      w.u32(item);
    }
  },
  decode(r: Reader): ObjectRequestFull {
    const ids: number[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      ids.push(r.u32());
    }
    return { ids };
  },
};

export interface ObjectSelected {
  id: number;
  by: Uuid;
  selected: boolean;
}

export const ObjectSelected = {
  ID: 86 as const,
  NAME: "ObjectSelected" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): ObjectSelected {
    return {
      id: 0,
      by: NULL_UUID,
      selected: false,
    };
  },
  encode(w: Writer, v: ObjectSelected): void {
    w.u32(v.id);
    w.uuid(v.by);
    w.bool(v.selected);
  },
  decode(r: Reader): ObjectSelected {
    const id = r.remaining > 0 ? r.u32() : 0;
    const by = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const selected = r.remaining > 0 ? r.bool() : false;
    return { id, by, selected };
  },
};

export interface AgentInput {
  sequence: number;
  controls: number;
  yaw: number;
  pitch: number;
  camera_position: Vec3;
  camera_forward: Vec3;
  draw_distance: number;
  dt: number;
  position: Vec3;
}

export const AgentInput = {
  ID: 100 as const,
  NAME: "AgentInput" as const,
  CHANNEL: Channel.Unreliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): AgentInput {
    return {
      sequence: 0,
      controls: 0,
      yaw: 0,
      pitch: 0,
      camera_position: { x: 0, y: 0, z: 0 },
      camera_forward: { x: 0, y: 0, z: 0 },
      draw_distance: 0,
      dt: 0,
      position: { x: 0, y: 0, z: 0 },
    };
  },
  encode(w: Writer, v: AgentInput): void {
    w.u32(v.sequence);
    w.u32(v.controls);
    w.f32(v.yaw);
    w.f32(v.pitch);
    w.vec3(v.camera_position);
    w.vec3(v.camera_forward);
    w.f32(v.draw_distance);
    w.f32(v.dt);
    w.vec3(v.position);
  },
  decode(r: Reader): AgentInput {
    const sequence = r.remaining > 0 ? r.u32() : 0;
    const controls = r.remaining > 0 ? r.u32() : 0;
    const yaw = r.remaining > 0 ? r.f32() : 0;
    const pitch = r.remaining > 0 ? r.f32() : 0;
    const camera_position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const camera_forward = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const draw_distance = r.remaining > 0 ? r.f32() : 0;
    const dt = r.remaining > 0 ? r.f32() : 0;
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    return { sequence, controls, yaw, pitch, camera_position, camera_forward, draw_distance, dt, position };
  },
};

export interface AgentPoseBatch {
  poses: AgentPose[];
  last_input_sequence: number;
}

export const AgentPoseBatch = {
  ID: 101 as const,
  NAME: "AgentPoseBatch" as const,
  CHANNEL: Channel.Unreliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): AgentPoseBatch {
    return {
      poses: [],
      last_input_sequence: 0,
    };
  },
  encode(w: Writer, v: AgentPoseBatch): void {
    w.u16(v.poses.length);
    for (const item of v.poses) {
      AgentPose.encode(w, item);
    }
    w.u32(v.last_input_sequence);
  },
  decode(r: Reader): AgentPoseBatch {
    const poses: AgentPose[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      poses.push(AgentPose.decode(r));
    }
    const last_input_sequence = r.remaining > 0 ? r.u32() : 0;
    return { poses, last_input_sequence };
  },
};

export interface AgentJoin {
  id: Uuid;
  local_id: number;
  username: string;
  display_name: string;
  group_title: string;
  position: Vec3;
  rotation: Quat;
  appearance: Appearance;
  is_child: boolean;
  is_bot: boolean;
  typing: boolean;
  away: boolean;
  health: number;
  menu: string[];
  frozen: boolean;
  admin: boolean;
}

export const AgentJoin = {
  ID: 102 as const,
  NAME: "AgentJoin" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): AgentJoin {
    return {
      id: NULL_UUID,
      local_id: 0,
      username: "",
      display_name: "",
      group_title: "",
      position: { x: 0, y: 0, z: 0 },
      rotation: { x: 0, y: 0, z: 0, w: 1 },
      appearance: Appearance.create(),
      is_child: false,
      is_bot: false,
      typing: false,
      away: false,
      health: 0,
      menu: [],
      frozen: false,
      admin: false,
    };
  },
  encode(w: Writer, v: AgentJoin): void {
    w.uuid(v.id);
    w.u32(v.local_id);
    w.string(v.username);
    w.string(v.display_name);
    w.string(v.group_title);
    w.vec3(v.position);
    w.quat(v.rotation);
    Appearance.encode(w, v.appearance);
    w.bool(v.is_child);
    w.bool(v.is_bot);
    w.bool(v.typing);
    w.bool(v.away);
    w.f32(v.health);
    w.u16(v.menu.length);
    for (const item of v.menu) {
      w.string(item);
    }
    w.bool(v.frozen);
    w.bool(v.admin);
  },
  decode(r: Reader): AgentJoin {
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const local_id = r.remaining > 0 ? r.u32() : 0;
    const username = r.remaining > 0 ? r.string() : "";
    const display_name = r.remaining > 0 ? r.string() : "";
    const group_title = r.remaining > 0 ? r.string() : "";
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const rotation = r.remaining > 0 ? r.quat() : { x: 0, y: 0, z: 0, w: 1 };
    const appearance = r.remaining > 0 ? Appearance.decode(r) : Appearance.create();
    const is_child = r.remaining > 0 ? r.bool() : false;
    const is_bot = r.remaining > 0 ? r.bool() : false;
    const typing = r.remaining > 0 ? r.bool() : false;
    const away = r.remaining > 0 ? r.bool() : false;
    const health = r.remaining > 0 ? r.f32() : 0;
    const menu: string[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      menu.push(r.string());
    }
    const frozen = r.remaining > 0 ? r.bool() : false;
    const admin = r.remaining > 0 ? r.bool() : false;
    return { id, local_id, username, display_name, group_title, position, rotation, appearance, is_child, is_bot, typing, away, health, menu, frozen, admin };
  },
};

export interface AgentLeave {
  id: Uuid;
}

export const AgentLeave = {
  ID: 103 as const,
  NAME: "AgentLeave" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): AgentLeave {
    return {
      id: NULL_UUID,
    };
  },
  encode(w: Writer, v: AgentLeave): void {
    w.uuid(v.id);
  },
  decode(r: Reader): AgentLeave {
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { id };
  },
};

export interface AgentAppearanceUpdate {
  id: Uuid;
  appearance: Appearance;
}

export const AgentAppearanceUpdate = {
  ID: 104 as const,
  NAME: "AgentAppearanceUpdate" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): AgentAppearanceUpdate {
    return {
      id: NULL_UUID,
      appearance: Appearance.create(),
    };
  },
  encode(w: Writer, v: AgentAppearanceUpdate): void {
    w.uuid(v.id);
    Appearance.encode(w, v.appearance);
  },
  decode(r: Reader): AgentAppearanceUpdate {
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const appearance = r.remaining > 0 ? Appearance.decode(r) : Appearance.create();
    return { id, appearance };
  },
};

export interface AgentSetAppearance {
  appearance: Appearance;
}

export const AgentSetAppearance = {
  ID: 105 as const,
  NAME: "AgentSetAppearance" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): AgentSetAppearance {
    return {
      appearance: Appearance.create(),
    };
  },
  encode(w: Writer, v: AgentSetAppearance): void {
    Appearance.encode(w, v.appearance);
  },
  decode(r: Reader): AgentSetAppearance {
    const appearance = r.remaining > 0 ? Appearance.decode(r) : Appearance.create();
    return { appearance };
  },
};

export interface AgentAnimationUpdate {
  id: Uuid;
  animations: Uuid[];
  sequences: number[];
}

export const AgentAnimationUpdate = {
  ID: 106 as const,
  NAME: "AgentAnimationUpdate" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): AgentAnimationUpdate {
    return {
      id: NULL_UUID,
      animations: [],
      sequences: [],
    };
  },
  encode(w: Writer, v: AgentAnimationUpdate): void {
    w.uuid(v.id);
    w.u16(v.animations.length);
    for (const item of v.animations) {
      w.uuid(item);
    }
    w.u16(v.sequences.length);
    for (const item of v.sequences) {
      w.u32(item);
    }
  },
  decode(r: Reader): AgentAnimationUpdate {
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const animations: Uuid[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      animations.push(r.uuid());
    }
    const sequences: number[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      sequences.push(r.u32());
    }
    return { id, animations, sequences };
  },
};

export interface AgentAnimationPlay {
  animation: Uuid;
  start: boolean;
}

export const AgentAnimationPlay = {
  ID: 107 as const,
  NAME: "AgentAnimationPlay" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): AgentAnimationPlay {
    return {
      animation: NULL_UUID,
      start: false,
    };
  },
  encode(w: Writer, v: AgentAnimationPlay): void {
    w.uuid(v.animation);
    w.bool(v.start);
  },
  decode(r: Reader): AgentAnimationPlay {
    const animation = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const start = r.remaining > 0 ? r.bool() : false;
    return { animation, start };
  },
};

export interface AgentTyping {
  id: Uuid;
  typing: boolean;
}

export const AgentTyping = {
  ID: 108 as const,
  NAME: "AgentTyping" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.Both,
  SINCE: 1,
  create(): AgentTyping {
    return {
      id: NULL_UUID,
      typing: false,
    };
  },
  encode(w: Writer, v: AgentTyping): void {
    w.uuid(v.id);
    w.bool(v.typing);
  },
  decode(r: Reader): AgentTyping {
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const typing = r.remaining > 0 ? r.bool() : false;
    return { id, typing };
  },
};

export interface AgentAway {
  id: Uuid;
  away: boolean;
}

export const AgentAway = {
  ID: 109 as const,
  NAME: "AgentAway" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.Both,
  SINCE: 1,
  create(): AgentAway {
    return {
      id: NULL_UUID,
      away: false,
    };
  },
  encode(w: Writer, v: AgentAway): void {
    w.uuid(v.id);
    w.bool(v.away);
  },
  decode(r: Reader): AgentAway {
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const away = r.remaining > 0 ? r.bool() : false;
    return { id, away };
  },
};

export interface AgentSit {
  id: Uuid;
  object: number;
  offset: Vec3;
  rotation: Quat;
  sitting: boolean;
}

export const AgentSit = {
  ID: 110 as const,
  NAME: "AgentSit" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): AgentSit {
    return {
      id: NULL_UUID,
      object: 0,
      offset: { x: 0, y: 0, z: 0 },
      rotation: { x: 0, y: 0, z: 0, w: 1 },
      sitting: false,
    };
  },
  encode(w: Writer, v: AgentSit): void {
    w.uuid(v.id);
    w.u32(v.object);
    w.vec3(v.offset);
    w.quat(v.rotation);
    w.bool(v.sitting);
  },
  decode(r: Reader): AgentSit {
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const object = r.remaining > 0 ? r.u32() : 0;
    const offset = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const rotation = r.remaining > 0 ? r.quat() : { x: 0, y: 0, z: 0, w: 1 };
    const sitting = r.remaining > 0 ? r.bool() : false;
    return { id, object, offset, rotation, sitting };
  },
};

export interface AgentHealth {
  health: number;
  max_health: number;
  mana: number;
  max_mana: number;
}

export const AgentHealth = {
  ID: 111 as const,
  NAME: "AgentHealth" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): AgentHealth {
    return {
      health: 0,
      max_health: 0,
      mana: 0,
      max_mana: 0,
    };
  },
  encode(w: Writer, v: AgentHealth): void {
    w.f32(v.health);
    w.f32(v.max_health);
    w.f32(v.mana);
    w.f32(v.max_mana);
  },
  decode(r: Reader): AgentHealth {
    const health = r.remaining > 0 ? r.f32() : 0;
    const max_health = r.remaining > 0 ? r.f32() : 0;
    const mana = r.remaining > 0 ? r.f32() : 0;
    const max_mana = r.remaining > 0 ? r.f32() : 0;
    return { health, max_health, mana, max_mana };
  },
};

export interface AgentTeleportRequest {
  region: string;
  region_id: Uuid;
  position: Vec3;
  look_at: Vec3;
  landmark: Uuid;
  home: boolean;
}

export const AgentTeleportRequest = {
  ID: 112 as const,
  NAME: "AgentTeleportRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): AgentTeleportRequest {
    return {
      region: "",
      region_id: NULL_UUID,
      position: { x: 0, y: 0, z: 0 },
      look_at: { x: 0, y: 0, z: 0 },
      landmark: NULL_UUID,
      home: false,
    };
  },
  encode(w: Writer, v: AgentTeleportRequest): void {
    w.string(v.region);
    w.uuid(v.region_id);
    w.vec3(v.position);
    w.vec3(v.look_at);
    w.uuid(v.landmark);
    w.bool(v.home);
  },
  decode(r: Reader): AgentTeleportRequest {
    const region = r.remaining > 0 ? r.string() : "";
    const region_id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const look_at = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const landmark = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const home = r.remaining > 0 ? r.bool() : false;
    return { region, region_id, position, look_at, landmark, home };
  },
};

export interface AgentTeleportStatus {
  status: TeleportStatus;
  message: string;
  region: Endpoint;
  region_id: Uuid;
  region_name: string;
  position: Vec3;
  look_at: Vec3;
  token: Uint8Array;
  velocity: Vec3;
}

export const AgentTeleportStatus = {
  ID: 113 as const,
  NAME: "AgentTeleportStatus" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): AgentTeleportStatus {
    return {
      status: TeleportStatus.Started,
      message: "",
      region: Endpoint.create(),
      region_id: NULL_UUID,
      region_name: "",
      position: { x: 0, y: 0, z: 0 },
      look_at: { x: 0, y: 0, z: 0 },
      token: new Uint8Array(0),
      velocity: { x: 0, y: 0, z: 0 },
    };
  },
  encode(w: Writer, v: AgentTeleportStatus): void {
    w.u8(v.status);
    w.string(v.message);
    Endpoint.encode(w, v.region);
    w.uuid(v.region_id);
    w.string(v.region_name);
    w.vec3(v.position);
    w.vec3(v.look_at);
    w.bytes(v.token);
    w.vec3(v.velocity);
  },
  decode(r: Reader): AgentTeleportStatus {
    const status = r.remaining > 0 ? r.enumValue(TELEPORT_STATUS_VALUES, r.u8()) as TeleportStatus : TeleportStatus.Started;
    const message = r.remaining > 0 ? r.string() : "";
    const region = r.remaining > 0 ? Endpoint.decode(r) : Endpoint.create();
    const region_id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const region_name = r.remaining > 0 ? r.string() : "";
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const look_at = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const token = r.remaining > 0 ? r.bytes() : new Uint8Array(0);
    const velocity = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    return { status, message, region, region_id, region_name, position, look_at, token, velocity };
  },
};

export interface AgentTeleportLure {
  from: Uuid;
  to: Uuid;
  message: string;
  lure_id: Uuid;
  region_id: Uuid;
  position: Vec3;
}

export const AgentTeleportLure = {
  ID: 114 as const,
  NAME: "AgentTeleportLure" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.Both,
  SINCE: 1,
  create(): AgentTeleportLure {
    return {
      from: NULL_UUID,
      to: NULL_UUID,
      message: "",
      lure_id: NULL_UUID,
      region_id: NULL_UUID,
      position: { x: 0, y: 0, z: 0 },
    };
  },
  encode(w: Writer, v: AgentTeleportLure): void {
    w.uuid(v.from);
    w.uuid(v.to);
    w.string(v.message);
    w.uuid(v.lure_id);
    w.uuid(v.region_id);
    w.vec3(v.position);
  },
  decode(r: Reader): AgentTeleportLure {
    const from = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const to = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const message = r.remaining > 0 ? r.string() : "";
    const lure_id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const region_id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    return { from, to, message, lure_id, region_id, position };
  },
};

export interface AgentTeleportLureAccept {
  lure_id: Uuid;
}

export const AgentTeleportLureAccept = {
  ID: 115 as const,
  NAME: "AgentTeleportLureAccept" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): AgentTeleportLureAccept {
    return {
      lure_id: NULL_UUID,
    };
  },
  encode(w: Writer, v: AgentTeleportLureAccept): void {
    w.uuid(v.lure_id);
  },
  decode(r: Reader): AgentTeleportLureAccept {
    const lure_id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { lure_id };
  },
};

export interface AgentSetHome {
}

export const AgentSetHome = {
  ID: 116 as const,
  NAME: "AgentSetHome" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): AgentSetHome {
    return {
    };
  },
  encode(w: Writer, v: AgentSetHome): void {
    void w;
    void v;
  },
  decode(r: Reader): AgentSetHome {
    void r;
    return {};
  },
};

export interface AgentTitleUpdate {
  id: Uuid;
  group_title: string;
  display_name: string;
  username: string;
}

export const AgentTitleUpdate = {
  ID: 117 as const,
  NAME: "AgentTitleUpdate" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): AgentTitleUpdate {
    return {
      id: NULL_UUID,
      group_title: "",
      display_name: "",
      username: "",
    };
  },
  encode(w: Writer, v: AgentTitleUpdate): void {
    w.uuid(v.id);
    w.string(v.group_title);
    w.string(v.display_name);
    w.string(v.username);
  },
  decode(r: Reader): AgentTitleUpdate {
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const group_title = r.remaining > 0 ? r.string() : "";
    const display_name = r.remaining > 0 ? r.string() : "";
    const username = r.remaining > 0 ? r.string() : "";
    return { id, group_title, display_name, username };
  },
};

export interface AgentCameraFollow {
  object: number;
  active: boolean;
  pitch: number;
  focus_offset: Vec3;
  position_lag: number;
  focus_lag: number;
  distance: number;
  behindness_angle: number;
  behindness_lag: number;
  position_threshold: number;
  focus_threshold: number;
  position: Vec3;
  focus: Vec3;
  has_position: boolean;
  has_focus: boolean;
  position_locked: boolean;
  focus_locked: boolean;
}

export const AgentCameraFollow = {
  ID: 118 as const,
  NAME: "AgentCameraFollow" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): AgentCameraFollow {
    return {
      object: 0,
      active: false,
      pitch: 0,
      focus_offset: { x: 0, y: 0, z: 0 },
      position_lag: 0,
      focus_lag: 0,
      distance: 0,
      behindness_angle: 0,
      behindness_lag: 0,
      position_threshold: 0,
      focus_threshold: 0,
      position: { x: 0, y: 0, z: 0 },
      focus: { x: 0, y: 0, z: 0 },
      has_position: false,
      has_focus: false,
      position_locked: false,
      focus_locked: false,
    };
  },
  encode(w: Writer, v: AgentCameraFollow): void {
    w.u32(v.object);
    w.bool(v.active);
    w.f32(v.pitch);
    w.vec3(v.focus_offset);
    w.f32(v.position_lag);
    w.f32(v.focus_lag);
    w.f32(v.distance);
    w.f32(v.behindness_angle);
    w.f32(v.behindness_lag);
    w.f32(v.position_threshold);
    w.f32(v.focus_threshold);
    w.vec3(v.position);
    w.vec3(v.focus);
    w.bool(v.has_position);
    w.bool(v.has_focus);
    w.bool(v.position_locked);
    w.bool(v.focus_locked);
  },
  decode(r: Reader): AgentCameraFollow {
    const object = r.remaining > 0 ? r.u32() : 0;
    const active = r.remaining > 0 ? r.bool() : false;
    const pitch = r.remaining > 0 ? r.f32() : 0;
    const focus_offset = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const position_lag = r.remaining > 0 ? r.f32() : 0;
    const focus_lag = r.remaining > 0 ? r.f32() : 0;
    const distance = r.remaining > 0 ? r.f32() : 0;
    const behindness_angle = r.remaining > 0 ? r.f32() : 0;
    const behindness_lag = r.remaining > 0 ? r.f32() : 0;
    const position_threshold = r.remaining > 0 ? r.f32() : 0;
    const focus_threshold = r.remaining > 0 ? r.f32() : 0;
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const focus = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const has_position = r.remaining > 0 ? r.bool() : false;
    const has_focus = r.remaining > 0 ? r.bool() : false;
    const position_locked = r.remaining > 0 ? r.bool() : false;
    const focus_locked = r.remaining > 0 ? r.bool() : false;
    return { object, active, pitch, focus_offset, position_lag, focus_lag, distance, behindness_angle, behindness_lag, position_threshold, focus_threshold, position, focus, has_position, has_focus, position_locked, focus_locked };
  },
};

export interface AgentEffect {
  id: Uuid;
  kind: number;
  target: Uuid;
  position: Vec3;
  color: Color;
  duration: number;
}

export const AgentEffect = {
  ID: 119 as const,
  NAME: "AgentEffect" as const,
  CHANNEL: Channel.Unreliable,
  DIRECTION: Direction.Both,
  SINCE: 1,
  create(): AgentEffect {
    return {
      id: NULL_UUID,
      kind: 0,
      target: NULL_UUID,
      position: { x: 0, y: 0, z: 0 },
      color: { r: 255, g: 255, b: 255, a: 255 },
      duration: 0,
    };
  },
  encode(w: Writer, v: AgentEffect): void {
    w.uuid(v.id);
    w.u8(v.kind);
    w.uuid(v.target);
    w.vec3(v.position);
    w.color(v.color);
    w.f32(v.duration);
  },
  decode(r: Reader): AgentEffect {
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const kind = r.remaining > 0 ? r.u8() : 0;
    const target = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const color = r.remaining > 0 ? r.color() : { r: 255, g: 255, b: 255, a: 255 };
    const duration = r.remaining > 0 ? r.f32() : 0;
    return { id, kind, target, position, color, duration };
  },
};

export interface AgentPushed {
  velocity: Vec3;
  position: Vec3;
}

export const AgentPushed = {
  ID: 120 as const,
  NAME: "AgentPushed" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): AgentPushed {
    return {
      velocity: { x: 0, y: 0, z: 0 },
      position: { x: 0, y: 0, z: 0 },
    };
  },
  encode(w: Writer, v: AgentPushed): void {
    w.vec3(v.velocity);
    w.vec3(v.position);
  },
  decode(r: Reader): AgentPushed {
    const velocity = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    return { velocity, position };
  },
};

export interface AgentControlGrant {
  object: number;
  controls: number;
  accept: boolean;
  pass_on: boolean;
}

export const AgentControlGrant = {
  ID: 121 as const,
  NAME: "AgentControlGrant" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): AgentControlGrant {
    return {
      object: 0,
      controls: 0,
      accept: false,
      pass_on: false,
    };
  },
  encode(w: Writer, v: AgentControlGrant): void {
    w.u32(v.object);
    w.u32(v.controls);
    w.bool(v.accept);
    w.bool(v.pass_on);
  },
  decode(r: Reader): AgentControlGrant {
    const object = r.remaining > 0 ? r.u32() : 0;
    const controls = r.remaining > 0 ? r.u32() : 0;
    const accept = r.remaining > 0 ? r.bool() : false;
    const pass_on = r.remaining > 0 ? r.bool() : false;
    return { object, controls, accept, pass_on };
  },
};

export interface AgentControlEvent {
  object: number;
  held: number;
  changed: number;
}

export const AgentControlEvent = {
  ID: 122 as const,
  NAME: "AgentControlEvent" as const,
  CHANNEL: Channel.Unreliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): AgentControlEvent {
    return {
      object: 0,
      held: 0,
      changed: 0,
    };
  },
  encode(w: Writer, v: AgentControlEvent): void {
    w.u32(v.object);
    w.u32(v.held);
    w.u32(v.changed);
  },
  decode(r: Reader): AgentControlEvent {
    const object = r.remaining > 0 ? r.u32() : 0;
    const held = r.remaining > 0 ? r.u32() : 0;
    const changed = r.remaining > 0 ? r.u32() : 0;
    return { object, held, changed };
  },
};

export interface ChatSend {
  channel: number;
  chat_type: ChatType;
  text: string;
}

export const ChatSend = {
  ID: 130 as const,
  NAME: "ChatSend" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ChatSend {
    return {
      channel: 0,
      chat_type: ChatType.Whisper,
      text: "",
    };
  },
  encode(w: Writer, v: ChatSend): void {
    w.i32(v.channel);
    w.u8(v.chat_type);
    w.string(v.text);
  },
  decode(r: Reader): ChatSend {
    const channel = r.remaining > 0 ? r.i32() : 0;
    const chat_type = r.remaining > 0 ? r.enumValue(CHAT_TYPE_VALUES, r.u8()) as ChatType : ChatType.Whisper;
    const text = r.remaining > 0 ? r.string() : "";
    return { channel, chat_type, text };
  },
};

export interface ChatReceive {
  source: ChatSource;
  chat_type: ChatType;
  channel: number;
  from: Uuid;
  from_name: string;
  owner: Uuid;
  position: Vec3;
  text: string;
  timestamp: bigint;
}

export const ChatReceive = {
  ID: 131 as const,
  NAME: "ChatReceive" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): ChatReceive {
    return {
      source: ChatSource.Agent,
      chat_type: ChatType.Whisper,
      channel: 0,
      from: NULL_UUID,
      from_name: "",
      owner: NULL_UUID,
      position: { x: 0, y: 0, z: 0 },
      text: "",
      timestamp: 0n,
    };
  },
  encode(w: Writer, v: ChatReceive): void {
    w.u8(v.source);
    w.u8(v.chat_type);
    w.i32(v.channel);
    w.uuid(v.from);
    w.string(v.from_name);
    w.uuid(v.owner);
    w.vec3(v.position);
    w.string(v.text);
    w.u64(v.timestamp);
  },
  decode(r: Reader): ChatReceive {
    const source = r.remaining > 0 ? r.enumValue(CHAT_SOURCE_VALUES, r.u8()) as ChatSource : ChatSource.Agent;
    const chat_type = r.remaining > 0 ? r.enumValue(CHAT_TYPE_VALUES, r.u8()) as ChatType : ChatType.Whisper;
    const channel = r.remaining > 0 ? r.i32() : 0;
    const from = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const from_name = r.remaining > 0 ? r.string() : "";
    const owner = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const text = r.remaining > 0 ? r.string() : "";
    const timestamp = r.remaining > 0 ? r.u64() : 0n;
    return { source, chat_type, channel, from, from_name, owner, position, text, timestamp };
  },
};

export interface InstantMessageSend {
  to: Uuid;
  text: string;
  session: Uuid;
}

export const InstantMessageSend = {
  ID: 132 as const,
  NAME: "InstantMessageSend" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): InstantMessageSend {
    return {
      to: NULL_UUID,
      text: "",
      session: NULL_UUID,
    };
  },
  encode(w: Writer, v: InstantMessageSend): void {
    w.uuid(v.to);
    w.string(v.text);
    w.uuid(v.session);
  },
  decode(r: Reader): InstantMessageSend {
    const to = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const text = r.remaining > 0 ? r.string() : "";
    const session = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { to, text, session };
  },
};

export interface InstantMessageReceive {
  from: Uuid;
  from_name: string;
  to: Uuid;
  text: string;
  session: Uuid;
  timestamp: bigint;
  offline: boolean;
}

export const InstantMessageReceive = {
  ID: 133 as const,
  NAME: "InstantMessageReceive" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): InstantMessageReceive {
    return {
      from: NULL_UUID,
      from_name: "",
      to: NULL_UUID,
      text: "",
      session: NULL_UUID,
      timestamp: 0n,
      offline: false,
    };
  },
  encode(w: Writer, v: InstantMessageReceive): void {
    w.uuid(v.from);
    w.string(v.from_name);
    w.uuid(v.to);
    w.string(v.text);
    w.uuid(v.session);
    w.u64(v.timestamp);
    w.bool(v.offline);
  },
  decode(r: Reader): InstantMessageReceive {
    const from = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const from_name = r.remaining > 0 ? r.string() : "";
    const to = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const text = r.remaining > 0 ? r.string() : "";
    const session = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const timestamp = r.remaining > 0 ? r.u64() : 0n;
    const offline = r.remaining > 0 ? r.bool() : false;
    return { from, from_name, to, text, session, timestamp, offline };
  },
};

export interface ScriptDialogShow {
  object: number;
  object_name: string;
  owner_name: string;
  channel: number;
  kind: DialogKind;
  message: string;
  buttons: string[];
  dialog_id: Uuid;
}

export const ScriptDialogShow = {
  ID: 134 as const,
  NAME: "ScriptDialogShow" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): ScriptDialogShow {
    return {
      object: 0,
      object_name: "",
      owner_name: "",
      channel: 0,
      kind: DialogKind.Buttons,
      message: "",
      buttons: [],
      dialog_id: NULL_UUID,
    };
  },
  encode(w: Writer, v: ScriptDialogShow): void {
    w.u32(v.object);
    w.string(v.object_name);
    w.string(v.owner_name);
    w.i32(v.channel);
    w.u8(v.kind);
    w.string(v.message);
    w.u16(v.buttons.length);
    for (const item of v.buttons) {
      w.string(item);
    }
    w.uuid(v.dialog_id);
  },
  decode(r: Reader): ScriptDialogShow {
    const object = r.remaining > 0 ? r.u32() : 0;
    const object_name = r.remaining > 0 ? r.string() : "";
    const owner_name = r.remaining > 0 ? r.string() : "";
    const channel = r.remaining > 0 ? r.i32() : 0;
    const kind = r.remaining > 0 ? r.enumValue(DIALOG_KIND_VALUES, r.u8()) as DialogKind : DialogKind.Buttons;
    const message = r.remaining > 0 ? r.string() : "";
    const buttons: string[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      buttons.push(r.string());
    }
    const dialog_id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { object, object_name, owner_name, channel, kind, message, buttons, dialog_id };
  },
};

export interface ScriptDialogReply {
  dialog_id: Uuid;
  object: number;
  channel: number;
  button_index: number;
  text: string;
}

export const ScriptDialogReply = {
  ID: 135 as const,
  NAME: "ScriptDialogReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ScriptDialogReply {
    return {
      dialog_id: NULL_UUID,
      object: 0,
      channel: 0,
      button_index: 0,
      text: "",
    };
  },
  encode(w: Writer, v: ScriptDialogReply): void {
    w.uuid(v.dialog_id);
    w.u32(v.object);
    w.i32(v.channel);
    w.i32(v.button_index);
    w.string(v.text);
  },
  decode(r: Reader): ScriptDialogReply {
    const dialog_id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const object = r.remaining > 0 ? r.u32() : 0;
    const channel = r.remaining > 0 ? r.i32() : 0;
    const button_index = r.remaining > 0 ? r.i32() : 0;
    const text = r.remaining > 0 ? r.string() : "";
    return { dialog_id, object, channel, button_index, text };
  },
};

export interface Notification {
  kind: number;
  title: string;
  text: string;
  from: Uuid;
  payload: string;
  notification_id: Uuid;
}

export const Notification = {
  ID: 136 as const,
  NAME: "Notification" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): Notification {
    return {
      kind: 0,
      title: "",
      text: "",
      from: NULL_UUID,
      payload: "",
      notification_id: NULL_UUID,
    };
  },
  encode(w: Writer, v: Notification): void {
    w.u8(v.kind);
    w.string(v.title);
    w.string(v.text);
    w.uuid(v.from);
    w.string(v.payload);
    w.uuid(v.notification_id);
  },
  decode(r: Reader): Notification {
    const kind = r.remaining > 0 ? r.u8() : 0;
    const title = r.remaining > 0 ? r.string() : "";
    const text = r.remaining > 0 ? r.string() : "";
    const from = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const payload = r.remaining > 0 ? r.string() : "";
    const notification_id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { kind, title, text, from, payload, notification_id };
  },
};

export interface NotificationReply {
  notification_id: Uuid;
  accepted: boolean;
  text: string;
}

export const NotificationReply = {
  ID: 137 as const,
  NAME: "NotificationReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): NotificationReply {
    return {
      notification_id: NULL_UUID,
      accepted: false,
      text: "",
    };
  },
  encode(w: Writer, v: NotificationReply): void {
    w.uuid(v.notification_id);
    w.bool(v.accepted);
    w.string(v.text);
  },
  decode(r: Reader): NotificationReply {
    const notification_id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const accepted = r.remaining > 0 ? r.bool() : false;
    const text = r.remaining > 0 ? r.string() : "";
    return { notification_id, accepted, text };
  },
};

export interface MuteUpdate {
  target: Uuid;
  name: string;
  muted: boolean;
  flags: number;
}

export const MuteUpdate = {
  ID: 138 as const,
  NAME: "MuteUpdate" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): MuteUpdate {
    return {
      target: NULL_UUID,
      name: "",
      muted: false,
      flags: 0,
    };
  },
  encode(w: Writer, v: MuteUpdate): void {
    w.uuid(v.target);
    w.string(v.name);
    w.bool(v.muted);
    w.u32(v.flags);
  },
  decode(r: Reader): MuteUpdate {
    const target = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const name = r.remaining > 0 ? r.string() : "";
    const muted = r.remaining > 0 ? r.bool() : false;
    const flags = r.remaining > 0 ? r.u32() : 0;
    return { target, name, muted, flags };
  },
};

export interface MuteList {
  targets: Uuid[];
  names: string[];
  flags: number[];
}

export const MuteList = {
  ID: 139 as const,
  NAME: "MuteList" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): MuteList {
    return {
      targets: [],
      names: [],
      flags: [],
    };
  },
  encode(w: Writer, v: MuteList): void {
    w.u16(v.targets.length);
    for (const item of v.targets) {
      w.uuid(item);
    }
    w.u16(v.names.length);
    for (const item of v.names) {
      w.string(item);
    }
    w.u16(v.flags.length);
    for (const item of v.flags) {
      w.u32(item);
    }
  },
  decode(r: Reader): MuteList {
    const targets: Uuid[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      targets.push(r.uuid());
    }
    const names: string[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      names.push(r.string());
    }
    const flags: number[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      flags.push(r.u32());
    }
    return { targets, names, flags };
  },
};

export interface TypingIndicator {
  peer: Uuid;
  typing: boolean;
}

export const TypingIndicator = {
  ID: 140 as const,
  NAME: "TypingIndicator" as const,
  CHANNEL: Channel.Unreliable,
  DIRECTION: Direction.Both,
  SINCE: 1,
  create(): TypingIndicator {
    return {
      peer: NULL_UUID,
      typing: false,
    };
  },
  encode(w: Writer, v: TypingIndicator): void {
    w.uuid(v.peer);
    w.bool(v.typing);
  },
  decode(r: Reader): TypingIndicator {
    const peer = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const typing = r.remaining > 0 ? r.bool() : false;
    return { peer, typing };
  },
};

export interface GestureActive {
  item: Uuid;
  active: boolean;
}

export const GestureActive = {
  ID: 141 as const,
  NAME: "GestureActive" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): GestureActive {
    return {
      item: NULL_UUID,
      active: false,
    };
  },
  encode(w: Writer, v: GestureActive): void {
    w.uuid(v.item);
    w.bool(v.active);
  },
  decode(r: Reader): GestureActive {
    const item = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const active = r.remaining > 0 ? r.bool() : false;
    return { item, active };
  },
};

export interface InventoryFetch {
  folder: Uuid;
  recursive: boolean;
  library: boolean;
}

export const InventoryFetch = {
  ID: 150 as const,
  NAME: "InventoryFetch" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): InventoryFetch {
    return {
      folder: NULL_UUID,
      recursive: false,
      library: false,
    };
  },
  encode(w: Writer, v: InventoryFetch): void {
    w.uuid(v.folder);
    w.bool(v.recursive);
    w.bool(v.library);
  },
  decode(r: Reader): InventoryFetch {
    const folder = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const recursive = r.remaining > 0 ? r.bool() : false;
    const library = r.remaining > 0 ? r.bool() : false;
    return { folder, recursive, library };
  },
};

export interface InventoryFolders {
  owner: Uuid;
  folders: InventoryFolder[];
  complete: boolean;
}

export const InventoryFolders = {
  ID: 151 as const,
  NAME: "InventoryFolders" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): InventoryFolders {
    return {
      owner: NULL_UUID,
      folders: [],
      complete: false,
    };
  },
  encode(w: Writer, v: InventoryFolders): void {
    w.uuid(v.owner);
    w.u16(v.folders.length);
    for (const item of v.folders) {
      InventoryFolder.encode(w, item);
    }
    w.bool(v.complete);
  },
  decode(r: Reader): InventoryFolders {
    const owner = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const folders: InventoryFolder[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      folders.push(InventoryFolder.decode(r));
    }
    const complete = r.remaining > 0 ? r.bool() : false;
    return { owner, folders, complete };
  },
};

export interface InventoryItems {
  owner: Uuid;
  folder: Uuid;
  items: InventoryItem[];
  complete: boolean;
}

export const InventoryItems = {
  ID: 152 as const,
  NAME: "InventoryItems" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): InventoryItems {
    return {
      owner: NULL_UUID,
      folder: NULL_UUID,
      items: [],
      complete: false,
    };
  },
  encode(w: Writer, v: InventoryItems): void {
    w.uuid(v.owner);
    w.uuid(v.folder);
    w.u16(v.items.length);
    for (const item of v.items) {
      InventoryItem.encode(w, item);
    }
    w.bool(v.complete);
  },
  decode(r: Reader): InventoryItems {
    const owner = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const folder = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const items: InventoryItem[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      items.push(InventoryItem.decode(r));
    }
    const complete = r.remaining > 0 ? r.bool() : false;
    return { owner, folder, items, complete };
  },
};

export interface InventoryFolderOp {
  op: InventoryOp;
  id: Uuid;
  parent: Uuid;
  name: string;
  kind: AssetKind;
}

export const InventoryFolderOp = {
  ID: 153 as const,
  NAME: "InventoryFolderOp" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): InventoryFolderOp {
    return {
      op: InventoryOp.Create,
      id: NULL_UUID,
      parent: NULL_UUID,
      name: "",
      kind: AssetKind.Texture,
    };
  },
  encode(w: Writer, v: InventoryFolderOp): void {
    w.u8(v.op);
    w.uuid(v.id);
    w.uuid(v.parent);
    w.string(v.name);
    w.u8(v.kind);
  },
  decode(r: Reader): InventoryFolderOp {
    const op = r.remaining > 0 ? r.enumValue(INVENTORY_OP_VALUES, r.u8()) as InventoryOp : InventoryOp.Create;
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const parent = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const name = r.remaining > 0 ? r.string() : "";
    const kind = r.remaining > 0 ? r.enumValue(ASSET_KIND_VALUES, r.u8()) as AssetKind : AssetKind.Texture;
    return { op, id, parent, name, kind };
  },
};

export interface InventoryItemOp {
  op: InventoryOp;
  id: Uuid;
  parent: Uuid;
  name: string;
  description: string;
  kind: AssetKind;
  asset: Uuid;
  wearable_slot: number;
}

export const InventoryItemOp = {
  ID: 154 as const,
  NAME: "InventoryItemOp" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): InventoryItemOp {
    return {
      op: InventoryOp.Create,
      id: NULL_UUID,
      parent: NULL_UUID,
      name: "",
      description: "",
      kind: AssetKind.Texture,
      asset: NULL_UUID,
      wearable_slot: 0,
    };
  },
  encode(w: Writer, v: InventoryItemOp): void {
    w.u8(v.op);
    w.uuid(v.id);
    w.uuid(v.parent);
    w.string(v.name);
    w.string(v.description);
    w.u8(v.kind);
    w.uuid(v.asset);
    w.u8(v.wearable_slot);
  },
  decode(r: Reader): InventoryItemOp {
    const op = r.remaining > 0 ? r.enumValue(INVENTORY_OP_VALUES, r.u8()) as InventoryOp : InventoryOp.Create;
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const parent = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const name = r.remaining > 0 ? r.string() : "";
    const description = r.remaining > 0 ? r.string() : "";
    const kind = r.remaining > 0 ? r.enumValue(ASSET_KIND_VALUES, r.u8()) as AssetKind : AssetKind.Texture;
    const asset = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const wearable_slot = r.remaining > 0 ? r.u8() : 0;
    return { op, id, parent, name, description, kind, asset, wearable_slot };
  },
};

export interface InventoryChanged {
  folders: InventoryFolder[];
  items: InventoryItem[];
  removed_folders: Uuid[];
  removed_items: Uuid[];
}

export const InventoryChanged = {
  ID: 155 as const,
  NAME: "InventoryChanged" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): InventoryChanged {
    return {
      folders: [],
      items: [],
      removed_folders: [],
      removed_items: [],
    };
  },
  encode(w: Writer, v: InventoryChanged): void {
    w.u16(v.folders.length);
    for (const item of v.folders) {
      InventoryFolder.encode(w, item);
    }
    w.u16(v.items.length);
    for (const item of v.items) {
      InventoryItem.encode(w, item);
    }
    w.u16(v.removed_folders.length);
    for (const item of v.removed_folders) {
      w.uuid(item);
    }
    w.u16(v.removed_items.length);
    for (const item of v.removed_items) {
      w.uuid(item);
    }
  },
  decode(r: Reader): InventoryChanged {
    const folders: InventoryFolder[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      folders.push(InventoryFolder.decode(r));
    }
    const items: InventoryItem[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      items.push(InventoryItem.decode(r));
    }
    const removed_folders: Uuid[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      removed_folders.push(r.uuid());
    }
    const removed_items: Uuid[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      removed_items.push(r.uuid());
    }
    return { folders, items, removed_folders, removed_items };
  },
};

export interface InventoryGive {
  to: Uuid;
  item: Uuid;
  folder: Uuid;
}

export const InventoryGive = {
  ID: 156 as const,
  NAME: "InventoryGive" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): InventoryGive {
    return {
      to: NULL_UUID,
      item: NULL_UUID,
      folder: NULL_UUID,
    };
  },
  encode(w: Writer, v: InventoryGive): void {
    w.uuid(v.to);
    w.uuid(v.item);
    w.uuid(v.folder);
  },
  decode(r: Reader): InventoryGive {
    const to = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const item = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const folder = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { to, item, folder };
  },
};

export interface InventoryOffer {
  from: Uuid;
  from_name: string;
  item: InventoryItem;
  offer_id: Uuid;
  from_object: boolean;
}

export const InventoryOffer = {
  ID: 157 as const,
  NAME: "InventoryOffer" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): InventoryOffer {
    return {
      from: NULL_UUID,
      from_name: "",
      item: InventoryItem.create(),
      offer_id: NULL_UUID,
      from_object: false,
    };
  },
  encode(w: Writer, v: InventoryOffer): void {
    w.uuid(v.from);
    w.string(v.from_name);
    InventoryItem.encode(w, v.item);
    w.uuid(v.offer_id);
    w.bool(v.from_object);
  },
  decode(r: Reader): InventoryOffer {
    const from = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const from_name = r.remaining > 0 ? r.string() : "";
    const item = r.remaining > 0 ? InventoryItem.decode(r) : InventoryItem.create();
    const offer_id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const from_object = r.remaining > 0 ? r.bool() : false;
    return { from, from_name, item, offer_id, from_object };
  },
};

export interface InventoryOfferReply {
  offer_id: Uuid;
  accept: boolean;
}

export const InventoryOfferReply = {
  ID: 158 as const,
  NAME: "InventoryOfferReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): InventoryOfferReply {
    return {
      offer_id: NULL_UUID,
      accept: false,
    };
  },
  encode(w: Writer, v: InventoryOfferReply): void {
    w.uuid(v.offer_id);
    w.bool(v.accept);
  },
  decode(r: Reader): InventoryOfferReply {
    const offer_id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const accept = r.remaining > 0 ? r.bool() : false;
    return { offer_id, accept };
  },
};

export interface TaskInventoryFetch {
  object: number;
}

export const TaskInventoryFetch = {
  ID: 159 as const,
  NAME: "TaskInventoryFetch" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): TaskInventoryFetch {
    return {
      object: 0,
    };
  },
  encode(w: Writer, v: TaskInventoryFetch): void {
    w.u32(v.object);
  },
  decode(r: Reader): TaskInventoryFetch {
    const object = r.remaining > 0 ? r.u32() : 0;
    return { object };
  },
};

export interface TaskInventoryItems {
  object: number;
  serial: number;
  items: InventoryItem[];
  running: boolean[];
}

export const TaskInventoryItems = {
  ID: 160 as const,
  NAME: "TaskInventoryItems" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): TaskInventoryItems {
    return {
      object: 0,
      serial: 0,
      items: [],
      running: [],
    };
  },
  encode(w: Writer, v: TaskInventoryItems): void {
    w.u32(v.object);
    w.u32(v.serial);
    w.u16(v.items.length);
    for (const item of v.items) {
      InventoryItem.encode(w, item);
    }
    w.u16(v.running.length);
    for (const item of v.running) {
      w.bool(item);
    }
  },
  decode(r: Reader): TaskInventoryItems {
    const object = r.remaining > 0 ? r.u32() : 0;
    const serial = r.remaining > 0 ? r.u32() : 0;
    const items: InventoryItem[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      items.push(InventoryItem.decode(r));
    }
    const running: boolean[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      running.push(r.bool());
    }
    return { object, serial, items, running };
  },
};

export interface TaskInventoryOp {
  object: number;
  op: InventoryOp;
  item: Uuid;
  from_inventory: Uuid;
  name: string;
}

export const TaskInventoryOp = {
  ID: 161 as const,
  NAME: "TaskInventoryOp" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): TaskInventoryOp {
    return {
      object: 0,
      op: InventoryOp.Create,
      item: NULL_UUID,
      from_inventory: NULL_UUID,
      name: "",
    };
  },
  encode(w: Writer, v: TaskInventoryOp): void {
    w.u32(v.object);
    w.u8(v.op);
    w.uuid(v.item);
    w.uuid(v.from_inventory);
    w.string(v.name);
  },
  decode(r: Reader): TaskInventoryOp {
    const object = r.remaining > 0 ? r.u32() : 0;
    const op = r.remaining > 0 ? r.enumValue(INVENTORY_OP_VALUES, r.u8()) as InventoryOp : InventoryOp.Create;
    const item = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const from_inventory = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const name = r.remaining > 0 ? r.string() : "";
    return { object, op, item, from_inventory, name };
  },
};

export interface WearableSet {
  wearables: WearableRef[];
}

export const WearableSet = {
  ID: 162 as const,
  NAME: "WearableSet" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): WearableSet {
    return {
      wearables: [],
    };
  },
  encode(w: Writer, v: WearableSet): void {
    w.u16(v.wearables.length);
    for (const item of v.wearables) {
      WearableRef.encode(w, item);
    }
  },
  decode(r: Reader): WearableSet {
    const wearables: WearableRef[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      wearables.push(WearableRef.decode(r));
    }
    return { wearables };
  },
};

export interface OutfitSave {
  name: string;
  folder: Uuid;
}

export const OutfitSave = {
  ID: 163 as const,
  NAME: "OutfitSave" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): OutfitSave {
    return {
      name: "",
      folder: NULL_UUID,
    };
  },
  encode(w: Writer, v: OutfitSave): void {
    w.string(v.name);
    w.uuid(v.folder);
  },
  decode(r: Reader): OutfitSave {
    const name = r.remaining > 0 ? r.string() : "";
    const folder = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { name, folder };
  },
};

export interface AssetRequest {
  id: Uuid;
  kind: AssetKind;
  priority: number;
  offset: number;
  max_bytes: number;
  request_id: number;
}

export const AssetRequest = {
  ID: 170 as const,
  NAME: "AssetRequest" as const,
  CHANNEL: Channel.Bulk,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): AssetRequest {
    return {
      id: NULL_UUID,
      kind: AssetKind.Texture,
      priority: 0,
      offset: 0,
      max_bytes: 0,
      request_id: 0,
    };
  },
  encode(w: Writer, v: AssetRequest): void {
    w.uuid(v.id);
    w.u8(v.kind);
    w.u8(v.priority);
    w.u32(v.offset);
    w.u32(v.max_bytes);
    w.u32(v.request_id);
  },
  decode(r: Reader): AssetRequest {
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const kind = r.remaining > 0 ? r.enumValue(ASSET_KIND_VALUES, r.u8()) as AssetKind : AssetKind.Texture;
    const priority = r.remaining > 0 ? r.u8() : 0;
    const offset = r.remaining > 0 ? r.u32() : 0;
    const max_bytes = r.remaining > 0 ? r.u32() : 0;
    const request_id = r.remaining > 0 ? r.u32() : 0;
    return { id, kind, priority, offset, max_bytes, request_id };
  },
};

export interface AssetHeader {
  request_id: number;
  id: Uuid;
  kind: AssetKind;
  size: number;
  content_type: string;
  hash: Uint8Array;
  found: boolean;
}

export const AssetHeader = {
  ID: 171 as const,
  NAME: "AssetHeader" as const,
  CHANNEL: Channel.Bulk,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): AssetHeader {
    return {
      request_id: 0,
      id: NULL_UUID,
      kind: AssetKind.Texture,
      size: 0,
      content_type: "",
      hash: new Uint8Array(0),
      found: false,
    };
  },
  encode(w: Writer, v: AssetHeader): void {
    w.u32(v.request_id);
    w.uuid(v.id);
    w.u8(v.kind);
    w.u32(v.size);
    w.string(v.content_type);
    w.bytes(v.hash);
    w.bool(v.found);
  },
  decode(r: Reader): AssetHeader {
    const request_id = r.remaining > 0 ? r.u32() : 0;
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const kind = r.remaining > 0 ? r.enumValue(ASSET_KIND_VALUES, r.u8()) as AssetKind : AssetKind.Texture;
    const size = r.remaining > 0 ? r.u32() : 0;
    const content_type = r.remaining > 0 ? r.string() : "";
    const hash = r.remaining > 0 ? r.bytes() : new Uint8Array(0);
    const found = r.remaining > 0 ? r.bool() : false;
    return { request_id, id, kind, size, content_type, hash, found };
  },
};

export interface AssetChunk {
  request_id: number;
  offset: number;
  data: Uint8Array;
  last: boolean;
}

export const AssetChunk = {
  ID: 172 as const,
  NAME: "AssetChunk" as const,
  CHANNEL: Channel.Bulk,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): AssetChunk {
    return {
      request_id: 0,
      offset: 0,
      data: new Uint8Array(0),
      last: false,
    };
  },
  encode(w: Writer, v: AssetChunk): void {
    w.u32(v.request_id);
    w.u32(v.offset);
    w.bytes(v.data);
    w.bool(v.last);
  },
  decode(r: Reader): AssetChunk {
    const request_id = r.remaining > 0 ? r.u32() : 0;
    const offset = r.remaining > 0 ? r.u32() : 0;
    const data = r.remaining > 0 ? r.bytes() : new Uint8Array(0);
    const last = r.remaining > 0 ? r.bool() : false;
    return { request_id, offset, data, last };
  },
};

export interface AssetCancel {
  request_id: number;
}

export const AssetCancel = {
  ID: 173 as const,
  NAME: "AssetCancel" as const,
  CHANNEL: Channel.Bulk,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): AssetCancel {
    return {
      request_id: 0,
    };
  },
  encode(w: Writer, v: AssetCancel): void {
    w.u32(v.request_id);
  },
  decode(r: Reader): AssetCancel {
    const request_id = r.remaining > 0 ? r.u32() : 0;
    return { request_id };
  },
};

export interface AssetUploadBegin {
  upload_id: number;
  kind: AssetKind;
  name: string;
  description: string;
  size: number;
  content_type: string;
  folder: Uuid;
  wearable_slot: number;
  temporary: boolean;
  hash: Uint8Array;
}

export const AssetUploadBegin = {
  ID: 174 as const,
  NAME: "AssetUploadBegin" as const,
  CHANNEL: Channel.Bulk,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): AssetUploadBegin {
    return {
      upload_id: 0,
      kind: AssetKind.Texture,
      name: "",
      description: "",
      size: 0,
      content_type: "",
      folder: NULL_UUID,
      wearable_slot: 0,
      temporary: false,
      hash: new Uint8Array(0),
    };
  },
  encode(w: Writer, v: AssetUploadBegin): void {
    w.u32(v.upload_id);
    w.u8(v.kind);
    w.string(v.name);
    w.string(v.description);
    w.u32(v.size);
    w.string(v.content_type);
    w.uuid(v.folder);
    w.u8(v.wearable_slot);
    w.bool(v.temporary);
    w.bytes(v.hash);
  },
  decode(r: Reader): AssetUploadBegin {
    const upload_id = r.remaining > 0 ? r.u32() : 0;
    const kind = r.remaining > 0 ? r.enumValue(ASSET_KIND_VALUES, r.u8()) as AssetKind : AssetKind.Texture;
    const name = r.remaining > 0 ? r.string() : "";
    const description = r.remaining > 0 ? r.string() : "";
    const size = r.remaining > 0 ? r.u32() : 0;
    const content_type = r.remaining > 0 ? r.string() : "";
    const folder = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const wearable_slot = r.remaining > 0 ? r.u8() : 0;
    const temporary = r.remaining > 0 ? r.bool() : false;
    const hash = r.remaining > 0 ? r.bytes() : new Uint8Array(0);
    return { upload_id, kind, name, description, size, content_type, folder, wearable_slot, temporary, hash };
  },
};

export interface AssetUploadChunk {
  upload_id: number;
  offset: number;
  data: Uint8Array;
  last: boolean;
}

export const AssetUploadChunk = {
  ID: 175 as const,
  NAME: "AssetUploadChunk" as const,
  CHANNEL: Channel.Bulk,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): AssetUploadChunk {
    return {
      upload_id: 0,
      offset: 0,
      data: new Uint8Array(0),
      last: false,
    };
  },
  encode(w: Writer, v: AssetUploadChunk): void {
    w.u32(v.upload_id);
    w.u32(v.offset);
    w.bytes(v.data);
    w.bool(v.last);
  },
  decode(r: Reader): AssetUploadChunk {
    const upload_id = r.remaining > 0 ? r.u32() : 0;
    const offset = r.remaining > 0 ? r.u32() : 0;
    const data = r.remaining > 0 ? r.bytes() : new Uint8Array(0);
    const last = r.remaining > 0 ? r.bool() : false;
    return { upload_id, offset, data, last };
  },
};

export interface AssetUploadResult {
  upload_id: number;
  ok: boolean;
  message: string;
  asset: Uuid;
  item: Uuid;
  cost: number;
}

export const AssetUploadResult = {
  ID: 176 as const,
  NAME: "AssetUploadResult" as const,
  CHANNEL: Channel.Bulk,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): AssetUploadResult {
    return {
      upload_id: 0,
      ok: false,
      message: "",
      asset: NULL_UUID,
      item: NULL_UUID,
      cost: 0,
    };
  },
  encode(w: Writer, v: AssetUploadResult): void {
    w.u32(v.upload_id);
    w.bool(v.ok);
    w.string(v.message);
    w.uuid(v.asset);
    w.uuid(v.item);
    w.i32(v.cost);
  },
  decode(r: Reader): AssetUploadResult {
    const upload_id = r.remaining > 0 ? r.u32() : 0;
    const ok = r.remaining > 0 ? r.bool() : false;
    const message = r.remaining > 0 ? r.string() : "";
    const asset = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const item = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const cost = r.remaining > 0 ? r.i32() : 0;
    return { upload_id, ok, message, asset, item, cost };
  },
};

export interface AssetUploadQuote {
  upload_id: number;
  cost: number;
  accepted: boolean;
}

export const AssetUploadQuote = {
  ID: 177 as const,
  NAME: "AssetUploadQuote" as const,
  CHANNEL: Channel.Bulk,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): AssetUploadQuote {
    return {
      upload_id: 0,
      cost: 0,
      accepted: false,
    };
  },
  encode(w: Writer, v: AssetUploadQuote): void {
    w.u32(v.upload_id);
    w.i32(v.cost);
    w.bool(v.accepted);
  },
  decode(r: Reader): AssetUploadQuote {
    const upload_id = r.remaining > 0 ? r.u32() : 0;
    const cost = r.remaining > 0 ? r.i32() : 0;
    const accepted = r.remaining > 0 ? r.bool() : false;
    return { upload_id, cost, accepted };
  },
};

export interface ScriptSave {
  object: number;
  item: Uuid;
  source: string;
  running: boolean;
  experience: Uuid;
}

export const ScriptSave = {
  ID: 180 as const,
  NAME: "ScriptSave" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ScriptSave {
    return {
      object: 0,
      item: NULL_UUID,
      source: "",
      running: false,
      experience: NULL_UUID,
    };
  },
  encode(w: Writer, v: ScriptSave): void {
    w.u32(v.object);
    w.uuid(v.item);
    w.string(v.source);
    w.bool(v.running);
    w.uuid(v.experience);
  },
  decode(r: Reader): ScriptSave {
    const object = r.remaining > 0 ? r.u32() : 0;
    const item = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const source = r.remaining > 0 ? r.string() : "";
    const running = r.remaining > 0 ? r.bool() : false;
    const experience = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { object, item, source, running, experience };
  },
};

export interface ScriptSaveResult {
  object: number;
  item: Uuid;
  ok: boolean;
  errors: ScriptError[];
  asset: Uuid;
}

export const ScriptSaveResult = {
  ID: 181 as const,
  NAME: "ScriptSaveResult" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): ScriptSaveResult {
    return {
      object: 0,
      item: NULL_UUID,
      ok: false,
      errors: [],
      asset: NULL_UUID,
    };
  },
  encode(w: Writer, v: ScriptSaveResult): void {
    w.u32(v.object);
    w.uuid(v.item);
    w.bool(v.ok);
    w.u16(v.errors.length);
    for (const item of v.errors) {
      ScriptError.encode(w, item);
    }
    w.uuid(v.asset);
  },
  decode(r: Reader): ScriptSaveResult {
    const object = r.remaining > 0 ? r.u32() : 0;
    const item = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const ok = r.remaining > 0 ? r.bool() : false;
    const errors: ScriptError[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      errors.push(ScriptError.decode(r));
    }
    const asset = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { object, item, ok, errors, asset };
  },
};

export interface ScriptSetRunning {
  object: number;
  item: Uuid;
  running: boolean;
}

export const ScriptSetRunning = {
  ID: 182 as const,
  NAME: "ScriptSetRunning" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ScriptSetRunning {
    return {
      object: 0,
      item: NULL_UUID,
      running: false,
    };
  },
  encode(w: Writer, v: ScriptSetRunning): void {
    w.u32(v.object);
    w.uuid(v.item);
    w.bool(v.running);
  },
  decode(r: Reader): ScriptSetRunning {
    const object = r.remaining > 0 ? r.u32() : 0;
    const item = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const running = r.remaining > 0 ? r.bool() : false;
    return { object, item, running };
  },
};

export interface ScriptReset {
  object: number;
  item: Uuid;
}

export const ScriptReset = {
  ID: 183 as const,
  NAME: "ScriptReset" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ScriptReset {
    return {
      object: 0,
      item: NULL_UUID,
    };
  },
  encode(w: Writer, v: ScriptReset): void {
    w.u32(v.object);
    w.uuid(v.item);
  },
  decode(r: Reader): ScriptReset {
    const object = r.remaining > 0 ? r.u32() : 0;
    const item = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { object, item };
  },
};

export interface ScriptRuntimeError {
  error: ScriptError;
  object_name: string;
}

export const ScriptRuntimeError = {
  ID: 184 as const,
  NAME: "ScriptRuntimeError" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): ScriptRuntimeError {
    return {
      error: ScriptError.create(),
      object_name: "",
    };
  },
  encode(w: Writer, v: ScriptRuntimeError): void {
    ScriptError.encode(w, v.error);
    w.string(v.object_name);
  },
  decode(r: Reader): ScriptRuntimeError {
    const error = r.remaining > 0 ? ScriptError.decode(r) : ScriptError.create();
    const object_name = r.remaining > 0 ? r.string() : "";
    return { error, object_name };
  },
};

export interface ScriptFetchSource {
  object: number;
  item: Uuid;
}

export const ScriptFetchSource = {
  ID: 185 as const,
  NAME: "ScriptFetchSource" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ScriptFetchSource {
    return {
      object: 0,
      item: NULL_UUID,
    };
  },
  encode(w: Writer, v: ScriptFetchSource): void {
    w.u32(v.object);
    w.uuid(v.item);
  },
  decode(r: Reader): ScriptFetchSource {
    const object = r.remaining > 0 ? r.u32() : 0;
    const item = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { object, item };
  },
};

export interface ScriptSource {
  object: number;
  item: Uuid;
  source: string;
  experience: Uuid;
}

export const ScriptSource = {
  ID: 186 as const,
  NAME: "ScriptSource" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): ScriptSource {
    return {
      object: 0,
      item: NULL_UUID,
      source: "",
      experience: NULL_UUID,
    };
  },
  encode(w: Writer, v: ScriptSource): void {
    w.u32(v.object);
    w.uuid(v.item);
    w.string(v.source);
    w.uuid(v.experience);
  },
  decode(r: Reader): ScriptSource {
    const object = r.remaining > 0 ? r.u32() : 0;
    const item = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const source = r.remaining > 0 ? r.string() : "";
    const experience = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { object, item, source, experience };
  },
};

export interface ScriptHudText {
  object: number;
  slot: number;
  text: string;
  color: Color;
}

export const ScriptHudText = {
  ID: 187 as const,
  NAME: "ScriptHudText" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): ScriptHudText {
    return {
      object: 0,
      slot: 0,
      text: "",
      color: { r: 255, g: 255, b: 255, a: 255 },
    };
  },
  encode(w: Writer, v: ScriptHudText): void {
    w.u32(v.object);
    w.u8(v.slot);
    w.string(v.text);
    w.color(v.color);
  },
  decode(r: Reader): ScriptHudText {
    const object = r.remaining > 0 ? r.u32() : 0;
    const slot = r.remaining > 0 ? r.u8() : 0;
    const text = r.remaining > 0 ? r.string() : "";
    const color = r.remaining > 0 ? r.color() : { r: 255, g: 255, b: 255, a: 255 };
    return { object, slot, text, color };
  },
};

export interface ScriptPanelShow {
  object: number;
  object_name: string;
  title: string;
  controls: ScriptPanelControl[];
}

export const ScriptPanelShow = {
  ID: 188 as const,
  NAME: "ScriptPanelShow" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 7,
  create(): ScriptPanelShow {
    return {
      object: 0,
      object_name: "",
      title: "",
      controls: [],
    };
  },
  encode(w: Writer, v: ScriptPanelShow): void {
    w.u32(v.object);
    w.string(v.object_name);
    w.string(v.title);
    w.u16(v.controls.length);
    for (const item of v.controls) {
      ScriptPanelControl.encode(w, item);
    }
  },
  decode(r: Reader): ScriptPanelShow {
    const object = r.remaining > 0 ? r.u32() : 0;
    const object_name = r.remaining > 0 ? r.string() : "";
    const title = r.remaining > 0 ? r.string() : "";
    const controls: ScriptPanelControl[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      controls.push(ScriptPanelControl.decode(r));
    }
    return { object, object_name, title, controls };
  },
};

export interface ScriptPanelHide {
  object: number;
}

export const ScriptPanelHide = {
  ID: 189 as const,
  NAME: "ScriptPanelHide" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 7,
  create(): ScriptPanelHide {
    return {
      object: 0,
    };
  },
  encode(w: Writer, v: ScriptPanelHide): void {
    w.u32(v.object);
  },
  decode(r: Reader): ScriptPanelHide {
    const object = r.remaining > 0 ? r.u32() : 0;
    return { object };
  },
};

export interface ScriptPanelUse {
  object: number;
  control: string;
  value: number;
}

export const ScriptPanelUse = {
  ID: 195 as const,
  NAME: "ScriptPanelUse" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 7,
  create(): ScriptPanelUse {
    return {
      object: 0,
      control: "",
      value: 0,
    };
  },
  encode(w: Writer, v: ScriptPanelUse): void {
    w.u32(v.object);
    w.string(v.control);
    w.f32(v.value);
  },
  decode(r: Reader): ScriptPanelUse {
    const object = r.remaining > 0 ? r.u32() : 0;
    const control = r.remaining > 0 ? r.string() : "";
    const value = r.remaining > 0 ? r.f32() : 0;
    return { object, control, value };
  },
};

export interface SoundPlay {
  sound: Uuid;
  object: number;
  owner: Uuid;
  position: Vec3;
  gain: number;
  looping: boolean;
  attached: boolean;
  radius: number;
  sync: number;
  box_min: Vec3;
  box_max: Vec3;
}

export const SoundPlay = {
  ID: 190 as const,
  NAME: "SoundPlay" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): SoundPlay {
    return {
      sound: NULL_UUID,
      object: 0,
      owner: NULL_UUID,
      position: { x: 0, y: 0, z: 0 },
      gain: 0,
      looping: false,
      attached: false,
      radius: 0,
      sync: 0,
      box_min: { x: 0, y: 0, z: 0 },
      box_max: { x: 0, y: 0, z: 0 },
    };
  },
  encode(w: Writer, v: SoundPlay): void {
    w.uuid(v.sound);
    w.u32(v.object);
    w.uuid(v.owner);
    w.vec3(v.position);
    w.f32(v.gain);
    w.bool(v.looping);
    w.bool(v.attached);
    w.f32(v.radius);
    w.u8(v.sync);
    w.vec3(v.box_min);
    w.vec3(v.box_max);
  },
  decode(r: Reader): SoundPlay {
    const sound = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const object = r.remaining > 0 ? r.u32() : 0;
    const owner = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const gain = r.remaining > 0 ? r.f32() : 0;
    const looping = r.remaining > 0 ? r.bool() : false;
    const attached = r.remaining > 0 ? r.bool() : false;
    const radius = r.remaining > 0 ? r.f32() : 0;
    const sync = r.remaining > 0 ? r.u8() : 0;
    const box_min = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const box_max = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    return { sound, object, owner, position, gain, looping, attached, radius, sync, box_min, box_max };
  },
};

export interface SoundStop {
  object: number;
  sound: Uuid;
}

export const SoundStop = {
  ID: 191 as const,
  NAME: "SoundStop" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): SoundStop {
    return {
      object: 0,
      sound: NULL_UUID,
    };
  },
  encode(w: Writer, v: SoundStop): void {
    w.u32(v.object);
    w.uuid(v.sound);
  },
  decode(r: Reader): SoundStop {
    const object = r.remaining > 0 ? r.u32() : 0;
    const sound = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { object, sound };
  },
};

export interface SoundPreload {
  sounds: Uuid[];
}

export const SoundPreload = {
  ID: 192 as const,
  NAME: "SoundPreload" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): SoundPreload {
    return {
      sounds: [],
    };
  },
  encode(w: Writer, v: SoundPreload): void {
    w.u16(v.sounds.length);
    for (const item of v.sounds) {
      w.uuid(item);
    }
  },
  decode(r: Reader): SoundPreload {
    const sounds: Uuid[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      sounds.push(r.uuid());
    }
    return { sounds };
  },
};

export interface AgentSoundPlay {
  sound: Uuid;
  gain: number;
}

export const AgentSoundPlay = {
  ID: 194 as const,
  NAME: "AgentSoundPlay" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): AgentSoundPlay {
    return {
      sound: NULL_UUID,
      gain: 0,
    };
  },
  encode(w: Writer, v: AgentSoundPlay): void {
    w.uuid(v.sound);
    w.f32(v.gain);
  },
  decode(r: Reader): AgentSoundPlay {
    const sound = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const gain = r.remaining > 0 ? r.f32() : 0;
    return { sound, gain };
  },
};

export interface ParcelMediaCommand {
  parcel: number;
  kind: number;
  command: number;
  url: string;
  time: number;
}

export const ParcelMediaCommand = {
  ID: 193 as const,
  NAME: "ParcelMediaCommand" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): ParcelMediaCommand {
    return {
      parcel: 0,
      kind: 0,
      command: 0,
      url: "",
      time: 0,
    };
  },
  encode(w: Writer, v: ParcelMediaCommand): void {
    w.u32(v.parcel);
    w.u8(v.kind);
    w.u8(v.command);
    w.string(v.url);
    w.f32(v.time);
  },
  decode(r: Reader): ParcelMediaCommand {
    const parcel = r.remaining > 0 ? r.u32() : 0;
    const kind = r.remaining > 0 ? r.u8() : 0;
    const command = r.remaining > 0 ? r.u8() : 0;
    const url = r.remaining > 0 ? r.string() : "";
    const time = r.remaining > 0 ? r.f32() : 0;
    return { parcel, kind, command, url, time };
  },
};

export interface ParcelOverlay {
  sequence: number;
  total: number;
  cells: Uint8Array;
}

export const ParcelOverlay = {
  ID: 200 as const,
  NAME: "ParcelOverlay" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): ParcelOverlay {
    return {
      sequence: 0,
      total: 0,
      cells: new Uint8Array(0),
    };
  },
  encode(w: Writer, v: ParcelOverlay): void {
    w.u8(v.sequence);
    w.u8(v.total);
    w.bytes(v.cells);
  },
  decode(r: Reader): ParcelOverlay {
    const sequence = r.remaining > 0 ? r.u8() : 0;
    const total = r.remaining > 0 ? r.u8() : 0;
    const cells = r.remaining > 0 ? r.bytes() : new Uint8Array(0);
    return { sequence, total, cells };
  },
};

export interface ParcelInfoRequest {
  parcel: number;
  position: Vec3;
  sequence: number;
}

export const ParcelInfoRequest = {
  ID: 201 as const,
  NAME: "ParcelInfoRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ParcelInfoRequest {
    return {
      parcel: 0,
      position: { x: 0, y: 0, z: 0 },
      sequence: 0,
    };
  },
  encode(w: Writer, v: ParcelInfoRequest): void {
    w.u32(v.parcel);
    w.vec3(v.position);
    w.u32(v.sequence);
  },
  decode(r: Reader): ParcelInfoRequest {
    const parcel = r.remaining > 0 ? r.u32() : 0;
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const sequence = r.remaining > 0 ? r.u32() : 0;
    return { parcel, position, sequence };
  },
};

export interface ParcelInfoReply {
  sequence: number;
  parcel: ParcelInfo;
  bitmap: Uint8Array;
  landing_look: Vec3;
}

export const ParcelInfoReply = {
  ID: 202 as const,
  NAME: "ParcelInfoReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): ParcelInfoReply {
    return {
      sequence: 0,
      parcel: ParcelInfo.create(),
      bitmap: new Uint8Array(0),
      landing_look: { x: 0, y: 0, z: 0 },
    };
  },
  encode(w: Writer, v: ParcelInfoReply): void {
    w.u32(v.sequence);
    ParcelInfo.encode(w, v.parcel);
    w.bytes(v.bitmap);
    w.vec3(v.landing_look);
  },
  decode(r: Reader): ParcelInfoReply {
    const sequence = r.remaining > 0 ? r.u32() : 0;
    const parcel = r.remaining > 0 ? ParcelInfo.decode(r) : ParcelInfo.create();
    const bitmap = r.remaining > 0 ? r.bytes() : new Uint8Array(0);
    const landing_look = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    return { sequence, parcel, bitmap, landing_look };
  },
};

export interface ParcelUpdate {
  parcel: ParcelInfo;
  landing_look: Vec3;
}

export const ParcelUpdate = {
  ID: 203 as const,
  NAME: "ParcelUpdate" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ParcelUpdate {
    return {
      parcel: ParcelInfo.create(),
      landing_look: { x: 0, y: 0, z: 0 },
    };
  },
  encode(w: Writer, v: ParcelUpdate): void {
    ParcelInfo.encode(w, v.parcel);
    w.vec3(v.landing_look);
  },
  decode(r: Reader): ParcelUpdate {
    const parcel = r.remaining > 0 ? ParcelInfo.decode(r) : ParcelInfo.create();
    const landing_look = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    return { parcel, landing_look };
  },
};

export interface ParcelDivide {
  west: number;
  south: number;
  east: number;
  north: number;
}

export const ParcelDivide = {
  ID: 204 as const,
  NAME: "ParcelDivide" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ParcelDivide {
    return {
      west: 0,
      south: 0,
      east: 0,
      north: 0,
    };
  },
  encode(w: Writer, v: ParcelDivide): void {
    w.f32(v.west);
    w.f32(v.south);
    w.f32(v.east);
    w.f32(v.north);
  },
  decode(r: Reader): ParcelDivide {
    const west = r.remaining > 0 ? r.f32() : 0;
    const south = r.remaining > 0 ? r.f32() : 0;
    const east = r.remaining > 0 ? r.f32() : 0;
    const north = r.remaining > 0 ? r.f32() : 0;
    return { west, south, east, north };
  },
};

export interface ParcelJoin {
  west: number;
  south: number;
  east: number;
  north: number;
}

export const ParcelJoin = {
  ID: 205 as const,
  NAME: "ParcelJoin" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ParcelJoin {
    return {
      west: 0,
      south: 0,
      east: 0,
      north: 0,
    };
  },
  encode(w: Writer, v: ParcelJoin): void {
    w.f32(v.west);
    w.f32(v.south);
    w.f32(v.east);
    w.f32(v.north);
  },
  decode(r: Reader): ParcelJoin {
    const west = r.remaining > 0 ? r.f32() : 0;
    const south = r.remaining > 0 ? r.f32() : 0;
    const east = r.remaining > 0 ? r.f32() : 0;
    const north = r.remaining > 0 ? r.f32() : 0;
    return { west, south, east, north };
  },
};

export interface ParcelBuy {
  parcel: number;
  price: number;
  for_group: Uuid;
}

export const ParcelBuy = {
  ID: 206 as const,
  NAME: "ParcelBuy" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ParcelBuy {
    return {
      parcel: 0,
      price: 0,
      for_group: NULL_UUID,
    };
  },
  encode(w: Writer, v: ParcelBuy): void {
    w.u32(v.parcel);
    w.i32(v.price);
    w.uuid(v.for_group);
  },
  decode(r: Reader): ParcelBuy {
    const parcel = r.remaining > 0 ? r.u32() : 0;
    const price = r.remaining > 0 ? r.i32() : 0;
    const for_group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { parcel, price, for_group };
  },
};

export interface ParcelRelease {
  parcel: number;
}

export const ParcelRelease = {
  ID: 207 as const,
  NAME: "ParcelRelease" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ParcelRelease {
    return {
      parcel: 0,
    };
  },
  encode(w: Writer, v: ParcelRelease): void {
    w.u32(v.parcel);
  },
  decode(r: Reader): ParcelRelease {
    const parcel = r.remaining > 0 ? r.u32() : 0;
    return { parcel };
  },
};

export interface ParcelAccessList {
  parcel: number;
  allowed: Uuid[];
  banned: Uuid[];
  allowed_expiry: bigint[];
  banned_expiry: bigint[];
}

export const ParcelAccessList = {
  ID: 208 as const,
  NAME: "ParcelAccessList" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.Both,
  SINCE: 1,
  create(): ParcelAccessList {
    return {
      parcel: 0,
      allowed: [],
      banned: [],
      allowed_expiry: [],
      banned_expiry: [],
    };
  },
  encode(w: Writer, v: ParcelAccessList): void {
    w.u32(v.parcel);
    w.u16(v.allowed.length);
    for (const item of v.allowed) {
      w.uuid(item);
    }
    w.u16(v.banned.length);
    for (const item of v.banned) {
      w.uuid(item);
    }
    w.u16(v.allowed_expiry.length);
    for (const item of v.allowed_expiry) {
      w.u64(item);
    }
    w.u16(v.banned_expiry.length);
    for (const item of v.banned_expiry) {
      w.u64(item);
    }
  },
  decode(r: Reader): ParcelAccessList {
    const parcel = r.remaining > 0 ? r.u32() : 0;
    const allowed: Uuid[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      allowed.push(r.uuid());
    }
    const banned: Uuid[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      banned.push(r.uuid());
    }
    const allowed_expiry: bigint[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      allowed_expiry.push(r.u64());
    }
    const banned_expiry: bigint[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      banned_expiry.push(r.u64());
    }
    return { parcel, allowed, banned, allowed_expiry, banned_expiry };
  },
};

export interface ParcelReturnObjects {
  parcel: number;
  owner: Uuid;
  return_others: boolean;
  return_group: boolean;
}

export const ParcelReturnObjects = {
  ID: 209 as const,
  NAME: "ParcelReturnObjects" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ParcelReturnObjects {
    return {
      parcel: 0,
      owner: NULL_UUID,
      return_others: false,
      return_group: false,
    };
  },
  encode(w: Writer, v: ParcelReturnObjects): void {
    w.u32(v.parcel);
    w.uuid(v.owner);
    w.bool(v.return_others);
    w.bool(v.return_group);
  },
  decode(r: Reader): ParcelReturnObjects {
    const parcel = r.remaining > 0 ? r.u32() : 0;
    const owner = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const return_others = r.remaining > 0 ? r.bool() : false;
    const return_group = r.remaining > 0 ? r.bool() : false;
    return { parcel, owner, return_others, return_group };
  },
};

export interface ParcelObjectOwners {
  parcel: number;
  owners: Uuid[];
  names: string[];
  counts: number[];
  online: boolean[];
}

export const ParcelObjectOwners = {
  ID: 210 as const,
  NAME: "ParcelObjectOwners" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): ParcelObjectOwners {
    return {
      parcel: 0,
      owners: [],
      names: [],
      counts: [],
      online: [],
    };
  },
  encode(w: Writer, v: ParcelObjectOwners): void {
    w.u32(v.parcel);
    w.u16(v.owners.length);
    for (const item of v.owners) {
      w.uuid(item);
    }
    w.u16(v.names.length);
    for (const item of v.names) {
      w.string(item);
    }
    w.u16(v.counts.length);
    for (const item of v.counts) {
      w.u32(item);
    }
    w.u16(v.online.length);
    for (const item of v.online) {
      w.bool(item);
    }
  },
  decode(r: Reader): ParcelObjectOwners {
    const parcel = r.remaining > 0 ? r.u32() : 0;
    const owners: Uuid[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      owners.push(r.uuid());
    }
    const names: string[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      names.push(r.string());
    }
    const counts: number[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      counts.push(r.u32());
    }
    const online: boolean[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      online.push(r.bool());
    }
    return { parcel, owners, names, counts, online };
  },
};

export interface ParcelEject {
  agent: Uuid;
  ban: boolean;
}

export const ParcelEject = {
  ID: 211 as const,
  NAME: "ParcelEject" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ParcelEject {
    return {
      agent: NULL_UUID,
      ban: false,
    };
  },
  encode(w: Writer, v: ParcelEject): void {
    w.uuid(v.agent);
    w.bool(v.ban);
  },
  decode(r: Reader): ParcelEject {
    const agent = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const ban = r.remaining > 0 ? r.bool() : false;
    return { agent, ban };
  },
};

export interface ParcelFreeze {
  agent: Uuid;
  freeze: boolean;
}

export const ParcelFreeze = {
  ID: 212 as const,
  NAME: "ParcelFreeze" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ParcelFreeze {
    return {
      agent: NULL_UUID,
      freeze: false,
    };
  },
  encode(w: Writer, v: ParcelFreeze): void {
    w.uuid(v.agent);
    w.bool(v.freeze);
  },
  decode(r: Reader): ParcelFreeze {
    const agent = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const freeze = r.remaining > 0 ? r.bool() : false;
    return { agent, freeze };
  },
};

export interface ParcelAuctionStart {
  parcel: number;
  start_price: number;
  seconds: number;
}

export const ParcelAuctionStart = {
  ID: 307 as const,
  NAME: "ParcelAuctionStart" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ParcelAuctionStart {
    return {
      parcel: 0,
      start_price: 0,
      seconds: 0,
    };
  },
  encode(w: Writer, v: ParcelAuctionStart): void {
    w.u32(v.parcel);
    w.u32(v.start_price);
    w.u32(v.seconds);
  },
  decode(r: Reader): ParcelAuctionStart {
    const parcel = r.remaining > 0 ? r.u32() : 0;
    const start_price = r.remaining > 0 ? r.u32() : 0;
    const seconds = r.remaining > 0 ? r.u32() : 0;
    return { parcel, start_price, seconds };
  },
};

export interface ParcelAuctionBid {
  parcel: number;
  amount: number;
}

export const ParcelAuctionBid = {
  ID: 308 as const,
  NAME: "ParcelAuctionBid" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ParcelAuctionBid {
    return {
      parcel: 0,
      amount: 0,
    };
  },
  encode(w: Writer, v: ParcelAuctionBid): void {
    w.u32(v.parcel);
    w.u32(v.amount);
  },
  decode(r: Reader): ParcelAuctionBid {
    const parcel = r.remaining > 0 ? r.u32() : 0;
    const amount = r.remaining > 0 ? r.u32() : 0;
    return { parcel, amount };
  },
};

export interface ParcelAuctionCancel {
  parcel: number;
}

export const ParcelAuctionCancel = {
  ID: 309 as const,
  NAME: "ParcelAuctionCancel" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ParcelAuctionCancel {
    return {
      parcel: 0,
    };
  },
  encode(w: Writer, v: ParcelAuctionCancel): void {
    w.u32(v.parcel);
  },
  decode(r: Reader): ParcelAuctionCancel {
    const parcel = r.remaining > 0 ? r.u32() : 0;
    return { parcel };
  },
};

export interface TaskInventoryTake {
  object: number;
  item: Uuid;
  folder: Uuid;
}

export const TaskInventoryTake = {
  ID: 310 as const,
  NAME: "TaskInventoryTake" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): TaskInventoryTake {
    return {
      object: 0,
      item: NULL_UUID,
      folder: NULL_UUID,
    };
  },
  encode(w: Writer, v: TaskInventoryTake): void {
    w.u32(v.object);
    w.uuid(v.item);
    w.uuid(v.folder);
  },
  decode(r: Reader): TaskInventoryTake {
    const object = r.remaining > 0 ? r.u32() : 0;
    const item = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const folder = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { object, item, folder };
  },
};

export interface InventoryTextSave {
  item: Uuid;
  text: string;
}

export const InventoryTextSave = {
  ID: 312 as const,
  NAME: "InventoryTextSave" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): InventoryTextSave {
    return {
      item: NULL_UUID,
      text: "",
    };
  },
  encode(w: Writer, v: InventoryTextSave): void {
    w.uuid(v.item);
    w.string(v.text);
  },
  decode(r: Reader): InventoryTextSave {
    const item = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const text = r.remaining > 0 ? r.string() : "";
    return { item, text };
  },
};

export interface ParcelMediaControl {
  parcel: number;
  kind: number;
  command: number;
  url: string;
  time: number;
}

export const ParcelMediaControl = {
  ID: 311 as const,
  NAME: "ParcelMediaControl" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ParcelMediaControl {
    return {
      parcel: 0,
      kind: 0,
      command: 0,
      url: "",
      time: 0,
    };
  },
  encode(w: Writer, v: ParcelMediaControl): void {
    w.u32(v.parcel);
    w.u8(v.kind);
    w.u8(v.command);
    w.string(v.url);
    w.f32(v.time);
  },
  decode(r: Reader): ParcelMediaControl {
    const parcel = r.remaining > 0 ? r.u32() : 0;
    const kind = r.remaining > 0 ? r.u8() : 0;
    const command = r.remaining > 0 ? r.u8() : 0;
    const url = r.remaining > 0 ? r.string() : "";
    const time = r.remaining > 0 ? r.f32() : 0;
    return { parcel, kind, command, url, time };
  },
};

export interface ParcelDeedToGroup {
  parcel: number;
  group: Uuid;
}

export const ParcelDeedToGroup = {
  ID: 213 as const,
  NAME: "ParcelDeedToGroup" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ParcelDeedToGroup {
    return {
      parcel: 0,
      group: NULL_UUID,
    };
  },
  encode(w: Writer, v: ParcelDeedToGroup): void {
    w.u32(v.parcel);
    w.uuid(v.group);
  },
  decode(r: Reader): ParcelDeedToGroup {
    const parcel = r.remaining > 0 ? r.u32() : 0;
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { parcel, group };
  },
};

export interface MapRequest {
  min_x: number;
  min_y: number;
  max_x: number;
  max_y: number;
  name: string;
}

export const MapRequest = {
  ID: 220 as const,
  NAME: "MapRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): MapRequest {
    return {
      min_x: 0,
      min_y: 0,
      max_x: 0,
      max_y: 0,
      name: "",
    };
  },
  encode(w: Writer, v: MapRequest): void {
    w.u32(v.min_x);
    w.u32(v.min_y);
    w.u32(v.max_x);
    w.u32(v.max_y);
    w.string(v.name);
  },
  decode(r: Reader): MapRequest {
    const min_x = r.remaining > 0 ? r.u32() : 0;
    const min_y = r.remaining > 0 ? r.u32() : 0;
    const max_x = r.remaining > 0 ? r.u32() : 0;
    const max_y = r.remaining > 0 ? r.u32() : 0;
    const name = r.remaining > 0 ? r.string() : "";
    return { min_x, min_y, max_x, max_y, name };
  },
};

export interface MapReply {
  regions: RegionSummary[];
  covers: GridBox[];
}

export const MapReply = {
  ID: 221 as const,
  NAME: "MapReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): MapReply {
    return {
      regions: [],
      covers: [],
    };
  },
  encode(w: Writer, v: MapReply): void {
    w.u16(v.regions.length);
    for (const item of v.regions) {
      RegionSummary.encode(w, item);
    }
    w.u16(v.covers.length);
    for (const item of v.covers) {
      GridBox.encode(w, item);
    }
  },
  decode(r: Reader): MapReply {
    const regions: RegionSummary[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      regions.push(RegionSummary.decode(r));
    }
    const covers: GridBox[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      covers.push(GridBox.decode(r));
    }
    return { regions, covers };
  },
};

export interface MapAgentsRequest {
  region_id: Uuid;
}

export const MapAgentsRequest = {
  ID: 222 as const,
  NAME: "MapAgentsRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): MapAgentsRequest {
    return {
      region_id: NULL_UUID,
    };
  },
  encode(w: Writer, v: MapAgentsRequest): void {
    w.uuid(v.region_id);
  },
  decode(r: Reader): MapAgentsRequest {
    const region_id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { region_id };
  },
};

export interface MapAgentsReply {
  region_id: Uuid;
  dots: MapAgentDot[];
}

export const MapAgentsReply = {
  ID: 223 as const,
  NAME: "MapAgentsReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): MapAgentsReply {
    return {
      region_id: NULL_UUID,
      dots: [],
    };
  },
  encode(w: Writer, v: MapAgentsReply): void {
    w.uuid(v.region_id);
    w.u16(v.dots.length);
    for (const item of v.dots) {
      MapAgentDot.encode(w, item);
    }
  },
  decode(r: Reader): MapAgentsReply {
    const region_id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const dots: MapAgentDot[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      dots.push(MapAgentDot.decode(r));
    }
    return { region_id, dots };
  },
};

export interface LandmarkCreate {
  name: string;
  folder: Uuid;
}

export const LandmarkCreate = {
  ID: 224 as const,
  NAME: "LandmarkCreate" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): LandmarkCreate {
    return {
      name: "",
      folder: NULL_UUID,
    };
  },
  encode(w: Writer, v: LandmarkCreate): void {
    w.string(v.name);
    w.uuid(v.folder);
  },
  decode(r: Reader): LandmarkCreate {
    const name = r.remaining > 0 ? r.string() : "";
    const folder = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { name, folder };
  },
};

export interface PlacesRequest {
  query: string;
  owned: boolean;
  group: Uuid;
}

export const PlacesRequest = {
  ID: 225 as const,
  NAME: "PlacesRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): PlacesRequest {
    return {
      query: "",
      owned: false,
      group: NULL_UUID,
    };
  },
  encode(w: Writer, v: PlacesRequest): void {
    w.string(v.query);
    w.bool(v.owned);
    w.uuid(v.group);
  },
  decode(r: Reader): PlacesRequest {
    const query = r.remaining > 0 ? r.string() : "";
    const owned = r.remaining > 0 ? r.bool() : false;
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { query, owned, group };
  },
};

export interface PlacesReply {
  parcels: ParcelInfo[];
  region_names: string[];
  positions: Vec3[];
}

export const PlacesReply = {
  ID: 226 as const,
  NAME: "PlacesReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): PlacesReply {
    return {
      parcels: [],
      region_names: [],
      positions: [],
    };
  },
  encode(w: Writer, v: PlacesReply): void {
    w.u16(v.parcels.length);
    for (const item of v.parcels) {
      ParcelInfo.encode(w, item);
    }
    w.u16(v.region_names.length);
    for (const item of v.region_names) {
      w.string(item);
    }
    w.u16(v.positions.length);
    for (const item of v.positions) {
      w.vec3(item);
    }
  },
  decode(r: Reader): PlacesReply {
    const parcels: ParcelInfo[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      parcels.push(ParcelInfo.decode(r));
    }
    const region_names: string[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      region_names.push(r.string());
    }
    const positions: Vec3[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      positions.push(r.vec3());
    }
    return { parcels, region_names, positions };
  },
};

export interface MapItemsRequest {
  kind: MapItemKind;
  min_x: number;
  min_y: number;
  max_x: number;
  max_y: number;
}

export const MapItemsRequest = {
  ID: 227 as const,
  NAME: "MapItemsRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): MapItemsRequest {
    return {
      kind: MapItemKind.Telehub,
      min_x: 0,
      min_y: 0,
      max_x: 0,
      max_y: 0,
    };
  },
  encode(w: Writer, v: MapItemsRequest): void {
    w.u8(v.kind);
    w.u32(v.min_x);
    w.u32(v.min_y);
    w.u32(v.max_x);
    w.u32(v.max_y);
  },
  decode(r: Reader): MapItemsRequest {
    const kind = r.remaining > 0 ? r.enumValue(MAP_ITEM_KIND_VALUES, r.u8()) as MapItemKind : MapItemKind.Telehub;
    const min_x = r.remaining > 0 ? r.u32() : 0;
    const min_y = r.remaining > 0 ? r.u32() : 0;
    const max_x = r.remaining > 0 ? r.u32() : 0;
    const max_y = r.remaining > 0 ? r.u32() : 0;
    return { kind, min_x, min_y, max_x, max_y };
  },
};

export interface MapItemsReply {
  kind: MapItemKind;
  items: MapItem[];
}

export const MapItemsReply = {
  ID: 228 as const,
  NAME: "MapItemsReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): MapItemsReply {
    return {
      kind: MapItemKind.Telehub,
      items: [],
    };
  },
  encode(w: Writer, v: MapItemsReply): void {
    w.u8(v.kind);
    w.u16(v.items.length);
    for (const item of v.items) {
      MapItem.encode(w, item);
    }
  },
  decode(r: Reader): MapItemsReply {
    const kind = r.remaining > 0 ? r.enumValue(MAP_ITEM_KIND_VALUES, r.u8()) as MapItemKind : MapItemKind.Telehub;
    const items: MapItem[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      items.push(MapItem.decode(r));
    }
    return { kind, items };
  },
};

export interface AgentHome {
  region_id: Uuid;
  region_name: string;
  grid_x: number;
  grid_y: number;
  position: Vec3;
  look_at: Vec3;
}

export const AgentHome = {
  ID: 229 as const,
  NAME: "AgentHome" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): AgentHome {
    return {
      region_id: NULL_UUID,
      region_name: "",
      grid_x: 0,
      grid_y: 0,
      position: { x: 0, y: 0, z: 0 },
      look_at: { x: 0, y: 0, z: 0 },
    };
  },
  encode(w: Writer, v: AgentHome): void {
    w.uuid(v.region_id);
    w.string(v.region_name);
    w.u32(v.grid_x);
    w.u32(v.grid_y);
    w.vec3(v.position);
    w.vec3(v.look_at);
  },
  decode(r: Reader): AgentHome {
    const region_id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const region_name = r.remaining > 0 ? r.string() : "";
    const grid_x = r.remaining > 0 ? r.u32() : 0;
    const grid_y = r.remaining > 0 ? r.u32() : 0;
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const look_at = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    return { region_id, region_name, grid_x, grid_y, position, look_at };
  },
};

export interface BalanceUpdate {
  balance: bigint;
  delta: bigint;
  description: string;
}

export const BalanceUpdate = {
  ID: 230 as const,
  NAME: "BalanceUpdate" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): BalanceUpdate {
    return {
      balance: 0n,
      delta: 0n,
      description: "",
    };
  },
  encode(w: Writer, v: BalanceUpdate): void {
    w.i64(v.balance);
    w.i64(v.delta);
    w.string(v.description);
  },
  decode(r: Reader): BalanceUpdate {
    const balance = r.remaining > 0 ? r.i64() : 0n;
    const delta = r.remaining > 0 ? r.i64() : 0n;
    const description = r.remaining > 0 ? r.string() : "";
    return { balance, delta, description };
  },
};

export interface MoneyTransfer {
  to: Uuid;
  amount: bigint;
  description: string;
}

export const MoneyTransfer = {
  ID: 231 as const,
  NAME: "MoneyTransfer" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): MoneyTransfer {
    return {
      to: NULL_UUID,
      amount: 0n,
      description: "",
    };
  },
  encode(w: Writer, v: MoneyTransfer): void {
    w.uuid(v.to);
    w.i64(v.amount);
    w.string(v.description);
  },
  decode(r: Reader): MoneyTransfer {
    const to = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const amount = r.remaining > 0 ? r.i64() : 0n;
    const description = r.remaining > 0 ? r.string() : "";
    return { to, amount, description };
  },
};

export interface MoneyTransferResult {
  ok: boolean;
  message: string;
  balance: bigint;
}

export const MoneyTransferResult = {
  ID: 232 as const,
  NAME: "MoneyTransferResult" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): MoneyTransferResult {
    return {
      ok: false,
      message: "",
      balance: 0n,
    };
  },
  encode(w: Writer, v: MoneyTransferResult): void {
    w.bool(v.ok);
    w.string(v.message);
    w.i64(v.balance);
  },
  decode(r: Reader): MoneyTransferResult {
    const ok = r.remaining > 0 ? r.bool() : false;
    const message = r.remaining > 0 ? r.string() : "";
    const balance = r.remaining > 0 ? r.i64() : 0n;
    return { ok, message, balance };
  },
};

export interface TransactionHistoryRequest {
  from_time: bigint;
  limit: number;
}

export const TransactionHistoryRequest = {
  ID: 233 as const,
  NAME: "TransactionHistoryRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): TransactionHistoryRequest {
    return {
      from_time: 0n,
      limit: 0,
    };
  },
  encode(w: Writer, v: TransactionHistoryRequest): void {
    w.u64(v.from_time);
    w.u16(v.limit);
  },
  decode(r: Reader): TransactionHistoryRequest {
    const from_time = r.remaining > 0 ? r.u64() : 0n;
    const limit = r.remaining > 0 ? r.u16() : 0;
    return { from_time, limit };
  },
};

export interface TransactionHistoryReply {
  timestamps: bigint[];
  amounts: bigint[];
  descriptions: string[];
  counterparties: string[];
}

export const TransactionHistoryReply = {
  ID: 234 as const,
  NAME: "TransactionHistoryReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): TransactionHistoryReply {
    return {
      timestamps: [],
      amounts: [],
      descriptions: [],
      counterparties: [],
    };
  },
  encode(w: Writer, v: TransactionHistoryReply): void {
    w.u16(v.timestamps.length);
    for (const item of v.timestamps) {
      w.u64(item);
    }
    w.u16(v.amounts.length);
    for (const item of v.amounts) {
      w.i64(item);
    }
    w.u16(v.descriptions.length);
    for (const item of v.descriptions) {
      w.string(item);
    }
    w.u16(v.counterparties.length);
    for (const item of v.counterparties) {
      w.string(item);
    }
  },
  decode(r: Reader): TransactionHistoryReply {
    const timestamps: bigint[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      timestamps.push(r.u64());
    }
    const amounts: bigint[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      amounts.push(r.i64());
    }
    const descriptions: string[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      descriptions.push(r.string());
    }
    const counterparties: string[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      counterparties.push(r.string());
    }
    return { timestamps, amounts, descriptions, counterparties };
  },
};

export interface NameLookup {
  ids: Uuid[];
}

export const NameLookup = {
  ID: 240 as const,
  NAME: "NameLookup" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): NameLookup {
    return {
      ids: [],
    };
  },
  encode(w: Writer, v: NameLookup): void {
    w.u16(v.ids.length);
    for (const item of v.ids) {
      w.uuid(item);
    }
  },
  decode(r: Reader): NameLookup {
    const ids: Uuid[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      ids.push(r.uuid());
    }
    return { ids };
  },
};

export interface NameReply {
  names: AgentName[];
}

export const NameReply = {
  ID: 241 as const,
  NAME: "NameReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): NameReply {
    return {
      names: [],
    };
  },
  encode(w: Writer, v: NameReply): void {
    w.u16(v.names.length);
    for (const item of v.names) {
      AgentName.encode(w, item);
    }
  },
  decode(r: Reader): NameReply {
    const names: AgentName[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      names.push(AgentName.decode(r));
    }
    return { names };
  },
};

export interface ProfileRequest {
  id: Uuid;
}

export const ProfileRequest = {
  ID: 242 as const,
  NAME: "ProfileRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ProfileRequest {
    return {
      id: NULL_UUID,
    };
  },
  encode(w: Writer, v: ProfileRequest): void {
    w.uuid(v.id);
  },
  decode(r: Reader): ProfileRequest {
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { id };
  },
};

export interface ProfileReply {
  id: Uuid;
  username: string;
  display_name: string;
  about: string;
  image: Uuid;
  born: bigint;
  partner: Uuid;
  account_level: number;
  online: boolean;
  interests: string;
  web_url: string;
  groups: GroupInfo[];
  display_name_set: boolean;
  display_name_next_change: bigint;
}

export const ProfileReply = {
  ID: 243 as const,
  NAME: "ProfileReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): ProfileReply {
    return {
      id: NULL_UUID,
      username: "",
      display_name: "",
      about: "",
      image: NULL_UUID,
      born: 0n,
      partner: NULL_UUID,
      account_level: 0,
      online: false,
      interests: "",
      web_url: "",
      groups: [],
      display_name_set: false,
      display_name_next_change: 0n,
    };
  },
  encode(w: Writer, v: ProfileReply): void {
    w.uuid(v.id);
    w.string(v.username);
    w.string(v.display_name);
    w.string(v.about);
    w.uuid(v.image);
    w.u64(v.born);
    w.uuid(v.partner);
    w.u8(v.account_level);
    w.bool(v.online);
    w.string(v.interests);
    w.string(v.web_url);
    w.u16(v.groups.length);
    for (const item of v.groups) {
      GroupInfo.encode(w, item);
    }
    w.bool(v.display_name_set);
    w.u64(v.display_name_next_change);
  },
  decode(r: Reader): ProfileReply {
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const username = r.remaining > 0 ? r.string() : "";
    const display_name = r.remaining > 0 ? r.string() : "";
    const about = r.remaining > 0 ? r.string() : "";
    const image = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const born = r.remaining > 0 ? r.u64() : 0n;
    const partner = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const account_level = r.remaining > 0 ? r.u8() : 0;
    const online = r.remaining > 0 ? r.bool() : false;
    const interests = r.remaining > 0 ? r.string() : "";
    const web_url = r.remaining > 0 ? r.string() : "";
    const groups: GroupInfo[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      groups.push(GroupInfo.decode(r));
    }
    const display_name_set = r.remaining > 0 ? r.bool() : false;
    const display_name_next_change = r.remaining > 0 ? r.u64() : 0n;
    return { id, username, display_name, about, image, born, partner, account_level, online, interests, web_url, groups, display_name_set, display_name_next_change };
  },
};

export interface ProfileUpdate {
  display_name: string;
  about: string;
  image: Uuid;
  interests: string;
  web_url: string;
}

export const ProfileUpdate = {
  ID: 244 as const,
  NAME: "ProfileUpdate" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ProfileUpdate {
    return {
      display_name: "",
      about: "",
      image: NULL_UUID,
      interests: "",
      web_url: "",
    };
  },
  encode(w: Writer, v: ProfileUpdate): void {
    w.string(v.display_name);
    w.string(v.about);
    w.uuid(v.image);
    w.string(v.interests);
    w.string(v.web_url);
  },
  decode(r: Reader): ProfileUpdate {
    const display_name = r.remaining > 0 ? r.string() : "";
    const about = r.remaining > 0 ? r.string() : "";
    const image = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const interests = r.remaining > 0 ? r.string() : "";
    const web_url = r.remaining > 0 ? r.string() : "";
    return { display_name, about, image, interests, web_url };
  },
};

export interface FriendList {
  friends: FriendInfo[];
}

export const FriendList = {
  ID: 245 as const,
  NAME: "FriendList" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): FriendList {
    return {
      friends: [],
    };
  },
  encode(w: Writer, v: FriendList): void {
    w.u16(v.friends.length);
    for (const item of v.friends) {
      FriendInfo.encode(w, item);
    }
  },
  decode(r: Reader): FriendList {
    const friends: FriendInfo[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      friends.push(FriendInfo.decode(r));
    }
    return { friends };
  },
};

export interface FriendRequest {
  from: Uuid;
  to: Uuid;
  message: string;
  request_id: Uuid;
}

export const FriendRequest = {
  ID: 246 as const,
  NAME: "FriendRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.Both,
  SINCE: 1,
  create(): FriendRequest {
    return {
      from: NULL_UUID,
      to: NULL_UUID,
      message: "",
      request_id: NULL_UUID,
    };
  },
  encode(w: Writer, v: FriendRequest): void {
    w.uuid(v.from);
    w.uuid(v.to);
    w.string(v.message);
    w.uuid(v.request_id);
  },
  decode(r: Reader): FriendRequest {
    const from = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const to = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const message = r.remaining > 0 ? r.string() : "";
    const request_id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { from, to, message, request_id };
  },
};

export interface FriendRequestReply {
  request_id: Uuid;
  accept: boolean;
}

export const FriendRequestReply = {
  ID: 247 as const,
  NAME: "FriendRequestReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): FriendRequestReply {
    return {
      request_id: NULL_UUID,
      accept: false,
    };
  },
  encode(w: Writer, v: FriendRequestReply): void {
    w.uuid(v.request_id);
    w.bool(v.accept);
  },
  decode(r: Reader): FriendRequestReply {
    const request_id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const accept = r.remaining > 0 ? r.bool() : false;
    return { request_id, accept };
  },
};

export interface FriendRemove {
  id: Uuid;
}

export const FriendRemove = {
  ID: 248 as const,
  NAME: "FriendRemove" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): FriendRemove {
    return {
      id: NULL_UUID,
    };
  },
  encode(w: Writer, v: FriendRemove): void {
    w.uuid(v.id);
  },
  decode(r: Reader): FriendRemove {
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { id };
  },
};

export interface FriendPresenceUpdate {
  id: Uuid;
  presence: FriendPresence;
}

export const FriendPresenceUpdate = {
  ID: 249 as const,
  NAME: "FriendPresenceUpdate" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): FriendPresenceUpdate {
    return {
      id: NULL_UUID,
      presence: FriendPresence.Offline,
    };
  },
  encode(w: Writer, v: FriendPresenceUpdate): void {
    w.uuid(v.id);
    w.u8(v.presence);
  },
  decode(r: Reader): FriendPresenceUpdate {
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const presence = r.remaining > 0 ? r.enumValue(FRIEND_PRESENCE_VALUES, r.u8()) as FriendPresence : FriendPresence.Offline;
    return { id, presence };
  },
};

export interface FriendRights {
  id: Uuid;
  rights: number;
}

export const FriendRights = {
  ID: 250 as const,
  NAME: "FriendRights" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): FriendRights {
    return {
      id: NULL_UUID,
      rights: 0,
    };
  },
  encode(w: Writer, v: FriendRights): void {
    w.uuid(v.id);
    w.u8(v.rights);
  },
  decode(r: Reader): FriendRights {
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const rights = r.remaining > 0 ? r.u8() : 0;
    return { id, rights };
  },
};

export interface GroupList {
  groups: GroupInfo[];
  titles: string[];
  powers: bigint[];
  active: Uuid;
}

export const GroupList = {
  ID: 260 as const,
  NAME: "GroupList" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): GroupList {
    return {
      groups: [],
      titles: [],
      powers: [],
      active: NULL_UUID,
    };
  },
  encode(w: Writer, v: GroupList): void {
    w.u16(v.groups.length);
    for (const item of v.groups) {
      GroupInfo.encode(w, item);
    }
    w.u16(v.titles.length);
    for (const item of v.titles) {
      w.string(item);
    }
    w.u16(v.powers.length);
    for (const item of v.powers) {
      w.u64(item);
    }
    w.uuid(v.active);
  },
  decode(r: Reader): GroupList {
    const groups: GroupInfo[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      groups.push(GroupInfo.decode(r));
    }
    const titles: string[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      titles.push(r.string());
    }
    const powers: bigint[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      powers.push(r.u64());
    }
    const active = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { groups, titles, powers, active };
  },
};

export interface GroupCreate {
  name: string;
  charter: string;
  insignia: Uuid;
  open_enrollment: boolean;
  fee: number;
  show_in_list: boolean;
  maturity: Maturity;
}

export const GroupCreate = {
  ID: 261 as const,
  NAME: "GroupCreate" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): GroupCreate {
    return {
      name: "",
      charter: "",
      insignia: NULL_UUID,
      open_enrollment: false,
      fee: 0,
      show_in_list: false,
      maturity: Maturity.General,
    };
  },
  encode(w: Writer, v: GroupCreate): void {
    w.string(v.name);
    w.string(v.charter);
    w.uuid(v.insignia);
    w.bool(v.open_enrollment);
    w.i32(v.fee);
    w.bool(v.show_in_list);
    w.u8(v.maturity);
  },
  decode(r: Reader): GroupCreate {
    const name = r.remaining > 0 ? r.string() : "";
    const charter = r.remaining > 0 ? r.string() : "";
    const insignia = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const open_enrollment = r.remaining > 0 ? r.bool() : false;
    const fee = r.remaining > 0 ? r.i32() : 0;
    const show_in_list = r.remaining > 0 ? r.bool() : false;
    const maturity = r.remaining > 0 ? r.enumValue(MATURITY_VALUES, r.u8()) as Maturity : Maturity.General;
    return { name, charter, insignia, open_enrollment, fee, show_in_list, maturity };
  },
};

export interface GroupCreateResult {
  ok: boolean;
  message: string;
  group: Uuid;
}

export const GroupCreateResult = {
  ID: 262 as const,
  NAME: "GroupCreateResult" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): GroupCreateResult {
    return {
      ok: false,
      message: "",
      group: NULL_UUID,
    };
  },
  encode(w: Writer, v: GroupCreateResult): void {
    w.bool(v.ok);
    w.string(v.message);
    w.uuid(v.group);
  },
  decode(r: Reader): GroupCreateResult {
    const ok = r.remaining > 0 ? r.bool() : false;
    const message = r.remaining > 0 ? r.string() : "";
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { ok, message, group };
  },
};

export interface GroupInfoRequest {
  group: Uuid;
}

export const GroupInfoRequest = {
  ID: 263 as const,
  NAME: "GroupInfoRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): GroupInfoRequest {
    return {
      group: NULL_UUID,
    };
  },
  encode(w: Writer, v: GroupInfoRequest): void {
    w.uuid(v.group);
  },
  decode(r: Reader): GroupInfoRequest {
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { group };
  },
};

export interface GroupInfoReply {
  group: GroupInfo;
  roles: GroupRoleInfo[];
  your_powers: bigint;
  your_title: string;
}

export const GroupInfoReply = {
  ID: 264 as const,
  NAME: "GroupInfoReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): GroupInfoReply {
    return {
      group: GroupInfo.create(),
      roles: [],
      your_powers: 0n,
      your_title: "",
    };
  },
  encode(w: Writer, v: GroupInfoReply): void {
    GroupInfo.encode(w, v.group);
    w.u16(v.roles.length);
    for (const item of v.roles) {
      GroupRoleInfo.encode(w, item);
    }
    w.u64(v.your_powers);
    w.string(v.your_title);
  },
  decode(r: Reader): GroupInfoReply {
    const group = r.remaining > 0 ? GroupInfo.decode(r) : GroupInfo.create();
    const roles: GroupRoleInfo[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      roles.push(GroupRoleInfo.decode(r));
    }
    const your_powers = r.remaining > 0 ? r.u64() : 0n;
    const your_title = r.remaining > 0 ? r.string() : "";
    return { group, roles, your_powers, your_title };
  },
};

export interface GroupMembersRequest {
  group: Uuid;
}

export const GroupMembersRequest = {
  ID: 265 as const,
  NAME: "GroupMembersRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): GroupMembersRequest {
    return {
      group: NULL_UUID,
    };
  },
  encode(w: Writer, v: GroupMembersRequest): void {
    w.uuid(v.group);
  },
  decode(r: Reader): GroupMembersRequest {
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { group };
  },
};

export interface GroupMembersReply {
  group: Uuid;
  members: GroupMemberInfo[];
}

export const GroupMembersReply = {
  ID: 266 as const,
  NAME: "GroupMembersReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): GroupMembersReply {
    return {
      group: NULL_UUID,
      members: [],
    };
  },
  encode(w: Writer, v: GroupMembersReply): void {
    w.uuid(v.group);
    w.u16(v.members.length);
    for (const item of v.members) {
      GroupMemberInfo.encode(w, item);
    }
  },
  decode(r: Reader): GroupMembersReply {
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const members: GroupMemberInfo[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      members.push(GroupMemberInfo.decode(r));
    }
    return { group, members };
  },
};

export interface GroupActivate {
  group: Uuid;
}

export const GroupActivate = {
  ID: 267 as const,
  NAME: "GroupActivate" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): GroupActivate {
    return {
      group: NULL_UUID,
    };
  },
  encode(w: Writer, v: GroupActivate): void {
    w.uuid(v.group);
  },
  decode(r: Reader): GroupActivate {
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { group };
  },
};

export interface GroupUpdate {
  group: GroupInfo;
}

export const GroupUpdate = {
  ID: 268 as const,
  NAME: "GroupUpdate" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): GroupUpdate {
    return {
      group: GroupInfo.create(),
    };
  },
  encode(w: Writer, v: GroupUpdate): void {
    GroupInfo.encode(w, v.group);
  },
  decode(r: Reader): GroupUpdate {
    const group = r.remaining > 0 ? GroupInfo.decode(r) : GroupInfo.create();
    return { group };
  },
};

export interface GroupJoin {
  group: Uuid;
}

export const GroupJoin = {
  ID: 269 as const,
  NAME: "GroupJoin" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): GroupJoin {
    return {
      group: NULL_UUID,
    };
  },
  encode(w: Writer, v: GroupJoin): void {
    w.uuid(v.group);
  },
  decode(r: Reader): GroupJoin {
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { group };
  },
};

export interface GroupLeave {
  group: Uuid;
}

export const GroupLeave = {
  ID: 270 as const,
  NAME: "GroupLeave" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): GroupLeave {
    return {
      group: NULL_UUID,
    };
  },
  encode(w: Writer, v: GroupLeave): void {
    w.uuid(v.group);
  },
  decode(r: Reader): GroupLeave {
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { group };
  },
};

export interface GroupInvite {
  group: Uuid;
  group_name: string;
  agent: Uuid;
  from: Uuid;
  from_name: string;
  role: Uuid;
  invite_id: Uuid;
}

export const GroupInvite = {
  ID: 271 as const,
  NAME: "GroupInvite" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.Both,
  SINCE: 1,
  create(): GroupInvite {
    return {
      group: NULL_UUID,
      group_name: "",
      agent: NULL_UUID,
      from: NULL_UUID,
      from_name: "",
      role: NULL_UUID,
      invite_id: NULL_UUID,
    };
  },
  encode(w: Writer, v: GroupInvite): void {
    w.uuid(v.group);
    w.string(v.group_name);
    w.uuid(v.agent);
    w.uuid(v.from);
    w.string(v.from_name);
    w.uuid(v.role);
    w.uuid(v.invite_id);
  },
  decode(r: Reader): GroupInvite {
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const group_name = r.remaining > 0 ? r.string() : "";
    const agent = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const from = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const from_name = r.remaining > 0 ? r.string() : "";
    const role = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const invite_id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { group, group_name, agent, from, from_name, role, invite_id };
  },
};

export interface GroupInviteReply {
  invite_id: Uuid;
  accept: boolean;
}

export const GroupInviteReply = {
  ID: 272 as const,
  NAME: "GroupInviteReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): GroupInviteReply {
    return {
      invite_id: NULL_UUID,
      accept: false,
    };
  },
  encode(w: Writer, v: GroupInviteReply): void {
    w.uuid(v.invite_id);
    w.bool(v.accept);
  },
  decode(r: Reader): GroupInviteReply {
    const invite_id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const accept = r.remaining > 0 ? r.bool() : false;
    return { invite_id, accept };
  },
};

export interface GroupEject {
  group: Uuid;
  agent: Uuid;
}

export const GroupEject = {
  ID: 273 as const,
  NAME: "GroupEject" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): GroupEject {
    return {
      group: NULL_UUID,
      agent: NULL_UUID,
    };
  },
  encode(w: Writer, v: GroupEject): void {
    w.uuid(v.group);
    w.uuid(v.agent);
  },
  decode(r: Reader): GroupEject {
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const agent = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { group, agent };
  },
};

export interface GroupRoleUpdate {
  group: Uuid;
  role: GroupRoleInfo;
  remove: boolean;
}

export const GroupRoleUpdate = {
  ID: 274 as const,
  NAME: "GroupRoleUpdate" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): GroupRoleUpdate {
    return {
      group: NULL_UUID,
      role: GroupRoleInfo.create(),
      remove: false,
    };
  },
  encode(w: Writer, v: GroupRoleUpdate): void {
    w.uuid(v.group);
    GroupRoleInfo.encode(w, v.role);
    w.bool(v.remove);
  },
  decode(r: Reader): GroupRoleUpdate {
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const role = r.remaining > 0 ? GroupRoleInfo.decode(r) : GroupRoleInfo.create();
    const remove = r.remaining > 0 ? r.bool() : false;
    return { group, role, remove };
  },
};

export interface GroupMemberRole {
  group: Uuid;
  agent: Uuid;
  role: Uuid;
  add: boolean;
}

export const GroupMemberRole = {
  ID: 275 as const,
  NAME: "GroupMemberRole" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): GroupMemberRole {
    return {
      group: NULL_UUID,
      agent: NULL_UUID,
      role: NULL_UUID,
      add: false,
    };
  },
  encode(w: Writer, v: GroupMemberRole): void {
    w.uuid(v.group);
    w.uuid(v.agent);
    w.uuid(v.role);
    w.bool(v.add);
  },
  decode(r: Reader): GroupMemberRole {
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const agent = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const role = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const add = r.remaining > 0 ? r.bool() : false;
    return { group, agent, role, add };
  },
};

export interface GroupTitleSet {
  group: Uuid;
  role: Uuid;
}

export const GroupTitleSet = {
  ID: 276 as const,
  NAME: "GroupTitleSet" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): GroupTitleSet {
    return {
      group: NULL_UUID,
      role: NULL_UUID,
    };
  },
  encode(w: Writer, v: GroupTitleSet): void {
    w.uuid(v.group);
    w.uuid(v.role);
  },
  decode(r: Reader): GroupTitleSet {
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const role = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { group, role };
  },
};

export interface GroupNoticeSend {
  group: Uuid;
  subject: string;
  body: string;
  attachment: Uuid;
}

export const GroupNoticeSend = {
  ID: 277 as const,
  NAME: "GroupNoticeSend" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): GroupNoticeSend {
    return {
      group: NULL_UUID,
      subject: "",
      body: "",
      attachment: NULL_UUID,
    };
  },
  encode(w: Writer, v: GroupNoticeSend): void {
    w.uuid(v.group);
    w.string(v.subject);
    w.string(v.body);
    w.uuid(v.attachment);
  },
  decode(r: Reader): GroupNoticeSend {
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const subject = r.remaining > 0 ? r.string() : "";
    const body = r.remaining > 0 ? r.string() : "";
    const attachment = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { group, subject, body, attachment };
  },
};

export interface GroupNoticesRequest {
  group: Uuid;
}

export const GroupNoticesRequest = {
  ID: 278 as const,
  NAME: "GroupNoticesRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): GroupNoticesRequest {
    return {
      group: NULL_UUID,
    };
  },
  encode(w: Writer, v: GroupNoticesRequest): void {
    w.uuid(v.group);
  },
  decode(r: Reader): GroupNoticesRequest {
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { group };
  },
};

export interface GroupNoticesReply {
  group: Uuid;
  notices: GroupNoticeInfo[];
}

export const GroupNoticesReply = {
  ID: 279 as const,
  NAME: "GroupNoticesReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): GroupNoticesReply {
    return {
      group: NULL_UUID,
      notices: [],
    };
  },
  encode(w: Writer, v: GroupNoticesReply): void {
    w.uuid(v.group);
    w.u16(v.notices.length);
    for (const item of v.notices) {
      GroupNoticeInfo.encode(w, item);
    }
  },
  decode(r: Reader): GroupNoticesReply {
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const notices: GroupNoticeInfo[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      notices.push(GroupNoticeInfo.decode(r));
    }
    return { group, notices };
  },
};

export interface GroupChatSend {
  group: Uuid;
  text: string;
}

export const GroupChatSend = {
  ID: 280 as const,
  NAME: "GroupChatSend" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): GroupChatSend {
    return {
      group: NULL_UUID,
      text: "",
    };
  },
  encode(w: Writer, v: GroupChatSend): void {
    w.uuid(v.group);
    w.string(v.text);
  },
  decode(r: Reader): GroupChatSend {
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const text = r.remaining > 0 ? r.string() : "";
    return { group, text };
  },
};

export interface GroupChatReceive {
  group: Uuid;
  from: Uuid;
  from_name: string;
  text: string;
  timestamp: bigint;
}

export const GroupChatReceive = {
  ID: 281 as const,
  NAME: "GroupChatReceive" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): GroupChatReceive {
    return {
      group: NULL_UUID,
      from: NULL_UUID,
      from_name: "",
      text: "",
      timestamp: 0n,
    };
  },
  encode(w: Writer, v: GroupChatReceive): void {
    w.uuid(v.group);
    w.uuid(v.from);
    w.string(v.from_name);
    w.string(v.text);
    w.u64(v.timestamp);
  },
  decode(r: Reader): GroupChatReceive {
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const from = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const from_name = r.remaining > 0 ? r.string() : "";
    const text = r.remaining > 0 ? r.string() : "";
    const timestamp = r.remaining > 0 ? r.u64() : 0n;
    return { group, from, from_name, text, timestamp };
  },
};

export interface GroupSearch {
  query: string;
}

export const GroupSearch = {
  ID: 282 as const,
  NAME: "GroupSearch" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): GroupSearch {
    return {
      query: "",
    };
  },
  encode(w: Writer, v: GroupSearch): void {
    w.string(v.query);
  },
  decode(r: Reader): GroupSearch {
    const query = r.remaining > 0 ? r.string() : "";
    return { query };
  },
};

export interface GroupSearchReply {
  groups: GroupInfo[];
}

export const GroupSearchReply = {
  ID: 283 as const,
  NAME: "GroupSearchReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): GroupSearchReply {
    return {
      groups: [],
    };
  },
  encode(w: Writer, v: GroupSearchReply): void {
    w.u16(v.groups.length);
    for (const item of v.groups) {
      GroupInfo.encode(w, item);
    }
  },
  decode(r: Reader): GroupSearchReply {
    const groups: GroupInfo[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      groups.push(GroupInfo.decode(r));
    }
    return { groups };
  },
};

export interface SearchRequest {
  kind: SearchKind;
  query: string;
  offset: number;
}

export const SearchRequest = {
  ID: 315 as const,
  NAME: "SearchRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): SearchRequest {
    return {
      kind: SearchKind.People,
      query: "",
      offset: 0,
    };
  },
  encode(w: Writer, v: SearchRequest): void {
    w.u8(v.kind);
    w.string(v.query);
    w.u32(v.offset);
  },
  decode(r: Reader): SearchRequest {
    const kind = r.remaining > 0 ? r.enumValue(SEARCH_KIND_VALUES, r.u8()) as SearchKind : SearchKind.People;
    const query = r.remaining > 0 ? r.string() : "";
    const offset = r.remaining > 0 ? r.u32() : 0;
    return { kind, query, offset };
  },
};

export interface SearchReply {
  kind: SearchKind;
  query: string;
  offset: number;
  results: SearchResult[];
  more: boolean;
}

export const SearchReply = {
  ID: 316 as const,
  NAME: "SearchReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): SearchReply {
    return {
      kind: SearchKind.People,
      query: "",
      offset: 0,
      results: [],
      more: false,
    };
  },
  encode(w: Writer, v: SearchReply): void {
    w.u8(v.kind);
    w.string(v.query);
    w.u32(v.offset);
    w.u16(v.results.length);
    for (const item of v.results) {
      SearchResult.encode(w, item);
    }
    w.bool(v.more);
  },
  decode(r: Reader): SearchReply {
    const kind = r.remaining > 0 ? r.enumValue(SEARCH_KIND_VALUES, r.u8()) as SearchKind : SearchKind.People;
    const query = r.remaining > 0 ? r.string() : "";
    const offset = r.remaining > 0 ? r.u32() : 0;
    const results: SearchResult[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      results.push(SearchResult.decode(r));
    }
    const more = r.remaining > 0 ? r.bool() : false;
    return { kind, query, offset, results, more };
  },
};

export interface EventCreate {
  name: string;
  description: string;
  category: number;
  starts_at: bigint;
  minutes: number;
  position: Vec3;
}

export const EventCreate = {
  ID: 317 as const,
  NAME: "EventCreate" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): EventCreate {
    return {
      name: "",
      description: "",
      category: 0,
      starts_at: 0n,
      minutes: 0,
      position: { x: 0, y: 0, z: 0 },
    };
  },
  encode(w: Writer, v: EventCreate): void {
    w.string(v.name);
    w.string(v.description);
    w.u8(v.category);
    w.u64(v.starts_at);
    w.u32(v.minutes);
    w.vec3(v.position);
  },
  decode(r: Reader): EventCreate {
    const name = r.remaining > 0 ? r.string() : "";
    const description = r.remaining > 0 ? r.string() : "";
    const category = r.remaining > 0 ? r.u8() : 0;
    const starts_at = r.remaining > 0 ? r.u64() : 0n;
    const minutes = r.remaining > 0 ? r.u32() : 0;
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    return { name, description, category, starts_at, minutes, position };
  },
};

export interface ClassifiedCreate {
  name: string;
  description: string;
  category: number;
  position: Vec3;
  image: Uuid;
  price: number;
}

export const ClassifiedCreate = {
  ID: 318 as const,
  NAME: "ClassifiedCreate" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ClassifiedCreate {
    return {
      name: "",
      description: "",
      category: 0,
      position: { x: 0, y: 0, z: 0 },
      image: NULL_UUID,
      price: 0,
    };
  },
  encode(w: Writer, v: ClassifiedCreate): void {
    w.string(v.name);
    w.string(v.description);
    w.u8(v.category);
    w.vec3(v.position);
    w.uuid(v.image);
    w.i32(v.price);
  },
  decode(r: Reader): ClassifiedCreate {
    const name = r.remaining > 0 ? r.string() : "";
    const description = r.remaining > 0 ? r.string() : "";
    const category = r.remaining > 0 ? r.u8() : 0;
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const image = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const price = r.remaining > 0 ? r.i32() : 0;
    return { name, description, category, position, image, price };
  },
};

export interface SearchListingDelete {
  kind: SearchKind;
  id: Uuid;
}

export const SearchListingDelete = {
  ID: 319 as const,
  NAME: "SearchListingDelete" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): SearchListingDelete {
    return {
      kind: SearchKind.People,
      id: NULL_UUID,
    };
  },
  encode(w: Writer, v: SearchListingDelete): void {
    w.u8(v.kind);
    w.uuid(v.id);
  },
  decode(r: Reader): SearchListingDelete {
    const kind = r.remaining > 0 ? r.enumValue(SEARCH_KIND_VALUES, r.u8()) as SearchKind : SearchKind.People;
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { kind, id };
  },
};

export interface VoiceJoin {
  offer: string;
}

export const VoiceJoin = {
  ID: 320 as const,
  NAME: "VoiceJoin" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): VoiceJoin {
    return {
      offer: "",
    };
  },
  encode(w: Writer, v: VoiceJoin): void {
    w.string(v.offer);
  },
  decode(r: Reader): VoiceJoin {
    const offer = r.remaining > 0 ? r.string() : "";
    return { offer };
  },
};

export interface VoiceAnswer {
  answer: string;
  error: string;
}

export const VoiceAnswer = {
  ID: 321 as const,
  NAME: "VoiceAnswer" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): VoiceAnswer {
    return {
      answer: "",
      error: "",
    };
  },
  encode(w: Writer, v: VoiceAnswer): void {
    w.string(v.answer);
    w.string(v.error);
  },
  decode(r: Reader): VoiceAnswer {
    const answer = r.remaining > 0 ? r.string() : "";
    const error = r.remaining > 0 ? r.string() : "";
    return { answer, error };
  },
};

export interface VoiceSlots {
  slots: VoiceSlot[];
  allowed: boolean;
}

export const VoiceSlots = {
  ID: 322 as const,
  NAME: "VoiceSlots" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): VoiceSlots {
    return {
      slots: [],
      allowed: false,
    };
  },
  encode(w: Writer, v: VoiceSlots): void {
    w.u16(v.slots.length);
    for (const item of v.slots) {
      VoiceSlot.encode(w, item);
    }
    w.bool(v.allowed);
  },
  decode(r: Reader): VoiceSlots {
    const slots: VoiceSlot[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      slots.push(VoiceSlot.decode(r));
    }
    const allowed = r.remaining > 0 ? r.bool() : false;
    return { slots, allowed };
  },
};

export interface VoiceLeave {
}

export const VoiceLeave = {
  ID: 323 as const,
  NAME: "VoiceLeave" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): VoiceLeave {
    return {
    };
  },
  encode(w: Writer, v: VoiceLeave): void {
    void w;
    void v;
  },
  decode(r: Reader): VoiceLeave {
    void r;
    return {};
  },
};

export interface VoiceActivity {
  levels: VoiceLevel[];
}

export const VoiceActivity = {
  ID: 324 as const,
  NAME: "VoiceActivity" as const,
  CHANNEL: Channel.Unreliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): VoiceActivity {
    return {
      levels: [],
    };
  },
  encode(w: Writer, v: VoiceActivity): void {
    w.u16(v.levels.length);
    for (const item of v.levels) {
      VoiceLevel.encode(w, item);
    }
  },
  decode(r: Reader): VoiceActivity {
    const levels: VoiceLevel[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      levels.push(VoiceLevel.decode(r));
    }
    return { levels };
  },
};

export interface ExperienceSave {
  experience: ExperienceInfo;
}

export const ExperienceSave = {
  ID: 325 as const,
  NAME: "ExperienceSave" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ExperienceSave {
    return {
      experience: ExperienceInfo.create(),
    };
  },
  encode(w: Writer, v: ExperienceSave): void {
    ExperienceInfo.encode(w, v.experience);
  },
  decode(r: Reader): ExperienceSave {
    const experience = r.remaining > 0 ? ExperienceInfo.decode(r) : ExperienceInfo.create();
    return { experience };
  },
};

export interface ExperienceListRequest {
  kind: ExperienceListKind;
  query: string;
}

export const ExperienceListRequest = {
  ID: 326 as const,
  NAME: "ExperienceListRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ExperienceListRequest {
    return {
      kind: ExperienceListKind.Mine,
      query: "",
    };
  },
  encode(w: Writer, v: ExperienceListRequest): void {
    w.u8(v.kind);
    w.string(v.query);
  },
  decode(r: Reader): ExperienceListRequest {
    const kind = r.remaining > 0 ? r.enumValue(EXPERIENCE_LIST_KIND_VALUES, r.u8()) as ExperienceListKind : ExperienceListKind.Mine;
    const query = r.remaining > 0 ? r.string() : "";
    return { kind, query };
  },
};

export interface ExperienceList {
  kind: ExperienceListKind;
  experiences: ExperienceInfo[];
  allowed: Uuid[];
  blocked: Uuid[];
  error: string;
}

export const ExperienceList = {
  ID: 327 as const,
  NAME: "ExperienceList" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): ExperienceList {
    return {
      kind: ExperienceListKind.Mine,
      experiences: [],
      allowed: [],
      blocked: [],
      error: "",
    };
  },
  encode(w: Writer, v: ExperienceList): void {
    w.u8(v.kind);
    w.u16(v.experiences.length);
    for (const item of v.experiences) {
      ExperienceInfo.encode(w, item);
    }
    w.u16(v.allowed.length);
    for (const item of v.allowed) {
      w.uuid(item);
    }
    w.u16(v.blocked.length);
    for (const item of v.blocked) {
      w.uuid(item);
    }
    w.string(v.error);
  },
  decode(r: Reader): ExperienceList {
    const kind = r.remaining > 0 ? r.enumValue(EXPERIENCE_LIST_KIND_VALUES, r.u8()) as ExperienceListKind : ExperienceListKind.Mine;
    const experiences: ExperienceInfo[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      experiences.push(ExperienceInfo.decode(r));
    }
    const allowed: Uuid[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      allowed.push(r.uuid());
    }
    const blocked: Uuid[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      blocked.push(r.uuid());
    }
    const error = r.remaining > 0 ? r.string() : "";
    return { kind, experiences, allowed, blocked, error };
  },
};

export interface ExperienceAnswer {
  experience: Uuid;
  answer: number;
}

export const ExperienceAnswer = {
  ID: 328 as const,
  NAME: "ExperienceAnswer" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ExperienceAnswer {
    return {
      experience: NULL_UUID,
      answer: 0,
    };
  },
  encode(w: Writer, v: ExperienceAnswer): void {
    w.uuid(v.experience);
    w.u8(v.answer);
  },
  decode(r: Reader): ExperienceAnswer {
    const experience = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const answer = r.remaining > 0 ? r.u8() : 0;
    return { experience, answer };
  },
};

export interface MarketListRequest {
  kind: MarketListKind;
  query: string;
  category: number;
  offset: number;
}

export const MarketListRequest = {
  ID: 329 as const,
  NAME: "MarketListRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): MarketListRequest {
    return {
      kind: MarketListKind.Browse,
      query: "",
      category: 0,
      offset: 0,
    };
  },
  encode(w: Writer, v: MarketListRequest): void {
    w.u8(v.kind);
    w.string(v.query);
    w.u8(v.category);
    w.u32(v.offset);
  },
  decode(r: Reader): MarketListRequest {
    const kind = r.remaining > 0 ? r.enumValue(MARKET_LIST_KIND_VALUES, r.u8()) as MarketListKind : MarketListKind.Browse;
    const query = r.remaining > 0 ? r.string() : "";
    const category = r.remaining > 0 ? r.u8() : 0;
    const offset = r.remaining > 0 ? r.u32() : 0;
    return { kind, query, category, offset };
  },
};

export interface MarketList {
  kind: MarketListKind;
  query: string;
  offset: number;
  listings: MarketListing[];
  more: boolean;
}

export const MarketList = {
  ID: 330 as const,
  NAME: "MarketList" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): MarketList {
    return {
      kind: MarketListKind.Browse,
      query: "",
      offset: 0,
      listings: [],
      more: false,
    };
  },
  encode(w: Writer, v: MarketList): void {
    w.u8(v.kind);
    w.string(v.query);
    w.u32(v.offset);
    w.u16(v.listings.length);
    for (const item of v.listings) {
      MarketListing.encode(w, item);
    }
    w.bool(v.more);
  },
  decode(r: Reader): MarketList {
    const kind = r.remaining > 0 ? r.enumValue(MARKET_LIST_KIND_VALUES, r.u8()) as MarketListKind : MarketListKind.Browse;
    const query = r.remaining > 0 ? r.string() : "";
    const offset = r.remaining > 0 ? r.u32() : 0;
    const listings: MarketListing[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      listings.push(MarketListing.decode(r));
    }
    const more = r.remaining > 0 ? r.bool() : false;
    return { kind, query, offset, listings, more };
  },
};

export interface MarketListingSave {
  id: Uuid;
  item: Uuid;
  name: string;
  description: string;
  category: number;
  price: number;
  image: Uuid;
  withdraw: boolean;
}

export const MarketListingSave = {
  ID: 331 as const,
  NAME: "MarketListingSave" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): MarketListingSave {
    return {
      id: NULL_UUID,
      item: NULL_UUID,
      name: "",
      description: "",
      category: 0,
      price: 0,
      image: NULL_UUID,
      withdraw: false,
    };
  },
  encode(w: Writer, v: MarketListingSave): void {
    w.uuid(v.id);
    w.uuid(v.item);
    w.string(v.name);
    w.string(v.description);
    w.u8(v.category);
    w.i32(v.price);
    w.uuid(v.image);
    w.bool(v.withdraw);
  },
  decode(r: Reader): MarketListingSave {
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const item = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const name = r.remaining > 0 ? r.string() : "";
    const description = r.remaining > 0 ? r.string() : "";
    const category = r.remaining > 0 ? r.u8() : 0;
    const price = r.remaining > 0 ? r.i32() : 0;
    const image = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const withdraw = r.remaining > 0 ? r.bool() : false;
    return { id, item, name, description, category, price, image, withdraw };
  },
};

export interface MarketBuy {
  listing: Uuid;
  price: number;
}

export const MarketBuy = {
  ID: 332 as const,
  NAME: "MarketBuy" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): MarketBuy {
    return {
      listing: NULL_UUID,
      price: 0,
    };
  },
  encode(w: Writer, v: MarketBuy): void {
    w.uuid(v.listing);
    w.i32(v.price);
  },
  decode(r: Reader): MarketBuy {
    const listing = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const price = r.remaining > 0 ? r.i32() : 0;
    return { listing, price };
  },
};

export interface MarketResult {
  listing: Uuid;
  ok: boolean;
  message: string;
}

export const MarketResult = {
  ID: 333 as const,
  NAME: "MarketResult" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): MarketResult {
    return {
      listing: NULL_UUID,
      ok: false,
      message: "",
    };
  },
  encode(w: Writer, v: MarketResult): void {
    w.uuid(v.listing);
    w.bool(v.ok);
    w.string(v.message);
  },
  decode(r: Reader): MarketResult {
    const listing = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const ok = r.remaining > 0 ? r.bool() : false;
    const message = r.remaining > 0 ? r.string() : "";
    return { listing, ok, message };
  },
};

export interface EstateUpdate {
  estate: EstateInfo;
}

export const EstateUpdate = {
  ID: 290 as const,
  NAME: "EstateUpdate" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): EstateUpdate {
    return {
      estate: EstateInfo.create(),
    };
  },
  encode(w: Writer, v: EstateUpdate): void {
    EstateInfo.encode(w, v.estate);
  },
  decode(r: Reader): EstateUpdate {
    const estate = r.remaining > 0 ? EstateInfo.decode(r) : EstateInfo.create();
    return { estate };
  },
};

export interface EstateKick {
  agent: Uuid;
  ban: boolean;
  message: string;
}

export const EstateKick = {
  ID: 291 as const,
  NAME: "EstateKick" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): EstateKick {
    return {
      agent: NULL_UUID,
      ban: false,
      message: "",
    };
  },
  encode(w: Writer, v: EstateKick): void {
    w.uuid(v.agent);
    w.bool(v.ban);
    w.string(v.message);
  },
  decode(r: Reader): EstateKick {
    const agent = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const ban = r.remaining > 0 ? r.bool() : false;
    const message = r.remaining > 0 ? r.string() : "";
    return { agent, ban, message };
  },
};

export interface EstateMessage {
  text: string;
}

export const EstateMessage = {
  ID: 292 as const,
  NAME: "EstateMessage" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): EstateMessage {
    return {
      text: "",
    };
  },
  encode(w: Writer, v: EstateMessage): void {
    w.string(v.text);
  },
  decode(r: Reader): EstateMessage {
    const text = r.remaining > 0 ? r.string() : "";
    return { text };
  },
};

export interface EstateRestart {
  seconds: number;
  cancel: boolean;
  forced: boolean;
}

export const EstateRestart = {
  ID: 293 as const,
  NAME: "EstateRestart" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): EstateRestart {
    return {
      seconds: 0,
      cancel: false,
      forced: false,
    };
  },
  encode(w: Writer, v: EstateRestart): void {
    w.u32(v.seconds);
    w.bool(v.cancel);
    w.bool(v.forced);
  },
  decode(r: Reader): EstateRestart {
    const seconds = r.remaining > 0 ? r.u32() : 0;
    const cancel = r.remaining > 0 ? r.bool() : false;
    const forced = r.remaining > 0 ? r.bool() : false;
    return { seconds, cancel, forced };
  },
};

export interface EstateTeleportHome {
  agent: Uuid;
  everyone: boolean;
}

export const EstateTeleportHome = {
  ID: 294 as const,
  NAME: "EstateTeleportHome" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): EstateTeleportHome {
    return {
      agent: NULL_UUID,
      everyone: false,
    };
  },
  encode(w: Writer, v: EstateTeleportHome): void {
    w.uuid(v.agent);
    w.bool(v.everyone);
  },
  decode(r: Reader): EstateTeleportHome {
    const agent = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const everyone = r.remaining > 0 ? r.bool() : false;
    return { agent, everyone };
  },
};

export interface GodRequest {
  level: number;
}

export const GodRequest = {
  ID: 295 as const,
  NAME: "GodRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): GodRequest {
    return {
      level: 0,
    };
  },
  encode(w: Writer, v: GodRequest): void {
    w.u8(v.level);
  },
  decode(r: Reader): GodRequest {
    const level = r.remaining > 0 ? r.u8() : 0;
    return { level };
  },
};

export interface GodGrant {
  level: number;
}

export const GodGrant = {
  ID: 296 as const,
  NAME: "GodGrant" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): GodGrant {
    return {
      level: 0,
    };
  },
  encode(w: Writer, v: GodGrant): void {
    w.u8(v.level);
  },
  decode(r: Reader): GodGrant {
    const level = r.remaining > 0 ? r.u8() : 0;
    return { level };
  },
};

export interface AdminObjectReturn {
  owner: Uuid;
  scripted_only: boolean;
}

export const AdminObjectReturn = {
  ID: 297 as const,
  NAME: "AdminObjectReturn" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): AdminObjectReturn {
    return {
      owner: NULL_UUID,
      scripted_only: false,
    };
  },
  encode(w: Writer, v: AdminObjectReturn): void {
    w.uuid(v.owner);
    w.bool(v.scripted_only);
  },
  decode(r: Reader): AdminObjectReturn {
    const owner = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const scripted_only = r.remaining > 0 ? r.bool() : false;
    return { owner, scripted_only };
  },
};

export interface AdminObjectAction {
  ids: number[];
  op: AdminObjectOp;
}

export const AdminObjectAction = {
  ID: 678 as const,
  NAME: "AdminObjectAction" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): AdminObjectAction {
    return {
      ids: [],
      op: AdminObjectOp.ForceOwnerToMe,
    };
  },
  encode(w: Writer, v: AdminObjectAction): void {
    w.u16(v.ids.length);
    for (const item of v.ids) {
      w.u32(item);
    }
    w.u8(v.op);
  },
  decode(r: Reader): AdminObjectAction {
    const ids: number[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      ids.push(r.u32());
    }
    const op = r.remaining > 0 ? r.enumValue(ADMIN_OBJECT_OP_VALUES, r.u8()) as AdminObjectOp : AdminObjectOp.ForceOwnerToMe;
    return { ids, op };
  },
};

export interface StaffAction {
  op: StaffOp;
  target: Uuid;
  text: string;
  seconds: number;
  level: number;
}

export const StaffAction = {
  ID: 679 as const,
  NAME: "StaffAction" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): StaffAction {
    return {
      op: StaffOp.KickFromGrid,
      target: NULL_UUID,
      text: "",
      seconds: 0,
      level: 0,
    };
  },
  encode(w: Writer, v: StaffAction): void {
    w.u8(v.op);
    w.uuid(v.target);
    w.string(v.text);
    w.u32(v.seconds);
    w.u8(v.level);
  },
  decode(r: Reader): StaffAction {
    const op = r.remaining > 0 ? r.enumValue(STAFF_OP_VALUES, r.u8()) as StaffOp : StaffOp.KickFromGrid;
    const target = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const text = r.remaining > 0 ? r.string() : "";
    const seconds = r.remaining > 0 ? r.u32() : 0;
    const level = r.remaining > 0 ? r.u8() : 0;
    return { op, target, text, seconds, level };
  },
};

export interface StaffActionReply {
  op: StaffOp;
  ok: boolean;
  message: string;
}

export const StaffActionReply = {
  ID: 680 as const,
  NAME: "StaffActionReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): StaffActionReply {
    return {
      op: StaffOp.KickFromGrid,
      ok: false,
      message: "",
    };
  },
  encode(w: Writer, v: StaffActionReply): void {
    w.u8(v.op);
    w.bool(v.ok);
    w.string(v.message);
  },
  decode(r: Reader): StaffActionReply {
    const op = r.remaining > 0 ? r.enumValue(STAFF_OP_VALUES, r.u8()) as StaffOp : StaffOp.KickFromGrid;
    const ok = r.remaining > 0 ? r.bool() : false;
    const message = r.remaining > 0 ? r.string() : "";
    return { op, ok, message };
  },
};

export interface TopScriptsRequest {
  colliders: boolean;
}

export const TopScriptsRequest = {
  ID: 298 as const,
  NAME: "TopScriptsRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): TopScriptsRequest {
    return {
      colliders: false,
    };
  },
  encode(w: Writer, v: TopScriptsRequest): void {
    w.bool(v.colliders);
  },
  decode(r: Reader): TopScriptsRequest {
    const colliders = r.remaining > 0 ? r.bool() : false;
    return { colliders };
  },
};

export interface TopScriptsReply {
  objects: number[];
  names: string[];
  owners: string[];
  costs: number[];
  positions: Vec3[];
}

export const TopScriptsReply = {
  ID: 299 as const,
  NAME: "TopScriptsReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): TopScriptsReply {
    return {
      objects: [],
      names: [],
      owners: [],
      costs: [],
      positions: [],
    };
  },
  encode(w: Writer, v: TopScriptsReply): void {
    w.u16(v.objects.length);
    for (const item of v.objects) {
      w.u32(item);
    }
    w.u16(v.names.length);
    for (const item of v.names) {
      w.string(item);
    }
    w.u16(v.owners.length);
    for (const item of v.owners) {
      w.string(item);
    }
    w.u16(v.costs.length);
    for (const item of v.costs) {
      w.f32(item);
    }
    w.u16(v.positions.length);
    for (const item of v.positions) {
      w.vec3(item);
    }
  },
  decode(r: Reader): TopScriptsReply {
    const objects: number[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      objects.push(r.u32());
    }
    const names: string[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      names.push(r.string());
    }
    const owners: string[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      owners.push(r.string());
    }
    const costs: number[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      costs.push(r.f32());
    }
    const positions: Vec3[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      positions.push(r.vec3());
    }
    return { objects, names, owners, costs, positions };
  },
};

export interface ObjectHudAttach {
  object: number;
  point: AttachPoint;
  position: Vec2;
}

export const ObjectHudAttach = {
  ID: 300 as const,
  NAME: "ObjectHudAttach" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): ObjectHudAttach {
    return {
      object: 0,
      point: AttachPoint.None,
      position: { x: 0, y: 0 },
    };
  },
  encode(w: Writer, v: ObjectHudAttach): void {
    w.u32(v.object);
    w.u8(v.point);
    w.vec2(v.position);
  },
  decode(r: Reader): ObjectHudAttach {
    const object = r.remaining > 0 ? r.u32() : 0;
    const point = r.remaining > 0 ? r.enumValue(ATTACH_POINT_VALUES, r.u8()) as AttachPoint : AttachPoint.None;
    const position = r.remaining > 0 ? r.vec2() : { x: 0, y: 0 };
    return { object, point, position };
  },
};

export interface ClientStatsReport {
  stats: SessionStats;
}

export const ClientStatsReport = {
  ID: 301 as const,
  NAME: "ClientStatsReport" as const,
  CHANNEL: Channel.Unreliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ClientStatsReport {
    return {
      stats: SessionStats.create(),
    };
  },
  encode(w: Writer, v: ClientStatsReport): void {
    SessionStats.encode(w, v.stats);
  },
  decode(r: Reader): ClientStatsReport {
    const stats = r.remaining > 0 ? SessionStats.decode(r) : SessionStats.create();
    return { stats };
  },
};

export interface AbuseReport {
  category: AbuseCategory;
  target_agent: Uuid;
  target_object: Uuid;
  summary: string;
  details: string;
  position: Vec3;
  screenshot: Uuid;
}

export const AbuseReport = {
  ID: 313 as const,
  NAME: "AbuseReport" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): AbuseReport {
    return {
      category: AbuseCategory.Other,
      target_agent: NULL_UUID,
      target_object: NULL_UUID,
      summary: "",
      details: "",
      position: { x: 0, y: 0, z: 0 },
      screenshot: NULL_UUID,
    };
  },
  encode(w: Writer, v: AbuseReport): void {
    w.u8(v.category);
    w.uuid(v.target_agent);
    w.uuid(v.target_object);
    w.string(v.summary);
    w.string(v.details);
    w.vec3(v.position);
    w.uuid(v.screenshot);
  },
  decode(r: Reader): AbuseReport {
    const category = r.remaining > 0 ? r.enumValue(ABUSE_CATEGORY_VALUES, r.u8()) as AbuseCategory : AbuseCategory.Other;
    const target_agent = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const target_object = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const summary = r.remaining > 0 ? r.string() : "";
    const details = r.remaining > 0 ? r.string() : "";
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const screenshot = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { category, target_agent, target_object, summary, details, position, screenshot };
  },
};

export interface AbuseReportAck {
  ok: boolean;
  message: string;
}

export const AbuseReportAck = {
  ID: 314 as const,
  NAME: "AbuseReportAck" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): AbuseReportAck {
    return {
      ok: false,
      message: "",
    };
  },
  encode(w: Writer, v: AbuseReportAck): void {
    w.bool(v.ok);
    w.string(v.message);
  },
  decode(r: Reader): AbuseReportAck {
    const ok = r.remaining > 0 ? r.bool() : false;
    const message = r.remaining > 0 ? r.string() : "";
    return { ok, message };
  },
};

export interface DetectedReport {
  object: number;
  detected: DetectedInfo[];
}

export const DetectedReport = {
  ID: 302 as const,
  NAME: "DetectedReport" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): DetectedReport {
    return {
      object: 0,
      detected: [],
    };
  },
  encode(w: Writer, v: DetectedReport): void {
    w.u32(v.object);
    w.u16(v.detected.length);
    for (const item of v.detected) {
      DetectedInfo.encode(w, item);
    }
  },
  decode(r: Reader): DetectedReport {
    const object = r.remaining > 0 ? r.u32() : 0;
    const detected: DetectedInfo[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      detected.push(DetectedInfo.decode(r));
    }
    return { object, detected };
  },
};

export interface CameraConstraint {
  plane: Vec4;
}

export const CameraConstraint = {
  ID: 303 as const,
  NAME: "CameraConstraint" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): CameraConstraint {
    return {
      plane: { x: 0, y: 0, z: 0, w: 0 },
    };
  },
  encode(w: Writer, v: CameraConstraint): void {
    w.vec4(v.plane);
  },
  decode(r: Reader): CameraConstraint {
    const plane = r.remaining > 0 ? r.vec4() : { x: 0, y: 0, z: 0, w: 0 };
    return { plane };
  },
};

export interface ViewerEffectSpawn {
  kind: number;
  position: Vec3;
  target: Vec3;
  color: Color;
  duration: number;
  texture: Uuid;
}

export const ViewerEffectSpawn = {
  ID: 304 as const,
  NAME: "ViewerEffectSpawn" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): ViewerEffectSpawn {
    return {
      kind: 0,
      position: { x: 0, y: 0, z: 0 },
      target: { x: 0, y: 0, z: 0 },
      color: { r: 255, g: 255, b: 255, a: 255 },
      duration: 0,
      texture: NULL_UUID,
    };
  },
  encode(w: Writer, v: ViewerEffectSpawn): void {
    w.u8(v.kind);
    w.vec3(v.position);
    w.vec3(v.target);
    w.color(v.color);
    w.f32(v.duration);
    w.uuid(v.texture);
  },
  decode(r: Reader): ViewerEffectSpawn {
    const kind = r.remaining > 0 ? r.u8() : 0;
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const target = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const color = r.remaining > 0 ? r.color() : { r: 255, g: 255, b: 255, a: 255 };
    const duration = r.remaining > 0 ? r.f32() : 0;
    const texture = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { kind, position, target, color, duration, texture };
  },
};

export interface TerrainRequest {
  patches: number[];
}

export const TerrainRequest = {
  ID: 305 as const,
  NAME: "TerrainRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): TerrainRequest {
    return {
      patches: [],
    };
  },
  encode(w: Writer, v: TerrainRequest): void {
    w.u16(v.patches.length);
    for (const item of v.patches) {
      w.u16(item);
    }
  },
  decode(r: Reader): TerrainRequest {
    const patches: number[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      patches.push(r.u16());
    }
    return { patches };
  },
};

export interface FriendLocateRequest {
  id: Uuid;
}

export const FriendLocateRequest = {
  ID: 334 as const,
  NAME: "FriendLocateRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): FriendLocateRequest {
    return {
      id: NULL_UUID,
    };
  },
  encode(w: Writer, v: FriendLocateRequest): void {
    w.uuid(v.id);
  },
  decode(r: Reader): FriendLocateRequest {
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { id };
  },
};

export interface FriendLocateReply {
  id: Uuid;
  found: boolean;
  region_id: Uuid;
  region_name: string;
  grid_x: number;
  grid_y: number;
  position: Vec3;
}

export const FriendLocateReply = {
  ID: 335 as const,
  NAME: "FriendLocateReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): FriendLocateReply {
    return {
      id: NULL_UUID,
      found: false,
      region_id: NULL_UUID,
      region_name: "",
      grid_x: 0,
      grid_y: 0,
      position: { x: 0, y: 0, z: 0 },
    };
  },
  encode(w: Writer, v: FriendLocateReply): void {
    w.uuid(v.id);
    w.bool(v.found);
    w.uuid(v.region_id);
    w.string(v.region_name);
    w.u32(v.grid_x);
    w.u32(v.grid_y);
    w.vec3(v.position);
  },
  decode(r: Reader): FriendLocateReply {
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const found = r.remaining > 0 ? r.bool() : false;
    const region_id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const region_name = r.remaining > 0 ? r.string() : "";
    const grid_x = r.remaining > 0 ? r.u32() : 0;
    const grid_y = r.remaining > 0 ? r.u32() : 0;
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    return { id, found, region_id, region_name, grid_x, grid_y, position };
  },
};

export interface MapParcelRequest {
  region_id: Uuid;
  position: Vec3;
}

export const MapParcelRequest = {
  ID: 336 as const,
  NAME: "MapParcelRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): MapParcelRequest {
    return {
      region_id: NULL_UUID,
      position: { x: 0, y: 0, z: 0 },
    };
  },
  encode(w: Writer, v: MapParcelRequest): void {
    w.uuid(v.region_id);
    w.vec3(v.position);
  },
  decode(r: Reader): MapParcelRequest {
    const region_id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    return { region_id, position };
  },
};

export interface MapParcelReply {
  region_id: Uuid;
  position: Vec3;
  found: boolean;
  name: string;
  area: number;
  for_sale: boolean;
  sale_price: number;
}

export const MapParcelReply = {
  ID: 337 as const,
  NAME: "MapParcelReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): MapParcelReply {
    return {
      region_id: NULL_UUID,
      position: { x: 0, y: 0, z: 0 },
      found: false,
      name: "",
      area: 0,
      for_sale: false,
      sale_price: 0,
    };
  },
  encode(w: Writer, v: MapParcelReply): void {
    w.uuid(v.region_id);
    w.vec3(v.position);
    w.bool(v.found);
    w.string(v.name);
    w.u32(v.area);
    w.bool(v.for_sale);
    w.i32(v.sale_price);
  },
  decode(r: Reader): MapParcelReply {
    const region_id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const found = r.remaining > 0 ? r.bool() : false;
    const name = r.remaining > 0 ? r.string() : "";
    const area = r.remaining > 0 ? r.u32() : 0;
    const for_sale = r.remaining > 0 ? r.bool() : false;
    const sale_price = r.remaining > 0 ? r.i32() : 0;
    return { region_id, position, found, name, area, for_sale, sale_price };
  },
};

export interface AgentControlsRelease {
}

export const AgentControlsRelease = {
  ID: 338 as const,
  NAME: "AgentControlsRelease" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): AgentControlsRelease {
    return {
    };
  },
  encode(w: Writer, v: AgentControlsRelease): void {
    void w;
    void v;
  },
  decode(r: Reader): AgentControlsRelease {
    void r;
    return {};
  },
};

export interface ObjectHandOff {
  ids: number[];
  region_id: Uuid;
}

export const ObjectHandOff = {
  ID: 339 as const,
  NAME: "ObjectHandOff" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): ObjectHandOff {
    return {
      ids: [],
      region_id: NULL_UUID,
    };
  },
  encode(w: Writer, v: ObjectHandOff): void {
    w.u16(v.ids.length);
    for (const item of v.ids) {
      w.u32(item);
    }
    w.uuid(v.region_id);
  },
  decode(r: Reader): ObjectHandOff {
    const ids: number[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      ids.push(r.u32());
    }
    const region_id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { ids, region_id };
  },
};

export interface VehicleFlags {
  object: number;
  flags: number;
}

export const VehicleFlags = {
  ID: 340 as const,
  NAME: "VehicleFlags" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): VehicleFlags {
    return {
      object: 0,
      flags: 0,
    };
  },
  encode(w: Writer, v: VehicleFlags): void {
    w.u32(v.object);
    w.u32(v.flags);
  },
  decode(r: Reader): VehicleFlags {
    const object = r.remaining > 0 ? r.u32() : 0;
    const flags = r.remaining > 0 ? r.u32() : 0;
    return { object, flags };
  },
};

export interface AttachmentWear {
  item: Uuid;
  point: AttachPoint;
  replace: boolean;
}

export const AttachmentWear = {
  ID: 341 as const,
  NAME: "AttachmentWear" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): AttachmentWear {
    return {
      item: NULL_UUID,
      point: AttachPoint.None,
      replace: false,
    };
  },
  encode(w: Writer, v: AttachmentWear): void {
    w.uuid(v.item);
    w.u8(v.point);
    w.bool(v.replace);
  },
  decode(r: Reader): AttachmentWear {
    const item = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const point = r.remaining > 0 ? r.enumValue(ATTACH_POINT_VALUES, r.u8()) as AttachPoint : AttachPoint.None;
    const replace = r.remaining > 0 ? r.bool() : false;
    return { item, point, replace };
  },
};

export interface AgentSetHover {
  hover: number;
}

export const AgentSetHover = {
  ID: 342 as const,
  NAME: "AgentSetHover" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): AgentSetHover {
    return {
      hover: 0,
    };
  },
  encode(w: Writer, v: AgentSetHover): void {
    w.f32(v.hover);
  },
  decode(r: Reader): AgentSetHover {
    const hover = r.remaining > 0 ? r.f32() : 0;
    return { hover };
  },
};

export interface AgentAnimationStopAll {
}

export const AgentAnimationStopAll = {
  ID: 343 as const,
  NAME: "AgentAnimationStopAll" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): AgentAnimationStopAll {
    return {
    };
  },
  encode(w: Writer, v: AgentAnimationStopAll): void {
    void w;
    void v;
  },
  decode(r: Reader): AgentAnimationStopAll {
    void r;
    return {};
  },
};

export interface AgentDoNotDisturb {
  on: boolean;
  reply: string;
}

export const AgentDoNotDisturb = {
  ID: 344 as const,
  NAME: "AgentDoNotDisturb" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): AgentDoNotDisturb {
    return {
      on: false,
      reply: "",
    };
  },
  encode(w: Writer, v: AgentDoNotDisturb): void {
    w.bool(v.on);
    w.string(v.reply);
  },
  decode(r: Reader): AgentDoNotDisturb {
    const on = r.remaining > 0 ? r.bool() : false;
    const reply = r.remaining > 0 ? r.string() : "";
    return { on, reply };
  },
};

export interface ProfileExtrasRequest {
  id: Uuid;
}

export const ProfileExtrasRequest = {
  ID: 345 as const,
  NAME: "ProfileExtrasRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ProfileExtrasRequest {
    return {
      id: NULL_UUID,
    };
  },
  encode(w: Writer, v: ProfileExtrasRequest): void {
    w.uuid(v.id);
  },
  decode(r: Reader): ProfileExtrasRequest {
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { id };
  },
};

export interface ProfileExtras {
  id: Uuid;
  picks: ProfilePick[];
  classifieds: SearchResult[];
  notes: string;
}

export const ProfileExtras = {
  ID: 346 as const,
  NAME: "ProfileExtras" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): ProfileExtras {
    return {
      id: NULL_UUID,
      picks: [],
      classifieds: [],
      notes: "",
    };
  },
  encode(w: Writer, v: ProfileExtras): void {
    w.uuid(v.id);
    w.u16(v.picks.length);
    for (const item of v.picks) {
      ProfilePick.encode(w, item);
    }
    w.u16(v.classifieds.length);
    for (const item of v.classifieds) {
      SearchResult.encode(w, item);
    }
    w.string(v.notes);
  },
  decode(r: Reader): ProfileExtras {
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const picks: ProfilePick[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      picks.push(ProfilePick.decode(r));
    }
    const classifieds: SearchResult[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      classifieds.push(SearchResult.decode(r));
    }
    const notes = r.remaining > 0 ? r.string() : "";
    return { id, picks, classifieds, notes };
  },
};

export interface PickSave {
  pick: ProfilePick;
  here: boolean;
}

export const PickSave = {
  ID: 347 as const,
  NAME: "PickSave" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): PickSave {
    return {
      pick: ProfilePick.create(),
      here: false,
    };
  },
  encode(w: Writer, v: PickSave): void {
    ProfilePick.encode(w, v.pick);
    w.bool(v.here);
  },
  decode(r: Reader): PickSave {
    const pick = r.remaining > 0 ? ProfilePick.decode(r) : ProfilePick.create();
    const here = r.remaining > 0 ? r.bool() : false;
    return { pick, here };
  },
};

export interface PickDelete {
  id: Uuid;
}

export const PickDelete = {
  ID: 348 as const,
  NAME: "PickDelete" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): PickDelete {
    return {
      id: NULL_UUID,
    };
  },
  encode(w: Writer, v: PickDelete): void {
    w.uuid(v.id);
  },
  decode(r: Reader): PickDelete {
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { id };
  },
};

export interface ProfileNotesSave {
  id: Uuid;
  notes: string;
}

export const ProfileNotesSave = {
  ID: 349 as const,
  NAME: "ProfileNotesSave" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ProfileNotesSave {
    return {
      id: NULL_UUID,
      notes: "",
    };
  },
  encode(w: Writer, v: ProfileNotesSave): void {
    w.uuid(v.id);
    w.string(v.notes);
  },
  decode(r: Reader): ProfileNotesSave {
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const notes = r.remaining > 0 ? r.string() : "";
    return { id, notes };
  },
};

export interface ObjectTouchAt {
  id: number;
  face: number;
  phase: TouchPhase;
  position: Vec3;
  uv: Vec2;
  st: Vec2;
  normal: Vec3;
  binormal: Vec3;
}

export const ObjectTouchAt = {
  ID: 360 as const,
  NAME: "ObjectTouchAt" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectTouchAt {
    return {
      id: 0,
      face: 0,
      phase: TouchPhase.Start,
      position: { x: 0, y: 0, z: 0 },
      uv: { x: 0, y: 0 },
      st: { x: 0, y: 0 },
      normal: { x: 0, y: 0, z: 0 },
      binormal: { x: 0, y: 0, z: 0 },
    };
  },
  encode(w: Writer, v: ObjectTouchAt): void {
    w.u32(v.id);
    w.u8(v.face);
    w.u8(v.phase);
    w.vec3(v.position);
    w.vec2(v.uv);
    w.vec2(v.st);
    w.vec3(v.normal);
    w.vec3(v.binormal);
  },
  decode(r: Reader): ObjectTouchAt {
    const id = r.remaining > 0 ? r.u32() : 0;
    const face = r.remaining > 0 ? r.u8() : 0;
    const phase = r.remaining > 0 ? r.enumValue(TOUCH_PHASE_VALUES, r.u8()) as TouchPhase : TouchPhase.Start;
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const uv = r.remaining > 0 ? r.vec2() : { x: 0, y: 0 };
    const st = r.remaining > 0 ? r.vec2() : { x: 0, y: 0 };
    const normal = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const binormal = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    return { id, face, phase, position, uv, st, normal, binormal };
  },
};

export interface ObjectSetSaleType {
  id: number;
  sale_type: SaleType;
}

export const ObjectSetSaleType = {
  ID: 380 as const,
  NAME: "ObjectSetSaleType" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectSetSaleType {
    return {
      id: 0,
      sale_type: SaleType.Original,
    };
  },
  encode(w: Writer, v: ObjectSetSaleType): void {
    w.u32(v.id);
    w.u8(v.sale_type);
  },
  decode(r: Reader): ObjectSetSaleType {
    const id = r.remaining > 0 ? r.u32() : 0;
    const sale_type = r.remaining > 0 ? r.enumValue(SALE_TYPE_VALUES, r.u8()) as SaleType : SaleType.Original;
    return { id, sale_type };
  },
};

export interface ObjectTradeRequest {
  id: number;
}

export const ObjectTradeRequest = {
  ID: 381 as const,
  NAME: "ObjectTradeRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectTradeRequest {
    return {
      id: 0,
    };
  },
  encode(w: Writer, v: ObjectTradeRequest): void {
    w.u32(v.id);
  },
  decode(r: Reader): ObjectTradeRequest {
    const id = r.remaining > 0 ? r.u32() : 0;
    return { id };
  },
};

export interface ObjectTrade {
  id: number;
  root: number;
  name: string;
  owner: Uuid;
  for_sale: boolean;
  sale_type: SaleType;
  price: number;
  next_owner: number;
  contents: TradeItem[];
  takes_money: boolean;
  pay_prices: number[];
}

export const ObjectTrade = {
  ID: 382 as const,
  NAME: "ObjectTrade" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): ObjectTrade {
    return {
      id: 0,
      root: 0,
      name: "",
      owner: NULL_UUID,
      for_sale: false,
      sale_type: SaleType.Original,
      price: 0,
      next_owner: 0,
      contents: [],
      takes_money: false,
      pay_prices: [],
    };
  },
  encode(w: Writer, v: ObjectTrade): void {
    w.u32(v.id);
    w.u32(v.root);
    w.string(v.name);
    w.uuid(v.owner);
    w.bool(v.for_sale);
    w.u8(v.sale_type);
    w.i32(v.price);
    w.u32(v.next_owner);
    w.u16(v.contents.length);
    for (const item of v.contents) {
      TradeItem.encode(w, item);
    }
    w.bool(v.takes_money);
    w.u16(v.pay_prices.length);
    for (const item of v.pay_prices) {
      w.i32(item);
    }
  },
  decode(r: Reader): ObjectTrade {
    const id = r.remaining > 0 ? r.u32() : 0;
    const root = r.remaining > 0 ? r.u32() : 0;
    const name = r.remaining > 0 ? r.string() : "";
    const owner = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const for_sale = r.remaining > 0 ? r.bool() : false;
    const sale_type = r.remaining > 0 ? r.enumValue(SALE_TYPE_VALUES, r.u8()) as SaleType : SaleType.Original;
    const price = r.remaining > 0 ? r.i32() : 0;
    const next_owner = r.remaining > 0 ? r.u32() : 0;
    const contents: TradeItem[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      contents.push(TradeItem.decode(r));
    }
    const takes_money = r.remaining > 0 ? r.bool() : false;
    const pay_prices: number[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      pay_prices.push(r.i32());
    }
    return { id, root, name, owner, for_sale, sale_type, price, next_owner, contents, takes_money, pay_prices };
  },
};

export interface ObjectPurchase {
  id: number;
  price: number;
  sale_type: SaleType;
}

export const ObjectPurchase = {
  ID: 383 as const,
  NAME: "ObjectPurchase" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectPurchase {
    return {
      id: 0,
      price: 0,
      sale_type: SaleType.Original,
    };
  },
  encode(w: Writer, v: ObjectPurchase): void {
    w.u32(v.id);
    w.i32(v.price);
    w.u8(v.sale_type);
  },
  decode(r: Reader): ObjectPurchase {
    const id = r.remaining > 0 ? r.u32() : 0;
    const price = r.remaining > 0 ? r.i32() : 0;
    const sale_type = r.remaining > 0 ? r.enumValue(SALE_TYPE_VALUES, r.u8()) as SaleType : SaleType.Original;
    return { id, price, sale_type };
  },
};

export interface TaskInventoryCopyAll {
  object: number;
  wear: boolean;
}

export const TaskInventoryCopyAll = {
  ID: 384 as const,
  NAME: "TaskInventoryCopyAll" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): TaskInventoryCopyAll {
    return {
      object: 0,
      wear: false,
    };
  },
  encode(w: Writer, v: TaskInventoryCopyAll): void {
    w.u32(v.object);
    w.bool(v.wear);
  },
  decode(r: Reader): TaskInventoryCopyAll {
    const object = r.remaining > 0 ? r.u32() : 0;
    const wear = r.remaining > 0 ? r.bool() : false;
    return { object, wear };
  },
};

export interface TaskInventoryCopied {
  object: number;
  folder: Uuid;
  copied: number;
  skipped: string[];
  wear: boolean;
}

export const TaskInventoryCopied = {
  ID: 385 as const,
  NAME: "TaskInventoryCopied" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): TaskInventoryCopied {
    return {
      object: 0,
      folder: NULL_UUID,
      copied: 0,
      skipped: [],
      wear: false,
    };
  },
  encode(w: Writer, v: TaskInventoryCopied): void {
    w.u32(v.object);
    w.uuid(v.folder);
    w.u32(v.copied);
    w.u16(v.skipped.length);
    for (const item of v.skipped) {
      w.string(item);
    }
    w.bool(v.wear);
  },
  decode(r: Reader): TaskInventoryCopied {
    const object = r.remaining > 0 ? r.u32() : 0;
    const folder = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const copied = r.remaining > 0 ? r.u32() : 0;
    const skipped: string[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      skipped.push(r.string());
    }
    const wear = r.remaining > 0 ? r.bool() : false;
    return { object, folder, copied, skipped, wear };
  },
};

export interface AgentTeleportAsk {
  to: Uuid;
  message: string;
}

export const AgentTeleportAsk = {
  ID: 386 as const,
  NAME: "AgentTeleportAsk" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): AgentTeleportAsk {
    return {
      to: NULL_UUID,
      message: "",
    };
  },
  encode(w: Writer, v: AgentTeleportAsk): void {
    w.uuid(v.to);
    w.string(v.message);
  },
  decode(r: Reader): AgentTeleportAsk {
    const to = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const message = r.remaining > 0 ? r.string() : "";
    return { to, message };
  },
};

export interface AgentTeleportAsked {
  from: Uuid;
  from_name: string;
  message: string;
}

export const AgentTeleportAsked = {
  ID: 387 as const,
  NAME: "AgentTeleportAsked" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): AgentTeleportAsked {
    return {
      from: NULL_UUID,
      from_name: "",
      message: "",
    };
  },
  encode(w: Writer, v: AgentTeleportAsked): void {
    w.uuid(v.from);
    w.string(v.from_name);
    w.string(v.message);
  },
  decode(r: Reader): AgentTeleportAsked {
    const from = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const from_name = r.remaining > 0 ? r.string() : "";
    const message = r.remaining > 0 ? r.string() : "";
    return { from, from_name, message };
  },
};

export interface ObjectMenuTouch {
  id: number;
  face: number;
  position: Vec3;
  uv: Vec2;
  start: boolean;
}

export const ObjectMenuTouch = {
  ID: 388 as const,
  NAME: "ObjectMenuTouch" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectMenuTouch {
    return {
      id: 0,
      face: 0,
      position: { x: 0, y: 0, z: 0 },
      uv: { x: 0, y: 0 },
      start: false,
    };
  },
  encode(w: Writer, v: ObjectMenuTouch): void {
    w.u32(v.id);
    w.u8(v.face);
    w.vec3(v.position);
    w.vec2(v.uv);
    w.bool(v.start);
  },
  decode(r: Reader): ObjectMenuTouch {
    const id = r.remaining > 0 ? r.u32() : 0;
    const face = r.remaining > 0 ? r.u8() : 0;
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const uv = r.remaining > 0 ? r.vec2() : { x: 0, y: 0 };
    const start = r.remaining > 0 ? r.bool() : false;
    return { id, face, position, uv, start };
  },
};

export interface GroupMemberOptions {
  group: Uuid;
  accept_notices: boolean;
  chat_muted: boolean;
}

export const GroupMemberOptions = {
  ID: 400 as const,
  NAME: "GroupMemberOptions" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): GroupMemberOptions {
    return {
      group: NULL_UUID,
      accept_notices: false,
      chat_muted: false,
    };
  },
  encode(w: Writer, v: GroupMemberOptions): void {
    w.uuid(v.group);
    w.bool(v.accept_notices);
    w.bool(v.chat_muted);
  },
  decode(r: Reader): GroupMemberOptions {
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const accept_notices = r.remaining > 0 ? r.bool() : false;
    const chat_muted = r.remaining > 0 ? r.bool() : false;
    return { group, accept_notices, chat_muted };
  },
};

export interface GroupMemberOptionsList {
  groups: Uuid[];
  accept_notices: boolean[];
  chat_muted: boolean[];
}

export const GroupMemberOptionsList = {
  ID: 401 as const,
  NAME: "GroupMemberOptionsList" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): GroupMemberOptionsList {
    return {
      groups: [],
      accept_notices: [],
      chat_muted: [],
    };
  },
  encode(w: Writer, v: GroupMemberOptionsList): void {
    w.u16(v.groups.length);
    for (const item of v.groups) {
      w.uuid(item);
    }
    w.u16(v.accept_notices.length);
    for (const item of v.accept_notices) {
      w.bool(item);
    }
    w.u16(v.chat_muted.length);
    for (const item of v.chat_muted) {
      w.bool(item);
    }
  },
  decode(r: Reader): GroupMemberOptionsList {
    const groups: Uuid[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      groups.push(r.uuid());
    }
    const accept_notices: boolean[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      accept_notices.push(r.bool());
    }
    const chat_muted: boolean[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      chat_muted.push(r.bool());
    }
    return { groups, accept_notices, chat_muted };
  },
};

export interface GroupChatHistoryRequest {
  group: Uuid;
}

export const GroupChatHistoryRequest = {
  ID: 402 as const,
  NAME: "GroupChatHistoryRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): GroupChatHistoryRequest {
    return {
      group: NULL_UUID,
    };
  },
  encode(w: Writer, v: GroupChatHistoryRequest): void {
    w.uuid(v.group);
  },
  decode(r: Reader): GroupChatHistoryRequest {
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { group };
  },
};

export interface GroupChatHistory {
  group: Uuid;
  lines: GroupChatLine[];
}

export const GroupChatHistory = {
  ID: 403 as const,
  NAME: "GroupChatHistory" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): GroupChatHistory {
    return {
      group: NULL_UUID,
      lines: [],
    };
  },
  encode(w: Writer, v: GroupChatHistory): void {
    w.uuid(v.group);
    w.u16(v.lines.length);
    for (const item of v.lines) {
      GroupChatLine.encode(w, item);
    }
  },
  decode(r: Reader): GroupChatHistory {
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const lines: GroupChatLine[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      lines.push(GroupChatLine.decode(r));
    }
    return { group, lines };
  },
};

export interface GroupNoticeReceive {
  group: Uuid;
  group_name: string;
  notice: Uuid;
  from: Uuid;
  from_name: string;
  subject: string;
  body: string;
  attachment_name: string;
  attachment_kind: AssetKind;
  timestamp: bigint;
}

export const GroupNoticeReceive = {
  ID: 404 as const,
  NAME: "GroupNoticeReceive" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): GroupNoticeReceive {
    return {
      group: NULL_UUID,
      group_name: "",
      notice: NULL_UUID,
      from: NULL_UUID,
      from_name: "",
      subject: "",
      body: "",
      attachment_name: "",
      attachment_kind: AssetKind.Texture,
      timestamp: 0n,
    };
  },
  encode(w: Writer, v: GroupNoticeReceive): void {
    w.uuid(v.group);
    w.string(v.group_name);
    w.uuid(v.notice);
    w.uuid(v.from);
    w.string(v.from_name);
    w.string(v.subject);
    w.string(v.body);
    w.string(v.attachment_name);
    w.u8(v.attachment_kind);
    w.u64(v.timestamp);
  },
  decode(r: Reader): GroupNoticeReceive {
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const group_name = r.remaining > 0 ? r.string() : "";
    const notice = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const from = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const from_name = r.remaining > 0 ? r.string() : "";
    const subject = r.remaining > 0 ? r.string() : "";
    const body = r.remaining > 0 ? r.string() : "";
    const attachment_name = r.remaining > 0 ? r.string() : "";
    const attachment_kind = r.remaining > 0 ? r.enumValue(ASSET_KIND_VALUES, r.u8()) as AssetKind : AssetKind.Texture;
    const timestamp = r.remaining > 0 ? r.u64() : 0n;
    return { group, group_name, notice, from, from_name, subject, body, attachment_name, attachment_kind, timestamp };
  },
};

export interface GroupNoticeAccept {
  group: Uuid;
  notice: Uuid;
}

export const GroupNoticeAccept = {
  ID: 405 as const,
  NAME: "GroupNoticeAccept" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): GroupNoticeAccept {
    return {
      group: NULL_UUID,
      notice: NULL_UUID,
    };
  },
  encode(w: Writer, v: GroupNoticeAccept): void {
    w.uuid(v.group);
    w.uuid(v.notice);
  },
  decode(r: Reader): GroupNoticeAccept {
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const notice = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { group, notice };
  },
};

export interface ConferenceSend {
  session: Uuid;
  members: Uuid[];
  text: string;
  left: boolean;
}

export const ConferenceSend = {
  ID: 406 as const,
  NAME: "ConferenceSend" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ConferenceSend {
    return {
      session: NULL_UUID,
      members: [],
      text: "",
      left: false,
    };
  },
  encode(w: Writer, v: ConferenceSend): void {
    w.uuid(v.session);
    w.u16(v.members.length);
    for (const item of v.members) {
      w.uuid(item);
    }
    w.string(v.text);
    w.bool(v.left);
  },
  decode(r: Reader): ConferenceSend {
    const session = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const members: Uuid[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      members.push(r.uuid());
    }
    const text = r.remaining > 0 ? r.string() : "";
    const left = r.remaining > 0 ? r.bool() : false;
    return { session, members, text, left };
  },
};

export interface ConferenceReceive {
  session: Uuid;
  from: Uuid;
  from_name: string;
  members: Uuid[];
  text: string;
  timestamp: bigint;
  offline: boolean;
  left: boolean;
}

export const ConferenceReceive = {
  ID: 407 as const,
  NAME: "ConferenceReceive" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): ConferenceReceive {
    return {
      session: NULL_UUID,
      from: NULL_UUID,
      from_name: "",
      members: [],
      text: "",
      timestamp: 0n,
      offline: false,
      left: false,
    };
  },
  encode(w: Writer, v: ConferenceReceive): void {
    w.uuid(v.session);
    w.uuid(v.from);
    w.string(v.from_name);
    w.u16(v.members.length);
    for (const item of v.members) {
      w.uuid(item);
    }
    w.string(v.text);
    w.u64(v.timestamp);
    w.bool(v.offline);
    w.bool(v.left);
  },
  decode(r: Reader): ConferenceReceive {
    const session = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const from = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const from_name = r.remaining > 0 ? r.string() : "";
    const members: Uuid[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      members.push(r.uuid());
    }
    const text = r.remaining > 0 ? r.string() : "";
    const timestamp = r.remaining > 0 ? r.u64() : 0n;
    const offline = r.remaining > 0 ? r.bool() : false;
    const left = r.remaining > 0 ? r.bool() : false;
    return { session, from, from_name, members, text, timestamp, offline, left };
  },
};

export interface EstateAccessRequest {
}

export const EstateAccessRequest = {
  ID: 420 as const,
  NAME: "EstateAccessRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): EstateAccessRequest {
    return {
    };
  },
  encode(w: Writer, v: EstateAccessRequest): void {
    void w;
    void v;
  },
  decode(r: Reader): EstateAccessRequest {
    void r;
    return {};
  },
};

export interface EstateAccessList {
  residents: Uuid[];
  groups: Uuid[];
  banned: Uuid[];
}

export const EstateAccessList = {
  ID: 421 as const,
  NAME: "EstateAccessList" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): EstateAccessList {
    return {
      residents: [],
      groups: [],
      banned: [],
    };
  },
  encode(w: Writer, v: EstateAccessList): void {
    w.u16(v.residents.length);
    for (const item of v.residents) {
      w.uuid(item);
    }
    w.u16(v.groups.length);
    for (const item of v.groups) {
      w.uuid(item);
    }
    w.u16(v.banned.length);
    for (const item of v.banned) {
      w.uuid(item);
    }
  },
  decode(r: Reader): EstateAccessList {
    const residents: Uuid[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      residents.push(r.uuid());
    }
    const groups: Uuid[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      groups.push(r.uuid());
    }
    const banned: Uuid[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      banned.push(r.uuid());
    }
    return { residents, groups, banned };
  },
};

export interface EstateAccessChange {
  kind: EstateAccessKind;
  id: Uuid;
  add: boolean;
}

export const EstateAccessChange = {
  ID: 422 as const,
  NAME: "EstateAccessChange" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): EstateAccessChange {
    return {
      kind: EstateAccessKind.Resident,
      id: NULL_UUID,
      add: false,
    };
  },
  encode(w: Writer, v: EstateAccessChange): void {
    w.u8(v.kind);
    w.uuid(v.id);
    w.bool(v.add);
  },
  decode(r: Reader): EstateAccessChange {
    const kind = r.remaining > 0 ? r.enumValue(ESTATE_ACCESS_KIND_VALUES, r.u8()) as EstateAccessKind : EstateAccessKind.Resident;
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const add = r.remaining > 0 ? r.bool() : false;
    return { kind, id, add };
  },
};

export interface ParcelEnvironmentReset {
  parcel: number;
}

export const ParcelEnvironmentReset = {
  ID: 423 as const,
  NAME: "ParcelEnvironmentReset" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ParcelEnvironmentReset {
    return {
      parcel: 0,
    };
  },
  encode(w: Writer, v: ParcelEnvironmentReset): void {
    w.u32(v.parcel);
  },
  decode(r: Reader): ParcelEnvironmentReset {
    const parcel = r.remaining > 0 ? r.u32() : 0;
    return { parcel };
  },
};

export interface OutfitWrite {
  item: Uuid;
  name: string;
  thumbnail: Uuid;
}

export const OutfitWrite = {
  ID: 441 as const,
  NAME: "OutfitWrite" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): OutfitWrite {
    return {
      item: NULL_UUID,
      name: "",
      thumbnail: NULL_UUID,
    };
  },
  encode(w: Writer, v: OutfitWrite): void {
    w.uuid(v.item);
    w.string(v.name);
    w.uuid(v.thumbnail);
  },
  decode(r: Reader): OutfitWrite {
    const item = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const name = r.remaining > 0 ? r.string() : "";
    const thumbnail = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { item, name, thumbnail };
  },
};

export interface AvatarChoose {
  folder: Uuid;
}

export const AvatarChoose = {
  ID: 442 as const,
  NAME: "AvatarChoose" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): AvatarChoose {
    return {
      folder: NULL_UUID,
    };
  },
  encode(w: Writer, v: AvatarChoose): void {
    w.uuid(v.folder);
  },
  decode(r: Reader): AvatarChoose {
    const folder = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { folder };
  },
};

export interface AvatarChosen {
  ok: boolean;
  message: string;
  outfit: Uuid;
  folder: Uuid;
}

export const AvatarChosen = {
  ID: 443 as const,
  NAME: "AvatarChosen" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): AvatarChosen {
    return {
      ok: false,
      message: "",
      outfit: NULL_UUID,
      folder: NULL_UUID,
    };
  },
  encode(w: Writer, v: AvatarChosen): void {
    w.bool(v.ok);
    w.string(v.message);
    w.uuid(v.outfit);
    w.uuid(v.folder);
  },
  decode(r: Reader): AvatarChosen {
    const ok = r.remaining > 0 ? r.bool() : false;
    const message = r.remaining > 0 ? r.string() : "";
    const outfit = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const folder = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { ok, message, outfit, folder };
  },
};

export interface ProfileDetails {
  id: Uuid;
  first_life_about: string;
  first_life_image: Uuid;
  partner_name: string;
  show_in_search: boolean;
  hide_age: boolean;
}

export const ProfileDetails = {
  ID: 444 as const,
  NAME: "ProfileDetails" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): ProfileDetails {
    return {
      id: NULL_UUID,
      first_life_about: "",
      first_life_image: NULL_UUID,
      partner_name: "",
      show_in_search: false,
      hide_age: false,
    };
  },
  encode(w: Writer, v: ProfileDetails): void {
    w.uuid(v.id);
    w.string(v.first_life_about);
    w.uuid(v.first_life_image);
    w.string(v.partner_name);
    w.bool(v.show_in_search);
    w.bool(v.hide_age);
  },
  decode(r: Reader): ProfileDetails {
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const first_life_about = r.remaining > 0 ? r.string() : "";
    const first_life_image = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const partner_name = r.remaining > 0 ? r.string() : "";
    const show_in_search = r.remaining > 0 ? r.bool() : false;
    const hide_age = r.remaining > 0 ? r.bool() : false;
    return { id, first_life_about, first_life_image, partner_name, show_in_search, hide_age };
  },
};

export interface ProfileDetailsUpdate {
  first_life_about: string;
  first_life_image: Uuid;
  show_in_search: boolean;
  hide_age: boolean;
}

export const ProfileDetailsUpdate = {
  ID: 445 as const,
  NAME: "ProfileDetailsUpdate" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ProfileDetailsUpdate {
    return {
      first_life_about: "",
      first_life_image: NULL_UUID,
      show_in_search: false,
      hide_age: false,
    };
  },
  encode(w: Writer, v: ProfileDetailsUpdate): void {
    w.string(v.first_life_about);
    w.uuid(v.first_life_image);
    w.bool(v.show_in_search);
    w.bool(v.hide_age);
  },
  decode(r: Reader): ProfileDetailsUpdate {
    const first_life_about = r.remaining > 0 ? r.string() : "";
    const first_life_image = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const show_in_search = r.remaining > 0 ? r.bool() : false;
    const hide_age = r.remaining > 0 ? r.bool() : false;
    return { first_life_about, first_life_image, show_in_search, hide_age };
  },
};

export interface AccountInfoRequest {
}

export const AccountInfoRequest = {
  ID: 446 as const,
  NAME: "AccountInfoRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): AccountInfoRequest {
    return {
    };
  },
  encode(w: Writer, v: AccountInfoRequest): void {
    void w;
    void v;
  },
  decode(r: Reader): AccountInfoRequest {
    void r;
    return {};
  },
};

export interface AccountInfo {
  username: string;
  email: string;
  born: bigint;
  last_login: bigint;
}

export const AccountInfo = {
  ID: 447 as const,
  NAME: "AccountInfo" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): AccountInfo {
    return {
      username: "",
      email: "",
      born: 0n,
      last_login: 0n,
    };
  },
  encode(w: Writer, v: AccountInfo): void {
    w.string(v.username);
    w.string(v.email);
    w.u64(v.born);
    w.u64(v.last_login);
  },
  decode(r: Reader): AccountInfo {
    const username = r.remaining > 0 ? r.string() : "";
    const email = r.remaining > 0 ? r.string() : "";
    const born = r.remaining > 0 ? r.u64() : 0n;
    const last_login = r.remaining > 0 ? r.u64() : 0n;
    return { username, email, born, last_login };
  },
};

export interface AccountPasswordChange {
  current: string;
  password: string;
}

export const AccountPasswordChange = {
  ID: 448 as const,
  NAME: "AccountPasswordChange" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): AccountPasswordChange {
    return {
      current: "",
      password: "",
    };
  },
  encode(w: Writer, v: AccountPasswordChange): void {
    w.string(v.current);
    w.string(v.password);
  },
  decode(r: Reader): AccountPasswordChange {
    const current = r.remaining > 0 ? r.string() : "";
    const password = r.remaining > 0 ? r.string() : "";
    return { current, password };
  },
};

export interface AccountEmailChange {
  password: string;
  email: string;
}

export const AccountEmailChange = {
  ID: 449 as const,
  NAME: "AccountEmailChange" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): AccountEmailChange {
    return {
      password: "",
      email: "",
    };
  },
  encode(w: Writer, v: AccountEmailChange): void {
    w.string(v.password);
    w.string(v.email);
  },
  decode(r: Reader): AccountEmailChange {
    const password = r.remaining > 0 ? r.string() : "";
    const email = r.remaining > 0 ? r.string() : "";
    return { password, email };
  },
};

export interface AccountChangeResult {
  ok: boolean;
  message: string;
}

export const AccountChangeResult = {
  ID: 450 as const,
  NAME: "AccountChangeResult" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): AccountChangeResult {
    return {
      ok: false,
      message: "",
    };
  },
  encode(w: Writer, v: AccountChangeResult): void {
    w.bool(v.ok);
    w.string(v.message);
  },
  decode(r: Reader): AccountChangeResult {
    const ok = r.remaining > 0 ? r.bool() : false;
    const message = r.remaining > 0 ? r.string() : "";
    return { ok, message };
  },
};

export interface ObjectWear {
  id: number;
  point: AttachPoint;
}

export const ObjectWear = {
  ID: 451 as const,
  NAME: "ObjectWear" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectWear {
    return {
      id: 0,
      point: AttachPoint.None,
    };
  },
  encode(w: Writer, v: ObjectWear): void {
    w.u32(v.id);
    w.u8(v.point);
  },
  decode(r: Reader): ObjectWear {
    const id = r.remaining > 0 ? r.u32() : 0;
    const point = r.remaining > 0 ? r.enumValue(ATTACH_POINT_VALUES, r.u8()) as AttachPoint : AttachPoint.None;
    return { id, point };
  },
};

export interface UploadPriceRequest {
  kind: AssetKind;
}

export const UploadPriceRequest = {
  ID: 460 as const,
  NAME: "UploadPriceRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): UploadPriceRequest {
    return {
      kind: AssetKind.Texture,
    };
  },
  encode(w: Writer, v: UploadPriceRequest): void {
    w.u8(v.kind);
  },
  decode(r: Reader): UploadPriceRequest {
    const kind = r.remaining > 0 ? r.enumValue(ASSET_KIND_VALUES, r.u8()) as AssetKind : AssetKind.Texture;
    return { kind };
  },
};

export interface UploadPrice {
  kind: AssetKind;
  cost: number;
  max_size: number;
}

export const UploadPrice = {
  ID: 461 as const,
  NAME: "UploadPrice" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): UploadPrice {
    return {
      kind: AssetKind.Texture,
      cost: 0,
      max_size: 0,
    };
  },
  encode(w: Writer, v: UploadPrice): void {
    w.u8(v.kind);
    w.i32(v.cost);
    w.u32(v.max_size);
  },
  decode(r: Reader): UploadPrice {
    const kind = r.remaining > 0 ? r.enumValue(ASSET_KIND_VALUES, r.u8()) as AssetKind : AssetKind.Texture;
    const cost = r.remaining > 0 ? r.i32() : 0;
    const max_size = r.remaining > 0 ? r.u32() : 0;
    return { kind, cost, max_size };
  },
};

export interface ObjectReturn {
  ids: number[];
}

export const ObjectReturn = {
  ID: 462 as const,
  NAME: "ObjectReturn" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectReturn {
    return {
      ids: [],
    };
  },
  encode(w: Writer, v: ObjectReturn): void {
    w.u16(v.ids.length);
    for (const item of v.ids) {
      w.u32(item);
    }
  },
  decode(r: Reader): ObjectReturn {
    const ids: number[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      ids.push(r.u32());
    }
    return { ids };
  },
};

export interface ObjectRestore {
  objects: Uuid[];
}

export const ObjectRestore = {
  ID: 463 as const,
  NAME: "ObjectRestore" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ObjectRestore {
    return {
      objects: [],
    };
  },
  encode(w: Writer, v: ObjectRestore): void {
    w.u16(v.objects.length);
    for (const item of v.objects) {
      w.uuid(item);
    }
  },
  decode(r: Reader): ObjectRestore {
    const objects: Uuid[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      objects.push(r.uuid());
    }
    return { objects };
  },
};

export interface ParcelObjectsRequest {
  parcel: number;
  owner: Uuid;
}

export const ParcelObjectsRequest = {
  ID: 464 as const,
  NAME: "ParcelObjectsRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ParcelObjectsRequest {
    return {
      parcel: 0,
      owner: NULL_UUID,
    };
  },
  encode(w: Writer, v: ParcelObjectsRequest): void {
    w.u32(v.parcel);
    w.uuid(v.owner);
  },
  decode(r: Reader): ParcelObjectsRequest {
    const parcel = r.remaining > 0 ? r.u32() : 0;
    const owner = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { parcel, owner };
  },
};

export interface ParcelObjects {
  parcel: number;
  owner: Uuid;
  objects: ParcelObjectEntry[];
}

export const ParcelObjects = {
  ID: 465 as const,
  NAME: "ParcelObjects" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): ParcelObjects {
    return {
      parcel: 0,
      owner: NULL_UUID,
      objects: [],
    };
  },
  encode(w: Writer, v: ParcelObjects): void {
    w.u32(v.parcel);
    w.uuid(v.owner);
    w.u16(v.objects.length);
    for (const item of v.objects) {
      ParcelObjectEntry.encode(w, item);
    }
  },
  decode(r: Reader): ParcelObjects {
    const parcel = r.remaining > 0 ? r.u32() : 0;
    const owner = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const objects: ParcelObjectEntry[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      objects.push(ParcelObjectEntry.decode(r));
    }
    return { parcel, owner, objects };
  },
};

export interface MapDestination {
  region: string;
  position: Vec3;
  look_at: Vec3;
  object: number;
}

export const MapDestination = {
  ID: 466 as const,
  NAME: "MapDestination" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): MapDestination {
    return {
      region: "",
      position: { x: 0, y: 0, z: 0 },
      look_at: { x: 0, y: 0, z: 0 },
      object: 0,
    };
  },
  encode(w: Writer, v: MapDestination): void {
    w.string(v.region);
    w.vec3(v.position);
    w.vec3(v.look_at);
    w.u32(v.object);
  },
  decode(r: Reader): MapDestination {
    const region = r.remaining > 0 ? r.string() : "";
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const look_at = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const object = r.remaining > 0 ? r.u32() : 0;
    return { region, position, look_at, object };
  },
};

export interface SoundAdjust {
  object: number;
  gain: number;
}

export const SoundAdjust = {
  ID: 467 as const,
  NAME: "SoundAdjust" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): SoundAdjust {
    return {
      object: 0,
      gain: 0,
    };
  },
  encode(w: Writer, v: SoundAdjust): void {
    w.u32(v.object);
    w.f32(v.gain);
  },
  decode(r: Reader): SoundAdjust {
    const object = r.remaining > 0 ? r.u32() : 0;
    const gain = r.remaining > 0 ? r.f32() : 0;
    return { object, gain };
  },
};

export interface SoundQueue {
  sound: Uuid;
  object: number;
  owner: Uuid;
  position: Vec3;
  gain: number;
  attached: boolean;
  radius: number;
}

export const SoundQueue = {
  ID: 468 as const,
  NAME: "SoundQueue" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): SoundQueue {
    return {
      sound: NULL_UUID,
      object: 0,
      owner: NULL_UUID,
      position: { x: 0, y: 0, z: 0 },
      gain: 0,
      attached: false,
      radius: 0,
    };
  },
  encode(w: Writer, v: SoundQueue): void {
    w.uuid(v.sound);
    w.u32(v.object);
    w.uuid(v.owner);
    w.vec3(v.position);
    w.f32(v.gain);
    w.bool(v.attached);
    w.f32(v.radius);
  },
  decode(r: Reader): SoundQueue {
    const sound = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const object = r.remaining > 0 ? r.u32() : 0;
    const owner = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const gain = r.remaining > 0 ? r.f32() : 0;
    const attached = r.remaining > 0 ? r.bool() : false;
    const radius = r.remaining > 0 ? r.f32() : 0;
    return { sound, object, owner, position, gain, attached, radius };
  },
};

export interface AvatarRenderReport {
  complexity: number;
  simplified: Uuid[];
}

export const AvatarRenderReport = {
  ID: 480 as const,
  NAME: "AvatarRenderReport" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): AvatarRenderReport {
    return {
      complexity: 0,
      simplified: [],
    };
  },
  encode(w: Writer, v: AvatarRenderReport): void {
    w.u32(v.complexity);
    w.u16(v.simplified.length);
    for (const item of v.simplified) {
      w.uuid(item);
    }
  },
  decode(r: Reader): AvatarRenderReport {
    const complexity = r.remaining > 0 ? r.u32() : 0;
    const simplified: Uuid[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      simplified.push(r.uuid());
    }
    return { complexity, simplified };
  },
};

export interface AvatarRenderNotice {
  complexity: number;
  reporting: number;
  simplified_by: number;
}

export const AvatarRenderNotice = {
  ID: 481 as const,
  NAME: "AvatarRenderNotice" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): AvatarRenderNotice {
    return {
      complexity: 0,
      reporting: 0,
      simplified_by: 0,
    };
  },
  encode(w: Writer, v: AvatarRenderNotice): void {
    w.u32(v.complexity);
    w.u16(v.reporting);
    w.u16(v.simplified_by);
  },
  decode(r: Reader): AvatarRenderNotice {
    const complexity = r.remaining > 0 ? r.u32() : 0;
    const reporting = r.remaining > 0 ? r.u16() : 0;
    const simplified_by = r.remaining > 0 ? r.u16() : 0;
    return { complexity, reporting, simplified_by };
  },
};

export interface AccountPreferencesRequest {
}

export const AccountPreferencesRequest = {
  ID: 482 as const,
  NAME: "AccountPreferencesRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): AccountPreferencesRequest {
    return {
    };
  },
  encode(w: Writer, v: AccountPreferencesRequest): void {
    void w;
    void v;
  },
  decode(r: Reader): AccountPreferencesRequest {
    void r;
    return {};
  },
};

export interface AccountPreferencesSet {
  preferences: AccountPreferences;
}

export const AccountPreferencesSet = {
  ID: 483 as const,
  NAME: "AccountPreferencesSet" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): AccountPreferencesSet {
    return {
      preferences: AccountPreferences.create(),
    };
  },
  encode(w: Writer, v: AccountPreferencesSet): void {
    AccountPreferences.encode(w, v.preferences);
  },
  decode(r: Reader): AccountPreferencesSet {
    const preferences = r.remaining > 0 ? AccountPreferences.decode(r) : AccountPreferences.create();
    return { preferences };
  },
};

export interface AccountPreferencesReply {
  preferences: AccountPreferences;
  message: string;
}

export const AccountPreferencesReply = {
  ID: 484 as const,
  NAME: "AccountPreferencesReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): AccountPreferencesReply {
    return {
      preferences: AccountPreferences.create(),
      message: "",
    };
  },
  encode(w: Writer, v: AccountPreferencesReply): void {
    AccountPreferences.encode(w, v.preferences);
    w.string(v.message);
  },
  decode(r: Reader): AccountPreferencesReply {
    const preferences = r.remaining > 0 ? AccountPreferences.decode(r) : AccountPreferences.create();
    const message = r.remaining > 0 ? r.string() : "";
    return { preferences, message };
  },
};

export interface VoiceCallStart {
  call: Uuid;
  kind: VoiceCallKind;
  target: Uuid;
  members: Uuid[];
}

export const VoiceCallStart = {
  ID: 500 as const,
  NAME: "VoiceCallStart" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): VoiceCallStart {
    return {
      call: NULL_UUID,
      kind: VoiceCallKind.Direct,
      target: NULL_UUID,
      members: [],
    };
  },
  encode(w: Writer, v: VoiceCallStart): void {
    w.uuid(v.call);
    w.u8(v.kind);
    w.uuid(v.target);
    w.u16(v.members.length);
    for (const item of v.members) {
      w.uuid(item);
    }
  },
  decode(r: Reader): VoiceCallStart {
    const call = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const kind = r.remaining > 0 ? r.enumValue(VOICE_CALL_KIND_VALUES, r.u8()) as VoiceCallKind : VoiceCallKind.Direct;
    const target = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const members: Uuid[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      members.push(r.uuid());
    }
    return { call, kind, target, members };
  },
};

export interface VoiceCallInvite {
  call: Uuid;
  kind: VoiceCallKind;
  from: Uuid;
  from_name: string;
  title: string;
  members: Uuid[];
}

export const VoiceCallInvite = {
  ID: 501 as const,
  NAME: "VoiceCallInvite" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): VoiceCallInvite {
    return {
      call: NULL_UUID,
      kind: VoiceCallKind.Direct,
      from: NULL_UUID,
      from_name: "",
      title: "",
      members: [],
    };
  },
  encode(w: Writer, v: VoiceCallInvite): void {
    w.uuid(v.call);
    w.u8(v.kind);
    w.uuid(v.from);
    w.string(v.from_name);
    w.string(v.title);
    w.u16(v.members.length);
    for (const item of v.members) {
      w.uuid(item);
    }
  },
  decode(r: Reader): VoiceCallInvite {
    const call = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const kind = r.remaining > 0 ? r.enumValue(VOICE_CALL_KIND_VALUES, r.u8()) as VoiceCallKind : VoiceCallKind.Direct;
    const from = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const from_name = r.remaining > 0 ? r.string() : "";
    const title = r.remaining > 0 ? r.string() : "";
    const members: Uuid[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      members.push(r.uuid());
    }
    return { call, kind, from, from_name, title, members };
  },
};

export interface VoiceCallJoin {
  call: Uuid;
  kind: VoiceCallKind;
  offer: string;
}

export const VoiceCallJoin = {
  ID: 502 as const,
  NAME: "VoiceCallJoin" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): VoiceCallJoin {
    return {
      call: NULL_UUID,
      kind: VoiceCallKind.Direct,
      offer: "",
    };
  },
  encode(w: Writer, v: VoiceCallJoin): void {
    w.uuid(v.call);
    w.u8(v.kind);
    w.string(v.offer);
  },
  decode(r: Reader): VoiceCallJoin {
    const call = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const kind = r.remaining > 0 ? r.enumValue(VOICE_CALL_KIND_VALUES, r.u8()) as VoiceCallKind : VoiceCallKind.Direct;
    const offer = r.remaining > 0 ? r.string() : "";
    return { call, kind, offer };
  },
};

export interface VoiceCallAnswer {
  call: Uuid;
  kind: VoiceCallKind;
  answer: string;
  error: string;
}

export const VoiceCallAnswer = {
  ID: 503 as const,
  NAME: "VoiceCallAnswer" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): VoiceCallAnswer {
    return {
      call: NULL_UUID,
      kind: VoiceCallKind.Direct,
      answer: "",
      error: "",
    };
  },
  encode(w: Writer, v: VoiceCallAnswer): void {
    w.uuid(v.call);
    w.u8(v.kind);
    w.string(v.answer);
    w.string(v.error);
  },
  decode(r: Reader): VoiceCallAnswer {
    const call = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const kind = r.remaining > 0 ? r.enumValue(VOICE_CALL_KIND_VALUES, r.u8()) as VoiceCallKind : VoiceCallKind.Direct;
    const answer = r.remaining > 0 ? r.string() : "";
    const error = r.remaining > 0 ? r.string() : "";
    return { call, kind, answer, error };
  },
};

export interface VoiceCallLeave {
  call: Uuid;
  kind: VoiceCallKind;
  declined: boolean;
}

export const VoiceCallLeave = {
  ID: 504 as const,
  NAME: "VoiceCallLeave" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): VoiceCallLeave {
    return {
      call: NULL_UUID,
      kind: VoiceCallKind.Direct,
      declined: false,
    };
  },
  encode(w: Writer, v: VoiceCallLeave): void {
    w.uuid(v.call);
    w.u8(v.kind);
    w.bool(v.declined);
  },
  decode(r: Reader): VoiceCallLeave {
    const call = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const kind = r.remaining > 0 ? r.enumValue(VOICE_CALL_KIND_VALUES, r.u8()) as VoiceCallKind : VoiceCallKind.Direct;
    const declined = r.remaining > 0 ? r.bool() : false;
    return { call, kind, declined };
  },
};

export interface VoiceCallEnded {
  call: Uuid;
  kind: VoiceCallKind;
  reason: string;
}

export const VoiceCallEnded = {
  ID: 505 as const,
  NAME: "VoiceCallEnded" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): VoiceCallEnded {
    return {
      call: NULL_UUID,
      kind: VoiceCallKind.Direct,
      reason: "",
    };
  },
  encode(w: Writer, v: VoiceCallEnded): void {
    w.uuid(v.call);
    w.u8(v.kind);
    w.string(v.reason);
  },
  decode(r: Reader): VoiceCallEnded {
    const call = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const kind = r.remaining > 0 ? r.enumValue(VOICE_CALL_KIND_VALUES, r.u8()) as VoiceCallKind : VoiceCallKind.Direct;
    const reason = r.remaining > 0 ? r.string() : "";
    return { call, kind, reason };
  },
};

export interface VoiceCallMembers {
  call: Uuid;
  members: VoiceCallMember[];
}

export const VoiceCallMembers = {
  ID: 506 as const,
  NAME: "VoiceCallMembers" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): VoiceCallMembers {
    return {
      call: NULL_UUID,
      members: [],
    };
  },
  encode(w: Writer, v: VoiceCallMembers): void {
    w.uuid(v.call);
    w.u16(v.members.length);
    for (const item of v.members) {
      VoiceCallMember.encode(w, item);
    }
  },
  decode(r: Reader): VoiceCallMembers {
    const call = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const members: VoiceCallMember[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      members.push(VoiceCallMember.decode(r));
    }
    return { call, members };
  },
};

export interface InstantMessageStored {
  to: Uuid;
}

export const InstantMessageStored = {
  ID: 507 as const,
  NAME: "InstantMessageStored" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): InstantMessageStored {
    return {
      to: NULL_UUID,
    };
  },
  encode(w: Writer, v: InstantMessageStored): void {
    w.uuid(v.to);
  },
  decode(r: Reader): InstantMessageStored {
    const to = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { to };
  },
};

export interface ObjectInstantMessage {
  object: Uuid;
  object_name: string;
  owner: Uuid;
  region_name: string;
  position: Vec3;
  text: string;
  timestamp: bigint;
  offline: boolean;
}

export const ObjectInstantMessage = {
  ID: 508 as const,
  NAME: "ObjectInstantMessage" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): ObjectInstantMessage {
    return {
      object: NULL_UUID,
      object_name: "",
      owner: NULL_UUID,
      region_name: "",
      position: { x: 0, y: 0, z: 0 },
      text: "",
      timestamp: 0n,
      offline: false,
    };
  },
  encode(w: Writer, v: ObjectInstantMessage): void {
    w.uuid(v.object);
    w.string(v.object_name);
    w.uuid(v.owner);
    w.string(v.region_name);
    w.vec3(v.position);
    w.string(v.text);
    w.u64(v.timestamp);
    w.bool(v.offline);
  },
  decode(r: Reader): ObjectInstantMessage {
    const object = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const object_name = r.remaining > 0 ? r.string() : "";
    const owner = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const region_name = r.remaining > 0 ? r.string() : "";
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const text = r.remaining > 0 ? r.string() : "";
    const timestamp = r.remaining > 0 ? r.u64() : 0n;
    const offline = r.remaining > 0 ? r.bool() : false;
    return { object, object_name, owner, region_name, position, text, timestamp, offline };
  },
};

export interface GroupMembersPageRequest {
  group: Uuid;
  offset: number;
  filter: string;
  role: Uuid;
  online_first: boolean;
}

export const GroupMembersPageRequest = {
  ID: 509 as const,
  NAME: "GroupMembersPageRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): GroupMembersPageRequest {
    return {
      group: NULL_UUID,
      offset: 0,
      filter: "",
      role: NULL_UUID,
      online_first: false,
    };
  },
  encode(w: Writer, v: GroupMembersPageRequest): void {
    w.uuid(v.group);
    w.u32(v.offset);
    w.string(v.filter);
    w.uuid(v.role);
    w.bool(v.online_first);
  },
  decode(r: Reader): GroupMembersPageRequest {
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const offset = r.remaining > 0 ? r.u32() : 0;
    const filter = r.remaining > 0 ? r.string() : "";
    const role = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const online_first = r.remaining > 0 ? r.bool() : false;
    return { group, offset, filter, role, online_first };
  },
};

export interface GroupMembersPage {
  group: Uuid;
  offset: number;
  total: number;
  filter: string;
  role: Uuid;
  online_first: boolean;
  members: GroupMember[];
}

export const GroupMembersPage = {
  ID: 510 as const,
  NAME: "GroupMembersPage" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): GroupMembersPage {
    return {
      group: NULL_UUID,
      offset: 0,
      total: 0,
      filter: "",
      role: NULL_UUID,
      online_first: false,
      members: [],
    };
  },
  encode(w: Writer, v: GroupMembersPage): void {
    w.uuid(v.group);
    w.u32(v.offset);
    w.u32(v.total);
    w.string(v.filter);
    w.uuid(v.role);
    w.bool(v.online_first);
    w.u16(v.members.length);
    for (const item of v.members) {
      GroupMember.encode(w, item);
    }
  },
  decode(r: Reader): GroupMembersPage {
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const offset = r.remaining > 0 ? r.u32() : 0;
    const total = r.remaining > 0 ? r.u32() : 0;
    const filter = r.remaining > 0 ? r.string() : "";
    const role = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const online_first = r.remaining > 0 ? r.bool() : false;
    const members: GroupMember[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      members.push(GroupMember.decode(r));
    }
    return { group, offset, total, filter, role, online_first, members };
  },
};

export interface GroupLandRequest {
  group: Uuid;
}

export const GroupLandRequest = {
  ID: 511 as const,
  NAME: "GroupLandRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): GroupLandRequest {
    return {
      group: NULL_UUID,
    };
  },
  encode(w: Writer, v: GroupLandRequest): void {
    w.uuid(v.group);
  },
  decode(r: Reader): GroupLandRequest {
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { group };
  },
};

export interface GroupLand {
  group: Uuid;
  parcels: GroupParcel[];
  held: number;
  contributed: number;
  yours: number;
  available: number;
}

export const GroupLand = {
  ID: 512 as const,
  NAME: "GroupLand" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): GroupLand {
    return {
      group: NULL_UUID,
      parcels: [],
      held: 0,
      contributed: 0,
      yours: 0,
      available: 0,
    };
  },
  encode(w: Writer, v: GroupLand): void {
    w.uuid(v.group);
    w.u16(v.parcels.length);
    for (const item of v.parcels) {
      GroupParcel.encode(w, item);
    }
    w.u32(v.held);
    w.u32(v.contributed);
    w.u32(v.yours);
    w.u32(v.available);
  },
  decode(r: Reader): GroupLand {
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const parcels: GroupParcel[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      parcels.push(GroupParcel.decode(r));
    }
    const held = r.remaining > 0 ? r.u32() : 0;
    const contributed = r.remaining > 0 ? r.u32() : 0;
    const yours = r.remaining > 0 ? r.u32() : 0;
    const available = r.remaining > 0 ? r.u32() : 0;
    return { group, parcels, held, contributed, yours, available };
  },
};

export interface GroupContributionSet {
  group: Uuid;
  area: number;
}

export const GroupContributionSet = {
  ID: 513 as const,
  NAME: "GroupContributionSet" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): GroupContributionSet {
    return {
      group: NULL_UUID,
      area: 0,
    };
  },
  encode(w: Writer, v: GroupContributionSet): void {
    w.uuid(v.group);
    w.u32(v.area);
  },
  decode(r: Reader): GroupContributionSet {
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const area = r.remaining > 0 ? r.u32() : 0;
    return { group, area };
  },
};

export interface GroupProfileChoice {
  group: Uuid;
  listed: boolean;
}

export const GroupProfileChoice = {
  ID: 514 as const,
  NAME: "GroupProfileChoice" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): GroupProfileChoice {
    return {
      group: NULL_UUID,
      listed: false,
    };
  },
  encode(w: Writer, v: GroupProfileChoice): void {
    w.uuid(v.group);
    w.bool(v.listed);
  },
  decode(r: Reader): GroupProfileChoice {
    const group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const listed = r.remaining > 0 ? r.bool() : false;
    return { group, listed };
  },
};

export interface GroupProfileChoices {
  groups: Uuid[];
  listed: boolean[];
}

export const GroupProfileChoices = {
  ID: 515 as const,
  NAME: "GroupProfileChoices" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): GroupProfileChoices {
    return {
      groups: [],
      listed: [],
    };
  },
  encode(w: Writer, v: GroupProfileChoices): void {
    w.u16(v.groups.length);
    for (const item of v.groups) {
      w.uuid(item);
    }
    w.u16(v.listed.length);
    for (const item of v.listed) {
      w.bool(item);
    }
  },
  decode(r: Reader): GroupProfileChoices {
    const groups: Uuid[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      groups.push(r.uuid());
    }
    const listed: boolean[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      listed.push(r.bool());
    }
    return { groups, listed };
  },
};

export interface TalkChoices {
  typing_animation: boolean;
  calls_from_friends_only: boolean;
  refuse_group_calls: boolean;
}

export const TalkChoices = {
  ID: 516 as const,
  NAME: "TalkChoices" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): TalkChoices {
    return {
      typing_animation: false,
      calls_from_friends_only: false,
      refuse_group_calls: false,
    };
  },
  encode(w: Writer, v: TalkChoices): void {
    w.bool(v.typing_animation);
    w.bool(v.calls_from_friends_only);
    w.bool(v.refuse_group_calls);
  },
  decode(r: Reader): TalkChoices {
    const typing_animation = r.remaining > 0 ? r.bool() : false;
    const calls_from_friends_only = r.remaining > 0 ? r.bool() : false;
    const refuse_group_calls = r.remaining > 0 ? r.bool() : false;
    return { typing_animation, calls_from_friends_only, refuse_group_calls };
  },
};

export interface EnvironmentDaySet {
  parcel: number;
  name: string;
  frames: EnvironmentFrame[];
  day_length_seconds: number;
  day_offset_seconds: number;
}

export const EnvironmentDaySet = {
  ID: 520 as const,
  NAME: "EnvironmentDaySet" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): EnvironmentDaySet {
    return {
      parcel: 0,
      name: "",
      frames: [],
      day_length_seconds: 0,
      day_offset_seconds: 0,
    };
  },
  encode(w: Writer, v: EnvironmentDaySet): void {
    w.u32(v.parcel);
    w.string(v.name);
    w.u16(v.frames.length);
    for (const item of v.frames) {
      EnvironmentFrame.encode(w, item);
    }
    w.u32(v.day_length_seconds);
    w.u32(v.day_offset_seconds);
  },
  decode(r: Reader): EnvironmentDaySet {
    const parcel = r.remaining > 0 ? r.u32() : 0;
    const name = r.remaining > 0 ? r.string() : "";
    const frames: EnvironmentFrame[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      frames.push(EnvironmentFrame.decode(r));
    }
    const day_length_seconds = r.remaining > 0 ? r.u32() : 0;
    const day_offset_seconds = r.remaining > 0 ? r.u32() : 0;
    return { parcel, name, frames, day_length_seconds, day_offset_seconds };
  },
};

export interface EnvironmentInfoRequest {
  parcel: number;
}

export const EnvironmentInfoRequest = {
  ID: 521 as const,
  NAME: "EnvironmentInfoRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): EnvironmentInfoRequest {
    return {
      parcel: 0,
    };
  },
  encode(w: Writer, v: EnvironmentInfoRequest): void {
    w.u32(v.parcel);
  },
  decode(r: Reader): EnvironmentInfoRequest {
    const parcel = r.remaining > 0 ? r.u32() : 0;
    return { parcel };
  },
};

export interface EnvironmentInfo {
  parcel: number;
  own: boolean;
  name: string;
  frames: EnvironmentFrame[];
  day_length_seconds: number;
  day_offset_seconds: number;
  parcels_may_override: boolean;
  may_change: boolean;
}

export const EnvironmentInfo = {
  ID: 522 as const,
  NAME: "EnvironmentInfo" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): EnvironmentInfo {
    return {
      parcel: 0,
      own: false,
      name: "",
      frames: [],
      day_length_seconds: 0,
      day_offset_seconds: 0,
      parcels_may_override: false,
      may_change: false,
    };
  },
  encode(w: Writer, v: EnvironmentInfo): void {
    w.u32(v.parcel);
    w.bool(v.own);
    w.string(v.name);
    w.u16(v.frames.length);
    for (const item of v.frames) {
      EnvironmentFrame.encode(w, item);
    }
    w.u32(v.day_length_seconds);
    w.u32(v.day_offset_seconds);
    w.bool(v.parcels_may_override);
    w.bool(v.may_change);
  },
  decode(r: Reader): EnvironmentInfo {
    const parcel = r.remaining > 0 ? r.u32() : 0;
    const own = r.remaining > 0 ? r.bool() : false;
    const name = r.remaining > 0 ? r.string() : "";
    const frames: EnvironmentFrame[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      frames.push(EnvironmentFrame.decode(r));
    }
    const day_length_seconds = r.remaining > 0 ? r.u32() : 0;
    const day_offset_seconds = r.remaining > 0 ? r.u32() : 0;
    const parcels_may_override = r.remaining > 0 ? r.bool() : false;
    const may_change = r.remaining > 0 ? r.bool() : false;
    return { parcel, own, name, frames, day_length_seconds, day_offset_seconds, parcels_may_override, may_change };
  },
};

export interface ParcelExtrasSet {
  parcel: number;
  auto_return_minutes: number;
  sell_to: Uuid;
}

export const ParcelExtrasSet = {
  ID: 523 as const,
  NAME: "ParcelExtrasSet" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ParcelExtrasSet {
    return {
      parcel: 0,
      auto_return_minutes: 0,
      sell_to: NULL_UUID,
    };
  },
  encode(w: Writer, v: ParcelExtrasSet): void {
    w.u32(v.parcel);
    w.u32(v.auto_return_minutes);
    w.uuid(v.sell_to);
  },
  decode(r: Reader): ParcelExtrasSet {
    const parcel = r.remaining > 0 ? r.u32() : 0;
    const auto_return_minutes = r.remaining > 0 ? r.u32() : 0;
    const sell_to = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { parcel, auto_return_minutes, sell_to };
  },
};

export interface ParcelExtras {
  parcel: number;
  auto_return_minutes: number;
  sell_to: Uuid;
  owner_objects: number;
  group_objects: number;
  other_objects: number;
}

export const ParcelExtras = {
  ID: 524 as const,
  NAME: "ParcelExtras" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): ParcelExtras {
    return {
      parcel: 0,
      auto_return_minutes: 0,
      sell_to: NULL_UUID,
      owner_objects: 0,
      group_objects: 0,
      other_objects: 0,
    };
  },
  encode(w: Writer, v: ParcelExtras): void {
    w.u32(v.parcel);
    w.u32(v.auto_return_minutes);
    w.uuid(v.sell_to);
    w.u32(v.owner_objects);
    w.u32(v.group_objects);
    w.u32(v.other_objects);
  },
  decode(r: Reader): ParcelExtras {
    const parcel = r.remaining > 0 ? r.u32() : 0;
    const auto_return_minutes = r.remaining > 0 ? r.u32() : 0;
    const sell_to = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const owner_objects = r.remaining > 0 ? r.u32() : 0;
    const group_objects = r.remaining > 0 ? r.u32() : 0;
    const other_objects = r.remaining > 0 ? r.u32() : 0;
    return { parcel, auto_return_minutes, sell_to, owner_objects, group_objects, other_objects };
  },
};

export interface LandSearchRequest {
  query: string;
  max_price: number;
  min_area: number;
  sort: LandSort;
  auctions: boolean;
  offset: number;
}

export const LandSearchRequest = {
  ID: 525 as const,
  NAME: "LandSearchRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): LandSearchRequest {
    return {
      query: "",
      max_price: 0,
      min_area: 0,
      sort: LandSort.Cheapest,
      auctions: false,
      offset: 0,
    };
  },
  encode(w: Writer, v: LandSearchRequest): void {
    w.string(v.query);
    w.u32(v.max_price);
    w.u32(v.min_area);
    w.u8(v.sort);
    w.bool(v.auctions);
    w.u32(v.offset);
  },
  decode(r: Reader): LandSearchRequest {
    const query = r.remaining > 0 ? r.string() : "";
    const max_price = r.remaining > 0 ? r.u32() : 0;
    const min_area = r.remaining > 0 ? r.u32() : 0;
    const sort = r.remaining > 0 ? r.enumValue(LAND_SORT_VALUES, r.u8()) as LandSort : LandSort.Cheapest;
    const auctions = r.remaining > 0 ? r.bool() : false;
    const offset = r.remaining > 0 ? r.u32() : 0;
    return { query, max_price, min_area, sort, auctions, offset };
  },
};

export interface LandSearchReply {
  query: string;
  offset: number;
  results: LandListing[];
  more: boolean;
}

export const LandSearchReply = {
  ID: 526 as const,
  NAME: "LandSearchReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): LandSearchReply {
    return {
      query: "",
      offset: 0,
      results: [],
      more: false,
    };
  },
  encode(w: Writer, v: LandSearchReply): void {
    w.string(v.query);
    w.u32(v.offset);
    w.u16(v.results.length);
    for (const item of v.results) {
      LandListing.encode(w, item);
    }
    w.bool(v.more);
  },
  decode(r: Reader): LandSearchReply {
    const query = r.remaining > 0 ? r.string() : "";
    const offset = r.remaining > 0 ? r.u32() : 0;
    const results: LandListing[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      results.push(LandListing.decode(r));
    }
    const more = r.remaining > 0 ? r.bool() : false;
    return { query, offset, results, more };
  },
};

export interface LandHoldingsRequest {
}

export const LandHoldingsRequest = {
  ID: 527 as const,
  NAME: "LandHoldingsRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): LandHoldingsRequest {
    return {
    };
  },
  encode(w: Writer, v: LandHoldingsRequest): void {
    void w;
    void v;
  },
  decode(r: Reader): LandHoldingsRequest {
    void r;
    return {};
  },
};

export interface LandHoldingsReply {
  parcels: LandListing[];
  allowance: number;
  held: number;
}

export const LandHoldingsReply = {
  ID: 528 as const,
  NAME: "LandHoldingsReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): LandHoldingsReply {
    return {
      parcels: [],
      allowance: 0,
      held: 0,
    };
  },
  encode(w: Writer, v: LandHoldingsReply): void {
    w.u16(v.parcels.length);
    for (const item of v.parcels) {
      LandListing.encode(w, item);
    }
    w.u32(v.allowance);
    w.u32(v.held);
  },
  decode(r: Reader): LandHoldingsReply {
    const parcels: LandListing[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      parcels.push(LandListing.decode(r));
    }
    const allowance = r.remaining > 0 ? r.u32() : 0;
    const held = r.remaining > 0 ? r.u32() : 0;
    return { parcels, allowance, held };
  },
};

export interface FeaturedPlacesRequest {
}

export const FeaturedPlacesRequest = {
  ID: 529 as const,
  NAME: "FeaturedPlacesRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): FeaturedPlacesRequest {
    return {
    };
  },
  encode(w: Writer, v: FeaturedPlacesRequest): void {
    void w;
    void v;
  },
  decode(r: Reader): FeaturedPlacesRequest {
    void r;
    return {};
  },
};

export interface FeaturedPlacesReply {
  places: FeaturedPlace[];
  may_edit: boolean;
}

export const FeaturedPlacesReply = {
  ID: 530 as const,
  NAME: "FeaturedPlacesReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): FeaturedPlacesReply {
    return {
      places: [],
      may_edit: false,
    };
  },
  encode(w: Writer, v: FeaturedPlacesReply): void {
    w.u16(v.places.length);
    for (const item of v.places) {
      FeaturedPlace.encode(w, item);
    }
    w.bool(v.may_edit);
  },
  decode(r: Reader): FeaturedPlacesReply {
    const places: FeaturedPlace[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      places.push(FeaturedPlace.decode(r));
    }
    const may_edit = r.remaining > 0 ? r.bool() : false;
    return { places, may_edit };
  },
};

export interface FeaturedPlaceSave {
  place: FeaturedPlace;
}

export const FeaturedPlaceSave = {
  ID: 531 as const,
  NAME: "FeaturedPlaceSave" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): FeaturedPlaceSave {
    return {
      place: FeaturedPlace.create(),
    };
  },
  encode(w: Writer, v: FeaturedPlaceSave): void {
    FeaturedPlace.encode(w, v.place);
  },
  decode(r: Reader): FeaturedPlaceSave {
    const place = r.remaining > 0 ? FeaturedPlace.decode(r) : FeaturedPlace.create();
    return { place };
  },
};

export interface FeaturedPlaceDelete {
  id: Uuid;
}

export const FeaturedPlaceDelete = {
  ID: 532 as const,
  NAME: "FeaturedPlaceDelete" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): FeaturedPlaceDelete {
    return {
      id: NULL_UUID,
    };
  },
  encode(w: Writer, v: FeaturedPlaceDelete): void {
    w.uuid(v.id);
  },
  decode(r: Reader): FeaturedPlaceDelete {
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { id };
  },
};

export interface RegionSpawnSet {
  position: Vec3;
  clear: boolean;
}

export const RegionSpawnSet = {
  ID: 533 as const,
  NAME: "RegionSpawnSet" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): RegionSpawnSet {
    return {
      position: { x: 0, y: 0, z: 0 },
      clear: false,
    };
  },
  encode(w: Writer, v: RegionSpawnSet): void {
    w.vec3(v.position);
    w.bool(v.clear);
  },
  decode(r: Reader): RegionSpawnSet {
    const position = r.remaining > 0 ? r.vec3() : { x: 0, y: 0, z: 0 };
    const clear = r.remaining > 0 ? r.bool() : false;
    return { position, clear };
  },
};

export interface EstateCovenantRequest {
}

export const EstateCovenantRequest = {
  ID: 540 as const,
  NAME: "EstateCovenantRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): EstateCovenantRequest {
    return {
    };
  },
  encode(w: Writer, v: EstateCovenantRequest): void {
    void w;
    void v;
  },
  decode(r: Reader): EstateCovenantRequest {
    void r;
    return {};
  },
};

export interface EstateCovenant {
  modified: bigint;
}

export const EstateCovenant = {
  ID: 541 as const,
  NAME: "EstateCovenant" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): EstateCovenant {
    return {
      modified: 0n,
    };
  },
  encode(w: Writer, v: EstateCovenant): void {
    w.u64(v.modified);
  },
  decode(r: Reader): EstateCovenant {
    const modified = r.remaining > 0 ? r.u64() : 0n;
    return { modified };
  },
};

export interface ParcelTermsSet {
  parcel: number;
  sell_objects: boolean;
  group_access: boolean;
}

export const ParcelTermsSet = {
  ID: 542 as const,
  NAME: "ParcelTermsSet" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ParcelTermsSet {
    return {
      parcel: 0,
      sell_objects: false,
      group_access: false,
    };
  },
  encode(w: Writer, v: ParcelTermsSet): void {
    w.u32(v.parcel);
    w.bool(v.sell_objects);
    w.bool(v.group_access);
  },
  decode(r: Reader): ParcelTermsSet {
    const parcel = r.remaining > 0 ? r.u32() : 0;
    const sell_objects = r.remaining > 0 ? r.bool() : false;
    const group_access = r.remaining > 0 ? r.bool() : false;
    return { parcel, sell_objects, group_access };
  },
};

export interface ParcelTerms {
  parcel: number;
  sell_objects: boolean;
  group_access: boolean;
  objects_sold: number;
  objects_kept: number;
}

export const ParcelTerms = {
  ID: 543 as const,
  NAME: "ParcelTerms" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): ParcelTerms {
    return {
      parcel: 0,
      sell_objects: false,
      group_access: false,
      objects_sold: 0,
      objects_kept: 0,
    };
  },
  encode(w: Writer, v: ParcelTerms): void {
    w.u32(v.parcel);
    w.bool(v.sell_objects);
    w.bool(v.group_access);
    w.u32(v.objects_sold);
    w.u32(v.objects_kept);
  },
  decode(r: Reader): ParcelTerms {
    const parcel = r.remaining > 0 ? r.u32() : 0;
    const sell_objects = r.remaining > 0 ? r.bool() : false;
    const group_access = r.remaining > 0 ? r.bool() : false;
    const objects_sold = r.remaining > 0 ? r.u32() : 0;
    const objects_kept = r.remaining > 0 ? r.u32() : 0;
    return { parcel, sell_objects, group_access, objects_sold, objects_kept };
  },
};

export interface ParcelBuyAgreed {
  parcel: number;
  price: number;
  for_group: Uuid;
  with_objects: boolean;
  objects_sold: number;
}

export const ParcelBuyAgreed = {
  ID: 544 as const,
  NAME: "ParcelBuyAgreed" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ParcelBuyAgreed {
    return {
      parcel: 0,
      price: 0,
      for_group: NULL_UUID,
      with_objects: false,
      objects_sold: 0,
    };
  },
  encode(w: Writer, v: ParcelBuyAgreed): void {
    w.u32(v.parcel);
    w.i32(v.price);
    w.uuid(v.for_group);
    w.bool(v.with_objects);
    w.u32(v.objects_sold);
  },
  decode(r: Reader): ParcelBuyAgreed {
    const parcel = r.remaining > 0 ? r.u32() : 0;
    const price = r.remaining > 0 ? r.i32() : 0;
    const for_group = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const with_objects = r.remaining > 0 ? r.bool() : false;
    const objects_sold = r.remaining > 0 ? r.u32() : 0;
    return { parcel, price, for_group, with_objects, objects_sold };
  },
};

export interface EventSearchRequest {
  sequence: number;
  query: string;
  offset: number;
  ratings: number;
  from: bigint;
  to: bigint;
  category: number;
}

export const EventSearchRequest = {
  ID: 545 as const,
  NAME: "EventSearchRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): EventSearchRequest {
    return {
      sequence: 0,
      query: "",
      offset: 0,
      ratings: 0,
      from: 0n,
      to: 0n,
      category: 0,
    };
  },
  encode(w: Writer, v: EventSearchRequest): void {
    w.u32(v.sequence);
    w.string(v.query);
    w.u32(v.offset);
    w.u8(v.ratings);
    w.u64(v.from);
    w.u64(v.to);
    w.u8(v.category);
  },
  decode(r: Reader): EventSearchRequest {
    const sequence = r.remaining > 0 ? r.u32() : 0;
    const query = r.remaining > 0 ? r.string() : "";
    const offset = r.remaining > 0 ? r.u32() : 0;
    const ratings = r.remaining > 0 ? r.u8() : 0;
    const from = r.remaining > 0 ? r.u64() : 0n;
    const to = r.remaining > 0 ? r.u64() : 0n;
    const category = r.remaining > 0 ? r.u8() : 0;
    return { sequence, query, offset, ratings, from, to, category };
  },
};

export interface EventSearchReply {
  sequence: number;
  offset: number;
  results: SearchResult[];
  more: boolean;
}

export const EventSearchReply = {
  ID: 546 as const,
  NAME: "EventSearchReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): EventSearchReply {
    return {
      sequence: 0,
      offset: 0,
      results: [],
      more: false,
    };
  },
  encode(w: Writer, v: EventSearchReply): void {
    w.u32(v.sequence);
    w.u32(v.offset);
    w.u16(v.results.length);
    for (const item of v.results) {
      SearchResult.encode(w, item);
    }
    w.bool(v.more);
  },
  decode(r: Reader): EventSearchReply {
    const sequence = r.remaining > 0 ? r.u32() : 0;
    const offset = r.remaining > 0 ? r.u32() : 0;
    const results: SearchResult[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      results.push(SearchResult.decode(r));
    }
    const more = r.remaining > 0 ? r.bool() : false;
    return { sequence, offset, results, more };
  },
};

export interface RegionSkyLayersSet {
  layers: SkyLayer[];
}

export const RegionSkyLayersSet = {
  ID: 547 as const,
  NAME: "RegionSkyLayersSet" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): RegionSkyLayersSet {
    return {
      layers: [],
    };
  },
  encode(w: Writer, v: RegionSkyLayersSet): void {
    w.u16(v.layers.length);
    for (const item of v.layers) {
      SkyLayer.encode(w, item);
    }
  },
  decode(r: Reader): RegionSkyLayersSet {
    const layers: SkyLayer[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      layers.push(SkyLayer.decode(r));
    }
    return { layers };
  },
};

export interface RegionSkyLayers {
  layers: SkyLayer[];
  covered: boolean;
}

export const RegionSkyLayers = {
  ID: 548 as const,
  NAME: "RegionSkyLayers" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): RegionSkyLayers {
    return {
      layers: [],
      covered: false,
    };
  },
  encode(w: Writer, v: RegionSkyLayers): void {
    w.u16(v.layers.length);
    for (const item of v.layers) {
      SkyLayer.encode(w, item);
    }
    w.bool(v.covered);
  },
  decode(r: Reader): RegionSkyLayers {
    const layers: SkyLayer[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      layers.push(SkyLayer.decode(r));
    }
    const covered = r.remaining > 0 ? r.bool() : false;
    return { layers, covered };
  },
};

export interface TerrainRawUpload {
  data: Uint8Array;
}

export const TerrainRawUpload = {
  ID: 640 as const,
  NAME: "TerrainRawUpload" as const,
  CHANNEL: Channel.Bulk,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): TerrainRawUpload {
    return {
      data: new Uint8Array(0),
    };
  },
  encode(w: Writer, v: TerrainRawUpload): void {
    w.bytes(v.data);
  },
  decode(r: Reader): TerrainRawUpload {
    const data = r.remaining > 0 ? r.bytes() : new Uint8Array(0);
    return { data };
  },
};

export interface TerrainRawRequest {
}

export const TerrainRawRequest = {
  ID: 641 as const,
  NAME: "TerrainRawRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): TerrainRawRequest {
    return {
    };
  },
  encode(w: Writer, v: TerrainRawRequest): void {
    void w;
    void v;
  },
  decode(r: Reader): TerrainRawRequest {
    void r;
    return {};
  },
};

export interface TerrainRaw {
  data: Uint8Array;
}

export const TerrainRaw = {
  ID: 642 as const,
  NAME: "TerrainRaw" as const,
  CHANNEL: Channel.Bulk,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): TerrainRaw {
    return {
      data: new Uint8Array(0),
    };
  },
  encode(w: Writer, v: TerrainRaw): void {
    w.bytes(v.data);
  },
  decode(r: Reader): TerrainRaw {
    const data = r.remaining > 0 ? r.bytes() : new Uint8Array(0);
    return { data };
  },
};

export interface RegionExtrasRequest {
}

export const RegionExtrasRequest = {
  ID: 650 as const,
  NAME: "RegionExtrasRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): RegionExtrasRequest {
    return {
    };
  },
  encode(w: Writer, v: RegionExtrasRequest): void {
    void w;
    void v;
  },
  decode(r: Reader): RegionExtrasRequest {
    void r;
    return {};
  },
};

export interface RegionExtras {
  product: string;
  terrain_raise_limit: number;
  terrain_lower_limit: number;
  object_bonus: number;
  restart_days: number;
  restart_minute: number;
  baked: boolean;
}

export const RegionExtras = {
  ID: 651 as const,
  NAME: "RegionExtras" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): RegionExtras {
    return {
      product: "",
      terrain_raise_limit: 0,
      terrain_lower_limit: 0,
      object_bonus: 0,
      restart_days: 0,
      restart_minute: 0,
      baked: false,
    };
  },
  encode(w: Writer, v: RegionExtras): void {
    w.string(v.product);
    w.f32(v.terrain_raise_limit);
    w.f32(v.terrain_lower_limit);
    w.f32(v.object_bonus);
    w.u8(v.restart_days);
    w.u16(v.restart_minute);
    w.bool(v.baked);
  },
  decode(r: Reader): RegionExtras {
    const product = r.remaining > 0 ? r.string() : "";
    const terrain_raise_limit = r.remaining > 0 ? r.f32() : 0;
    const terrain_lower_limit = r.remaining > 0 ? r.f32() : 0;
    const object_bonus = r.remaining > 0 ? r.f32() : 0;
    const restart_days = r.remaining > 0 ? r.u8() : 0;
    const restart_minute = r.remaining > 0 ? r.u16() : 0;
    const baked = r.remaining > 0 ? r.bool() : false;
    return { product, terrain_raise_limit, terrain_lower_limit, object_bonus, restart_days, restart_minute, baked };
  },
};

export interface RegionExtrasSet {
  terrain_raise_limit: number;
  terrain_lower_limit: number;
  object_bonus: number;
  restart_days: number;
  restart_minute: number;
}

export const RegionExtrasSet = {
  ID: 652 as const,
  NAME: "RegionExtrasSet" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): RegionExtrasSet {
    return {
      terrain_raise_limit: 0,
      terrain_lower_limit: 0,
      object_bonus: 0,
      restart_days: 0,
      restart_minute: 0,
    };
  },
  encode(w: Writer, v: RegionExtrasSet): void {
    w.f32(v.terrain_raise_limit);
    w.f32(v.terrain_lower_limit);
    w.f32(v.object_bonus);
    w.u8(v.restart_days);
    w.u16(v.restart_minute);
  },
  decode(r: Reader): RegionExtrasSet {
    const terrain_raise_limit = r.remaining > 0 ? r.f32() : 0;
    const terrain_lower_limit = r.remaining > 0 ? r.f32() : 0;
    const object_bonus = r.remaining > 0 ? r.f32() : 0;
    const restart_days = r.remaining > 0 ? r.u8() : 0;
    const restart_minute = r.remaining > 0 ? r.u16() : 0;
    return { terrain_raise_limit, terrain_lower_limit, object_bonus, restart_days, restart_minute };
  },
};

export interface TopObjectsRequest {
  colliders: boolean;
  name: string;
  owner: Uuid;
  parcel: string;
}

export const TopObjectsRequest = {
  ID: 653 as const,
  NAME: "TopObjectsRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): TopObjectsRequest {
    return {
      colliders: false,
      name: "",
      owner: NULL_UUID,
      parcel: "",
    };
  },
  encode(w: Writer, v: TopObjectsRequest): void {
    w.bool(v.colliders);
    w.string(v.name);
    w.uuid(v.owner);
    w.string(v.parcel);
  },
  decode(r: Reader): TopObjectsRequest {
    const colliders = r.remaining > 0 ? r.bool() : false;
    const name = r.remaining > 0 ? r.string() : "";
    const owner = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const parcel = r.remaining > 0 ? r.string() : "";
    return { colliders, name, owner, parcel };
  },
};

export interface TopObjectsReply {
  colliders: boolean;
  objects: TopObject[];
  total: number;
  total_ms: number;
  total_kb: number;
}

export const TopObjectsReply = {
  ID: 654 as const,
  NAME: "TopObjectsReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): TopObjectsReply {
    return {
      colliders: false,
      objects: [],
      total: 0,
      total_ms: 0,
      total_kb: 0,
    };
  },
  encode(w: Writer, v: TopObjectsReply): void {
    w.bool(v.colliders);
    w.u16(v.objects.length);
    for (const item of v.objects) {
      TopObject.encode(w, item);
    }
    w.u32(v.total);
    w.f32(v.total_ms);
    w.u32(v.total_kb);
  },
  decode(r: Reader): TopObjectsReply {
    const colliders = r.remaining > 0 ? r.bool() : false;
    const objects: TopObject[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      objects.push(TopObject.decode(r));
    }
    const total = r.remaining > 0 ? r.u32() : 0;
    const total_ms = r.remaining > 0 ? r.f32() : 0;
    const total_kb = r.remaining > 0 ? r.u32() : 0;
    return { colliders, objects, total, total_ms, total_kb };
  },
};

export interface RegionObjectReturn {
  owner: Uuid;
  scripted_only: boolean;
  others_land_only: boolean;
}

export const RegionObjectReturn = {
  ID: 655 as const,
  NAME: "RegionObjectReturn" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): RegionObjectReturn {
    return {
      owner: NULL_UUID,
      scripted_only: false,
      others_land_only: false,
    };
  },
  encode(w: Writer, v: RegionObjectReturn): void {
    w.uuid(v.owner);
    w.bool(v.scripted_only);
    w.bool(v.others_land_only);
  },
  decode(r: Reader): RegionObjectReturn {
    const owner = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const scripted_only = r.remaining > 0 ? r.bool() : false;
    const others_land_only = r.remaining > 0 ? r.bool() : false;
    return { owner, scripted_only, others_land_only };
  },
};

export interface InventoryFavourite {
  item: Uuid;
  favourite: boolean;
}

export const InventoryFavourite = {
  ID: 620 as const,
  NAME: "InventoryFavourite" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): InventoryFavourite {
    return {
      item: NULL_UUID,
      favourite: false,
    };
  },
  encode(w: Writer, v: InventoryFavourite): void {
    w.uuid(v.item);
    w.bool(v.favourite);
  },
  decode(r: Reader): InventoryFavourite {
    const item = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const favourite = r.remaining > 0 ? r.bool() : false;
    return { item, favourite };
  },
};

export interface ParcelScriptInfoRequest {
  parcel: number;
}

export const ParcelScriptInfoRequest = {
  ID: 621 as const,
  NAME: "ParcelScriptInfoRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): ParcelScriptInfoRequest {
    return {
      parcel: 0,
    };
  },
  encode(w: Writer, v: ParcelScriptInfoRequest): void {
    w.u32(v.parcel);
  },
  decode(r: Reader): ParcelScriptInfoRequest {
    const parcel = r.remaining > 0 ? r.u32() : 0;
    return { parcel };
  },
};

export interface ParcelScriptInfo {
  parcel: number;
  listed: boolean;
  objects: ScriptUse[];
  attachments: ScriptUse[];
  scripts: number;
  memory: number;
}

export const ParcelScriptInfo = {
  ID: 622 as const,
  NAME: "ParcelScriptInfo" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): ParcelScriptInfo {
    return {
      parcel: 0,
      listed: false,
      objects: [],
      attachments: [],
      scripts: 0,
      memory: 0,
    };
  },
  encode(w: Writer, v: ParcelScriptInfo): void {
    w.u32(v.parcel);
    w.bool(v.listed);
    w.u16(v.objects.length);
    for (const item of v.objects) {
      ScriptUse.encode(w, item);
    }
    w.u16(v.attachments.length);
    for (const item of v.attachments) {
      ScriptUse.encode(w, item);
    }
    w.u32(v.scripts);
    w.u32(v.memory);
  },
  decode(r: Reader): ParcelScriptInfo {
    const parcel = r.remaining > 0 ? r.u32() : 0;
    const listed = r.remaining > 0 ? r.bool() : false;
    const objects: ScriptUse[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      objects.push(ScriptUse.decode(r));
    }
    const attachments: ScriptUse[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      attachments.push(ScriptUse.decode(r));
    }
    const scripts = r.remaining > 0 ? r.u32() : 0;
    const memory = r.remaining > 0 ? r.u32() : 0;
    return { parcel, listed, objects, attachments, scripts, memory };
  },
};

export interface MapLevelTilesRequest {
  level: number;
  min_x: number;
  min_y: number;
  max_x: number;
  max_y: number;
}

export const MapLevelTilesRequest = {
  ID: 580 as const,
  NAME: "MapLevelTilesRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): MapLevelTilesRequest {
    return {
      level: 0,
      min_x: 0,
      min_y: 0,
      max_x: 0,
      max_y: 0,
    };
  },
  encode(w: Writer, v: MapLevelTilesRequest): void {
    w.u8(v.level);
    w.u32(v.min_x);
    w.u32(v.min_y);
    w.u32(v.max_x);
    w.u32(v.max_y);
  },
  decode(r: Reader): MapLevelTilesRequest {
    const level = r.remaining > 0 ? r.u8() : 0;
    const min_x = r.remaining > 0 ? r.u32() : 0;
    const min_y = r.remaining > 0 ? r.u32() : 0;
    const max_x = r.remaining > 0 ? r.u32() : 0;
    const max_y = r.remaining > 0 ? r.u32() : 0;
    return { level, min_x, min_y, max_x, max_y };
  },
};

export interface MapLevelTilesReply {
  level: number;
  tiles: MapLevelTile[];
  covers: GridBox[];
}

export const MapLevelTilesReply = {
  ID: 581 as const,
  NAME: "MapLevelTilesReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): MapLevelTilesReply {
    return {
      level: 0,
      tiles: [],
      covers: [],
    };
  },
  encode(w: Writer, v: MapLevelTilesReply): void {
    w.u8(v.level);
    w.u16(v.tiles.length);
    for (const item of v.tiles) {
      MapLevelTile.encode(w, item);
    }
    w.u16(v.covers.length);
    for (const item of v.covers) {
      GridBox.encode(w, item);
    }
  },
  decode(r: Reader): MapLevelTilesReply {
    const level = r.remaining > 0 ? r.u8() : 0;
    const tiles: MapLevelTile[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      tiles.push(MapLevelTile.decode(r));
    }
    const covers: GridBox[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      covers.push(GridBox.decode(r));
    }
    return { level, tiles, covers };
  },
};

export interface MapLandRequest {
  min_x: number;
  min_y: number;
  max_x: number;
  max_y: number;
}

export const MapLandRequest = {
  ID: 582 as const,
  NAME: "MapLandRequest" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): MapLandRequest {
    return {
      min_x: 0,
      min_y: 0,
      max_x: 0,
      max_y: 0,
    };
  },
  encode(w: Writer, v: MapLandRequest): void {
    w.u32(v.min_x);
    w.u32(v.min_y);
    w.u32(v.max_x);
    w.u32(v.max_y);
  },
  decode(r: Reader): MapLandRequest {
    const min_x = r.remaining > 0 ? r.u32() : 0;
    const min_y = r.remaining > 0 ? r.u32() : 0;
    const max_x = r.remaining > 0 ? r.u32() : 0;
    const max_y = r.remaining > 0 ? r.u32() : 0;
    return { min_x, min_y, max_x, max_y };
  },
};

export interface MapLandReply {
  lands: MapLand[];
}

export const MapLandReply = {
  ID: 583 as const,
  NAME: "MapLandReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): MapLandReply {
    return {
      lands: [],
    };
  },
  encode(w: Writer, v: MapLandReply): void {
    w.u16(v.lands.length);
    for (const item of v.lands) {
      MapLand.encode(w, item);
    }
  },
  decode(r: Reader): MapLandReply {
    const lands: MapLand[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      lands.push(MapLand.decode(r));
    }
    return { lands };
  },
};

export interface CurrencyBuy {
  units: number;
  viewer_url: string;
}

export const CurrencyBuy = {
  ID: 670 as const,
  NAME: "CurrencyBuy" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): CurrencyBuy {
    return {
      units: 0,
      viewer_url: "",
    };
  },
  encode(w: Writer, v: CurrencyBuy): void {
    w.u32(v.units);
    w.string(v.viewer_url);
  },
  decode(r: Reader): CurrencyBuy {
    const units = r.remaining > 0 ? r.u32() : 0;
    const viewer_url = r.remaining > 0 ? r.string() : "";
    return { units, viewer_url };
  },
};

export interface CurrencyBuyReply {
  ok: boolean;
  url: string;
  message: string;
}

export const CurrencyBuyReply = {
  ID: 671 as const,
  NAME: "CurrencyBuyReply" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): CurrencyBuyReply {
    return {
      ok: false,
      url: "",
      message: "",
    };
  },
  encode(w: Writer, v: CurrencyBuyReply): void {
    w.bool(v.ok);
    w.string(v.url);
    w.string(v.message);
  },
  decode(r: Reader): CurrencyBuyReply {
    const ok = r.remaining > 0 ? r.bool() : false;
    const url = r.remaining > 0 ? r.string() : "";
    const message = r.remaining > 0 ? r.string() : "";
    return { ok, url, message };
  },
};

export interface CurrencyBuyCheck {
}

export const CurrencyBuyCheck = {
  ID: 672 as const,
  NAME: "CurrencyBuyCheck" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): CurrencyBuyCheck {
    return {
    };
  },
  encode(w: Writer, v: CurrencyBuyCheck): void {
    void w;
    void v;
  },
  decode(r: Reader): CurrencyBuyCheck {
    void r;
    return {};
  },
};

export interface LookPublish {
  name: string;
  about: string;
  portrait: Uuid;
}

export const LookPublish = {
  ID: 673 as const,
  NAME: "LookPublish" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): LookPublish {
    return {
      name: "",
      about: "",
      portrait: NULL_UUID,
    };
  },
  encode(w: Writer, v: LookPublish): void {
    w.string(v.name);
    w.string(v.about);
    w.uuid(v.portrait);
  },
  decode(r: Reader): LookPublish {
    const name = r.remaining > 0 ? r.string() : "";
    const about = r.remaining > 0 ? r.string() : "";
    const portrait = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { name, about, portrait };
  },
};

export interface LookPublished {
  ok: boolean;
  message: string;
  folder: Uuid;
}

export const LookPublished = {
  ID: 674 as const,
  NAME: "LookPublished" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 1,
  create(): LookPublished {
    return {
      ok: false,
      message: "",
      folder: NULL_UUID,
    };
  },
  encode(w: Writer, v: LookPublished): void {
    w.bool(v.ok);
    w.string(v.message);
    w.uuid(v.folder);
  },
  decode(r: Reader): LookPublished {
    const ok = r.remaining > 0 ? r.bool() : false;
    const message = r.remaining > 0 ? r.string() : "";
    const folder = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { ok, message, folder };
  },
};

export interface LookWithdraw {
  folder: Uuid;
}

export const LookWithdraw = {
  ID: 675 as const,
  NAME: "LookWithdraw" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): LookWithdraw {
    return {
      folder: NULL_UUID,
    };
  },
  encode(w: Writer, v: LookWithdraw): void {
    w.uuid(v.folder);
  },
  decode(r: Reader): LookWithdraw {
    const folder = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { folder };
  },
};

export interface LibraryPublish {
  folder: Uuid;
  parent: Uuid;
  name: string;
}

export const LibraryPublish = {
  ID: 677 as const,
  NAME: "LibraryPublish" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): LibraryPublish {
    return {
      folder: NULL_UUID,
      parent: NULL_UUID,
      name: "",
    };
  },
  encode(w: Writer, v: LibraryPublish): void {
    w.uuid(v.folder);
    w.uuid(v.parent);
    w.string(v.name);
  },
  decode(r: Reader): LibraryPublish {
    const folder = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const parent = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const name = r.remaining > 0 ? r.string() : "";
    return { folder, parent, name };
  },
};

export interface StarterLookSet {
  folder: Uuid;
}

export const StarterLookSet = {
  ID: 676 as const,
  NAME: "StarterLookSet" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 1,
  create(): StarterLookSet {
    return {
      folder: NULL_UUID,
    };
  },
  encode(w: Writer, v: StarterLookSet): void {
    w.uuid(v.folder);
  },
  decode(r: Reader): StarterLookSet {
    const folder = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { folder };
  },
};

export interface ObjectItemDescribe {
  item: Uuid;
}

export const ObjectItemDescribe = {
  ID: 681 as const,
  NAME: "ObjectItemDescribe" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 3,
  create(): ObjectItemDescribe {
    return {
      item: NULL_UUID,
    };
  },
  encode(w: Writer, v: ObjectItemDescribe): void {
    w.uuid(v.item);
  },
  decode(r: Reader): ObjectItemDescribe {
    const item = r.remaining > 0 ? r.uuid() : NULL_UUID;
    return { item };
  },
};

export interface ObjectItemParts {
  item: Uuid;
  parts: ObjectFull[];
}

export const ObjectItemParts = {
  ID: 682 as const,
  NAME: "ObjectItemParts" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 3,
  create(): ObjectItemParts {
    return {
      item: NULL_UUID,
      parts: [],
    };
  },
  encode(w: Writer, v: ObjectItemParts): void {
    w.uuid(v.item);
    w.u16(v.parts.length);
    for (const item of v.parts) {
      ObjectFull.encode(w, item);
    }
  },
  decode(r: Reader): ObjectItemParts {
    const item = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const parts: ObjectFull[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      parts.push(ObjectFull.decode(r));
    }
    return { item, parts };
  },
};

export interface TerrainShape {
  points: TerrainPoint[];
}

export const TerrainShape = {
  ID: 683 as const,
  NAME: "TerrainShape" as const,
  CHANNEL: Channel.Bulk,
  DIRECTION: Direction.ClientToServer,
  SINCE: 4,
  create(): TerrainShape {
    return {
      points: [],
    };
  },
  encode(w: Writer, v: TerrainShape): void {
    w.u16(v.points.length);
    for (const item of v.points) {
      TerrainPoint.encode(w, item);
    }
  },
  decode(r: Reader): TerrainShape {
    const points: TerrainPoint[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      points.push(TerrainPoint.decode(r));
    }
    return { points };
  },
};

export interface TerrainShaped {
  changed: number;
  refused: number;
  held: number;
}

export const TerrainShaped = {
  ID: 684 as const,
  NAME: "TerrainShaped" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 4,
  create(): TerrainShaped {
    return {
      changed: 0,
      refused: 0,
      held: 0,
    };
  },
  encode(w: Writer, v: TerrainShaped): void {
    w.u32(v.changed);
    w.u32(v.refused);
    w.u32(v.held);
  },
  decode(r: Reader): TerrainShaped {
    const changed = r.remaining > 0 ? r.u32() : 0;
    const refused = r.remaining > 0 ? r.u32() : 0;
    const held = r.remaining > 0 ? r.u32() : 0;
    return { changed, refused, held };
  },
};

export interface BotMenu {
  id: Uuid;
  options: string[];
}

export const BotMenu = {
  ID: 685 as const,
  NAME: "BotMenu" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 10,
  create(): BotMenu {
    return {
      id: NULL_UUID,
      options: [],
    };
  },
  encode(w: Writer, v: BotMenu): void {
    w.uuid(v.id);
    w.u16(v.options.length);
    for (const item of v.options) {
      w.string(item);
    }
  },
  decode(r: Reader): BotMenu {
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const options: string[] = [];
    for (let n = r.remaining > 0 ? r.u16() : 0; n > 0 && r.ok; n--) {
      options.push(r.string());
    }
    return { id, options };
  },
};

export interface BotClick {
  id: Uuid;
  option: number;
}

export const BotClick = {
  ID: 686 as const,
  NAME: "BotClick" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 10,
  create(): BotClick {
    return {
      id: NULL_UUID,
      option: 0,
    };
  },
  encode(w: Writer, v: BotClick): void {
    w.uuid(v.id);
    w.i32(v.option);
  },
  decode(r: Reader): BotClick {
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const option = r.remaining > 0 ? r.i32() : 0;
    return { id, option };
  },
};

export interface TerrainEditArea {
  tool: number;
  west: number;
  south: number;
  east: number;
  north: number;
  strength: number;
}

export const TerrainEditArea = {
  ID: 687 as const,
  NAME: "TerrainEditArea" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ClientToServer,
  SINCE: 13,
  create(): TerrainEditArea {
    return {
      tool: 0,
      west: 0,
      south: 0,
      east: 0,
      north: 0,
      strength: 0,
    };
  },
  encode(w: Writer, v: TerrainEditArea): void {
    w.u8(v.tool);
    w.f32(v.west);
    w.f32(v.south);
    w.f32(v.east);
    w.f32(v.north);
    w.f32(v.strength);
  },
  decode(r: Reader): TerrainEditArea {
    const tool = r.remaining > 0 ? r.u8() : 0;
    const west = r.remaining > 0 ? r.f32() : 0;
    const south = r.remaining > 0 ? r.f32() : 0;
    const east = r.remaining > 0 ? r.f32() : 0;
    const north = r.remaining > 0 ? r.f32() : 0;
    const strength = r.remaining > 0 ? r.f32() : 0;
    return { tool, west, south, east, north, strength };
  },
};

export interface AgentStatus {
  id: Uuid;
  frozen: boolean;
  admin: boolean;
}

export const AgentStatus = {
  ID: 688 as const,
  NAME: "AgentStatus" as const,
  CHANNEL: Channel.Reliable,
  DIRECTION: Direction.ServerToClient,
  SINCE: 14,
  create(): AgentStatus {
    return {
      id: NULL_UUID,
      frozen: false,
      admin: false,
    };
  },
  encode(w: Writer, v: AgentStatus): void {
    w.uuid(v.id);
    w.bool(v.frozen);
    w.bool(v.admin);
  },
  decode(r: Reader): AgentStatus {
    const id = r.remaining > 0 ? r.uuid() : NULL_UUID;
    const frozen = r.remaining > 0 ? r.bool() : false;
    const admin = r.remaining > 0 ? r.bool() : false;
    return { id, frozen, admin };
  },
};

export type Message =
  | { type: "Ping"; body: Ping }
  | { type: "Pong"; body: Pong }
  | { type: "Disconnect"; body: Disconnect }
  | { type: "Alert"; body: Alert }
  | { type: "Kick"; body: Kick }
  | { type: "LoginRequest"; body: LoginRequest }
  | { type: "LoginResponse"; body: LoginResponse }
  | { type: "LogoutRequest"; body: LogoutRequest }
  | { type: "LogoutResponse"; body: LogoutResponse }
  | { type: "CreateAccountRequest"; body: CreateAccountRequest }
  | { type: "CreateAccountResponse"; body: CreateAccountResponse }
  | { type: "RegionEnter"; body: RegionEnter }
  | { type: "RegionWelcome"; body: RegionWelcome }
  | { type: "RegionReady"; body: RegionReady }
  | { type: "RegionLeave"; body: RegionLeave }
  | { type: "RegionStatsUpdate"; body: RegionStatsUpdate }
  | { type: "NeighborRegions"; body: NeighborRegions }
  | { type: "RegionInfoUpdate"; body: RegionInfoUpdate }
  | { type: "RegionSettingsUpdate"; body: RegionSettingsUpdate }
  | { type: "LandHolding"; body: LandHolding }
  | { type: "RegionRestartNotice"; body: RegionRestartNotice }
  | { type: "TimeSync"; body: TimeSync }
  | { type: "TerrainPatch"; body: TerrainPatch }
  | { type: "TerrainEdit"; body: TerrainEdit }
  | { type: "TerrainTexturesUpdate"; body: TerrainTexturesUpdate }
  | { type: "TerrainBake"; body: TerrainBake }
  | { type: "WindUpdate"; body: WindUpdate }
  | { type: "SkyUpdate"; body: SkyUpdate }
  | { type: "WaterUpdate"; body: WaterUpdate }
  | { type: "DayCycleUpdate"; body: DayCycleUpdate }
  | { type: "EnvironmentSet"; body: EnvironmentSet }
  | { type: "ObjectAdd"; body: ObjectAdd }
  | { type: "ObjectUpdate"; body: ObjectUpdate }
  | { type: "ObjectMoveBatch"; body: ObjectMoveBatch }
  | { type: "ObjectRemove"; body: ObjectRemove }
  | { type: "ObjectCreate"; body: ObjectCreate }
  | { type: "ObjectEdit"; body: ObjectEdit }
  | { type: "ObjectSetShape"; body: ObjectSetShape }
  | { type: "ObjectSetFaces"; body: ObjectSetFaces }
  | { type: "ObjectSetFlags"; body: ObjectSetFlags }
  | { type: "ObjectSetNames"; body: ObjectSetNames }
  | { type: "ObjectSetText"; body: ObjectSetText }
  | { type: "ObjectSetLight"; body: ObjectSetLight }
  | { type: "ObjectSetFlexible"; body: ObjectSetFlexible }
  | { type: "ObjectSetParticles"; body: ObjectSetParticles }
  | { type: "ObjectSetMaterial"; body: ObjectSetMaterial }
  | { type: "ObjectSetPermissions"; body: ObjectSetPermissions }
  | { type: "ObjectLink"; body: ObjectLink }
  | { type: "ObjectUnlink"; body: ObjectUnlink }
  | { type: "ObjectDelete"; body: ObjectDelete }
  | { type: "ObjectDuplicate"; body: ObjectDuplicate }
  | { type: "ObjectSelect"; body: ObjectSelect }
  | { type: "ObjectTake"; body: ObjectTake }
  | { type: "ObjectRez"; body: ObjectRez }
  | { type: "ObjectTouch"; body: ObjectTouch }
  | { type: "ObjectGrab"; body: ObjectGrab }
  | { type: "ObjectSit"; body: ObjectSit }
  | { type: "ObjectStand"; body: ObjectStand }
  | { type: "ObjectPay"; body: ObjectPay }
  | { type: "ObjectBuy"; body: ObjectBuy }
  | { type: "ObjectSetMesh"; body: ObjectSetMesh }
  | { type: "ObjectSetSit"; body: ObjectSetSit }
  | { type: "ObjectSetMedia"; body: ObjectSetMedia }
  | { type: "ObjectAttach"; body: ObjectAttach }
  | { type: "ObjectDetach"; body: ObjectDetach }
  | { type: "ObjectSetOwner"; body: ObjectSetOwner }
  | { type: "ObjectRequestFull"; body: ObjectRequestFull }
  | { type: "ObjectSelected"; body: ObjectSelected }
  | { type: "AgentInput"; body: AgentInput }
  | { type: "AgentPoseBatch"; body: AgentPoseBatch }
  | { type: "AgentJoin"; body: AgentJoin }
  | { type: "AgentLeave"; body: AgentLeave }
  | { type: "AgentAppearanceUpdate"; body: AgentAppearanceUpdate }
  | { type: "AgentSetAppearance"; body: AgentSetAppearance }
  | { type: "AgentAnimationUpdate"; body: AgentAnimationUpdate }
  | { type: "AgentAnimationPlay"; body: AgentAnimationPlay }
  | { type: "AgentTyping"; body: AgentTyping }
  | { type: "AgentAway"; body: AgentAway }
  | { type: "AgentSit"; body: AgentSit }
  | { type: "AgentHealth"; body: AgentHealth }
  | { type: "AgentTeleportRequest"; body: AgentTeleportRequest }
  | { type: "AgentTeleportStatus"; body: AgentTeleportStatus }
  | { type: "AgentTeleportLure"; body: AgentTeleportLure }
  | { type: "AgentTeleportLureAccept"; body: AgentTeleportLureAccept }
  | { type: "AgentSetHome"; body: AgentSetHome }
  | { type: "AgentTitleUpdate"; body: AgentTitleUpdate }
  | { type: "AgentCameraFollow"; body: AgentCameraFollow }
  | { type: "AgentEffect"; body: AgentEffect }
  | { type: "AgentPushed"; body: AgentPushed }
  | { type: "AgentControlGrant"; body: AgentControlGrant }
  | { type: "AgentControlEvent"; body: AgentControlEvent }
  | { type: "ChatSend"; body: ChatSend }
  | { type: "ChatReceive"; body: ChatReceive }
  | { type: "InstantMessageSend"; body: InstantMessageSend }
  | { type: "InstantMessageReceive"; body: InstantMessageReceive }
  | { type: "ScriptDialogShow"; body: ScriptDialogShow }
  | { type: "ScriptDialogReply"; body: ScriptDialogReply }
  | { type: "Notification"; body: Notification }
  | { type: "NotificationReply"; body: NotificationReply }
  | { type: "MuteUpdate"; body: MuteUpdate }
  | { type: "MuteList"; body: MuteList }
  | { type: "TypingIndicator"; body: TypingIndicator }
  | { type: "GestureActive"; body: GestureActive }
  | { type: "InventoryFetch"; body: InventoryFetch }
  | { type: "InventoryFolders"; body: InventoryFolders }
  | { type: "InventoryItems"; body: InventoryItems }
  | { type: "InventoryFolderOp"; body: InventoryFolderOp }
  | { type: "InventoryItemOp"; body: InventoryItemOp }
  | { type: "InventoryChanged"; body: InventoryChanged }
  | { type: "InventoryGive"; body: InventoryGive }
  | { type: "InventoryOffer"; body: InventoryOffer }
  | { type: "InventoryOfferReply"; body: InventoryOfferReply }
  | { type: "TaskInventoryFetch"; body: TaskInventoryFetch }
  | { type: "TaskInventoryItems"; body: TaskInventoryItems }
  | { type: "TaskInventoryOp"; body: TaskInventoryOp }
  | { type: "WearableSet"; body: WearableSet }
  | { type: "OutfitSave"; body: OutfitSave }
  | { type: "AssetRequest"; body: AssetRequest }
  | { type: "AssetHeader"; body: AssetHeader }
  | { type: "AssetChunk"; body: AssetChunk }
  | { type: "AssetCancel"; body: AssetCancel }
  | { type: "AssetUploadBegin"; body: AssetUploadBegin }
  | { type: "AssetUploadChunk"; body: AssetUploadChunk }
  | { type: "AssetUploadResult"; body: AssetUploadResult }
  | { type: "AssetUploadQuote"; body: AssetUploadQuote }
  | { type: "ScriptSave"; body: ScriptSave }
  | { type: "ScriptSaveResult"; body: ScriptSaveResult }
  | { type: "ScriptSetRunning"; body: ScriptSetRunning }
  | { type: "ScriptReset"; body: ScriptReset }
  | { type: "ScriptRuntimeError"; body: ScriptRuntimeError }
  | { type: "ScriptFetchSource"; body: ScriptFetchSource }
  | { type: "ScriptSource"; body: ScriptSource }
  | { type: "ScriptHudText"; body: ScriptHudText }
  | { type: "ScriptPanelShow"; body: ScriptPanelShow }
  | { type: "ScriptPanelHide"; body: ScriptPanelHide }
  | { type: "ScriptPanelUse"; body: ScriptPanelUse }
  | { type: "SoundPlay"; body: SoundPlay }
  | { type: "SoundStop"; body: SoundStop }
  | { type: "SoundPreload"; body: SoundPreload }
  | { type: "AgentSoundPlay"; body: AgentSoundPlay }
  | { type: "ParcelMediaCommand"; body: ParcelMediaCommand }
  | { type: "ParcelOverlay"; body: ParcelOverlay }
  | { type: "ParcelInfoRequest"; body: ParcelInfoRequest }
  | { type: "ParcelInfoReply"; body: ParcelInfoReply }
  | { type: "ParcelUpdate"; body: ParcelUpdate }
  | { type: "ParcelDivide"; body: ParcelDivide }
  | { type: "ParcelJoin"; body: ParcelJoin }
  | { type: "ParcelBuy"; body: ParcelBuy }
  | { type: "ParcelRelease"; body: ParcelRelease }
  | { type: "ParcelAccessList"; body: ParcelAccessList }
  | { type: "ParcelReturnObjects"; body: ParcelReturnObjects }
  | { type: "ParcelObjectOwners"; body: ParcelObjectOwners }
  | { type: "ParcelEject"; body: ParcelEject }
  | { type: "ParcelFreeze"; body: ParcelFreeze }
  | { type: "ParcelAuctionStart"; body: ParcelAuctionStart }
  | { type: "ParcelAuctionBid"; body: ParcelAuctionBid }
  | { type: "ParcelAuctionCancel"; body: ParcelAuctionCancel }
  | { type: "TaskInventoryTake"; body: TaskInventoryTake }
  | { type: "InventoryTextSave"; body: InventoryTextSave }
  | { type: "ParcelMediaControl"; body: ParcelMediaControl }
  | { type: "ParcelDeedToGroup"; body: ParcelDeedToGroup }
  | { type: "MapRequest"; body: MapRequest }
  | { type: "MapReply"; body: MapReply }
  | { type: "MapAgentsRequest"; body: MapAgentsRequest }
  | { type: "MapAgentsReply"; body: MapAgentsReply }
  | { type: "LandmarkCreate"; body: LandmarkCreate }
  | { type: "PlacesRequest"; body: PlacesRequest }
  | { type: "PlacesReply"; body: PlacesReply }
  | { type: "MapItemsRequest"; body: MapItemsRequest }
  | { type: "MapItemsReply"; body: MapItemsReply }
  | { type: "AgentHome"; body: AgentHome }
  | { type: "BalanceUpdate"; body: BalanceUpdate }
  | { type: "MoneyTransfer"; body: MoneyTransfer }
  | { type: "MoneyTransferResult"; body: MoneyTransferResult }
  | { type: "TransactionHistoryRequest"; body: TransactionHistoryRequest }
  | { type: "TransactionHistoryReply"; body: TransactionHistoryReply }
  | { type: "NameLookup"; body: NameLookup }
  | { type: "NameReply"; body: NameReply }
  | { type: "ProfileRequest"; body: ProfileRequest }
  | { type: "ProfileReply"; body: ProfileReply }
  | { type: "ProfileUpdate"; body: ProfileUpdate }
  | { type: "FriendList"; body: FriendList }
  | { type: "FriendRequest"; body: FriendRequest }
  | { type: "FriendRequestReply"; body: FriendRequestReply }
  | { type: "FriendRemove"; body: FriendRemove }
  | { type: "FriendPresenceUpdate"; body: FriendPresenceUpdate }
  | { type: "FriendRights"; body: FriendRights }
  | { type: "GroupList"; body: GroupList }
  | { type: "GroupCreate"; body: GroupCreate }
  | { type: "GroupCreateResult"; body: GroupCreateResult }
  | { type: "GroupInfoRequest"; body: GroupInfoRequest }
  | { type: "GroupInfoReply"; body: GroupInfoReply }
  | { type: "GroupMembersRequest"; body: GroupMembersRequest }
  | { type: "GroupMembersReply"; body: GroupMembersReply }
  | { type: "GroupActivate"; body: GroupActivate }
  | { type: "GroupUpdate"; body: GroupUpdate }
  | { type: "GroupJoin"; body: GroupJoin }
  | { type: "GroupLeave"; body: GroupLeave }
  | { type: "GroupInvite"; body: GroupInvite }
  | { type: "GroupInviteReply"; body: GroupInviteReply }
  | { type: "GroupEject"; body: GroupEject }
  | { type: "GroupRoleUpdate"; body: GroupRoleUpdate }
  | { type: "GroupMemberRole"; body: GroupMemberRole }
  | { type: "GroupTitleSet"; body: GroupTitleSet }
  | { type: "GroupNoticeSend"; body: GroupNoticeSend }
  | { type: "GroupNoticesRequest"; body: GroupNoticesRequest }
  | { type: "GroupNoticesReply"; body: GroupNoticesReply }
  | { type: "GroupChatSend"; body: GroupChatSend }
  | { type: "GroupChatReceive"; body: GroupChatReceive }
  | { type: "GroupSearch"; body: GroupSearch }
  | { type: "GroupSearchReply"; body: GroupSearchReply }
  | { type: "SearchRequest"; body: SearchRequest }
  | { type: "SearchReply"; body: SearchReply }
  | { type: "EventCreate"; body: EventCreate }
  | { type: "ClassifiedCreate"; body: ClassifiedCreate }
  | { type: "SearchListingDelete"; body: SearchListingDelete }
  | { type: "VoiceJoin"; body: VoiceJoin }
  | { type: "VoiceAnswer"; body: VoiceAnswer }
  | { type: "VoiceSlots"; body: VoiceSlots }
  | { type: "VoiceLeave"; body: VoiceLeave }
  | { type: "VoiceActivity"; body: VoiceActivity }
  | { type: "ExperienceSave"; body: ExperienceSave }
  | { type: "ExperienceListRequest"; body: ExperienceListRequest }
  | { type: "ExperienceList"; body: ExperienceList }
  | { type: "ExperienceAnswer"; body: ExperienceAnswer }
  | { type: "MarketListRequest"; body: MarketListRequest }
  | { type: "MarketList"; body: MarketList }
  | { type: "MarketListingSave"; body: MarketListingSave }
  | { type: "MarketBuy"; body: MarketBuy }
  | { type: "MarketResult"; body: MarketResult }
  | { type: "EstateUpdate"; body: EstateUpdate }
  | { type: "EstateKick"; body: EstateKick }
  | { type: "EstateMessage"; body: EstateMessage }
  | { type: "EstateRestart"; body: EstateRestart }
  | { type: "EstateTeleportHome"; body: EstateTeleportHome }
  | { type: "GodRequest"; body: GodRequest }
  | { type: "GodGrant"; body: GodGrant }
  | { type: "AdminObjectReturn"; body: AdminObjectReturn }
  | { type: "AdminObjectAction"; body: AdminObjectAction }
  | { type: "StaffAction"; body: StaffAction }
  | { type: "StaffActionReply"; body: StaffActionReply }
  | { type: "TopScriptsRequest"; body: TopScriptsRequest }
  | { type: "TopScriptsReply"; body: TopScriptsReply }
  | { type: "ObjectHudAttach"; body: ObjectHudAttach }
  | { type: "ClientStatsReport"; body: ClientStatsReport }
  | { type: "AbuseReport"; body: AbuseReport }
  | { type: "AbuseReportAck"; body: AbuseReportAck }
  | { type: "DetectedReport"; body: DetectedReport }
  | { type: "CameraConstraint"; body: CameraConstraint }
  | { type: "ViewerEffectSpawn"; body: ViewerEffectSpawn }
  | { type: "TerrainRequest"; body: TerrainRequest }
  | { type: "FriendLocateRequest"; body: FriendLocateRequest }
  | { type: "FriendLocateReply"; body: FriendLocateReply }
  | { type: "MapParcelRequest"; body: MapParcelRequest }
  | { type: "MapParcelReply"; body: MapParcelReply }
  | { type: "AgentControlsRelease"; body: AgentControlsRelease }
  | { type: "ObjectHandOff"; body: ObjectHandOff }
  | { type: "VehicleFlags"; body: VehicleFlags }
  | { type: "AttachmentWear"; body: AttachmentWear }
  | { type: "AgentSetHover"; body: AgentSetHover }
  | { type: "AgentAnimationStopAll"; body: AgentAnimationStopAll }
  | { type: "AgentDoNotDisturb"; body: AgentDoNotDisturb }
  | { type: "ProfileExtrasRequest"; body: ProfileExtrasRequest }
  | { type: "ProfileExtras"; body: ProfileExtras }
  | { type: "PickSave"; body: PickSave }
  | { type: "PickDelete"; body: PickDelete }
  | { type: "ProfileNotesSave"; body: ProfileNotesSave }
  | { type: "ObjectTouchAt"; body: ObjectTouchAt }
  | { type: "ObjectSetSaleType"; body: ObjectSetSaleType }
  | { type: "ObjectTradeRequest"; body: ObjectTradeRequest }
  | { type: "ObjectTrade"; body: ObjectTrade }
  | { type: "ObjectPurchase"; body: ObjectPurchase }
  | { type: "TaskInventoryCopyAll"; body: TaskInventoryCopyAll }
  | { type: "TaskInventoryCopied"; body: TaskInventoryCopied }
  | { type: "AgentTeleportAsk"; body: AgentTeleportAsk }
  | { type: "AgentTeleportAsked"; body: AgentTeleportAsked }
  | { type: "ObjectMenuTouch"; body: ObjectMenuTouch }
  | { type: "GroupMemberOptions"; body: GroupMemberOptions }
  | { type: "GroupMemberOptionsList"; body: GroupMemberOptionsList }
  | { type: "GroupChatHistoryRequest"; body: GroupChatHistoryRequest }
  | { type: "GroupChatHistory"; body: GroupChatHistory }
  | { type: "GroupNoticeReceive"; body: GroupNoticeReceive }
  | { type: "GroupNoticeAccept"; body: GroupNoticeAccept }
  | { type: "ConferenceSend"; body: ConferenceSend }
  | { type: "ConferenceReceive"; body: ConferenceReceive }
  | { type: "EstateAccessRequest"; body: EstateAccessRequest }
  | { type: "EstateAccessList"; body: EstateAccessList }
  | { type: "EstateAccessChange"; body: EstateAccessChange }
  | { type: "ParcelEnvironmentReset"; body: ParcelEnvironmentReset }
  | { type: "OutfitWrite"; body: OutfitWrite }
  | { type: "AvatarChoose"; body: AvatarChoose }
  | { type: "AvatarChosen"; body: AvatarChosen }
  | { type: "ProfileDetails"; body: ProfileDetails }
  | { type: "ProfileDetailsUpdate"; body: ProfileDetailsUpdate }
  | { type: "AccountInfoRequest"; body: AccountInfoRequest }
  | { type: "AccountInfo"; body: AccountInfo }
  | { type: "AccountPasswordChange"; body: AccountPasswordChange }
  | { type: "AccountEmailChange"; body: AccountEmailChange }
  | { type: "AccountChangeResult"; body: AccountChangeResult }
  | { type: "ObjectWear"; body: ObjectWear }
  | { type: "UploadPriceRequest"; body: UploadPriceRequest }
  | { type: "UploadPrice"; body: UploadPrice }
  | { type: "ObjectReturn"; body: ObjectReturn }
  | { type: "ObjectRestore"; body: ObjectRestore }
  | { type: "ParcelObjectsRequest"; body: ParcelObjectsRequest }
  | { type: "ParcelObjects"; body: ParcelObjects }
  | { type: "MapDestination"; body: MapDestination }
  | { type: "SoundAdjust"; body: SoundAdjust }
  | { type: "SoundQueue"; body: SoundQueue }
  | { type: "AvatarRenderReport"; body: AvatarRenderReport }
  | { type: "AvatarRenderNotice"; body: AvatarRenderNotice }
  | { type: "AccountPreferencesRequest"; body: AccountPreferencesRequest }
  | { type: "AccountPreferencesSet"; body: AccountPreferencesSet }
  | { type: "AccountPreferencesReply"; body: AccountPreferencesReply }
  | { type: "VoiceCallStart"; body: VoiceCallStart }
  | { type: "VoiceCallInvite"; body: VoiceCallInvite }
  | { type: "VoiceCallJoin"; body: VoiceCallJoin }
  | { type: "VoiceCallAnswer"; body: VoiceCallAnswer }
  | { type: "VoiceCallLeave"; body: VoiceCallLeave }
  | { type: "VoiceCallEnded"; body: VoiceCallEnded }
  | { type: "VoiceCallMembers"; body: VoiceCallMembers }
  | { type: "InstantMessageStored"; body: InstantMessageStored }
  | { type: "ObjectInstantMessage"; body: ObjectInstantMessage }
  | { type: "GroupMembersPageRequest"; body: GroupMembersPageRequest }
  | { type: "GroupMembersPage"; body: GroupMembersPage }
  | { type: "GroupLandRequest"; body: GroupLandRequest }
  | { type: "GroupLand"; body: GroupLand }
  | { type: "GroupContributionSet"; body: GroupContributionSet }
  | { type: "GroupProfileChoice"; body: GroupProfileChoice }
  | { type: "GroupProfileChoices"; body: GroupProfileChoices }
  | { type: "TalkChoices"; body: TalkChoices }
  | { type: "EnvironmentDaySet"; body: EnvironmentDaySet }
  | { type: "EnvironmentInfoRequest"; body: EnvironmentInfoRequest }
  | { type: "EnvironmentInfo"; body: EnvironmentInfo }
  | { type: "ParcelExtrasSet"; body: ParcelExtrasSet }
  | { type: "ParcelExtras"; body: ParcelExtras }
  | { type: "LandSearchRequest"; body: LandSearchRequest }
  | { type: "LandSearchReply"; body: LandSearchReply }
  | { type: "LandHoldingsRequest"; body: LandHoldingsRequest }
  | { type: "LandHoldingsReply"; body: LandHoldingsReply }
  | { type: "FeaturedPlacesRequest"; body: FeaturedPlacesRequest }
  | { type: "FeaturedPlacesReply"; body: FeaturedPlacesReply }
  | { type: "FeaturedPlaceSave"; body: FeaturedPlaceSave }
  | { type: "FeaturedPlaceDelete"; body: FeaturedPlaceDelete }
  | { type: "RegionSpawnSet"; body: RegionSpawnSet }
  | { type: "EstateCovenantRequest"; body: EstateCovenantRequest }
  | { type: "EstateCovenant"; body: EstateCovenant }
  | { type: "ParcelTermsSet"; body: ParcelTermsSet }
  | { type: "ParcelTerms"; body: ParcelTerms }
  | { type: "ParcelBuyAgreed"; body: ParcelBuyAgreed }
  | { type: "EventSearchRequest"; body: EventSearchRequest }
  | { type: "EventSearchReply"; body: EventSearchReply }
  | { type: "RegionSkyLayersSet"; body: RegionSkyLayersSet }
  | { type: "RegionSkyLayers"; body: RegionSkyLayers }
  | { type: "TerrainRawUpload"; body: TerrainRawUpload }
  | { type: "TerrainRawRequest"; body: TerrainRawRequest }
  | { type: "TerrainRaw"; body: TerrainRaw }
  | { type: "RegionExtrasRequest"; body: RegionExtrasRequest }
  | { type: "RegionExtras"; body: RegionExtras }
  | { type: "RegionExtrasSet"; body: RegionExtrasSet }
  | { type: "TopObjectsRequest"; body: TopObjectsRequest }
  | { type: "TopObjectsReply"; body: TopObjectsReply }
  | { type: "RegionObjectReturn"; body: RegionObjectReturn }
  | { type: "InventoryFavourite"; body: InventoryFavourite }
  | { type: "ParcelScriptInfoRequest"; body: ParcelScriptInfoRequest }
  | { type: "ParcelScriptInfo"; body: ParcelScriptInfo }
  | { type: "MapLevelTilesRequest"; body: MapLevelTilesRequest }
  | { type: "MapLevelTilesReply"; body: MapLevelTilesReply }
  | { type: "MapLandRequest"; body: MapLandRequest }
  | { type: "MapLandReply"; body: MapLandReply }
  | { type: "CurrencyBuy"; body: CurrencyBuy }
  | { type: "CurrencyBuyReply"; body: CurrencyBuyReply }
  | { type: "CurrencyBuyCheck"; body: CurrencyBuyCheck }
  | { type: "LookPublish"; body: LookPublish }
  | { type: "LookPublished"; body: LookPublished }
  | { type: "LookWithdraw"; body: LookWithdraw }
  | { type: "LibraryPublish"; body: LibraryPublish }
  | { type: "StarterLookSet"; body: StarterLookSet }
  | { type: "ObjectItemDescribe"; body: ObjectItemDescribe }
  | { type: "ObjectItemParts"; body: ObjectItemParts }
  | { type: "TerrainShape"; body: TerrainShape }
  | { type: "TerrainShaped"; body: TerrainShaped }
  | { type: "BotMenu"; body: BotMenu }
  | { type: "BotClick"; body: BotClick }
  | { type: "TerrainEditArea"; body: TerrainEditArea }
  | { type: "AgentStatus"; body: AgentStatus };

export type MessageType = Message["type"];

export type MessageBody<T extends MessageType> = Extract<Message, { type: T }>["body"];

export const MESSAGE_IDS: Record<MessageType, number> = {
  Ping: 1,
  Pong: 2,
  Disconnect: 3,
  Alert: 4,
  Kick: 5,
  LoginRequest: 10,
  LoginResponse: 11,
  LogoutRequest: 12,
  LogoutResponse: 13,
  CreateAccountRequest: 14,
  CreateAccountResponse: 15,
  RegionEnter: 20,
  RegionWelcome: 21,
  RegionReady: 22,
  RegionLeave: 23,
  RegionStatsUpdate: 24,
  NeighborRegions: 25,
  RegionInfoUpdate: 26,
  RegionSettingsUpdate: 27,
  LandHolding: 306,
  RegionRestartNotice: 28,
  TimeSync: 29,
  TerrainPatch: 30,
  TerrainEdit: 31,
  TerrainTexturesUpdate: 32,
  TerrainBake: 33,
  WindUpdate: 34,
  SkyUpdate: 40,
  WaterUpdate: 41,
  DayCycleUpdate: 42,
  EnvironmentSet: 43,
  ObjectAdd: 50,
  ObjectUpdate: 51,
  ObjectMoveBatch: 52,
  ObjectRemove: 53,
  ObjectCreate: 54,
  ObjectEdit: 55,
  ObjectSetShape: 56,
  ObjectSetFaces: 57,
  ObjectSetFlags: 58,
  ObjectSetNames: 59,
  ObjectSetText: 60,
  ObjectSetLight: 61,
  ObjectSetFlexible: 62,
  ObjectSetParticles: 63,
  ObjectSetMaterial: 64,
  ObjectSetPermissions: 65,
  ObjectLink: 66,
  ObjectUnlink: 67,
  ObjectDelete: 68,
  ObjectDuplicate: 69,
  ObjectSelect: 70,
  ObjectTake: 71,
  ObjectRez: 72,
  ObjectTouch: 73,
  ObjectGrab: 74,
  ObjectSit: 75,
  ObjectStand: 76,
  ObjectPay: 77,
  ObjectBuy: 78,
  ObjectSetMesh: 79,
  ObjectSetSit: 80,
  ObjectSetMedia: 81,
  ObjectAttach: 82,
  ObjectDetach: 83,
  ObjectSetOwner: 84,
  ObjectRequestFull: 85,
  ObjectSelected: 86,
  AgentInput: 100,
  AgentPoseBatch: 101,
  AgentJoin: 102,
  AgentLeave: 103,
  AgentAppearanceUpdate: 104,
  AgentSetAppearance: 105,
  AgentAnimationUpdate: 106,
  AgentAnimationPlay: 107,
  AgentTyping: 108,
  AgentAway: 109,
  AgentSit: 110,
  AgentHealth: 111,
  AgentTeleportRequest: 112,
  AgentTeleportStatus: 113,
  AgentTeleportLure: 114,
  AgentTeleportLureAccept: 115,
  AgentSetHome: 116,
  AgentTitleUpdate: 117,
  AgentCameraFollow: 118,
  AgentEffect: 119,
  AgentPushed: 120,
  AgentControlGrant: 121,
  AgentControlEvent: 122,
  ChatSend: 130,
  ChatReceive: 131,
  InstantMessageSend: 132,
  InstantMessageReceive: 133,
  ScriptDialogShow: 134,
  ScriptDialogReply: 135,
  Notification: 136,
  NotificationReply: 137,
  MuteUpdate: 138,
  MuteList: 139,
  TypingIndicator: 140,
  GestureActive: 141,
  InventoryFetch: 150,
  InventoryFolders: 151,
  InventoryItems: 152,
  InventoryFolderOp: 153,
  InventoryItemOp: 154,
  InventoryChanged: 155,
  InventoryGive: 156,
  InventoryOffer: 157,
  InventoryOfferReply: 158,
  TaskInventoryFetch: 159,
  TaskInventoryItems: 160,
  TaskInventoryOp: 161,
  WearableSet: 162,
  OutfitSave: 163,
  AssetRequest: 170,
  AssetHeader: 171,
  AssetChunk: 172,
  AssetCancel: 173,
  AssetUploadBegin: 174,
  AssetUploadChunk: 175,
  AssetUploadResult: 176,
  AssetUploadQuote: 177,
  ScriptSave: 180,
  ScriptSaveResult: 181,
  ScriptSetRunning: 182,
  ScriptReset: 183,
  ScriptRuntimeError: 184,
  ScriptFetchSource: 185,
  ScriptSource: 186,
  ScriptHudText: 187,
  ScriptPanelShow: 188,
  ScriptPanelHide: 189,
  ScriptPanelUse: 195,
  SoundPlay: 190,
  SoundStop: 191,
  SoundPreload: 192,
  AgentSoundPlay: 194,
  ParcelMediaCommand: 193,
  ParcelOverlay: 200,
  ParcelInfoRequest: 201,
  ParcelInfoReply: 202,
  ParcelUpdate: 203,
  ParcelDivide: 204,
  ParcelJoin: 205,
  ParcelBuy: 206,
  ParcelRelease: 207,
  ParcelAccessList: 208,
  ParcelReturnObjects: 209,
  ParcelObjectOwners: 210,
  ParcelEject: 211,
  ParcelFreeze: 212,
  ParcelAuctionStart: 307,
  ParcelAuctionBid: 308,
  ParcelAuctionCancel: 309,
  TaskInventoryTake: 310,
  InventoryTextSave: 312,
  ParcelMediaControl: 311,
  ParcelDeedToGroup: 213,
  MapRequest: 220,
  MapReply: 221,
  MapAgentsRequest: 222,
  MapAgentsReply: 223,
  LandmarkCreate: 224,
  PlacesRequest: 225,
  PlacesReply: 226,
  MapItemsRequest: 227,
  MapItemsReply: 228,
  AgentHome: 229,
  BalanceUpdate: 230,
  MoneyTransfer: 231,
  MoneyTransferResult: 232,
  TransactionHistoryRequest: 233,
  TransactionHistoryReply: 234,
  NameLookup: 240,
  NameReply: 241,
  ProfileRequest: 242,
  ProfileReply: 243,
  ProfileUpdate: 244,
  FriendList: 245,
  FriendRequest: 246,
  FriendRequestReply: 247,
  FriendRemove: 248,
  FriendPresenceUpdate: 249,
  FriendRights: 250,
  GroupList: 260,
  GroupCreate: 261,
  GroupCreateResult: 262,
  GroupInfoRequest: 263,
  GroupInfoReply: 264,
  GroupMembersRequest: 265,
  GroupMembersReply: 266,
  GroupActivate: 267,
  GroupUpdate: 268,
  GroupJoin: 269,
  GroupLeave: 270,
  GroupInvite: 271,
  GroupInviteReply: 272,
  GroupEject: 273,
  GroupRoleUpdate: 274,
  GroupMemberRole: 275,
  GroupTitleSet: 276,
  GroupNoticeSend: 277,
  GroupNoticesRequest: 278,
  GroupNoticesReply: 279,
  GroupChatSend: 280,
  GroupChatReceive: 281,
  GroupSearch: 282,
  GroupSearchReply: 283,
  SearchRequest: 315,
  SearchReply: 316,
  EventCreate: 317,
  ClassifiedCreate: 318,
  SearchListingDelete: 319,
  VoiceJoin: 320,
  VoiceAnswer: 321,
  VoiceSlots: 322,
  VoiceLeave: 323,
  VoiceActivity: 324,
  ExperienceSave: 325,
  ExperienceListRequest: 326,
  ExperienceList: 327,
  ExperienceAnswer: 328,
  MarketListRequest: 329,
  MarketList: 330,
  MarketListingSave: 331,
  MarketBuy: 332,
  MarketResult: 333,
  EstateUpdate: 290,
  EstateKick: 291,
  EstateMessage: 292,
  EstateRestart: 293,
  EstateTeleportHome: 294,
  GodRequest: 295,
  GodGrant: 296,
  AdminObjectReturn: 297,
  AdminObjectAction: 678,
  StaffAction: 679,
  StaffActionReply: 680,
  TopScriptsRequest: 298,
  TopScriptsReply: 299,
  ObjectHudAttach: 300,
  ClientStatsReport: 301,
  AbuseReport: 313,
  AbuseReportAck: 314,
  DetectedReport: 302,
  CameraConstraint: 303,
  ViewerEffectSpawn: 304,
  TerrainRequest: 305,
  FriendLocateRequest: 334,
  FriendLocateReply: 335,
  MapParcelRequest: 336,
  MapParcelReply: 337,
  AgentControlsRelease: 338,
  ObjectHandOff: 339,
  VehicleFlags: 340,
  AttachmentWear: 341,
  AgentSetHover: 342,
  AgentAnimationStopAll: 343,
  AgentDoNotDisturb: 344,
  ProfileExtrasRequest: 345,
  ProfileExtras: 346,
  PickSave: 347,
  PickDelete: 348,
  ProfileNotesSave: 349,
  ObjectTouchAt: 360,
  ObjectSetSaleType: 380,
  ObjectTradeRequest: 381,
  ObjectTrade: 382,
  ObjectPurchase: 383,
  TaskInventoryCopyAll: 384,
  TaskInventoryCopied: 385,
  AgentTeleportAsk: 386,
  AgentTeleportAsked: 387,
  ObjectMenuTouch: 388,
  GroupMemberOptions: 400,
  GroupMemberOptionsList: 401,
  GroupChatHistoryRequest: 402,
  GroupChatHistory: 403,
  GroupNoticeReceive: 404,
  GroupNoticeAccept: 405,
  ConferenceSend: 406,
  ConferenceReceive: 407,
  EstateAccessRequest: 420,
  EstateAccessList: 421,
  EstateAccessChange: 422,
  ParcelEnvironmentReset: 423,
  OutfitWrite: 441,
  AvatarChoose: 442,
  AvatarChosen: 443,
  ProfileDetails: 444,
  ProfileDetailsUpdate: 445,
  AccountInfoRequest: 446,
  AccountInfo: 447,
  AccountPasswordChange: 448,
  AccountEmailChange: 449,
  AccountChangeResult: 450,
  ObjectWear: 451,
  UploadPriceRequest: 460,
  UploadPrice: 461,
  ObjectReturn: 462,
  ObjectRestore: 463,
  ParcelObjectsRequest: 464,
  ParcelObjects: 465,
  MapDestination: 466,
  SoundAdjust: 467,
  SoundQueue: 468,
  AvatarRenderReport: 480,
  AvatarRenderNotice: 481,
  AccountPreferencesRequest: 482,
  AccountPreferencesSet: 483,
  AccountPreferencesReply: 484,
  VoiceCallStart: 500,
  VoiceCallInvite: 501,
  VoiceCallJoin: 502,
  VoiceCallAnswer: 503,
  VoiceCallLeave: 504,
  VoiceCallEnded: 505,
  VoiceCallMembers: 506,
  InstantMessageStored: 507,
  ObjectInstantMessage: 508,
  GroupMembersPageRequest: 509,
  GroupMembersPage: 510,
  GroupLandRequest: 511,
  GroupLand: 512,
  GroupContributionSet: 513,
  GroupProfileChoice: 514,
  GroupProfileChoices: 515,
  TalkChoices: 516,
  EnvironmentDaySet: 520,
  EnvironmentInfoRequest: 521,
  EnvironmentInfo: 522,
  ParcelExtrasSet: 523,
  ParcelExtras: 524,
  LandSearchRequest: 525,
  LandSearchReply: 526,
  LandHoldingsRequest: 527,
  LandHoldingsReply: 528,
  FeaturedPlacesRequest: 529,
  FeaturedPlacesReply: 530,
  FeaturedPlaceSave: 531,
  FeaturedPlaceDelete: 532,
  RegionSpawnSet: 533,
  EstateCovenantRequest: 540,
  EstateCovenant: 541,
  ParcelTermsSet: 542,
  ParcelTerms: 543,
  ParcelBuyAgreed: 544,
  EventSearchRequest: 545,
  EventSearchReply: 546,
  RegionSkyLayersSet: 547,
  RegionSkyLayers: 548,
  TerrainRawUpload: 640,
  TerrainRawRequest: 641,
  TerrainRaw: 642,
  RegionExtrasRequest: 650,
  RegionExtras: 651,
  RegionExtrasSet: 652,
  TopObjectsRequest: 653,
  TopObjectsReply: 654,
  RegionObjectReturn: 655,
  InventoryFavourite: 620,
  ParcelScriptInfoRequest: 621,
  ParcelScriptInfo: 622,
  MapLevelTilesRequest: 580,
  MapLevelTilesReply: 581,
  MapLandRequest: 582,
  MapLandReply: 583,
  CurrencyBuy: 670,
  CurrencyBuyReply: 671,
  CurrencyBuyCheck: 672,
  LookPublish: 673,
  LookPublished: 674,
  LookWithdraw: 675,
  LibraryPublish: 677,
  StarterLookSet: 676,
  ObjectItemDescribe: 681,
  ObjectItemParts: 682,
  TerrainShape: 683,
  TerrainShaped: 684,
  BotMenu: 685,
  BotClick: 686,
  TerrainEditArea: 687,
  AgentStatus: 688,
};

/** The protocol revision each message came in: a region of an older one skips it. */
export const MESSAGE_SINCE: Record<MessageType, number> = {
  Ping: 1,
  Pong: 1,
  Disconnect: 1,
  Alert: 1,
  Kick: 1,
  LoginRequest: 1,
  LoginResponse: 1,
  LogoutRequest: 1,
  LogoutResponse: 1,
  CreateAccountRequest: 1,
  CreateAccountResponse: 1,
  RegionEnter: 1,
  RegionWelcome: 1,
  RegionReady: 1,
  RegionLeave: 1,
  RegionStatsUpdate: 1,
  NeighborRegions: 1,
  RegionInfoUpdate: 1,
  RegionSettingsUpdate: 1,
  LandHolding: 1,
  RegionRestartNotice: 1,
  TimeSync: 1,
  TerrainPatch: 1,
  TerrainEdit: 1,
  TerrainTexturesUpdate: 1,
  TerrainBake: 1,
  WindUpdate: 1,
  SkyUpdate: 1,
  WaterUpdate: 1,
  DayCycleUpdate: 1,
  EnvironmentSet: 1,
  ObjectAdd: 1,
  ObjectUpdate: 1,
  ObjectMoveBatch: 1,
  ObjectRemove: 1,
  ObjectCreate: 1,
  ObjectEdit: 1,
  ObjectSetShape: 1,
  ObjectSetFaces: 1,
  ObjectSetFlags: 1,
  ObjectSetNames: 1,
  ObjectSetText: 1,
  ObjectSetLight: 1,
  ObjectSetFlexible: 1,
  ObjectSetParticles: 1,
  ObjectSetMaterial: 1,
  ObjectSetPermissions: 1,
  ObjectLink: 1,
  ObjectUnlink: 1,
  ObjectDelete: 1,
  ObjectDuplicate: 1,
  ObjectSelect: 1,
  ObjectTake: 1,
  ObjectRez: 1,
  ObjectTouch: 1,
  ObjectGrab: 1,
  ObjectSit: 1,
  ObjectStand: 1,
  ObjectPay: 1,
  ObjectBuy: 1,
  ObjectSetMesh: 1,
  ObjectSetSit: 1,
  ObjectSetMedia: 1,
  ObjectAttach: 1,
  ObjectDetach: 1,
  ObjectSetOwner: 1,
  ObjectRequestFull: 1,
  ObjectSelected: 1,
  AgentInput: 1,
  AgentPoseBatch: 1,
  AgentJoin: 1,
  AgentLeave: 1,
  AgentAppearanceUpdate: 1,
  AgentSetAppearance: 1,
  AgentAnimationUpdate: 1,
  AgentAnimationPlay: 1,
  AgentTyping: 1,
  AgentAway: 1,
  AgentSit: 1,
  AgentHealth: 1,
  AgentTeleportRequest: 1,
  AgentTeleportStatus: 1,
  AgentTeleportLure: 1,
  AgentTeleportLureAccept: 1,
  AgentSetHome: 1,
  AgentTitleUpdate: 1,
  AgentCameraFollow: 1,
  AgentEffect: 1,
  AgentPushed: 1,
  AgentControlGrant: 1,
  AgentControlEvent: 1,
  ChatSend: 1,
  ChatReceive: 1,
  InstantMessageSend: 1,
  InstantMessageReceive: 1,
  ScriptDialogShow: 1,
  ScriptDialogReply: 1,
  Notification: 1,
  NotificationReply: 1,
  MuteUpdate: 1,
  MuteList: 1,
  TypingIndicator: 1,
  GestureActive: 1,
  InventoryFetch: 1,
  InventoryFolders: 1,
  InventoryItems: 1,
  InventoryFolderOp: 1,
  InventoryItemOp: 1,
  InventoryChanged: 1,
  InventoryGive: 1,
  InventoryOffer: 1,
  InventoryOfferReply: 1,
  TaskInventoryFetch: 1,
  TaskInventoryItems: 1,
  TaskInventoryOp: 1,
  WearableSet: 1,
  OutfitSave: 1,
  AssetRequest: 1,
  AssetHeader: 1,
  AssetChunk: 1,
  AssetCancel: 1,
  AssetUploadBegin: 1,
  AssetUploadChunk: 1,
  AssetUploadResult: 1,
  AssetUploadQuote: 1,
  ScriptSave: 1,
  ScriptSaveResult: 1,
  ScriptSetRunning: 1,
  ScriptReset: 1,
  ScriptRuntimeError: 1,
  ScriptFetchSource: 1,
  ScriptSource: 1,
  ScriptHudText: 1,
  ScriptPanelShow: 7,
  ScriptPanelHide: 7,
  ScriptPanelUse: 7,
  SoundPlay: 1,
  SoundStop: 1,
  SoundPreload: 1,
  AgentSoundPlay: 1,
  ParcelMediaCommand: 1,
  ParcelOverlay: 1,
  ParcelInfoRequest: 1,
  ParcelInfoReply: 1,
  ParcelUpdate: 1,
  ParcelDivide: 1,
  ParcelJoin: 1,
  ParcelBuy: 1,
  ParcelRelease: 1,
  ParcelAccessList: 1,
  ParcelReturnObjects: 1,
  ParcelObjectOwners: 1,
  ParcelEject: 1,
  ParcelFreeze: 1,
  ParcelAuctionStart: 1,
  ParcelAuctionBid: 1,
  ParcelAuctionCancel: 1,
  TaskInventoryTake: 1,
  InventoryTextSave: 1,
  ParcelMediaControl: 1,
  ParcelDeedToGroup: 1,
  MapRequest: 1,
  MapReply: 1,
  MapAgentsRequest: 1,
  MapAgentsReply: 1,
  LandmarkCreate: 1,
  PlacesRequest: 1,
  PlacesReply: 1,
  MapItemsRequest: 1,
  MapItemsReply: 1,
  AgentHome: 1,
  BalanceUpdate: 1,
  MoneyTransfer: 1,
  MoneyTransferResult: 1,
  TransactionHistoryRequest: 1,
  TransactionHistoryReply: 1,
  NameLookup: 1,
  NameReply: 1,
  ProfileRequest: 1,
  ProfileReply: 1,
  ProfileUpdate: 1,
  FriendList: 1,
  FriendRequest: 1,
  FriendRequestReply: 1,
  FriendRemove: 1,
  FriendPresenceUpdate: 1,
  FriendRights: 1,
  GroupList: 1,
  GroupCreate: 1,
  GroupCreateResult: 1,
  GroupInfoRequest: 1,
  GroupInfoReply: 1,
  GroupMembersRequest: 1,
  GroupMembersReply: 1,
  GroupActivate: 1,
  GroupUpdate: 1,
  GroupJoin: 1,
  GroupLeave: 1,
  GroupInvite: 1,
  GroupInviteReply: 1,
  GroupEject: 1,
  GroupRoleUpdate: 1,
  GroupMemberRole: 1,
  GroupTitleSet: 1,
  GroupNoticeSend: 1,
  GroupNoticesRequest: 1,
  GroupNoticesReply: 1,
  GroupChatSend: 1,
  GroupChatReceive: 1,
  GroupSearch: 1,
  GroupSearchReply: 1,
  SearchRequest: 1,
  SearchReply: 1,
  EventCreate: 1,
  ClassifiedCreate: 1,
  SearchListingDelete: 1,
  VoiceJoin: 1,
  VoiceAnswer: 1,
  VoiceSlots: 1,
  VoiceLeave: 1,
  VoiceActivity: 1,
  ExperienceSave: 1,
  ExperienceListRequest: 1,
  ExperienceList: 1,
  ExperienceAnswer: 1,
  MarketListRequest: 1,
  MarketList: 1,
  MarketListingSave: 1,
  MarketBuy: 1,
  MarketResult: 1,
  EstateUpdate: 1,
  EstateKick: 1,
  EstateMessage: 1,
  EstateRestart: 1,
  EstateTeleportHome: 1,
  GodRequest: 1,
  GodGrant: 1,
  AdminObjectReturn: 1,
  AdminObjectAction: 1,
  StaffAction: 1,
  StaffActionReply: 1,
  TopScriptsRequest: 1,
  TopScriptsReply: 1,
  ObjectHudAttach: 1,
  ClientStatsReport: 1,
  AbuseReport: 1,
  AbuseReportAck: 1,
  DetectedReport: 1,
  CameraConstraint: 1,
  ViewerEffectSpawn: 1,
  TerrainRequest: 1,
  FriendLocateRequest: 1,
  FriendLocateReply: 1,
  MapParcelRequest: 1,
  MapParcelReply: 1,
  AgentControlsRelease: 1,
  ObjectHandOff: 1,
  VehicleFlags: 1,
  AttachmentWear: 1,
  AgentSetHover: 1,
  AgentAnimationStopAll: 1,
  AgentDoNotDisturb: 1,
  ProfileExtrasRequest: 1,
  ProfileExtras: 1,
  PickSave: 1,
  PickDelete: 1,
  ProfileNotesSave: 1,
  ObjectTouchAt: 1,
  ObjectSetSaleType: 1,
  ObjectTradeRequest: 1,
  ObjectTrade: 1,
  ObjectPurchase: 1,
  TaskInventoryCopyAll: 1,
  TaskInventoryCopied: 1,
  AgentTeleportAsk: 1,
  AgentTeleportAsked: 1,
  ObjectMenuTouch: 1,
  GroupMemberOptions: 1,
  GroupMemberOptionsList: 1,
  GroupChatHistoryRequest: 1,
  GroupChatHistory: 1,
  GroupNoticeReceive: 1,
  GroupNoticeAccept: 1,
  ConferenceSend: 1,
  ConferenceReceive: 1,
  EstateAccessRequest: 1,
  EstateAccessList: 1,
  EstateAccessChange: 1,
  ParcelEnvironmentReset: 1,
  OutfitWrite: 1,
  AvatarChoose: 1,
  AvatarChosen: 1,
  ProfileDetails: 1,
  ProfileDetailsUpdate: 1,
  AccountInfoRequest: 1,
  AccountInfo: 1,
  AccountPasswordChange: 1,
  AccountEmailChange: 1,
  AccountChangeResult: 1,
  ObjectWear: 1,
  UploadPriceRequest: 1,
  UploadPrice: 1,
  ObjectReturn: 1,
  ObjectRestore: 1,
  ParcelObjectsRequest: 1,
  ParcelObjects: 1,
  MapDestination: 1,
  SoundAdjust: 1,
  SoundQueue: 1,
  AvatarRenderReport: 1,
  AvatarRenderNotice: 1,
  AccountPreferencesRequest: 1,
  AccountPreferencesSet: 1,
  AccountPreferencesReply: 1,
  VoiceCallStart: 1,
  VoiceCallInvite: 1,
  VoiceCallJoin: 1,
  VoiceCallAnswer: 1,
  VoiceCallLeave: 1,
  VoiceCallEnded: 1,
  VoiceCallMembers: 1,
  InstantMessageStored: 1,
  ObjectInstantMessage: 1,
  GroupMembersPageRequest: 1,
  GroupMembersPage: 1,
  GroupLandRequest: 1,
  GroupLand: 1,
  GroupContributionSet: 1,
  GroupProfileChoice: 1,
  GroupProfileChoices: 1,
  TalkChoices: 1,
  EnvironmentDaySet: 1,
  EnvironmentInfoRequest: 1,
  EnvironmentInfo: 1,
  ParcelExtrasSet: 1,
  ParcelExtras: 1,
  LandSearchRequest: 1,
  LandSearchReply: 1,
  LandHoldingsRequest: 1,
  LandHoldingsReply: 1,
  FeaturedPlacesRequest: 1,
  FeaturedPlacesReply: 1,
  FeaturedPlaceSave: 1,
  FeaturedPlaceDelete: 1,
  RegionSpawnSet: 1,
  EstateCovenantRequest: 1,
  EstateCovenant: 1,
  ParcelTermsSet: 1,
  ParcelTerms: 1,
  ParcelBuyAgreed: 1,
  EventSearchRequest: 1,
  EventSearchReply: 1,
  RegionSkyLayersSet: 1,
  RegionSkyLayers: 1,
  TerrainRawUpload: 1,
  TerrainRawRequest: 1,
  TerrainRaw: 1,
  RegionExtrasRequest: 1,
  RegionExtras: 1,
  RegionExtrasSet: 1,
  TopObjectsRequest: 1,
  TopObjectsReply: 1,
  RegionObjectReturn: 1,
  InventoryFavourite: 1,
  ParcelScriptInfoRequest: 1,
  ParcelScriptInfo: 1,
  MapLevelTilesRequest: 1,
  MapLevelTilesReply: 1,
  MapLandRequest: 1,
  MapLandReply: 1,
  CurrencyBuy: 1,
  CurrencyBuyReply: 1,
  CurrencyBuyCheck: 1,
  LookPublish: 1,
  LookPublished: 1,
  LookWithdraw: 1,
  LibraryPublish: 1,
  StarterLookSet: 1,
  ObjectItemDescribe: 3,
  ObjectItemParts: 3,
  TerrainShape: 4,
  TerrainShaped: 4,
  BotMenu: 10,
  BotClick: 10,
  TerrainEditArea: 13,
  AgentStatus: 14,
};

export const MESSAGE_CHANNELS: Record<MessageType, Channel> = {
  Ping: Channel.Unreliable,
  Pong: Channel.Unreliable,
  Disconnect: Channel.Reliable,
  Alert: Channel.Reliable,
  Kick: Channel.Reliable,
  LoginRequest: Channel.Reliable,
  LoginResponse: Channel.Reliable,
  LogoutRequest: Channel.Reliable,
  LogoutResponse: Channel.Reliable,
  CreateAccountRequest: Channel.Reliable,
  CreateAccountResponse: Channel.Reliable,
  RegionEnter: Channel.Reliable,
  RegionWelcome: Channel.Reliable,
  RegionReady: Channel.Reliable,
  RegionLeave: Channel.Reliable,
  RegionStatsUpdate: Channel.Unreliable,
  NeighborRegions: Channel.Reliable,
  RegionInfoUpdate: Channel.Reliable,
  RegionSettingsUpdate: Channel.Reliable,
  LandHolding: Channel.Reliable,
  RegionRestartNotice: Channel.Reliable,
  TimeSync: Channel.Unreliable,
  TerrainPatch: Channel.Reliable,
  TerrainEdit: Channel.Reliable,
  TerrainTexturesUpdate: Channel.Reliable,
  TerrainBake: Channel.Reliable,
  WindUpdate: Channel.Unreliable,
  SkyUpdate: Channel.Reliable,
  WaterUpdate: Channel.Reliable,
  DayCycleUpdate: Channel.Reliable,
  EnvironmentSet: Channel.Reliable,
  ObjectAdd: Channel.Reliable,
  ObjectUpdate: Channel.Reliable,
  ObjectMoveBatch: Channel.Unreliable,
  ObjectRemove: Channel.Reliable,
  ObjectCreate: Channel.Reliable,
  ObjectEdit: Channel.Reliable,
  ObjectSetShape: Channel.Reliable,
  ObjectSetFaces: Channel.Reliable,
  ObjectSetFlags: Channel.Reliable,
  ObjectSetNames: Channel.Reliable,
  ObjectSetText: Channel.Reliable,
  ObjectSetLight: Channel.Reliable,
  ObjectSetFlexible: Channel.Reliable,
  ObjectSetParticles: Channel.Reliable,
  ObjectSetMaterial: Channel.Reliable,
  ObjectSetPermissions: Channel.Reliable,
  ObjectLink: Channel.Reliable,
  ObjectUnlink: Channel.Reliable,
  ObjectDelete: Channel.Reliable,
  ObjectDuplicate: Channel.Reliable,
  ObjectSelect: Channel.Reliable,
  ObjectTake: Channel.Reliable,
  ObjectRez: Channel.Reliable,
  ObjectTouch: Channel.Reliable,
  ObjectGrab: Channel.Unreliable,
  ObjectSit: Channel.Reliable,
  ObjectStand: Channel.Reliable,
  ObjectPay: Channel.Reliable,
  ObjectBuy: Channel.Reliable,
  ObjectSetMesh: Channel.Reliable,
  ObjectSetSit: Channel.Reliable,
  ObjectSetMedia: Channel.Reliable,
  ObjectAttach: Channel.Reliable,
  ObjectDetach: Channel.Reliable,
  ObjectSetOwner: Channel.Reliable,
  ObjectRequestFull: Channel.Reliable,
  ObjectSelected: Channel.Reliable,
  AgentInput: Channel.Unreliable,
  AgentPoseBatch: Channel.Unreliable,
  AgentJoin: Channel.Reliable,
  AgentLeave: Channel.Reliable,
  AgentAppearanceUpdate: Channel.Reliable,
  AgentSetAppearance: Channel.Reliable,
  AgentAnimationUpdate: Channel.Reliable,
  AgentAnimationPlay: Channel.Reliable,
  AgentTyping: Channel.Reliable,
  AgentAway: Channel.Reliable,
  AgentSit: Channel.Reliable,
  AgentHealth: Channel.Reliable,
  AgentTeleportRequest: Channel.Reliable,
  AgentTeleportStatus: Channel.Reliable,
  AgentTeleportLure: Channel.Reliable,
  AgentTeleportLureAccept: Channel.Reliable,
  AgentSetHome: Channel.Reliable,
  AgentTitleUpdate: Channel.Reliable,
  AgentCameraFollow: Channel.Reliable,
  AgentEffect: Channel.Unreliable,
  AgentPushed: Channel.Reliable,
  AgentControlGrant: Channel.Reliable,
  AgentControlEvent: Channel.Unreliable,
  ChatSend: Channel.Reliable,
  ChatReceive: Channel.Reliable,
  InstantMessageSend: Channel.Reliable,
  InstantMessageReceive: Channel.Reliable,
  ScriptDialogShow: Channel.Reliable,
  ScriptDialogReply: Channel.Reliable,
  Notification: Channel.Reliable,
  NotificationReply: Channel.Reliable,
  MuteUpdate: Channel.Reliable,
  MuteList: Channel.Reliable,
  TypingIndicator: Channel.Unreliable,
  GestureActive: Channel.Reliable,
  InventoryFetch: Channel.Reliable,
  InventoryFolders: Channel.Reliable,
  InventoryItems: Channel.Reliable,
  InventoryFolderOp: Channel.Reliable,
  InventoryItemOp: Channel.Reliable,
  InventoryChanged: Channel.Reliable,
  InventoryGive: Channel.Reliable,
  InventoryOffer: Channel.Reliable,
  InventoryOfferReply: Channel.Reliable,
  TaskInventoryFetch: Channel.Reliable,
  TaskInventoryItems: Channel.Reliable,
  TaskInventoryOp: Channel.Reliable,
  WearableSet: Channel.Reliable,
  OutfitSave: Channel.Reliable,
  AssetRequest: Channel.Bulk,
  AssetHeader: Channel.Bulk,
  AssetChunk: Channel.Bulk,
  AssetCancel: Channel.Bulk,
  AssetUploadBegin: Channel.Bulk,
  AssetUploadChunk: Channel.Bulk,
  AssetUploadResult: Channel.Bulk,
  AssetUploadQuote: Channel.Bulk,
  ScriptSave: Channel.Reliable,
  ScriptSaveResult: Channel.Reliable,
  ScriptSetRunning: Channel.Reliable,
  ScriptReset: Channel.Reliable,
  ScriptRuntimeError: Channel.Reliable,
  ScriptFetchSource: Channel.Reliable,
  ScriptSource: Channel.Reliable,
  ScriptHudText: Channel.Reliable,
  ScriptPanelShow: Channel.Reliable,
  ScriptPanelHide: Channel.Reliable,
  ScriptPanelUse: Channel.Reliable,
  SoundPlay: Channel.Reliable,
  SoundStop: Channel.Reliable,
  SoundPreload: Channel.Reliable,
  AgentSoundPlay: Channel.Reliable,
  ParcelMediaCommand: Channel.Reliable,
  ParcelOverlay: Channel.Reliable,
  ParcelInfoRequest: Channel.Reliable,
  ParcelInfoReply: Channel.Reliable,
  ParcelUpdate: Channel.Reliable,
  ParcelDivide: Channel.Reliable,
  ParcelJoin: Channel.Reliable,
  ParcelBuy: Channel.Reliable,
  ParcelRelease: Channel.Reliable,
  ParcelAccessList: Channel.Reliable,
  ParcelReturnObjects: Channel.Reliable,
  ParcelObjectOwners: Channel.Reliable,
  ParcelEject: Channel.Reliable,
  ParcelFreeze: Channel.Reliable,
  ParcelAuctionStart: Channel.Reliable,
  ParcelAuctionBid: Channel.Reliable,
  ParcelAuctionCancel: Channel.Reliable,
  TaskInventoryTake: Channel.Reliable,
  InventoryTextSave: Channel.Reliable,
  ParcelMediaControl: Channel.Reliable,
  ParcelDeedToGroup: Channel.Reliable,
  MapRequest: Channel.Reliable,
  MapReply: Channel.Reliable,
  MapAgentsRequest: Channel.Reliable,
  MapAgentsReply: Channel.Reliable,
  LandmarkCreate: Channel.Reliable,
  PlacesRequest: Channel.Reliable,
  PlacesReply: Channel.Reliable,
  MapItemsRequest: Channel.Reliable,
  MapItemsReply: Channel.Reliable,
  AgentHome: Channel.Reliable,
  BalanceUpdate: Channel.Reliable,
  MoneyTransfer: Channel.Reliable,
  MoneyTransferResult: Channel.Reliable,
  TransactionHistoryRequest: Channel.Reliable,
  TransactionHistoryReply: Channel.Reliable,
  NameLookup: Channel.Reliable,
  NameReply: Channel.Reliable,
  ProfileRequest: Channel.Reliable,
  ProfileReply: Channel.Reliable,
  ProfileUpdate: Channel.Reliable,
  FriendList: Channel.Reliable,
  FriendRequest: Channel.Reliable,
  FriendRequestReply: Channel.Reliable,
  FriendRemove: Channel.Reliable,
  FriendPresenceUpdate: Channel.Reliable,
  FriendRights: Channel.Reliable,
  GroupList: Channel.Reliable,
  GroupCreate: Channel.Reliable,
  GroupCreateResult: Channel.Reliable,
  GroupInfoRequest: Channel.Reliable,
  GroupInfoReply: Channel.Reliable,
  GroupMembersRequest: Channel.Reliable,
  GroupMembersReply: Channel.Reliable,
  GroupActivate: Channel.Reliable,
  GroupUpdate: Channel.Reliable,
  GroupJoin: Channel.Reliable,
  GroupLeave: Channel.Reliable,
  GroupInvite: Channel.Reliable,
  GroupInviteReply: Channel.Reliable,
  GroupEject: Channel.Reliable,
  GroupRoleUpdate: Channel.Reliable,
  GroupMemberRole: Channel.Reliable,
  GroupTitleSet: Channel.Reliable,
  GroupNoticeSend: Channel.Reliable,
  GroupNoticesRequest: Channel.Reliable,
  GroupNoticesReply: Channel.Reliable,
  GroupChatSend: Channel.Reliable,
  GroupChatReceive: Channel.Reliable,
  GroupSearch: Channel.Reliable,
  GroupSearchReply: Channel.Reliable,
  SearchRequest: Channel.Reliable,
  SearchReply: Channel.Reliable,
  EventCreate: Channel.Reliable,
  ClassifiedCreate: Channel.Reliable,
  SearchListingDelete: Channel.Reliable,
  VoiceJoin: Channel.Reliable,
  VoiceAnswer: Channel.Reliable,
  VoiceSlots: Channel.Reliable,
  VoiceLeave: Channel.Reliable,
  VoiceActivity: Channel.Unreliable,
  ExperienceSave: Channel.Reliable,
  ExperienceListRequest: Channel.Reliable,
  ExperienceList: Channel.Reliable,
  ExperienceAnswer: Channel.Reliable,
  MarketListRequest: Channel.Reliable,
  MarketList: Channel.Reliable,
  MarketListingSave: Channel.Reliable,
  MarketBuy: Channel.Reliable,
  MarketResult: Channel.Reliable,
  EstateUpdate: Channel.Reliable,
  EstateKick: Channel.Reliable,
  EstateMessage: Channel.Reliable,
  EstateRestart: Channel.Reliable,
  EstateTeleportHome: Channel.Reliable,
  GodRequest: Channel.Reliable,
  GodGrant: Channel.Reliable,
  AdminObjectReturn: Channel.Reliable,
  AdminObjectAction: Channel.Reliable,
  StaffAction: Channel.Reliable,
  StaffActionReply: Channel.Reliable,
  TopScriptsRequest: Channel.Reliable,
  TopScriptsReply: Channel.Reliable,
  ObjectHudAttach: Channel.Reliable,
  ClientStatsReport: Channel.Unreliable,
  AbuseReport: Channel.Reliable,
  AbuseReportAck: Channel.Reliable,
  DetectedReport: Channel.Reliable,
  CameraConstraint: Channel.Reliable,
  ViewerEffectSpawn: Channel.Reliable,
  TerrainRequest: Channel.Reliable,
  FriendLocateRequest: Channel.Reliable,
  FriendLocateReply: Channel.Reliable,
  MapParcelRequest: Channel.Reliable,
  MapParcelReply: Channel.Reliable,
  AgentControlsRelease: Channel.Reliable,
  ObjectHandOff: Channel.Reliable,
  VehicleFlags: Channel.Reliable,
  AttachmentWear: Channel.Reliable,
  AgentSetHover: Channel.Reliable,
  AgentAnimationStopAll: Channel.Reliable,
  AgentDoNotDisturb: Channel.Reliable,
  ProfileExtrasRequest: Channel.Reliable,
  ProfileExtras: Channel.Reliable,
  PickSave: Channel.Reliable,
  PickDelete: Channel.Reliable,
  ProfileNotesSave: Channel.Reliable,
  ObjectTouchAt: Channel.Reliable,
  ObjectSetSaleType: Channel.Reliable,
  ObjectTradeRequest: Channel.Reliable,
  ObjectTrade: Channel.Reliable,
  ObjectPurchase: Channel.Reliable,
  TaskInventoryCopyAll: Channel.Reliable,
  TaskInventoryCopied: Channel.Reliable,
  AgentTeleportAsk: Channel.Reliable,
  AgentTeleportAsked: Channel.Reliable,
  ObjectMenuTouch: Channel.Reliable,
  GroupMemberOptions: Channel.Reliable,
  GroupMemberOptionsList: Channel.Reliable,
  GroupChatHistoryRequest: Channel.Reliable,
  GroupChatHistory: Channel.Reliable,
  GroupNoticeReceive: Channel.Reliable,
  GroupNoticeAccept: Channel.Reliable,
  ConferenceSend: Channel.Reliable,
  ConferenceReceive: Channel.Reliable,
  EstateAccessRequest: Channel.Reliable,
  EstateAccessList: Channel.Reliable,
  EstateAccessChange: Channel.Reliable,
  ParcelEnvironmentReset: Channel.Reliable,
  OutfitWrite: Channel.Reliable,
  AvatarChoose: Channel.Reliable,
  AvatarChosen: Channel.Reliable,
  ProfileDetails: Channel.Reliable,
  ProfileDetailsUpdate: Channel.Reliable,
  AccountInfoRequest: Channel.Reliable,
  AccountInfo: Channel.Reliable,
  AccountPasswordChange: Channel.Reliable,
  AccountEmailChange: Channel.Reliable,
  AccountChangeResult: Channel.Reliable,
  ObjectWear: Channel.Reliable,
  UploadPriceRequest: Channel.Reliable,
  UploadPrice: Channel.Reliable,
  ObjectReturn: Channel.Reliable,
  ObjectRestore: Channel.Reliable,
  ParcelObjectsRequest: Channel.Reliable,
  ParcelObjects: Channel.Reliable,
  MapDestination: Channel.Reliable,
  SoundAdjust: Channel.Reliable,
  SoundQueue: Channel.Reliable,
  AvatarRenderReport: Channel.Reliable,
  AvatarRenderNotice: Channel.Reliable,
  AccountPreferencesRequest: Channel.Reliable,
  AccountPreferencesSet: Channel.Reliable,
  AccountPreferencesReply: Channel.Reliable,
  VoiceCallStart: Channel.Reliable,
  VoiceCallInvite: Channel.Reliable,
  VoiceCallJoin: Channel.Reliable,
  VoiceCallAnswer: Channel.Reliable,
  VoiceCallLeave: Channel.Reliable,
  VoiceCallEnded: Channel.Reliable,
  VoiceCallMembers: Channel.Reliable,
  InstantMessageStored: Channel.Reliable,
  ObjectInstantMessage: Channel.Reliable,
  GroupMembersPageRequest: Channel.Reliable,
  GroupMembersPage: Channel.Reliable,
  GroupLandRequest: Channel.Reliable,
  GroupLand: Channel.Reliable,
  GroupContributionSet: Channel.Reliable,
  GroupProfileChoice: Channel.Reliable,
  GroupProfileChoices: Channel.Reliable,
  TalkChoices: Channel.Reliable,
  EnvironmentDaySet: Channel.Reliable,
  EnvironmentInfoRequest: Channel.Reliable,
  EnvironmentInfo: Channel.Reliable,
  ParcelExtrasSet: Channel.Reliable,
  ParcelExtras: Channel.Reliable,
  LandSearchRequest: Channel.Reliable,
  LandSearchReply: Channel.Reliable,
  LandHoldingsRequest: Channel.Reliable,
  LandHoldingsReply: Channel.Reliable,
  FeaturedPlacesRequest: Channel.Reliable,
  FeaturedPlacesReply: Channel.Reliable,
  FeaturedPlaceSave: Channel.Reliable,
  FeaturedPlaceDelete: Channel.Reliable,
  RegionSpawnSet: Channel.Reliable,
  EstateCovenantRequest: Channel.Reliable,
  EstateCovenant: Channel.Reliable,
  ParcelTermsSet: Channel.Reliable,
  ParcelTerms: Channel.Reliable,
  ParcelBuyAgreed: Channel.Reliable,
  EventSearchRequest: Channel.Reliable,
  EventSearchReply: Channel.Reliable,
  RegionSkyLayersSet: Channel.Reliable,
  RegionSkyLayers: Channel.Reliable,
  TerrainRawUpload: Channel.Bulk,
  TerrainRawRequest: Channel.Reliable,
  TerrainRaw: Channel.Bulk,
  RegionExtrasRequest: Channel.Reliable,
  RegionExtras: Channel.Reliable,
  RegionExtrasSet: Channel.Reliable,
  TopObjectsRequest: Channel.Reliable,
  TopObjectsReply: Channel.Reliable,
  RegionObjectReturn: Channel.Reliable,
  InventoryFavourite: Channel.Reliable,
  ParcelScriptInfoRequest: Channel.Reliable,
  ParcelScriptInfo: Channel.Reliable,
  MapLevelTilesRequest: Channel.Reliable,
  MapLevelTilesReply: Channel.Reliable,
  MapLandRequest: Channel.Reliable,
  MapLandReply: Channel.Reliable,
  CurrencyBuy: Channel.Reliable,
  CurrencyBuyReply: Channel.Reliable,
  CurrencyBuyCheck: Channel.Reliable,
  LookPublish: Channel.Reliable,
  LookPublished: Channel.Reliable,
  LookWithdraw: Channel.Reliable,
  LibraryPublish: Channel.Reliable,
  StarterLookSet: Channel.Reliable,
  ObjectItemDescribe: Channel.Reliable,
  ObjectItemParts: Channel.Reliable,
  TerrainShape: Channel.Bulk,
  TerrainShaped: Channel.Reliable,
  BotMenu: Channel.Reliable,
  BotClick: Channel.Reliable,
  TerrainEditArea: Channel.Reliable,
  AgentStatus: Channel.Reliable,
};

export function messageName(id: number): string {
  switch (id) {
    case 1: return "Ping";
    case 2: return "Pong";
    case 3: return "Disconnect";
    case 4: return "Alert";
    case 5: return "Kick";
    case 10: return "LoginRequest";
    case 11: return "LoginResponse";
    case 12: return "LogoutRequest";
    case 13: return "LogoutResponse";
    case 14: return "CreateAccountRequest";
    case 15: return "CreateAccountResponse";
    case 20: return "RegionEnter";
    case 21: return "RegionWelcome";
    case 22: return "RegionReady";
    case 23: return "RegionLeave";
    case 24: return "RegionStatsUpdate";
    case 25: return "NeighborRegions";
    case 26: return "RegionInfoUpdate";
    case 27: return "RegionSettingsUpdate";
    case 306: return "LandHolding";
    case 28: return "RegionRestartNotice";
    case 29: return "TimeSync";
    case 30: return "TerrainPatch";
    case 31: return "TerrainEdit";
    case 32: return "TerrainTexturesUpdate";
    case 33: return "TerrainBake";
    case 34: return "WindUpdate";
    case 40: return "SkyUpdate";
    case 41: return "WaterUpdate";
    case 42: return "DayCycleUpdate";
    case 43: return "EnvironmentSet";
    case 50: return "ObjectAdd";
    case 51: return "ObjectUpdate";
    case 52: return "ObjectMoveBatch";
    case 53: return "ObjectRemove";
    case 54: return "ObjectCreate";
    case 55: return "ObjectEdit";
    case 56: return "ObjectSetShape";
    case 57: return "ObjectSetFaces";
    case 58: return "ObjectSetFlags";
    case 59: return "ObjectSetNames";
    case 60: return "ObjectSetText";
    case 61: return "ObjectSetLight";
    case 62: return "ObjectSetFlexible";
    case 63: return "ObjectSetParticles";
    case 64: return "ObjectSetMaterial";
    case 65: return "ObjectSetPermissions";
    case 66: return "ObjectLink";
    case 67: return "ObjectUnlink";
    case 68: return "ObjectDelete";
    case 69: return "ObjectDuplicate";
    case 70: return "ObjectSelect";
    case 71: return "ObjectTake";
    case 72: return "ObjectRez";
    case 73: return "ObjectTouch";
    case 74: return "ObjectGrab";
    case 75: return "ObjectSit";
    case 76: return "ObjectStand";
    case 77: return "ObjectPay";
    case 78: return "ObjectBuy";
    case 79: return "ObjectSetMesh";
    case 80: return "ObjectSetSit";
    case 81: return "ObjectSetMedia";
    case 82: return "ObjectAttach";
    case 83: return "ObjectDetach";
    case 84: return "ObjectSetOwner";
    case 85: return "ObjectRequestFull";
    case 86: return "ObjectSelected";
    case 100: return "AgentInput";
    case 101: return "AgentPoseBatch";
    case 102: return "AgentJoin";
    case 103: return "AgentLeave";
    case 104: return "AgentAppearanceUpdate";
    case 105: return "AgentSetAppearance";
    case 106: return "AgentAnimationUpdate";
    case 107: return "AgentAnimationPlay";
    case 108: return "AgentTyping";
    case 109: return "AgentAway";
    case 110: return "AgentSit";
    case 111: return "AgentHealth";
    case 112: return "AgentTeleportRequest";
    case 113: return "AgentTeleportStatus";
    case 114: return "AgentTeleportLure";
    case 115: return "AgentTeleportLureAccept";
    case 116: return "AgentSetHome";
    case 117: return "AgentTitleUpdate";
    case 118: return "AgentCameraFollow";
    case 119: return "AgentEffect";
    case 120: return "AgentPushed";
    case 121: return "AgentControlGrant";
    case 122: return "AgentControlEvent";
    case 130: return "ChatSend";
    case 131: return "ChatReceive";
    case 132: return "InstantMessageSend";
    case 133: return "InstantMessageReceive";
    case 134: return "ScriptDialogShow";
    case 135: return "ScriptDialogReply";
    case 136: return "Notification";
    case 137: return "NotificationReply";
    case 138: return "MuteUpdate";
    case 139: return "MuteList";
    case 140: return "TypingIndicator";
    case 141: return "GestureActive";
    case 150: return "InventoryFetch";
    case 151: return "InventoryFolders";
    case 152: return "InventoryItems";
    case 153: return "InventoryFolderOp";
    case 154: return "InventoryItemOp";
    case 155: return "InventoryChanged";
    case 156: return "InventoryGive";
    case 157: return "InventoryOffer";
    case 158: return "InventoryOfferReply";
    case 159: return "TaskInventoryFetch";
    case 160: return "TaskInventoryItems";
    case 161: return "TaskInventoryOp";
    case 162: return "WearableSet";
    case 163: return "OutfitSave";
    case 170: return "AssetRequest";
    case 171: return "AssetHeader";
    case 172: return "AssetChunk";
    case 173: return "AssetCancel";
    case 174: return "AssetUploadBegin";
    case 175: return "AssetUploadChunk";
    case 176: return "AssetUploadResult";
    case 177: return "AssetUploadQuote";
    case 180: return "ScriptSave";
    case 181: return "ScriptSaveResult";
    case 182: return "ScriptSetRunning";
    case 183: return "ScriptReset";
    case 184: return "ScriptRuntimeError";
    case 185: return "ScriptFetchSource";
    case 186: return "ScriptSource";
    case 187: return "ScriptHudText";
    case 188: return "ScriptPanelShow";
    case 189: return "ScriptPanelHide";
    case 195: return "ScriptPanelUse";
    case 190: return "SoundPlay";
    case 191: return "SoundStop";
    case 192: return "SoundPreload";
    case 194: return "AgentSoundPlay";
    case 193: return "ParcelMediaCommand";
    case 200: return "ParcelOverlay";
    case 201: return "ParcelInfoRequest";
    case 202: return "ParcelInfoReply";
    case 203: return "ParcelUpdate";
    case 204: return "ParcelDivide";
    case 205: return "ParcelJoin";
    case 206: return "ParcelBuy";
    case 207: return "ParcelRelease";
    case 208: return "ParcelAccessList";
    case 209: return "ParcelReturnObjects";
    case 210: return "ParcelObjectOwners";
    case 211: return "ParcelEject";
    case 212: return "ParcelFreeze";
    case 307: return "ParcelAuctionStart";
    case 308: return "ParcelAuctionBid";
    case 309: return "ParcelAuctionCancel";
    case 310: return "TaskInventoryTake";
    case 312: return "InventoryTextSave";
    case 311: return "ParcelMediaControl";
    case 213: return "ParcelDeedToGroup";
    case 220: return "MapRequest";
    case 221: return "MapReply";
    case 222: return "MapAgentsRequest";
    case 223: return "MapAgentsReply";
    case 224: return "LandmarkCreate";
    case 225: return "PlacesRequest";
    case 226: return "PlacesReply";
    case 227: return "MapItemsRequest";
    case 228: return "MapItemsReply";
    case 229: return "AgentHome";
    case 230: return "BalanceUpdate";
    case 231: return "MoneyTransfer";
    case 232: return "MoneyTransferResult";
    case 233: return "TransactionHistoryRequest";
    case 234: return "TransactionHistoryReply";
    case 240: return "NameLookup";
    case 241: return "NameReply";
    case 242: return "ProfileRequest";
    case 243: return "ProfileReply";
    case 244: return "ProfileUpdate";
    case 245: return "FriendList";
    case 246: return "FriendRequest";
    case 247: return "FriendRequestReply";
    case 248: return "FriendRemove";
    case 249: return "FriendPresenceUpdate";
    case 250: return "FriendRights";
    case 260: return "GroupList";
    case 261: return "GroupCreate";
    case 262: return "GroupCreateResult";
    case 263: return "GroupInfoRequest";
    case 264: return "GroupInfoReply";
    case 265: return "GroupMembersRequest";
    case 266: return "GroupMembersReply";
    case 267: return "GroupActivate";
    case 268: return "GroupUpdate";
    case 269: return "GroupJoin";
    case 270: return "GroupLeave";
    case 271: return "GroupInvite";
    case 272: return "GroupInviteReply";
    case 273: return "GroupEject";
    case 274: return "GroupRoleUpdate";
    case 275: return "GroupMemberRole";
    case 276: return "GroupTitleSet";
    case 277: return "GroupNoticeSend";
    case 278: return "GroupNoticesRequest";
    case 279: return "GroupNoticesReply";
    case 280: return "GroupChatSend";
    case 281: return "GroupChatReceive";
    case 282: return "GroupSearch";
    case 283: return "GroupSearchReply";
    case 315: return "SearchRequest";
    case 316: return "SearchReply";
    case 317: return "EventCreate";
    case 318: return "ClassifiedCreate";
    case 319: return "SearchListingDelete";
    case 320: return "VoiceJoin";
    case 321: return "VoiceAnswer";
    case 322: return "VoiceSlots";
    case 323: return "VoiceLeave";
    case 324: return "VoiceActivity";
    case 325: return "ExperienceSave";
    case 326: return "ExperienceListRequest";
    case 327: return "ExperienceList";
    case 328: return "ExperienceAnswer";
    case 329: return "MarketListRequest";
    case 330: return "MarketList";
    case 331: return "MarketListingSave";
    case 332: return "MarketBuy";
    case 333: return "MarketResult";
    case 290: return "EstateUpdate";
    case 291: return "EstateKick";
    case 292: return "EstateMessage";
    case 293: return "EstateRestart";
    case 294: return "EstateTeleportHome";
    case 295: return "GodRequest";
    case 296: return "GodGrant";
    case 297: return "AdminObjectReturn";
    case 678: return "AdminObjectAction";
    case 679: return "StaffAction";
    case 680: return "StaffActionReply";
    case 298: return "TopScriptsRequest";
    case 299: return "TopScriptsReply";
    case 300: return "ObjectHudAttach";
    case 301: return "ClientStatsReport";
    case 313: return "AbuseReport";
    case 314: return "AbuseReportAck";
    case 302: return "DetectedReport";
    case 303: return "CameraConstraint";
    case 304: return "ViewerEffectSpawn";
    case 305: return "TerrainRequest";
    case 334: return "FriendLocateRequest";
    case 335: return "FriendLocateReply";
    case 336: return "MapParcelRequest";
    case 337: return "MapParcelReply";
    case 338: return "AgentControlsRelease";
    case 339: return "ObjectHandOff";
    case 340: return "VehicleFlags";
    case 341: return "AttachmentWear";
    case 342: return "AgentSetHover";
    case 343: return "AgentAnimationStopAll";
    case 344: return "AgentDoNotDisturb";
    case 345: return "ProfileExtrasRequest";
    case 346: return "ProfileExtras";
    case 347: return "PickSave";
    case 348: return "PickDelete";
    case 349: return "ProfileNotesSave";
    case 360: return "ObjectTouchAt";
    case 380: return "ObjectSetSaleType";
    case 381: return "ObjectTradeRequest";
    case 382: return "ObjectTrade";
    case 383: return "ObjectPurchase";
    case 384: return "TaskInventoryCopyAll";
    case 385: return "TaskInventoryCopied";
    case 386: return "AgentTeleportAsk";
    case 387: return "AgentTeleportAsked";
    case 388: return "ObjectMenuTouch";
    case 400: return "GroupMemberOptions";
    case 401: return "GroupMemberOptionsList";
    case 402: return "GroupChatHistoryRequest";
    case 403: return "GroupChatHistory";
    case 404: return "GroupNoticeReceive";
    case 405: return "GroupNoticeAccept";
    case 406: return "ConferenceSend";
    case 407: return "ConferenceReceive";
    case 420: return "EstateAccessRequest";
    case 421: return "EstateAccessList";
    case 422: return "EstateAccessChange";
    case 423: return "ParcelEnvironmentReset";
    case 441: return "OutfitWrite";
    case 442: return "AvatarChoose";
    case 443: return "AvatarChosen";
    case 444: return "ProfileDetails";
    case 445: return "ProfileDetailsUpdate";
    case 446: return "AccountInfoRequest";
    case 447: return "AccountInfo";
    case 448: return "AccountPasswordChange";
    case 449: return "AccountEmailChange";
    case 450: return "AccountChangeResult";
    case 451: return "ObjectWear";
    case 460: return "UploadPriceRequest";
    case 461: return "UploadPrice";
    case 462: return "ObjectReturn";
    case 463: return "ObjectRestore";
    case 464: return "ParcelObjectsRequest";
    case 465: return "ParcelObjects";
    case 466: return "MapDestination";
    case 467: return "SoundAdjust";
    case 468: return "SoundQueue";
    case 480: return "AvatarRenderReport";
    case 481: return "AvatarRenderNotice";
    case 482: return "AccountPreferencesRequest";
    case 483: return "AccountPreferencesSet";
    case 484: return "AccountPreferencesReply";
    case 500: return "VoiceCallStart";
    case 501: return "VoiceCallInvite";
    case 502: return "VoiceCallJoin";
    case 503: return "VoiceCallAnswer";
    case 504: return "VoiceCallLeave";
    case 505: return "VoiceCallEnded";
    case 506: return "VoiceCallMembers";
    case 507: return "InstantMessageStored";
    case 508: return "ObjectInstantMessage";
    case 509: return "GroupMembersPageRequest";
    case 510: return "GroupMembersPage";
    case 511: return "GroupLandRequest";
    case 512: return "GroupLand";
    case 513: return "GroupContributionSet";
    case 514: return "GroupProfileChoice";
    case 515: return "GroupProfileChoices";
    case 516: return "TalkChoices";
    case 520: return "EnvironmentDaySet";
    case 521: return "EnvironmentInfoRequest";
    case 522: return "EnvironmentInfo";
    case 523: return "ParcelExtrasSet";
    case 524: return "ParcelExtras";
    case 525: return "LandSearchRequest";
    case 526: return "LandSearchReply";
    case 527: return "LandHoldingsRequest";
    case 528: return "LandHoldingsReply";
    case 529: return "FeaturedPlacesRequest";
    case 530: return "FeaturedPlacesReply";
    case 531: return "FeaturedPlaceSave";
    case 532: return "FeaturedPlaceDelete";
    case 533: return "RegionSpawnSet";
    case 540: return "EstateCovenantRequest";
    case 541: return "EstateCovenant";
    case 542: return "ParcelTermsSet";
    case 543: return "ParcelTerms";
    case 544: return "ParcelBuyAgreed";
    case 545: return "EventSearchRequest";
    case 546: return "EventSearchReply";
    case 547: return "RegionSkyLayersSet";
    case 548: return "RegionSkyLayers";
    case 640: return "TerrainRawUpload";
    case 641: return "TerrainRawRequest";
    case 642: return "TerrainRaw";
    case 650: return "RegionExtrasRequest";
    case 651: return "RegionExtras";
    case 652: return "RegionExtrasSet";
    case 653: return "TopObjectsRequest";
    case 654: return "TopObjectsReply";
    case 655: return "RegionObjectReturn";
    case 620: return "InventoryFavourite";
    case 621: return "ParcelScriptInfoRequest";
    case 622: return "ParcelScriptInfo";
    case 580: return "MapLevelTilesRequest";
    case 581: return "MapLevelTilesReply";
    case 582: return "MapLandRequest";
    case 583: return "MapLandReply";
    case 670: return "CurrencyBuy";
    case 671: return "CurrencyBuyReply";
    case 672: return "CurrencyBuyCheck";
    case 673: return "LookPublish";
    case 674: return "LookPublished";
    case 675: return "LookWithdraw";
    case 677: return "LibraryPublish";
    case 676: return "StarterLookSet";
    case 681: return "ObjectItemDescribe";
    case 682: return "ObjectItemParts";
    case 683: return "TerrainShape";
    case 684: return "TerrainShaped";
    case 685: return "BotMenu";
    case 686: return "BotClick";
    case 687: return "TerrainEditArea";
    case 688: return "AgentStatus";
    default: return "Unknown";
  }
}

export function messageChannel(id: number): Channel | undefined {
  switch (id) {
    case 1: return Channel.Unreliable;
    case 2: return Channel.Unreliable;
    case 3: return Channel.Reliable;
    case 4: return Channel.Reliable;
    case 5: return Channel.Reliable;
    case 10: return Channel.Reliable;
    case 11: return Channel.Reliable;
    case 12: return Channel.Reliable;
    case 13: return Channel.Reliable;
    case 14: return Channel.Reliable;
    case 15: return Channel.Reliable;
    case 20: return Channel.Reliable;
    case 21: return Channel.Reliable;
    case 22: return Channel.Reliable;
    case 23: return Channel.Reliable;
    case 24: return Channel.Unreliable;
    case 25: return Channel.Reliable;
    case 26: return Channel.Reliable;
    case 27: return Channel.Reliable;
    case 306: return Channel.Reliable;
    case 28: return Channel.Reliable;
    case 29: return Channel.Unreliable;
    case 30: return Channel.Reliable;
    case 31: return Channel.Reliable;
    case 32: return Channel.Reliable;
    case 33: return Channel.Reliable;
    case 34: return Channel.Unreliable;
    case 40: return Channel.Reliable;
    case 41: return Channel.Reliable;
    case 42: return Channel.Reliable;
    case 43: return Channel.Reliable;
    case 50: return Channel.Reliable;
    case 51: return Channel.Reliable;
    case 52: return Channel.Unreliable;
    case 53: return Channel.Reliable;
    case 54: return Channel.Reliable;
    case 55: return Channel.Reliable;
    case 56: return Channel.Reliable;
    case 57: return Channel.Reliable;
    case 58: return Channel.Reliable;
    case 59: return Channel.Reliable;
    case 60: return Channel.Reliable;
    case 61: return Channel.Reliable;
    case 62: return Channel.Reliable;
    case 63: return Channel.Reliable;
    case 64: return Channel.Reliable;
    case 65: return Channel.Reliable;
    case 66: return Channel.Reliable;
    case 67: return Channel.Reliable;
    case 68: return Channel.Reliable;
    case 69: return Channel.Reliable;
    case 70: return Channel.Reliable;
    case 71: return Channel.Reliable;
    case 72: return Channel.Reliable;
    case 73: return Channel.Reliable;
    case 74: return Channel.Unreliable;
    case 75: return Channel.Reliable;
    case 76: return Channel.Reliable;
    case 77: return Channel.Reliable;
    case 78: return Channel.Reliable;
    case 79: return Channel.Reliable;
    case 80: return Channel.Reliable;
    case 81: return Channel.Reliable;
    case 82: return Channel.Reliable;
    case 83: return Channel.Reliable;
    case 84: return Channel.Reliable;
    case 85: return Channel.Reliable;
    case 86: return Channel.Reliable;
    case 100: return Channel.Unreliable;
    case 101: return Channel.Unreliable;
    case 102: return Channel.Reliable;
    case 103: return Channel.Reliable;
    case 104: return Channel.Reliable;
    case 105: return Channel.Reliable;
    case 106: return Channel.Reliable;
    case 107: return Channel.Reliable;
    case 108: return Channel.Reliable;
    case 109: return Channel.Reliable;
    case 110: return Channel.Reliable;
    case 111: return Channel.Reliable;
    case 112: return Channel.Reliable;
    case 113: return Channel.Reliable;
    case 114: return Channel.Reliable;
    case 115: return Channel.Reliable;
    case 116: return Channel.Reliable;
    case 117: return Channel.Reliable;
    case 118: return Channel.Reliable;
    case 119: return Channel.Unreliable;
    case 120: return Channel.Reliable;
    case 121: return Channel.Reliable;
    case 122: return Channel.Unreliable;
    case 130: return Channel.Reliable;
    case 131: return Channel.Reliable;
    case 132: return Channel.Reliable;
    case 133: return Channel.Reliable;
    case 134: return Channel.Reliable;
    case 135: return Channel.Reliable;
    case 136: return Channel.Reliable;
    case 137: return Channel.Reliable;
    case 138: return Channel.Reliable;
    case 139: return Channel.Reliable;
    case 140: return Channel.Unreliable;
    case 141: return Channel.Reliable;
    case 150: return Channel.Reliable;
    case 151: return Channel.Reliable;
    case 152: return Channel.Reliable;
    case 153: return Channel.Reliable;
    case 154: return Channel.Reliable;
    case 155: return Channel.Reliable;
    case 156: return Channel.Reliable;
    case 157: return Channel.Reliable;
    case 158: return Channel.Reliable;
    case 159: return Channel.Reliable;
    case 160: return Channel.Reliable;
    case 161: return Channel.Reliable;
    case 162: return Channel.Reliable;
    case 163: return Channel.Reliable;
    case 170: return Channel.Bulk;
    case 171: return Channel.Bulk;
    case 172: return Channel.Bulk;
    case 173: return Channel.Bulk;
    case 174: return Channel.Bulk;
    case 175: return Channel.Bulk;
    case 176: return Channel.Bulk;
    case 177: return Channel.Bulk;
    case 180: return Channel.Reliable;
    case 181: return Channel.Reliable;
    case 182: return Channel.Reliable;
    case 183: return Channel.Reliable;
    case 184: return Channel.Reliable;
    case 185: return Channel.Reliable;
    case 186: return Channel.Reliable;
    case 187: return Channel.Reliable;
    case 188: return Channel.Reliable;
    case 189: return Channel.Reliable;
    case 195: return Channel.Reliable;
    case 190: return Channel.Reliable;
    case 191: return Channel.Reliable;
    case 192: return Channel.Reliable;
    case 194: return Channel.Reliable;
    case 193: return Channel.Reliable;
    case 200: return Channel.Reliable;
    case 201: return Channel.Reliable;
    case 202: return Channel.Reliable;
    case 203: return Channel.Reliable;
    case 204: return Channel.Reliable;
    case 205: return Channel.Reliable;
    case 206: return Channel.Reliable;
    case 207: return Channel.Reliable;
    case 208: return Channel.Reliable;
    case 209: return Channel.Reliable;
    case 210: return Channel.Reliable;
    case 211: return Channel.Reliable;
    case 212: return Channel.Reliable;
    case 307: return Channel.Reliable;
    case 308: return Channel.Reliable;
    case 309: return Channel.Reliable;
    case 310: return Channel.Reliable;
    case 312: return Channel.Reliable;
    case 311: return Channel.Reliable;
    case 213: return Channel.Reliable;
    case 220: return Channel.Reliable;
    case 221: return Channel.Reliable;
    case 222: return Channel.Reliable;
    case 223: return Channel.Reliable;
    case 224: return Channel.Reliable;
    case 225: return Channel.Reliable;
    case 226: return Channel.Reliable;
    case 227: return Channel.Reliable;
    case 228: return Channel.Reliable;
    case 229: return Channel.Reliable;
    case 230: return Channel.Reliable;
    case 231: return Channel.Reliable;
    case 232: return Channel.Reliable;
    case 233: return Channel.Reliable;
    case 234: return Channel.Reliable;
    case 240: return Channel.Reliable;
    case 241: return Channel.Reliable;
    case 242: return Channel.Reliable;
    case 243: return Channel.Reliable;
    case 244: return Channel.Reliable;
    case 245: return Channel.Reliable;
    case 246: return Channel.Reliable;
    case 247: return Channel.Reliable;
    case 248: return Channel.Reliable;
    case 249: return Channel.Reliable;
    case 250: return Channel.Reliable;
    case 260: return Channel.Reliable;
    case 261: return Channel.Reliable;
    case 262: return Channel.Reliable;
    case 263: return Channel.Reliable;
    case 264: return Channel.Reliable;
    case 265: return Channel.Reliable;
    case 266: return Channel.Reliable;
    case 267: return Channel.Reliable;
    case 268: return Channel.Reliable;
    case 269: return Channel.Reliable;
    case 270: return Channel.Reliable;
    case 271: return Channel.Reliable;
    case 272: return Channel.Reliable;
    case 273: return Channel.Reliable;
    case 274: return Channel.Reliable;
    case 275: return Channel.Reliable;
    case 276: return Channel.Reliable;
    case 277: return Channel.Reliable;
    case 278: return Channel.Reliable;
    case 279: return Channel.Reliable;
    case 280: return Channel.Reliable;
    case 281: return Channel.Reliable;
    case 282: return Channel.Reliable;
    case 283: return Channel.Reliable;
    case 315: return Channel.Reliable;
    case 316: return Channel.Reliable;
    case 317: return Channel.Reliable;
    case 318: return Channel.Reliable;
    case 319: return Channel.Reliable;
    case 320: return Channel.Reliable;
    case 321: return Channel.Reliable;
    case 322: return Channel.Reliable;
    case 323: return Channel.Reliable;
    case 324: return Channel.Unreliable;
    case 325: return Channel.Reliable;
    case 326: return Channel.Reliable;
    case 327: return Channel.Reliable;
    case 328: return Channel.Reliable;
    case 329: return Channel.Reliable;
    case 330: return Channel.Reliable;
    case 331: return Channel.Reliable;
    case 332: return Channel.Reliable;
    case 333: return Channel.Reliable;
    case 290: return Channel.Reliable;
    case 291: return Channel.Reliable;
    case 292: return Channel.Reliable;
    case 293: return Channel.Reliable;
    case 294: return Channel.Reliable;
    case 295: return Channel.Reliable;
    case 296: return Channel.Reliable;
    case 297: return Channel.Reliable;
    case 678: return Channel.Reliable;
    case 679: return Channel.Reliable;
    case 680: return Channel.Reliable;
    case 298: return Channel.Reliable;
    case 299: return Channel.Reliable;
    case 300: return Channel.Reliable;
    case 301: return Channel.Unreliable;
    case 313: return Channel.Reliable;
    case 314: return Channel.Reliable;
    case 302: return Channel.Reliable;
    case 303: return Channel.Reliable;
    case 304: return Channel.Reliable;
    case 305: return Channel.Reliable;
    case 334: return Channel.Reliable;
    case 335: return Channel.Reliable;
    case 336: return Channel.Reliable;
    case 337: return Channel.Reliable;
    case 338: return Channel.Reliable;
    case 339: return Channel.Reliable;
    case 340: return Channel.Reliable;
    case 341: return Channel.Reliable;
    case 342: return Channel.Reliable;
    case 343: return Channel.Reliable;
    case 344: return Channel.Reliable;
    case 345: return Channel.Reliable;
    case 346: return Channel.Reliable;
    case 347: return Channel.Reliable;
    case 348: return Channel.Reliable;
    case 349: return Channel.Reliable;
    case 360: return Channel.Reliable;
    case 380: return Channel.Reliable;
    case 381: return Channel.Reliable;
    case 382: return Channel.Reliable;
    case 383: return Channel.Reliable;
    case 384: return Channel.Reliable;
    case 385: return Channel.Reliable;
    case 386: return Channel.Reliable;
    case 387: return Channel.Reliable;
    case 388: return Channel.Reliable;
    case 400: return Channel.Reliable;
    case 401: return Channel.Reliable;
    case 402: return Channel.Reliable;
    case 403: return Channel.Reliable;
    case 404: return Channel.Reliable;
    case 405: return Channel.Reliable;
    case 406: return Channel.Reliable;
    case 407: return Channel.Reliable;
    case 420: return Channel.Reliable;
    case 421: return Channel.Reliable;
    case 422: return Channel.Reliable;
    case 423: return Channel.Reliable;
    case 441: return Channel.Reliable;
    case 442: return Channel.Reliable;
    case 443: return Channel.Reliable;
    case 444: return Channel.Reliable;
    case 445: return Channel.Reliable;
    case 446: return Channel.Reliable;
    case 447: return Channel.Reliable;
    case 448: return Channel.Reliable;
    case 449: return Channel.Reliable;
    case 450: return Channel.Reliable;
    case 451: return Channel.Reliable;
    case 460: return Channel.Reliable;
    case 461: return Channel.Reliable;
    case 462: return Channel.Reliable;
    case 463: return Channel.Reliable;
    case 464: return Channel.Reliable;
    case 465: return Channel.Reliable;
    case 466: return Channel.Reliable;
    case 467: return Channel.Reliable;
    case 468: return Channel.Reliable;
    case 480: return Channel.Reliable;
    case 481: return Channel.Reliable;
    case 482: return Channel.Reliable;
    case 483: return Channel.Reliable;
    case 484: return Channel.Reliable;
    case 500: return Channel.Reliable;
    case 501: return Channel.Reliable;
    case 502: return Channel.Reliable;
    case 503: return Channel.Reliable;
    case 504: return Channel.Reliable;
    case 505: return Channel.Reliable;
    case 506: return Channel.Reliable;
    case 507: return Channel.Reliable;
    case 508: return Channel.Reliable;
    case 509: return Channel.Reliable;
    case 510: return Channel.Reliable;
    case 511: return Channel.Reliable;
    case 512: return Channel.Reliable;
    case 513: return Channel.Reliable;
    case 514: return Channel.Reliable;
    case 515: return Channel.Reliable;
    case 516: return Channel.Reliable;
    case 520: return Channel.Reliable;
    case 521: return Channel.Reliable;
    case 522: return Channel.Reliable;
    case 523: return Channel.Reliable;
    case 524: return Channel.Reliable;
    case 525: return Channel.Reliable;
    case 526: return Channel.Reliable;
    case 527: return Channel.Reliable;
    case 528: return Channel.Reliable;
    case 529: return Channel.Reliable;
    case 530: return Channel.Reliable;
    case 531: return Channel.Reliable;
    case 532: return Channel.Reliable;
    case 533: return Channel.Reliable;
    case 540: return Channel.Reliable;
    case 541: return Channel.Reliable;
    case 542: return Channel.Reliable;
    case 543: return Channel.Reliable;
    case 544: return Channel.Reliable;
    case 545: return Channel.Reliable;
    case 546: return Channel.Reliable;
    case 547: return Channel.Reliable;
    case 548: return Channel.Reliable;
    case 640: return Channel.Bulk;
    case 641: return Channel.Reliable;
    case 642: return Channel.Bulk;
    case 650: return Channel.Reliable;
    case 651: return Channel.Reliable;
    case 652: return Channel.Reliable;
    case 653: return Channel.Reliable;
    case 654: return Channel.Reliable;
    case 655: return Channel.Reliable;
    case 620: return Channel.Reliable;
    case 621: return Channel.Reliable;
    case 622: return Channel.Reliable;
    case 580: return Channel.Reliable;
    case 581: return Channel.Reliable;
    case 582: return Channel.Reliable;
    case 583: return Channel.Reliable;
    case 670: return Channel.Reliable;
    case 671: return Channel.Reliable;
    case 672: return Channel.Reliable;
    case 673: return Channel.Reliable;
    case 674: return Channel.Reliable;
    case 675: return Channel.Reliable;
    case 677: return Channel.Reliable;
    case 676: return Channel.Reliable;
    case 681: return Channel.Reliable;
    case 682: return Channel.Reliable;
    case 683: return Channel.Bulk;
    case 684: return Channel.Reliable;
    case 685: return Channel.Reliable;
    case 686: return Channel.Reliable;
    case 687: return Channel.Reliable;
    case 688: return Channel.Reliable;
    default: return undefined;
  }
}

export function encodeMessage(w: Writer, m: Message): void {
  switch (m.type) {
    case "Ping": Ping.encode(w, m.body); break;
    case "Pong": Pong.encode(w, m.body); break;
    case "Disconnect": Disconnect.encode(w, m.body); break;
    case "Alert": Alert.encode(w, m.body); break;
    case "Kick": Kick.encode(w, m.body); break;
    case "LoginRequest": LoginRequest.encode(w, m.body); break;
    case "LoginResponse": LoginResponse.encode(w, m.body); break;
    case "LogoutRequest": LogoutRequest.encode(w, m.body); break;
    case "LogoutResponse": LogoutResponse.encode(w, m.body); break;
    case "CreateAccountRequest": CreateAccountRequest.encode(w, m.body); break;
    case "CreateAccountResponse": CreateAccountResponse.encode(w, m.body); break;
    case "RegionEnter": RegionEnter.encode(w, m.body); break;
    case "RegionWelcome": RegionWelcome.encode(w, m.body); break;
    case "RegionReady": RegionReady.encode(w, m.body); break;
    case "RegionLeave": RegionLeave.encode(w, m.body); break;
    case "RegionStatsUpdate": RegionStatsUpdate.encode(w, m.body); break;
    case "NeighborRegions": NeighborRegions.encode(w, m.body); break;
    case "RegionInfoUpdate": RegionInfoUpdate.encode(w, m.body); break;
    case "RegionSettingsUpdate": RegionSettingsUpdate.encode(w, m.body); break;
    case "LandHolding": LandHolding.encode(w, m.body); break;
    case "RegionRestartNotice": RegionRestartNotice.encode(w, m.body); break;
    case "TimeSync": TimeSync.encode(w, m.body); break;
    case "TerrainPatch": TerrainPatch.encode(w, m.body); break;
    case "TerrainEdit": TerrainEdit.encode(w, m.body); break;
    case "TerrainTexturesUpdate": TerrainTexturesUpdate.encode(w, m.body); break;
    case "TerrainBake": TerrainBake.encode(w, m.body); break;
    case "WindUpdate": WindUpdate.encode(w, m.body); break;
    case "SkyUpdate": SkyUpdate.encode(w, m.body); break;
    case "WaterUpdate": WaterUpdate.encode(w, m.body); break;
    case "DayCycleUpdate": DayCycleUpdate.encode(w, m.body); break;
    case "EnvironmentSet": EnvironmentSet.encode(w, m.body); break;
    case "ObjectAdd": ObjectAdd.encode(w, m.body); break;
    case "ObjectUpdate": ObjectUpdate.encode(w, m.body); break;
    case "ObjectMoveBatch": ObjectMoveBatch.encode(w, m.body); break;
    case "ObjectRemove": ObjectRemove.encode(w, m.body); break;
    case "ObjectCreate": ObjectCreate.encode(w, m.body); break;
    case "ObjectEdit": ObjectEdit.encode(w, m.body); break;
    case "ObjectSetShape": ObjectSetShape.encode(w, m.body); break;
    case "ObjectSetFaces": ObjectSetFaces.encode(w, m.body); break;
    case "ObjectSetFlags": ObjectSetFlags.encode(w, m.body); break;
    case "ObjectSetNames": ObjectSetNames.encode(w, m.body); break;
    case "ObjectSetText": ObjectSetText.encode(w, m.body); break;
    case "ObjectSetLight": ObjectSetLight.encode(w, m.body); break;
    case "ObjectSetFlexible": ObjectSetFlexible.encode(w, m.body); break;
    case "ObjectSetParticles": ObjectSetParticles.encode(w, m.body); break;
    case "ObjectSetMaterial": ObjectSetMaterial.encode(w, m.body); break;
    case "ObjectSetPermissions": ObjectSetPermissions.encode(w, m.body); break;
    case "ObjectLink": ObjectLink.encode(w, m.body); break;
    case "ObjectUnlink": ObjectUnlink.encode(w, m.body); break;
    case "ObjectDelete": ObjectDelete.encode(w, m.body); break;
    case "ObjectDuplicate": ObjectDuplicate.encode(w, m.body); break;
    case "ObjectSelect": ObjectSelect.encode(w, m.body); break;
    case "ObjectTake": ObjectTake.encode(w, m.body); break;
    case "ObjectRez": ObjectRez.encode(w, m.body); break;
    case "ObjectTouch": ObjectTouch.encode(w, m.body); break;
    case "ObjectGrab": ObjectGrab.encode(w, m.body); break;
    case "ObjectSit": ObjectSit.encode(w, m.body); break;
    case "ObjectStand": ObjectStand.encode(w, m.body); break;
    case "ObjectPay": ObjectPay.encode(w, m.body); break;
    case "ObjectBuy": ObjectBuy.encode(w, m.body); break;
    case "ObjectSetMesh": ObjectSetMesh.encode(w, m.body); break;
    case "ObjectSetSit": ObjectSetSit.encode(w, m.body); break;
    case "ObjectSetMedia": ObjectSetMedia.encode(w, m.body); break;
    case "ObjectAttach": ObjectAttach.encode(w, m.body); break;
    case "ObjectDetach": ObjectDetach.encode(w, m.body); break;
    case "ObjectSetOwner": ObjectSetOwner.encode(w, m.body); break;
    case "ObjectRequestFull": ObjectRequestFull.encode(w, m.body); break;
    case "ObjectSelected": ObjectSelected.encode(w, m.body); break;
    case "AgentInput": AgentInput.encode(w, m.body); break;
    case "AgentPoseBatch": AgentPoseBatch.encode(w, m.body); break;
    case "AgentJoin": AgentJoin.encode(w, m.body); break;
    case "AgentLeave": AgentLeave.encode(w, m.body); break;
    case "AgentAppearanceUpdate": AgentAppearanceUpdate.encode(w, m.body); break;
    case "AgentSetAppearance": AgentSetAppearance.encode(w, m.body); break;
    case "AgentAnimationUpdate": AgentAnimationUpdate.encode(w, m.body); break;
    case "AgentAnimationPlay": AgentAnimationPlay.encode(w, m.body); break;
    case "AgentTyping": AgentTyping.encode(w, m.body); break;
    case "AgentAway": AgentAway.encode(w, m.body); break;
    case "AgentSit": AgentSit.encode(w, m.body); break;
    case "AgentHealth": AgentHealth.encode(w, m.body); break;
    case "AgentTeleportRequest": AgentTeleportRequest.encode(w, m.body); break;
    case "AgentTeleportStatus": AgentTeleportStatus.encode(w, m.body); break;
    case "AgentTeleportLure": AgentTeleportLure.encode(w, m.body); break;
    case "AgentTeleportLureAccept": AgentTeleportLureAccept.encode(w, m.body); break;
    case "AgentSetHome": AgentSetHome.encode(w, m.body); break;
    case "AgentTitleUpdate": AgentTitleUpdate.encode(w, m.body); break;
    case "AgentCameraFollow": AgentCameraFollow.encode(w, m.body); break;
    case "AgentEffect": AgentEffect.encode(w, m.body); break;
    case "AgentPushed": AgentPushed.encode(w, m.body); break;
    case "AgentControlGrant": AgentControlGrant.encode(w, m.body); break;
    case "AgentControlEvent": AgentControlEvent.encode(w, m.body); break;
    case "ChatSend": ChatSend.encode(w, m.body); break;
    case "ChatReceive": ChatReceive.encode(w, m.body); break;
    case "InstantMessageSend": InstantMessageSend.encode(w, m.body); break;
    case "InstantMessageReceive": InstantMessageReceive.encode(w, m.body); break;
    case "ScriptDialogShow": ScriptDialogShow.encode(w, m.body); break;
    case "ScriptDialogReply": ScriptDialogReply.encode(w, m.body); break;
    case "Notification": Notification.encode(w, m.body); break;
    case "NotificationReply": NotificationReply.encode(w, m.body); break;
    case "MuteUpdate": MuteUpdate.encode(w, m.body); break;
    case "MuteList": MuteList.encode(w, m.body); break;
    case "TypingIndicator": TypingIndicator.encode(w, m.body); break;
    case "GestureActive": GestureActive.encode(w, m.body); break;
    case "InventoryFetch": InventoryFetch.encode(w, m.body); break;
    case "InventoryFolders": InventoryFolders.encode(w, m.body); break;
    case "InventoryItems": InventoryItems.encode(w, m.body); break;
    case "InventoryFolderOp": InventoryFolderOp.encode(w, m.body); break;
    case "InventoryItemOp": InventoryItemOp.encode(w, m.body); break;
    case "InventoryChanged": InventoryChanged.encode(w, m.body); break;
    case "InventoryGive": InventoryGive.encode(w, m.body); break;
    case "InventoryOffer": InventoryOffer.encode(w, m.body); break;
    case "InventoryOfferReply": InventoryOfferReply.encode(w, m.body); break;
    case "TaskInventoryFetch": TaskInventoryFetch.encode(w, m.body); break;
    case "TaskInventoryItems": TaskInventoryItems.encode(w, m.body); break;
    case "TaskInventoryOp": TaskInventoryOp.encode(w, m.body); break;
    case "WearableSet": WearableSet.encode(w, m.body); break;
    case "OutfitSave": OutfitSave.encode(w, m.body); break;
    case "AssetRequest": AssetRequest.encode(w, m.body); break;
    case "AssetHeader": AssetHeader.encode(w, m.body); break;
    case "AssetChunk": AssetChunk.encode(w, m.body); break;
    case "AssetCancel": AssetCancel.encode(w, m.body); break;
    case "AssetUploadBegin": AssetUploadBegin.encode(w, m.body); break;
    case "AssetUploadChunk": AssetUploadChunk.encode(w, m.body); break;
    case "AssetUploadResult": AssetUploadResult.encode(w, m.body); break;
    case "AssetUploadQuote": AssetUploadQuote.encode(w, m.body); break;
    case "ScriptSave": ScriptSave.encode(w, m.body); break;
    case "ScriptSaveResult": ScriptSaveResult.encode(w, m.body); break;
    case "ScriptSetRunning": ScriptSetRunning.encode(w, m.body); break;
    case "ScriptReset": ScriptReset.encode(w, m.body); break;
    case "ScriptRuntimeError": ScriptRuntimeError.encode(w, m.body); break;
    case "ScriptFetchSource": ScriptFetchSource.encode(w, m.body); break;
    case "ScriptSource": ScriptSource.encode(w, m.body); break;
    case "ScriptHudText": ScriptHudText.encode(w, m.body); break;
    case "ScriptPanelShow": ScriptPanelShow.encode(w, m.body); break;
    case "ScriptPanelHide": ScriptPanelHide.encode(w, m.body); break;
    case "ScriptPanelUse": ScriptPanelUse.encode(w, m.body); break;
    case "SoundPlay": SoundPlay.encode(w, m.body); break;
    case "SoundStop": SoundStop.encode(w, m.body); break;
    case "SoundPreload": SoundPreload.encode(w, m.body); break;
    case "AgentSoundPlay": AgentSoundPlay.encode(w, m.body); break;
    case "ParcelMediaCommand": ParcelMediaCommand.encode(w, m.body); break;
    case "ParcelOverlay": ParcelOverlay.encode(w, m.body); break;
    case "ParcelInfoRequest": ParcelInfoRequest.encode(w, m.body); break;
    case "ParcelInfoReply": ParcelInfoReply.encode(w, m.body); break;
    case "ParcelUpdate": ParcelUpdate.encode(w, m.body); break;
    case "ParcelDivide": ParcelDivide.encode(w, m.body); break;
    case "ParcelJoin": ParcelJoin.encode(w, m.body); break;
    case "ParcelBuy": ParcelBuy.encode(w, m.body); break;
    case "ParcelRelease": ParcelRelease.encode(w, m.body); break;
    case "ParcelAccessList": ParcelAccessList.encode(w, m.body); break;
    case "ParcelReturnObjects": ParcelReturnObjects.encode(w, m.body); break;
    case "ParcelObjectOwners": ParcelObjectOwners.encode(w, m.body); break;
    case "ParcelEject": ParcelEject.encode(w, m.body); break;
    case "ParcelFreeze": ParcelFreeze.encode(w, m.body); break;
    case "ParcelAuctionStart": ParcelAuctionStart.encode(w, m.body); break;
    case "ParcelAuctionBid": ParcelAuctionBid.encode(w, m.body); break;
    case "ParcelAuctionCancel": ParcelAuctionCancel.encode(w, m.body); break;
    case "TaskInventoryTake": TaskInventoryTake.encode(w, m.body); break;
    case "InventoryTextSave": InventoryTextSave.encode(w, m.body); break;
    case "ParcelMediaControl": ParcelMediaControl.encode(w, m.body); break;
    case "ParcelDeedToGroup": ParcelDeedToGroup.encode(w, m.body); break;
    case "MapRequest": MapRequest.encode(w, m.body); break;
    case "MapReply": MapReply.encode(w, m.body); break;
    case "MapAgentsRequest": MapAgentsRequest.encode(w, m.body); break;
    case "MapAgentsReply": MapAgentsReply.encode(w, m.body); break;
    case "LandmarkCreate": LandmarkCreate.encode(w, m.body); break;
    case "PlacesRequest": PlacesRequest.encode(w, m.body); break;
    case "PlacesReply": PlacesReply.encode(w, m.body); break;
    case "MapItemsRequest": MapItemsRequest.encode(w, m.body); break;
    case "MapItemsReply": MapItemsReply.encode(w, m.body); break;
    case "AgentHome": AgentHome.encode(w, m.body); break;
    case "BalanceUpdate": BalanceUpdate.encode(w, m.body); break;
    case "MoneyTransfer": MoneyTransfer.encode(w, m.body); break;
    case "MoneyTransferResult": MoneyTransferResult.encode(w, m.body); break;
    case "TransactionHistoryRequest": TransactionHistoryRequest.encode(w, m.body); break;
    case "TransactionHistoryReply": TransactionHistoryReply.encode(w, m.body); break;
    case "NameLookup": NameLookup.encode(w, m.body); break;
    case "NameReply": NameReply.encode(w, m.body); break;
    case "ProfileRequest": ProfileRequest.encode(w, m.body); break;
    case "ProfileReply": ProfileReply.encode(w, m.body); break;
    case "ProfileUpdate": ProfileUpdate.encode(w, m.body); break;
    case "FriendList": FriendList.encode(w, m.body); break;
    case "FriendRequest": FriendRequest.encode(w, m.body); break;
    case "FriendRequestReply": FriendRequestReply.encode(w, m.body); break;
    case "FriendRemove": FriendRemove.encode(w, m.body); break;
    case "FriendPresenceUpdate": FriendPresenceUpdate.encode(w, m.body); break;
    case "FriendRights": FriendRights.encode(w, m.body); break;
    case "GroupList": GroupList.encode(w, m.body); break;
    case "GroupCreate": GroupCreate.encode(w, m.body); break;
    case "GroupCreateResult": GroupCreateResult.encode(w, m.body); break;
    case "GroupInfoRequest": GroupInfoRequest.encode(w, m.body); break;
    case "GroupInfoReply": GroupInfoReply.encode(w, m.body); break;
    case "GroupMembersRequest": GroupMembersRequest.encode(w, m.body); break;
    case "GroupMembersReply": GroupMembersReply.encode(w, m.body); break;
    case "GroupActivate": GroupActivate.encode(w, m.body); break;
    case "GroupUpdate": GroupUpdate.encode(w, m.body); break;
    case "GroupJoin": GroupJoin.encode(w, m.body); break;
    case "GroupLeave": GroupLeave.encode(w, m.body); break;
    case "GroupInvite": GroupInvite.encode(w, m.body); break;
    case "GroupInviteReply": GroupInviteReply.encode(w, m.body); break;
    case "GroupEject": GroupEject.encode(w, m.body); break;
    case "GroupRoleUpdate": GroupRoleUpdate.encode(w, m.body); break;
    case "GroupMemberRole": GroupMemberRole.encode(w, m.body); break;
    case "GroupTitleSet": GroupTitleSet.encode(w, m.body); break;
    case "GroupNoticeSend": GroupNoticeSend.encode(w, m.body); break;
    case "GroupNoticesRequest": GroupNoticesRequest.encode(w, m.body); break;
    case "GroupNoticesReply": GroupNoticesReply.encode(w, m.body); break;
    case "GroupChatSend": GroupChatSend.encode(w, m.body); break;
    case "GroupChatReceive": GroupChatReceive.encode(w, m.body); break;
    case "GroupSearch": GroupSearch.encode(w, m.body); break;
    case "GroupSearchReply": GroupSearchReply.encode(w, m.body); break;
    case "SearchRequest": SearchRequest.encode(w, m.body); break;
    case "SearchReply": SearchReply.encode(w, m.body); break;
    case "EventCreate": EventCreate.encode(w, m.body); break;
    case "ClassifiedCreate": ClassifiedCreate.encode(w, m.body); break;
    case "SearchListingDelete": SearchListingDelete.encode(w, m.body); break;
    case "VoiceJoin": VoiceJoin.encode(w, m.body); break;
    case "VoiceAnswer": VoiceAnswer.encode(w, m.body); break;
    case "VoiceSlots": VoiceSlots.encode(w, m.body); break;
    case "VoiceLeave": VoiceLeave.encode(w, m.body); break;
    case "VoiceActivity": VoiceActivity.encode(w, m.body); break;
    case "ExperienceSave": ExperienceSave.encode(w, m.body); break;
    case "ExperienceListRequest": ExperienceListRequest.encode(w, m.body); break;
    case "ExperienceList": ExperienceList.encode(w, m.body); break;
    case "ExperienceAnswer": ExperienceAnswer.encode(w, m.body); break;
    case "MarketListRequest": MarketListRequest.encode(w, m.body); break;
    case "MarketList": MarketList.encode(w, m.body); break;
    case "MarketListingSave": MarketListingSave.encode(w, m.body); break;
    case "MarketBuy": MarketBuy.encode(w, m.body); break;
    case "MarketResult": MarketResult.encode(w, m.body); break;
    case "EstateUpdate": EstateUpdate.encode(w, m.body); break;
    case "EstateKick": EstateKick.encode(w, m.body); break;
    case "EstateMessage": EstateMessage.encode(w, m.body); break;
    case "EstateRestart": EstateRestart.encode(w, m.body); break;
    case "EstateTeleportHome": EstateTeleportHome.encode(w, m.body); break;
    case "GodRequest": GodRequest.encode(w, m.body); break;
    case "GodGrant": GodGrant.encode(w, m.body); break;
    case "AdminObjectReturn": AdminObjectReturn.encode(w, m.body); break;
    case "AdminObjectAction": AdminObjectAction.encode(w, m.body); break;
    case "StaffAction": StaffAction.encode(w, m.body); break;
    case "StaffActionReply": StaffActionReply.encode(w, m.body); break;
    case "TopScriptsRequest": TopScriptsRequest.encode(w, m.body); break;
    case "TopScriptsReply": TopScriptsReply.encode(w, m.body); break;
    case "ObjectHudAttach": ObjectHudAttach.encode(w, m.body); break;
    case "ClientStatsReport": ClientStatsReport.encode(w, m.body); break;
    case "AbuseReport": AbuseReport.encode(w, m.body); break;
    case "AbuseReportAck": AbuseReportAck.encode(w, m.body); break;
    case "DetectedReport": DetectedReport.encode(w, m.body); break;
    case "CameraConstraint": CameraConstraint.encode(w, m.body); break;
    case "ViewerEffectSpawn": ViewerEffectSpawn.encode(w, m.body); break;
    case "TerrainRequest": TerrainRequest.encode(w, m.body); break;
    case "FriendLocateRequest": FriendLocateRequest.encode(w, m.body); break;
    case "FriendLocateReply": FriendLocateReply.encode(w, m.body); break;
    case "MapParcelRequest": MapParcelRequest.encode(w, m.body); break;
    case "MapParcelReply": MapParcelReply.encode(w, m.body); break;
    case "AgentControlsRelease": AgentControlsRelease.encode(w, m.body); break;
    case "ObjectHandOff": ObjectHandOff.encode(w, m.body); break;
    case "VehicleFlags": VehicleFlags.encode(w, m.body); break;
    case "AttachmentWear": AttachmentWear.encode(w, m.body); break;
    case "AgentSetHover": AgentSetHover.encode(w, m.body); break;
    case "AgentAnimationStopAll": AgentAnimationStopAll.encode(w, m.body); break;
    case "AgentDoNotDisturb": AgentDoNotDisturb.encode(w, m.body); break;
    case "ProfileExtrasRequest": ProfileExtrasRequest.encode(w, m.body); break;
    case "ProfileExtras": ProfileExtras.encode(w, m.body); break;
    case "PickSave": PickSave.encode(w, m.body); break;
    case "PickDelete": PickDelete.encode(w, m.body); break;
    case "ProfileNotesSave": ProfileNotesSave.encode(w, m.body); break;
    case "ObjectTouchAt": ObjectTouchAt.encode(w, m.body); break;
    case "ObjectSetSaleType": ObjectSetSaleType.encode(w, m.body); break;
    case "ObjectTradeRequest": ObjectTradeRequest.encode(w, m.body); break;
    case "ObjectTrade": ObjectTrade.encode(w, m.body); break;
    case "ObjectPurchase": ObjectPurchase.encode(w, m.body); break;
    case "TaskInventoryCopyAll": TaskInventoryCopyAll.encode(w, m.body); break;
    case "TaskInventoryCopied": TaskInventoryCopied.encode(w, m.body); break;
    case "AgentTeleportAsk": AgentTeleportAsk.encode(w, m.body); break;
    case "AgentTeleportAsked": AgentTeleportAsked.encode(w, m.body); break;
    case "ObjectMenuTouch": ObjectMenuTouch.encode(w, m.body); break;
    case "GroupMemberOptions": GroupMemberOptions.encode(w, m.body); break;
    case "GroupMemberOptionsList": GroupMemberOptionsList.encode(w, m.body); break;
    case "GroupChatHistoryRequest": GroupChatHistoryRequest.encode(w, m.body); break;
    case "GroupChatHistory": GroupChatHistory.encode(w, m.body); break;
    case "GroupNoticeReceive": GroupNoticeReceive.encode(w, m.body); break;
    case "GroupNoticeAccept": GroupNoticeAccept.encode(w, m.body); break;
    case "ConferenceSend": ConferenceSend.encode(w, m.body); break;
    case "ConferenceReceive": ConferenceReceive.encode(w, m.body); break;
    case "EstateAccessRequest": EstateAccessRequest.encode(w, m.body); break;
    case "EstateAccessList": EstateAccessList.encode(w, m.body); break;
    case "EstateAccessChange": EstateAccessChange.encode(w, m.body); break;
    case "ParcelEnvironmentReset": ParcelEnvironmentReset.encode(w, m.body); break;
    case "OutfitWrite": OutfitWrite.encode(w, m.body); break;
    case "AvatarChoose": AvatarChoose.encode(w, m.body); break;
    case "AvatarChosen": AvatarChosen.encode(w, m.body); break;
    case "ProfileDetails": ProfileDetails.encode(w, m.body); break;
    case "ProfileDetailsUpdate": ProfileDetailsUpdate.encode(w, m.body); break;
    case "AccountInfoRequest": AccountInfoRequest.encode(w, m.body); break;
    case "AccountInfo": AccountInfo.encode(w, m.body); break;
    case "AccountPasswordChange": AccountPasswordChange.encode(w, m.body); break;
    case "AccountEmailChange": AccountEmailChange.encode(w, m.body); break;
    case "AccountChangeResult": AccountChangeResult.encode(w, m.body); break;
    case "ObjectWear": ObjectWear.encode(w, m.body); break;
    case "UploadPriceRequest": UploadPriceRequest.encode(w, m.body); break;
    case "UploadPrice": UploadPrice.encode(w, m.body); break;
    case "ObjectReturn": ObjectReturn.encode(w, m.body); break;
    case "ObjectRestore": ObjectRestore.encode(w, m.body); break;
    case "ParcelObjectsRequest": ParcelObjectsRequest.encode(w, m.body); break;
    case "ParcelObjects": ParcelObjects.encode(w, m.body); break;
    case "MapDestination": MapDestination.encode(w, m.body); break;
    case "SoundAdjust": SoundAdjust.encode(w, m.body); break;
    case "SoundQueue": SoundQueue.encode(w, m.body); break;
    case "AvatarRenderReport": AvatarRenderReport.encode(w, m.body); break;
    case "AvatarRenderNotice": AvatarRenderNotice.encode(w, m.body); break;
    case "AccountPreferencesRequest": AccountPreferencesRequest.encode(w, m.body); break;
    case "AccountPreferencesSet": AccountPreferencesSet.encode(w, m.body); break;
    case "AccountPreferencesReply": AccountPreferencesReply.encode(w, m.body); break;
    case "VoiceCallStart": VoiceCallStart.encode(w, m.body); break;
    case "VoiceCallInvite": VoiceCallInvite.encode(w, m.body); break;
    case "VoiceCallJoin": VoiceCallJoin.encode(w, m.body); break;
    case "VoiceCallAnswer": VoiceCallAnswer.encode(w, m.body); break;
    case "VoiceCallLeave": VoiceCallLeave.encode(w, m.body); break;
    case "VoiceCallEnded": VoiceCallEnded.encode(w, m.body); break;
    case "VoiceCallMembers": VoiceCallMembers.encode(w, m.body); break;
    case "InstantMessageStored": InstantMessageStored.encode(w, m.body); break;
    case "ObjectInstantMessage": ObjectInstantMessage.encode(w, m.body); break;
    case "GroupMembersPageRequest": GroupMembersPageRequest.encode(w, m.body); break;
    case "GroupMembersPage": GroupMembersPage.encode(w, m.body); break;
    case "GroupLandRequest": GroupLandRequest.encode(w, m.body); break;
    case "GroupLand": GroupLand.encode(w, m.body); break;
    case "GroupContributionSet": GroupContributionSet.encode(w, m.body); break;
    case "GroupProfileChoice": GroupProfileChoice.encode(w, m.body); break;
    case "GroupProfileChoices": GroupProfileChoices.encode(w, m.body); break;
    case "TalkChoices": TalkChoices.encode(w, m.body); break;
    case "EnvironmentDaySet": EnvironmentDaySet.encode(w, m.body); break;
    case "EnvironmentInfoRequest": EnvironmentInfoRequest.encode(w, m.body); break;
    case "EnvironmentInfo": EnvironmentInfo.encode(w, m.body); break;
    case "ParcelExtrasSet": ParcelExtrasSet.encode(w, m.body); break;
    case "ParcelExtras": ParcelExtras.encode(w, m.body); break;
    case "LandSearchRequest": LandSearchRequest.encode(w, m.body); break;
    case "LandSearchReply": LandSearchReply.encode(w, m.body); break;
    case "LandHoldingsRequest": LandHoldingsRequest.encode(w, m.body); break;
    case "LandHoldingsReply": LandHoldingsReply.encode(w, m.body); break;
    case "FeaturedPlacesRequest": FeaturedPlacesRequest.encode(w, m.body); break;
    case "FeaturedPlacesReply": FeaturedPlacesReply.encode(w, m.body); break;
    case "FeaturedPlaceSave": FeaturedPlaceSave.encode(w, m.body); break;
    case "FeaturedPlaceDelete": FeaturedPlaceDelete.encode(w, m.body); break;
    case "RegionSpawnSet": RegionSpawnSet.encode(w, m.body); break;
    case "EstateCovenantRequest": EstateCovenantRequest.encode(w, m.body); break;
    case "EstateCovenant": EstateCovenant.encode(w, m.body); break;
    case "ParcelTermsSet": ParcelTermsSet.encode(w, m.body); break;
    case "ParcelTerms": ParcelTerms.encode(w, m.body); break;
    case "ParcelBuyAgreed": ParcelBuyAgreed.encode(w, m.body); break;
    case "EventSearchRequest": EventSearchRequest.encode(w, m.body); break;
    case "EventSearchReply": EventSearchReply.encode(w, m.body); break;
    case "RegionSkyLayersSet": RegionSkyLayersSet.encode(w, m.body); break;
    case "RegionSkyLayers": RegionSkyLayers.encode(w, m.body); break;
    case "TerrainRawUpload": TerrainRawUpload.encode(w, m.body); break;
    case "TerrainRawRequest": TerrainRawRequest.encode(w, m.body); break;
    case "TerrainRaw": TerrainRaw.encode(w, m.body); break;
    case "RegionExtrasRequest": RegionExtrasRequest.encode(w, m.body); break;
    case "RegionExtras": RegionExtras.encode(w, m.body); break;
    case "RegionExtrasSet": RegionExtrasSet.encode(w, m.body); break;
    case "TopObjectsRequest": TopObjectsRequest.encode(w, m.body); break;
    case "TopObjectsReply": TopObjectsReply.encode(w, m.body); break;
    case "RegionObjectReturn": RegionObjectReturn.encode(w, m.body); break;
    case "InventoryFavourite": InventoryFavourite.encode(w, m.body); break;
    case "ParcelScriptInfoRequest": ParcelScriptInfoRequest.encode(w, m.body); break;
    case "ParcelScriptInfo": ParcelScriptInfo.encode(w, m.body); break;
    case "MapLevelTilesRequest": MapLevelTilesRequest.encode(w, m.body); break;
    case "MapLevelTilesReply": MapLevelTilesReply.encode(w, m.body); break;
    case "MapLandRequest": MapLandRequest.encode(w, m.body); break;
    case "MapLandReply": MapLandReply.encode(w, m.body); break;
    case "CurrencyBuy": CurrencyBuy.encode(w, m.body); break;
    case "CurrencyBuyReply": CurrencyBuyReply.encode(w, m.body); break;
    case "CurrencyBuyCheck": CurrencyBuyCheck.encode(w, m.body); break;
    case "LookPublish": LookPublish.encode(w, m.body); break;
    case "LookPublished": LookPublished.encode(w, m.body); break;
    case "LookWithdraw": LookWithdraw.encode(w, m.body); break;
    case "LibraryPublish": LibraryPublish.encode(w, m.body); break;
    case "StarterLookSet": StarterLookSet.encode(w, m.body); break;
    case "ObjectItemDescribe": ObjectItemDescribe.encode(w, m.body); break;
    case "ObjectItemParts": ObjectItemParts.encode(w, m.body); break;
    case "TerrainShape": TerrainShape.encode(w, m.body); break;
    case "TerrainShaped": TerrainShaped.encode(w, m.body); break;
    case "BotMenu": BotMenu.encode(w, m.body); break;
    case "BotClick": BotClick.encode(w, m.body); break;
    case "TerrainEditArea": TerrainEditArea.encode(w, m.body); break;
    case "AgentStatus": AgentStatus.encode(w, m.body); break;
  }
}

export function decodeMessage(id: number, r: Reader): Message | undefined {
  switch (id) {
    case 1: return { type: "Ping", body: Ping.decode(r) };
    case 2: return { type: "Pong", body: Pong.decode(r) };
    case 3: return { type: "Disconnect", body: Disconnect.decode(r) };
    case 4: return { type: "Alert", body: Alert.decode(r) };
    case 5: return { type: "Kick", body: Kick.decode(r) };
    case 10: return { type: "LoginRequest", body: LoginRequest.decode(r) };
    case 11: return { type: "LoginResponse", body: LoginResponse.decode(r) };
    case 12: return { type: "LogoutRequest", body: LogoutRequest.decode(r) };
    case 13: return { type: "LogoutResponse", body: LogoutResponse.decode(r) };
    case 14: return { type: "CreateAccountRequest", body: CreateAccountRequest.decode(r) };
    case 15: return { type: "CreateAccountResponse", body: CreateAccountResponse.decode(r) };
    case 20: return { type: "RegionEnter", body: RegionEnter.decode(r) };
    case 21: return { type: "RegionWelcome", body: RegionWelcome.decode(r) };
    case 22: return { type: "RegionReady", body: RegionReady.decode(r) };
    case 23: return { type: "RegionLeave", body: RegionLeave.decode(r) };
    case 24: return { type: "RegionStatsUpdate", body: RegionStatsUpdate.decode(r) };
    case 25: return { type: "NeighborRegions", body: NeighborRegions.decode(r) };
    case 26: return { type: "RegionInfoUpdate", body: RegionInfoUpdate.decode(r) };
    case 27: return { type: "RegionSettingsUpdate", body: RegionSettingsUpdate.decode(r) };
    case 306: return { type: "LandHolding", body: LandHolding.decode(r) };
    case 28: return { type: "RegionRestartNotice", body: RegionRestartNotice.decode(r) };
    case 29: return { type: "TimeSync", body: TimeSync.decode(r) };
    case 30: return { type: "TerrainPatch", body: TerrainPatch.decode(r) };
    case 31: return { type: "TerrainEdit", body: TerrainEdit.decode(r) };
    case 32: return { type: "TerrainTexturesUpdate", body: TerrainTexturesUpdate.decode(r) };
    case 33: return { type: "TerrainBake", body: TerrainBake.decode(r) };
    case 34: return { type: "WindUpdate", body: WindUpdate.decode(r) };
    case 40: return { type: "SkyUpdate", body: SkyUpdate.decode(r) };
    case 41: return { type: "WaterUpdate", body: WaterUpdate.decode(r) };
    case 42: return { type: "DayCycleUpdate", body: DayCycleUpdate.decode(r) };
    case 43: return { type: "EnvironmentSet", body: EnvironmentSet.decode(r) };
    case 50: return { type: "ObjectAdd", body: ObjectAdd.decode(r) };
    case 51: return { type: "ObjectUpdate", body: ObjectUpdate.decode(r) };
    case 52: return { type: "ObjectMoveBatch", body: ObjectMoveBatch.decode(r) };
    case 53: return { type: "ObjectRemove", body: ObjectRemove.decode(r) };
    case 54: return { type: "ObjectCreate", body: ObjectCreate.decode(r) };
    case 55: return { type: "ObjectEdit", body: ObjectEdit.decode(r) };
    case 56: return { type: "ObjectSetShape", body: ObjectSetShape.decode(r) };
    case 57: return { type: "ObjectSetFaces", body: ObjectSetFaces.decode(r) };
    case 58: return { type: "ObjectSetFlags", body: ObjectSetFlags.decode(r) };
    case 59: return { type: "ObjectSetNames", body: ObjectSetNames.decode(r) };
    case 60: return { type: "ObjectSetText", body: ObjectSetText.decode(r) };
    case 61: return { type: "ObjectSetLight", body: ObjectSetLight.decode(r) };
    case 62: return { type: "ObjectSetFlexible", body: ObjectSetFlexible.decode(r) };
    case 63: return { type: "ObjectSetParticles", body: ObjectSetParticles.decode(r) };
    case 64: return { type: "ObjectSetMaterial", body: ObjectSetMaterial.decode(r) };
    case 65: return { type: "ObjectSetPermissions", body: ObjectSetPermissions.decode(r) };
    case 66: return { type: "ObjectLink", body: ObjectLink.decode(r) };
    case 67: return { type: "ObjectUnlink", body: ObjectUnlink.decode(r) };
    case 68: return { type: "ObjectDelete", body: ObjectDelete.decode(r) };
    case 69: return { type: "ObjectDuplicate", body: ObjectDuplicate.decode(r) };
    case 70: return { type: "ObjectSelect", body: ObjectSelect.decode(r) };
    case 71: return { type: "ObjectTake", body: ObjectTake.decode(r) };
    case 72: return { type: "ObjectRez", body: ObjectRez.decode(r) };
    case 73: return { type: "ObjectTouch", body: ObjectTouch.decode(r) };
    case 74: return { type: "ObjectGrab", body: ObjectGrab.decode(r) };
    case 75: return { type: "ObjectSit", body: ObjectSit.decode(r) };
    case 76: return { type: "ObjectStand", body: ObjectStand.decode(r) };
    case 77: return { type: "ObjectPay", body: ObjectPay.decode(r) };
    case 78: return { type: "ObjectBuy", body: ObjectBuy.decode(r) };
    case 79: return { type: "ObjectSetMesh", body: ObjectSetMesh.decode(r) };
    case 80: return { type: "ObjectSetSit", body: ObjectSetSit.decode(r) };
    case 81: return { type: "ObjectSetMedia", body: ObjectSetMedia.decode(r) };
    case 82: return { type: "ObjectAttach", body: ObjectAttach.decode(r) };
    case 83: return { type: "ObjectDetach", body: ObjectDetach.decode(r) };
    case 84: return { type: "ObjectSetOwner", body: ObjectSetOwner.decode(r) };
    case 85: return { type: "ObjectRequestFull", body: ObjectRequestFull.decode(r) };
    case 86: return { type: "ObjectSelected", body: ObjectSelected.decode(r) };
    case 100: return { type: "AgentInput", body: AgentInput.decode(r) };
    case 101: return { type: "AgentPoseBatch", body: AgentPoseBatch.decode(r) };
    case 102: return { type: "AgentJoin", body: AgentJoin.decode(r) };
    case 103: return { type: "AgentLeave", body: AgentLeave.decode(r) };
    case 104: return { type: "AgentAppearanceUpdate", body: AgentAppearanceUpdate.decode(r) };
    case 105: return { type: "AgentSetAppearance", body: AgentSetAppearance.decode(r) };
    case 106: return { type: "AgentAnimationUpdate", body: AgentAnimationUpdate.decode(r) };
    case 107: return { type: "AgentAnimationPlay", body: AgentAnimationPlay.decode(r) };
    case 108: return { type: "AgentTyping", body: AgentTyping.decode(r) };
    case 109: return { type: "AgentAway", body: AgentAway.decode(r) };
    case 110: return { type: "AgentSit", body: AgentSit.decode(r) };
    case 111: return { type: "AgentHealth", body: AgentHealth.decode(r) };
    case 112: return { type: "AgentTeleportRequest", body: AgentTeleportRequest.decode(r) };
    case 113: return { type: "AgentTeleportStatus", body: AgentTeleportStatus.decode(r) };
    case 114: return { type: "AgentTeleportLure", body: AgentTeleportLure.decode(r) };
    case 115: return { type: "AgentTeleportLureAccept", body: AgentTeleportLureAccept.decode(r) };
    case 116: return { type: "AgentSetHome", body: AgentSetHome.decode(r) };
    case 117: return { type: "AgentTitleUpdate", body: AgentTitleUpdate.decode(r) };
    case 118: return { type: "AgentCameraFollow", body: AgentCameraFollow.decode(r) };
    case 119: return { type: "AgentEffect", body: AgentEffect.decode(r) };
    case 120: return { type: "AgentPushed", body: AgentPushed.decode(r) };
    case 121: return { type: "AgentControlGrant", body: AgentControlGrant.decode(r) };
    case 122: return { type: "AgentControlEvent", body: AgentControlEvent.decode(r) };
    case 130: return { type: "ChatSend", body: ChatSend.decode(r) };
    case 131: return { type: "ChatReceive", body: ChatReceive.decode(r) };
    case 132: return { type: "InstantMessageSend", body: InstantMessageSend.decode(r) };
    case 133: return { type: "InstantMessageReceive", body: InstantMessageReceive.decode(r) };
    case 134: return { type: "ScriptDialogShow", body: ScriptDialogShow.decode(r) };
    case 135: return { type: "ScriptDialogReply", body: ScriptDialogReply.decode(r) };
    case 136: return { type: "Notification", body: Notification.decode(r) };
    case 137: return { type: "NotificationReply", body: NotificationReply.decode(r) };
    case 138: return { type: "MuteUpdate", body: MuteUpdate.decode(r) };
    case 139: return { type: "MuteList", body: MuteList.decode(r) };
    case 140: return { type: "TypingIndicator", body: TypingIndicator.decode(r) };
    case 141: return { type: "GestureActive", body: GestureActive.decode(r) };
    case 150: return { type: "InventoryFetch", body: InventoryFetch.decode(r) };
    case 151: return { type: "InventoryFolders", body: InventoryFolders.decode(r) };
    case 152: return { type: "InventoryItems", body: InventoryItems.decode(r) };
    case 153: return { type: "InventoryFolderOp", body: InventoryFolderOp.decode(r) };
    case 154: return { type: "InventoryItemOp", body: InventoryItemOp.decode(r) };
    case 155: return { type: "InventoryChanged", body: InventoryChanged.decode(r) };
    case 156: return { type: "InventoryGive", body: InventoryGive.decode(r) };
    case 157: return { type: "InventoryOffer", body: InventoryOffer.decode(r) };
    case 158: return { type: "InventoryOfferReply", body: InventoryOfferReply.decode(r) };
    case 159: return { type: "TaskInventoryFetch", body: TaskInventoryFetch.decode(r) };
    case 160: return { type: "TaskInventoryItems", body: TaskInventoryItems.decode(r) };
    case 161: return { type: "TaskInventoryOp", body: TaskInventoryOp.decode(r) };
    case 162: return { type: "WearableSet", body: WearableSet.decode(r) };
    case 163: return { type: "OutfitSave", body: OutfitSave.decode(r) };
    case 170: return { type: "AssetRequest", body: AssetRequest.decode(r) };
    case 171: return { type: "AssetHeader", body: AssetHeader.decode(r) };
    case 172: return { type: "AssetChunk", body: AssetChunk.decode(r) };
    case 173: return { type: "AssetCancel", body: AssetCancel.decode(r) };
    case 174: return { type: "AssetUploadBegin", body: AssetUploadBegin.decode(r) };
    case 175: return { type: "AssetUploadChunk", body: AssetUploadChunk.decode(r) };
    case 176: return { type: "AssetUploadResult", body: AssetUploadResult.decode(r) };
    case 177: return { type: "AssetUploadQuote", body: AssetUploadQuote.decode(r) };
    case 180: return { type: "ScriptSave", body: ScriptSave.decode(r) };
    case 181: return { type: "ScriptSaveResult", body: ScriptSaveResult.decode(r) };
    case 182: return { type: "ScriptSetRunning", body: ScriptSetRunning.decode(r) };
    case 183: return { type: "ScriptReset", body: ScriptReset.decode(r) };
    case 184: return { type: "ScriptRuntimeError", body: ScriptRuntimeError.decode(r) };
    case 185: return { type: "ScriptFetchSource", body: ScriptFetchSource.decode(r) };
    case 186: return { type: "ScriptSource", body: ScriptSource.decode(r) };
    case 187: return { type: "ScriptHudText", body: ScriptHudText.decode(r) };
    case 188: return { type: "ScriptPanelShow", body: ScriptPanelShow.decode(r) };
    case 189: return { type: "ScriptPanelHide", body: ScriptPanelHide.decode(r) };
    case 195: return { type: "ScriptPanelUse", body: ScriptPanelUse.decode(r) };
    case 190: return { type: "SoundPlay", body: SoundPlay.decode(r) };
    case 191: return { type: "SoundStop", body: SoundStop.decode(r) };
    case 192: return { type: "SoundPreload", body: SoundPreload.decode(r) };
    case 194: return { type: "AgentSoundPlay", body: AgentSoundPlay.decode(r) };
    case 193: return { type: "ParcelMediaCommand", body: ParcelMediaCommand.decode(r) };
    case 200: return { type: "ParcelOverlay", body: ParcelOverlay.decode(r) };
    case 201: return { type: "ParcelInfoRequest", body: ParcelInfoRequest.decode(r) };
    case 202: return { type: "ParcelInfoReply", body: ParcelInfoReply.decode(r) };
    case 203: return { type: "ParcelUpdate", body: ParcelUpdate.decode(r) };
    case 204: return { type: "ParcelDivide", body: ParcelDivide.decode(r) };
    case 205: return { type: "ParcelJoin", body: ParcelJoin.decode(r) };
    case 206: return { type: "ParcelBuy", body: ParcelBuy.decode(r) };
    case 207: return { type: "ParcelRelease", body: ParcelRelease.decode(r) };
    case 208: return { type: "ParcelAccessList", body: ParcelAccessList.decode(r) };
    case 209: return { type: "ParcelReturnObjects", body: ParcelReturnObjects.decode(r) };
    case 210: return { type: "ParcelObjectOwners", body: ParcelObjectOwners.decode(r) };
    case 211: return { type: "ParcelEject", body: ParcelEject.decode(r) };
    case 212: return { type: "ParcelFreeze", body: ParcelFreeze.decode(r) };
    case 307: return { type: "ParcelAuctionStart", body: ParcelAuctionStart.decode(r) };
    case 308: return { type: "ParcelAuctionBid", body: ParcelAuctionBid.decode(r) };
    case 309: return { type: "ParcelAuctionCancel", body: ParcelAuctionCancel.decode(r) };
    case 310: return { type: "TaskInventoryTake", body: TaskInventoryTake.decode(r) };
    case 312: return { type: "InventoryTextSave", body: InventoryTextSave.decode(r) };
    case 311: return { type: "ParcelMediaControl", body: ParcelMediaControl.decode(r) };
    case 213: return { type: "ParcelDeedToGroup", body: ParcelDeedToGroup.decode(r) };
    case 220: return { type: "MapRequest", body: MapRequest.decode(r) };
    case 221: return { type: "MapReply", body: MapReply.decode(r) };
    case 222: return { type: "MapAgentsRequest", body: MapAgentsRequest.decode(r) };
    case 223: return { type: "MapAgentsReply", body: MapAgentsReply.decode(r) };
    case 224: return { type: "LandmarkCreate", body: LandmarkCreate.decode(r) };
    case 225: return { type: "PlacesRequest", body: PlacesRequest.decode(r) };
    case 226: return { type: "PlacesReply", body: PlacesReply.decode(r) };
    case 227: return { type: "MapItemsRequest", body: MapItemsRequest.decode(r) };
    case 228: return { type: "MapItemsReply", body: MapItemsReply.decode(r) };
    case 229: return { type: "AgentHome", body: AgentHome.decode(r) };
    case 230: return { type: "BalanceUpdate", body: BalanceUpdate.decode(r) };
    case 231: return { type: "MoneyTransfer", body: MoneyTransfer.decode(r) };
    case 232: return { type: "MoneyTransferResult", body: MoneyTransferResult.decode(r) };
    case 233: return { type: "TransactionHistoryRequest", body: TransactionHistoryRequest.decode(r) };
    case 234: return { type: "TransactionHistoryReply", body: TransactionHistoryReply.decode(r) };
    case 240: return { type: "NameLookup", body: NameLookup.decode(r) };
    case 241: return { type: "NameReply", body: NameReply.decode(r) };
    case 242: return { type: "ProfileRequest", body: ProfileRequest.decode(r) };
    case 243: return { type: "ProfileReply", body: ProfileReply.decode(r) };
    case 244: return { type: "ProfileUpdate", body: ProfileUpdate.decode(r) };
    case 245: return { type: "FriendList", body: FriendList.decode(r) };
    case 246: return { type: "FriendRequest", body: FriendRequest.decode(r) };
    case 247: return { type: "FriendRequestReply", body: FriendRequestReply.decode(r) };
    case 248: return { type: "FriendRemove", body: FriendRemove.decode(r) };
    case 249: return { type: "FriendPresenceUpdate", body: FriendPresenceUpdate.decode(r) };
    case 250: return { type: "FriendRights", body: FriendRights.decode(r) };
    case 260: return { type: "GroupList", body: GroupList.decode(r) };
    case 261: return { type: "GroupCreate", body: GroupCreate.decode(r) };
    case 262: return { type: "GroupCreateResult", body: GroupCreateResult.decode(r) };
    case 263: return { type: "GroupInfoRequest", body: GroupInfoRequest.decode(r) };
    case 264: return { type: "GroupInfoReply", body: GroupInfoReply.decode(r) };
    case 265: return { type: "GroupMembersRequest", body: GroupMembersRequest.decode(r) };
    case 266: return { type: "GroupMembersReply", body: GroupMembersReply.decode(r) };
    case 267: return { type: "GroupActivate", body: GroupActivate.decode(r) };
    case 268: return { type: "GroupUpdate", body: GroupUpdate.decode(r) };
    case 269: return { type: "GroupJoin", body: GroupJoin.decode(r) };
    case 270: return { type: "GroupLeave", body: GroupLeave.decode(r) };
    case 271: return { type: "GroupInvite", body: GroupInvite.decode(r) };
    case 272: return { type: "GroupInviteReply", body: GroupInviteReply.decode(r) };
    case 273: return { type: "GroupEject", body: GroupEject.decode(r) };
    case 274: return { type: "GroupRoleUpdate", body: GroupRoleUpdate.decode(r) };
    case 275: return { type: "GroupMemberRole", body: GroupMemberRole.decode(r) };
    case 276: return { type: "GroupTitleSet", body: GroupTitleSet.decode(r) };
    case 277: return { type: "GroupNoticeSend", body: GroupNoticeSend.decode(r) };
    case 278: return { type: "GroupNoticesRequest", body: GroupNoticesRequest.decode(r) };
    case 279: return { type: "GroupNoticesReply", body: GroupNoticesReply.decode(r) };
    case 280: return { type: "GroupChatSend", body: GroupChatSend.decode(r) };
    case 281: return { type: "GroupChatReceive", body: GroupChatReceive.decode(r) };
    case 282: return { type: "GroupSearch", body: GroupSearch.decode(r) };
    case 283: return { type: "GroupSearchReply", body: GroupSearchReply.decode(r) };
    case 315: return { type: "SearchRequest", body: SearchRequest.decode(r) };
    case 316: return { type: "SearchReply", body: SearchReply.decode(r) };
    case 317: return { type: "EventCreate", body: EventCreate.decode(r) };
    case 318: return { type: "ClassifiedCreate", body: ClassifiedCreate.decode(r) };
    case 319: return { type: "SearchListingDelete", body: SearchListingDelete.decode(r) };
    case 320: return { type: "VoiceJoin", body: VoiceJoin.decode(r) };
    case 321: return { type: "VoiceAnswer", body: VoiceAnswer.decode(r) };
    case 322: return { type: "VoiceSlots", body: VoiceSlots.decode(r) };
    case 323: return { type: "VoiceLeave", body: VoiceLeave.decode(r) };
    case 324: return { type: "VoiceActivity", body: VoiceActivity.decode(r) };
    case 325: return { type: "ExperienceSave", body: ExperienceSave.decode(r) };
    case 326: return { type: "ExperienceListRequest", body: ExperienceListRequest.decode(r) };
    case 327: return { type: "ExperienceList", body: ExperienceList.decode(r) };
    case 328: return { type: "ExperienceAnswer", body: ExperienceAnswer.decode(r) };
    case 329: return { type: "MarketListRequest", body: MarketListRequest.decode(r) };
    case 330: return { type: "MarketList", body: MarketList.decode(r) };
    case 331: return { type: "MarketListingSave", body: MarketListingSave.decode(r) };
    case 332: return { type: "MarketBuy", body: MarketBuy.decode(r) };
    case 333: return { type: "MarketResult", body: MarketResult.decode(r) };
    case 290: return { type: "EstateUpdate", body: EstateUpdate.decode(r) };
    case 291: return { type: "EstateKick", body: EstateKick.decode(r) };
    case 292: return { type: "EstateMessage", body: EstateMessage.decode(r) };
    case 293: return { type: "EstateRestart", body: EstateRestart.decode(r) };
    case 294: return { type: "EstateTeleportHome", body: EstateTeleportHome.decode(r) };
    case 295: return { type: "GodRequest", body: GodRequest.decode(r) };
    case 296: return { type: "GodGrant", body: GodGrant.decode(r) };
    case 297: return { type: "AdminObjectReturn", body: AdminObjectReturn.decode(r) };
    case 678: return { type: "AdminObjectAction", body: AdminObjectAction.decode(r) };
    case 679: return { type: "StaffAction", body: StaffAction.decode(r) };
    case 680: return { type: "StaffActionReply", body: StaffActionReply.decode(r) };
    case 298: return { type: "TopScriptsRequest", body: TopScriptsRequest.decode(r) };
    case 299: return { type: "TopScriptsReply", body: TopScriptsReply.decode(r) };
    case 300: return { type: "ObjectHudAttach", body: ObjectHudAttach.decode(r) };
    case 301: return { type: "ClientStatsReport", body: ClientStatsReport.decode(r) };
    case 313: return { type: "AbuseReport", body: AbuseReport.decode(r) };
    case 314: return { type: "AbuseReportAck", body: AbuseReportAck.decode(r) };
    case 302: return { type: "DetectedReport", body: DetectedReport.decode(r) };
    case 303: return { type: "CameraConstraint", body: CameraConstraint.decode(r) };
    case 304: return { type: "ViewerEffectSpawn", body: ViewerEffectSpawn.decode(r) };
    case 305: return { type: "TerrainRequest", body: TerrainRequest.decode(r) };
    case 334: return { type: "FriendLocateRequest", body: FriendLocateRequest.decode(r) };
    case 335: return { type: "FriendLocateReply", body: FriendLocateReply.decode(r) };
    case 336: return { type: "MapParcelRequest", body: MapParcelRequest.decode(r) };
    case 337: return { type: "MapParcelReply", body: MapParcelReply.decode(r) };
    case 338: return { type: "AgentControlsRelease", body: AgentControlsRelease.decode(r) };
    case 339: return { type: "ObjectHandOff", body: ObjectHandOff.decode(r) };
    case 340: return { type: "VehicleFlags", body: VehicleFlags.decode(r) };
    case 341: return { type: "AttachmentWear", body: AttachmentWear.decode(r) };
    case 342: return { type: "AgentSetHover", body: AgentSetHover.decode(r) };
    case 343: return { type: "AgentAnimationStopAll", body: AgentAnimationStopAll.decode(r) };
    case 344: return { type: "AgentDoNotDisturb", body: AgentDoNotDisturb.decode(r) };
    case 345: return { type: "ProfileExtrasRequest", body: ProfileExtrasRequest.decode(r) };
    case 346: return { type: "ProfileExtras", body: ProfileExtras.decode(r) };
    case 347: return { type: "PickSave", body: PickSave.decode(r) };
    case 348: return { type: "PickDelete", body: PickDelete.decode(r) };
    case 349: return { type: "ProfileNotesSave", body: ProfileNotesSave.decode(r) };
    case 360: return { type: "ObjectTouchAt", body: ObjectTouchAt.decode(r) };
    case 380: return { type: "ObjectSetSaleType", body: ObjectSetSaleType.decode(r) };
    case 381: return { type: "ObjectTradeRequest", body: ObjectTradeRequest.decode(r) };
    case 382: return { type: "ObjectTrade", body: ObjectTrade.decode(r) };
    case 383: return { type: "ObjectPurchase", body: ObjectPurchase.decode(r) };
    case 384: return { type: "TaskInventoryCopyAll", body: TaskInventoryCopyAll.decode(r) };
    case 385: return { type: "TaskInventoryCopied", body: TaskInventoryCopied.decode(r) };
    case 386: return { type: "AgentTeleportAsk", body: AgentTeleportAsk.decode(r) };
    case 387: return { type: "AgentTeleportAsked", body: AgentTeleportAsked.decode(r) };
    case 388: return { type: "ObjectMenuTouch", body: ObjectMenuTouch.decode(r) };
    case 400: return { type: "GroupMemberOptions", body: GroupMemberOptions.decode(r) };
    case 401: return { type: "GroupMemberOptionsList", body: GroupMemberOptionsList.decode(r) };
    case 402: return { type: "GroupChatHistoryRequest", body: GroupChatHistoryRequest.decode(r) };
    case 403: return { type: "GroupChatHistory", body: GroupChatHistory.decode(r) };
    case 404: return { type: "GroupNoticeReceive", body: GroupNoticeReceive.decode(r) };
    case 405: return { type: "GroupNoticeAccept", body: GroupNoticeAccept.decode(r) };
    case 406: return { type: "ConferenceSend", body: ConferenceSend.decode(r) };
    case 407: return { type: "ConferenceReceive", body: ConferenceReceive.decode(r) };
    case 420: return { type: "EstateAccessRequest", body: EstateAccessRequest.decode(r) };
    case 421: return { type: "EstateAccessList", body: EstateAccessList.decode(r) };
    case 422: return { type: "EstateAccessChange", body: EstateAccessChange.decode(r) };
    case 423: return { type: "ParcelEnvironmentReset", body: ParcelEnvironmentReset.decode(r) };
    case 441: return { type: "OutfitWrite", body: OutfitWrite.decode(r) };
    case 442: return { type: "AvatarChoose", body: AvatarChoose.decode(r) };
    case 443: return { type: "AvatarChosen", body: AvatarChosen.decode(r) };
    case 444: return { type: "ProfileDetails", body: ProfileDetails.decode(r) };
    case 445: return { type: "ProfileDetailsUpdate", body: ProfileDetailsUpdate.decode(r) };
    case 446: return { type: "AccountInfoRequest", body: AccountInfoRequest.decode(r) };
    case 447: return { type: "AccountInfo", body: AccountInfo.decode(r) };
    case 448: return { type: "AccountPasswordChange", body: AccountPasswordChange.decode(r) };
    case 449: return { type: "AccountEmailChange", body: AccountEmailChange.decode(r) };
    case 450: return { type: "AccountChangeResult", body: AccountChangeResult.decode(r) };
    case 451: return { type: "ObjectWear", body: ObjectWear.decode(r) };
    case 460: return { type: "UploadPriceRequest", body: UploadPriceRequest.decode(r) };
    case 461: return { type: "UploadPrice", body: UploadPrice.decode(r) };
    case 462: return { type: "ObjectReturn", body: ObjectReturn.decode(r) };
    case 463: return { type: "ObjectRestore", body: ObjectRestore.decode(r) };
    case 464: return { type: "ParcelObjectsRequest", body: ParcelObjectsRequest.decode(r) };
    case 465: return { type: "ParcelObjects", body: ParcelObjects.decode(r) };
    case 466: return { type: "MapDestination", body: MapDestination.decode(r) };
    case 467: return { type: "SoundAdjust", body: SoundAdjust.decode(r) };
    case 468: return { type: "SoundQueue", body: SoundQueue.decode(r) };
    case 480: return { type: "AvatarRenderReport", body: AvatarRenderReport.decode(r) };
    case 481: return { type: "AvatarRenderNotice", body: AvatarRenderNotice.decode(r) };
    case 482: return { type: "AccountPreferencesRequest", body: AccountPreferencesRequest.decode(r) };
    case 483: return { type: "AccountPreferencesSet", body: AccountPreferencesSet.decode(r) };
    case 484: return { type: "AccountPreferencesReply", body: AccountPreferencesReply.decode(r) };
    case 500: return { type: "VoiceCallStart", body: VoiceCallStart.decode(r) };
    case 501: return { type: "VoiceCallInvite", body: VoiceCallInvite.decode(r) };
    case 502: return { type: "VoiceCallJoin", body: VoiceCallJoin.decode(r) };
    case 503: return { type: "VoiceCallAnswer", body: VoiceCallAnswer.decode(r) };
    case 504: return { type: "VoiceCallLeave", body: VoiceCallLeave.decode(r) };
    case 505: return { type: "VoiceCallEnded", body: VoiceCallEnded.decode(r) };
    case 506: return { type: "VoiceCallMembers", body: VoiceCallMembers.decode(r) };
    case 507: return { type: "InstantMessageStored", body: InstantMessageStored.decode(r) };
    case 508: return { type: "ObjectInstantMessage", body: ObjectInstantMessage.decode(r) };
    case 509: return { type: "GroupMembersPageRequest", body: GroupMembersPageRequest.decode(r) };
    case 510: return { type: "GroupMembersPage", body: GroupMembersPage.decode(r) };
    case 511: return { type: "GroupLandRequest", body: GroupLandRequest.decode(r) };
    case 512: return { type: "GroupLand", body: GroupLand.decode(r) };
    case 513: return { type: "GroupContributionSet", body: GroupContributionSet.decode(r) };
    case 514: return { type: "GroupProfileChoice", body: GroupProfileChoice.decode(r) };
    case 515: return { type: "GroupProfileChoices", body: GroupProfileChoices.decode(r) };
    case 516: return { type: "TalkChoices", body: TalkChoices.decode(r) };
    case 520: return { type: "EnvironmentDaySet", body: EnvironmentDaySet.decode(r) };
    case 521: return { type: "EnvironmentInfoRequest", body: EnvironmentInfoRequest.decode(r) };
    case 522: return { type: "EnvironmentInfo", body: EnvironmentInfo.decode(r) };
    case 523: return { type: "ParcelExtrasSet", body: ParcelExtrasSet.decode(r) };
    case 524: return { type: "ParcelExtras", body: ParcelExtras.decode(r) };
    case 525: return { type: "LandSearchRequest", body: LandSearchRequest.decode(r) };
    case 526: return { type: "LandSearchReply", body: LandSearchReply.decode(r) };
    case 527: return { type: "LandHoldingsRequest", body: LandHoldingsRequest.decode(r) };
    case 528: return { type: "LandHoldingsReply", body: LandHoldingsReply.decode(r) };
    case 529: return { type: "FeaturedPlacesRequest", body: FeaturedPlacesRequest.decode(r) };
    case 530: return { type: "FeaturedPlacesReply", body: FeaturedPlacesReply.decode(r) };
    case 531: return { type: "FeaturedPlaceSave", body: FeaturedPlaceSave.decode(r) };
    case 532: return { type: "FeaturedPlaceDelete", body: FeaturedPlaceDelete.decode(r) };
    case 533: return { type: "RegionSpawnSet", body: RegionSpawnSet.decode(r) };
    case 540: return { type: "EstateCovenantRequest", body: EstateCovenantRequest.decode(r) };
    case 541: return { type: "EstateCovenant", body: EstateCovenant.decode(r) };
    case 542: return { type: "ParcelTermsSet", body: ParcelTermsSet.decode(r) };
    case 543: return { type: "ParcelTerms", body: ParcelTerms.decode(r) };
    case 544: return { type: "ParcelBuyAgreed", body: ParcelBuyAgreed.decode(r) };
    case 545: return { type: "EventSearchRequest", body: EventSearchRequest.decode(r) };
    case 546: return { type: "EventSearchReply", body: EventSearchReply.decode(r) };
    case 547: return { type: "RegionSkyLayersSet", body: RegionSkyLayersSet.decode(r) };
    case 548: return { type: "RegionSkyLayers", body: RegionSkyLayers.decode(r) };
    case 640: return { type: "TerrainRawUpload", body: TerrainRawUpload.decode(r) };
    case 641: return { type: "TerrainRawRequest", body: TerrainRawRequest.decode(r) };
    case 642: return { type: "TerrainRaw", body: TerrainRaw.decode(r) };
    case 650: return { type: "RegionExtrasRequest", body: RegionExtrasRequest.decode(r) };
    case 651: return { type: "RegionExtras", body: RegionExtras.decode(r) };
    case 652: return { type: "RegionExtrasSet", body: RegionExtrasSet.decode(r) };
    case 653: return { type: "TopObjectsRequest", body: TopObjectsRequest.decode(r) };
    case 654: return { type: "TopObjectsReply", body: TopObjectsReply.decode(r) };
    case 655: return { type: "RegionObjectReturn", body: RegionObjectReturn.decode(r) };
    case 620: return { type: "InventoryFavourite", body: InventoryFavourite.decode(r) };
    case 621: return { type: "ParcelScriptInfoRequest", body: ParcelScriptInfoRequest.decode(r) };
    case 622: return { type: "ParcelScriptInfo", body: ParcelScriptInfo.decode(r) };
    case 580: return { type: "MapLevelTilesRequest", body: MapLevelTilesRequest.decode(r) };
    case 581: return { type: "MapLevelTilesReply", body: MapLevelTilesReply.decode(r) };
    case 582: return { type: "MapLandRequest", body: MapLandRequest.decode(r) };
    case 583: return { type: "MapLandReply", body: MapLandReply.decode(r) };
    case 670: return { type: "CurrencyBuy", body: CurrencyBuy.decode(r) };
    case 671: return { type: "CurrencyBuyReply", body: CurrencyBuyReply.decode(r) };
    case 672: return { type: "CurrencyBuyCheck", body: CurrencyBuyCheck.decode(r) };
    case 673: return { type: "LookPublish", body: LookPublish.decode(r) };
    case 674: return { type: "LookPublished", body: LookPublished.decode(r) };
    case 675: return { type: "LookWithdraw", body: LookWithdraw.decode(r) };
    case 677: return { type: "LibraryPublish", body: LibraryPublish.decode(r) };
    case 676: return { type: "StarterLookSet", body: StarterLookSet.decode(r) };
    case 681: return { type: "ObjectItemDescribe", body: ObjectItemDescribe.decode(r) };
    case 682: return { type: "ObjectItemParts", body: ObjectItemParts.decode(r) };
    case 683: return { type: "TerrainShape", body: TerrainShape.decode(r) };
    case 684: return { type: "TerrainShaped", body: TerrainShaped.decode(r) };
    case 685: return { type: "BotMenu", body: BotMenu.decode(r) };
    case 686: return { type: "BotClick", body: BotClick.decode(r) };
    case 687: return { type: "TerrainEditArea", body: TerrainEditArea.decode(r) };
    case 688: return { type: "AgentStatus", body: AgentStatus.decode(r) };
    default: return undefined;
  }
}

export function message<T extends MessageType>(type: T, body: MessageBody<T>): Message {
  return { type, body } as Message;
}
